
import { CommonModule } from '@angular/common';
import { Component, OnInit, ElementRef, HostListener, inject, ViewChild, AfterViewInit, Renderer2, ViewChildren, QueryList, SimpleChanges, input } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
  ReactiveFormsModule,
  AbstractControl,
  FormArray,
  NgModel,
  ValidatorFn,
} from '@angular/forms';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { CustomDatePipe } from '../pipes/customdate.pipe';
import {
  BsDatepickerConfig,
  BsDatepickerModule,
} from 'ngx-bootstrap/datepicker';
import { DecimalPipe, formatNumber } from '@angular/common';
import { SignupformService } from '../services/signupform.service';
import { Meta } from '@angular/platform-browser';
import { environment } from '../environments/environment'
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SignaturePad } from 'angular2-signaturepad';
import Swal from 'sweetalert2';
import { PhoneNumberPipe } from '../pipes/phone-number.pipe'
import {
  floatWith2Decimals,
  groupBy,
  sumBy,
  adjustWith2DecimalsForUI,
  formFields,
  fieldsMapping,
  formFieldsUpdated,
  formThemes,
  dummyPlans,
  beneficiaryData,
  extraBankAccountDetails,
  countriesData,
  isNameKeyAllowed,
} from "../commonfunctions/commonFunction";
import { SharedService } from '../shared/shared.service';
import { ToastrService } from 'ngx-toastr';
import { switchMap, catchError, of } from 'rxjs';
import { Observable } from 'rxjs';
declare var Accept: any;
import { strings } from '../../assets/languageStrings';
import { CommonService } from '@ideabytes/groupbenefitz_common_ui';
import { CorporateService } from '../services/corporate.service';
import { calculateAgeFrom, daysBetween, toApiDate, toLocalDate, toTypingDate } from '../utils/date-utils';
import { applyPlanPricingFallback } from '../utils/plan-pricing';

@Component({
  selector: 'app-generic-signup-form',
  templateUrl: './generic-signup-form.component.html',
  styleUrl: './generic-signup-form.component.scss',
  providers: [CustomDatePipe, DecimalPipe, HttpClient, PhoneNumberPipe],
})
export class GenericSignupFormComponent implements AfterViewInit {
  @ViewChild('myTextarea') myTextarea!: ElementRef<HTMLTextAreaElement>;
  @ViewChild('scriptTarget') scriptTarget!: ElementRef;
  @ViewChild('doctorSelfGenderRef') doctorSelfGenderRef!: NgModel;

  myDateValue: Date | undefined;
  Object = Object;
  date: Date = new Date();
  bsConfig: Partial<BsDatepickerConfig>;
  // bsConfig: any;
  minDate: Date = new Date();
  maxDate: Date = new Date();
  childminDate: Date = new Date();
  childmaxDate: Date = new Date();
  showBenificiaryForm = true;
  showbenificaryTable = false;
  isEditable = true;
  public showPaymenthMethod: boolean = false;
  enableEditIndex = null;
  addeditbenficiary = false
  benficiaryCount = false;
  phrOption: boolean = false;
  showBenificiaryFormCond = false;
  signupFormConfigurationsOverride:any = false // false
  plansTemplate:any = 'default' // default
  hidePlanCategorization:any = false // false
  // broker signupFormConfigurations flag: true → addedToPolicy goes out as true/false,
  // anything else → 1/0
  sendTrueOrFalseForAddedToPolicy: any = false;
  hideCompanyPaidPlans:any = false // false
  signupFormDynamicStyles:any;
  coveragesOverride:any = false;
  
  wawanessaForm = new FormGroup({
    smoker: new FormControl(''),
    earningsAmount: new FormControl(''),
    earningsFrequency: new FormControl(''),
  })

  iafggenderForm = new FormGroup(
    {
      memberinfo: new FormControl(''),
      gender: new FormControl(''),
      spouseinfo: new FormControl(''),
      spousegender: new FormControl(''),
      
    })
    
benficiaryForm!: FormGroup;
// Initialized as empty group so CORP API handler can safely call .get() before buildDynamicForm() runs
userForm: FormGroup = new FormGroup({}, { updateOn: 'change' });

 activeBeneficiaryFields: Record<string, Record<string, any>> = {};
activeBeneficiarySections: string[] = [];

imagedisplay: any = false;
  voidCheckFileName: string = '';
  showPADMODAL: any = false;

get voidCheckFileDisplayName(): string {
    if (!this.voidCheckFileName) return '';
    const lastDot = this.voidCheckFileName.lastIndexOf('.');
    if (lastDot === -1) {
      return this.voidCheckFileName.length > 10 ? this.voidCheckFileName.substring(0, 10) + '...' : this.voidCheckFileName;
    }
    const name = this.voidCheckFileName.substring(0, lastDot);
    const ext = this.voidCheckFileName.substring(lastDot);
    return name.length > 10 ? name.substring(0, 10) + '...' + ext : this.voidCheckFileName;
  }

  paymentForm = new FormGroup(
    {
      cutomerId: new FormControl(''),
      PublicApiKey: new FormControl(''),
      SuccessUri: new FormControl(''),
      FailUri: new FormControl(''),
      FirstName: new FormControl(''),
      LastName: new FormControl(''),
      paymentRadioCheck: new FormControl(''),
      email: new FormControl(''),
      CardNumber: new FormControl(''),
      ExpirationMonth: new FormControl(''),
      ExporationYear: new FormControl(''),
      cvv: new FormControl(''),

      // signature:["", Validators.required],
      nameonthecard: new FormControl(''),

      // aptcheck: ["", Validators.compose([apt_suitecheck])],
      aptcheck: new FormControl(''),

      streetaddress: new FormControl(''),
      streetaddressline2: new FormControl(''),
      city: new FormControl(''),
      province: new FormControl(''),
      postalcode: new FormControl(''),
      recaptchaReactive: new FormControl(''),
    },
    { updateOn: 'change' }
  );
  bankpayForm = new FormGroup(
    {
      banknumber: new FormControl(''),

      transitnumber: new FormControl(''),
      accountnumber: new FormControl(''),
      bankname: new FormControl(''),
      voidcheck: new FormControl(''),
      checkbankdetails: new FormControl(''),
      bankaptcheck: new FormControl(''),
      bankstreetaddress: new FormControl(''),
      bankstreetaddressline2: new FormControl(''),
      bankcity: new FormControl(''),
      bankprovince: new FormControl(''),
      bankpostalcode: new FormControl(''),
    },
    { updateOn: 'change' }
  );

  // ── Extra Bank Account (plan premium payment) ──────────────────────────────
  extraBankAccountOption: string = 'different'; // 'same' | 'different'
  extraBankImageDisplay: any = false;         // base64 void cheque preview
  extraBankVoidChequeFile: File | null = null; // raw file for multipart upload
  extraBankNameRes: string = '';              // bank name from verify call
  extraBankVerifyButton: boolean = false;     // show Verify button
  extraBankDetails = extraBankAccountDetails; // data from commonFunction
  extraBankerrormsg: string = '';             // error msg for extra bank verify
  extraBankSubmitted: boolean = false;        // true after first submit attempt

  extraBankPayForm = new FormGroup({
    financial_institute_name: new FormControl(''),
    branch_address:           new FormControl(''),
    extra_city:               new FormControl(''),
    extra_province:           new FormControl(''),
    transit_number:           new FormControl('', Validators.required),
    bank_number:              new FormControl('', Validators.required),
    account_number:           new FormControl('', Validators.required),
    upload_void_cheque:       new FormControl(''),
  });
  // ── end Extra Bank Account ─────────────────────────────────────────────────

  insuranceForm: FormGroup;
  // insuranceForm = new FormGroup(
  //   {


  //     memberHeight: new FormControl(''),
  //     memberHeightUnit: new FormControl(''),
  //     memberWeight: new FormControl(''),
  //     memberWeightUnit: new FormControl(''),
  //     spouseHeight: new FormControl(''),
  //     spouseHeightUnit: new FormControl(''),
  //     spouseWeight: new FormControl(''),
  //     spouseWeightUnit: new FormControl(''),



  //   },
  //   { updateOn: 'change' }
  // );
  submitted = false;
  private http = inject(HttpClient);
  public languageTokensArray: any = [];
  public lang: any = {};
  public selectedLanguage: any;
  public configprovinceres: any;
  activeTab: any = 0;
  previousTab: any = -1;
  bsValue = new Date();
  invalidPostalCodeForProvince: boolean = false;
  invalidSpousePostalCodeForProvince: boolean = false;
  private enrollmentDateLocked: boolean = false; // true when broker sets a fixed enrollment date
  provineList: any;
  provineListPayment: any;
  provineListcreditPayment: any
  plansData: any = [{ groups: [{ plans: [] }] }];
  /** Corp (NHLAA) plans, built separately so GIG plansData stays untouched. */
  corpPlansData: any[] = [];
  /** Coverage level to show + auto-select for NHLAA company-paid plans (SINGLE / COUPLE / FAMILY). */
  corpPossibleCoverage: string = 'SINGLE';

  // ── Corp summary arrays — populated by planCoverafeFunctionCorp() for NHLAA
  //    and used by the existing CORP summary tab HTML (currForm == 'CORP' block).
  //    Declared here so the template never crashes with "undefined" even before
  //    the first checkbox change fires planCoverafeFunctionCorp().
  public directpayCCplansarr:    any[] = [];
  public payrollCCplansarr:      any[] = [];
  public employeeDealingPlansarr:any[] = [];
  public companyDealingPlans:    any[] = [];
  public companySelectedPlans:   any[] = [];
  public EmployeeSelectedPlans:  any[] = [];
  public allSelectedPlans:       any[] = [];
  public alloptinplans:          any[] = [];
  public companyCoveredPlans:    any[] = [];
  public singleSummaryTable:     boolean = false;
  public iafgplansCheck:         any[] = [];
  public paidEmployeeShare:      number = 0;
  public coveredEmployeeShare:   number = 0;
  public totalEmployeeShare:     number = 0;
  public cartDisplayAmount:      any = 0;
  public voluntryplansCheck:     boolean = false;
  public showUnits:              any = false;

  // ── Computed summary totals (mirrors corporate-signup planCoverafeFunction totals) ──
  public allPlansAmountTotal:                      any = 0;
  public allPlansTotal:                            any = 0;
  public allPlansTotaltax:                         any = 0;
  public companyPaidTotal:                         any = 0;
  public companyCoveredTotal:                      any = 0;
  public paidEmployeedTotal:                       any = 0;
  public companyCoveredCompanyShareTotal:          any = 0;
  public companyCoveredEmployeeShareTotal:         any = 0;
  public empDirectpayPlanamountTotal:              any = 0;
  public empDirectpayPlantaxTotal:                 any = 0;
  public empDirectpayPlangrandTotal:               any = 0;
  public DirectCCpayPlangrandTotal:                any = 0;
  public companydealingplansTotal:                 any = 0;
  public companydealingplanstaxTotal:              any = 0;
  public companydealingplansgrandTotal:            any = 0;

  configplanEnrollmentDateFull: any;
  childInfoAddDataArray: any = [];
  addbenificaryData: any = []
  childTableEditRowIndex: number = 0;
  public staticData: any = [];
  public ticks: any[] | undefined;
  public cardBackground: any = [];
  public cardColors: any = [];
// stepper.component.ts
tabs = [
  { title: 'Personal Information', langKey: "Personal_Information" },
  { title: 'Plan Selection', langKey: "Plan_Selection" },
  { title: 'Enrollment Summary', langKey: "Enrollment_Summary" },
];
readonly OVERLAP = 18;
  currForm: any = "GIG";
  showContent: boolean = false;
  showCalendar = false;
  corporateAutoPlanSelection: any;
  employercheck: any;
  customerPaymentMethod: any = '';
  companyName: any;
  completeapplicantinfo: any;
  applicantSpousename: any;
  applicantChildrenname: any;
  applicantfirstname: any;
  applicantFirstName: any;
  applicantLastName: any;
  applicantEmail: any;
  applicantPhoneNumber: any;
  applicantDateofhire: any;
  paymentFirstName: any;
  paymentLastName: any;
  deltaCompanyTax: any;
  public payrolldeduction: any;
  usePADPaymentMethod: any;
  useCreditCardPaymentMethod: any;
  public applicantPlanEnrollmentDate: any = "";
  public configpworkingrovinceres: any
  formName_: any;
  isdandjform: boolean = false;
  showdandjform: boolean = false;
  requireSpouseEmail: any;
  requireDentalHealthCoverage: any;
  warnRequiredDependantMedicalExam: any;
  brokerConfig: any;
  configPlanEnrollmentDate: any;
  currency: any;
  brokerType: any;
  working_provincelistid: any;
  dateOfEligibility: any;
  signupFormOverrides: any;


getState(i: number): 'done' | 'active' | 'pending' {
  if (i < this.activeTab) return 'done';
  if (i === this.activeTab) return 'active';
  return 'pending';
}

getTabFill(i: number): string {
  const s = this.getState(i);
  if (s === 'done') return '#d1f0dc';
  if (s === 'active') return '#edfaf2';
  return '#f0f0f0';
}

getTabStroke(i: number): string {
  const s = this.getState(i);
  if (s === 'done') return '#7ecfa0';
  if (s === 'active') return '#4db87a';
  return '#d0d0d0';
}

getTabTextColor(i: number): string {
  const s = this.getState(i);
  if (s === 'pending') return '#aaa';
  return '#155d30';
}


// Add this helper
getTabState(i: number): 'completed' | 'active' | 'pending' {
  if (i < this.activeTab) return 'completed';
  if (i === this.activeTab) return 'active';
  return 'pending';
}

getZIndex(i: number): number {
  if (i === this.activeTab) return 10;
  if (i < this.activeTab) return 5 + i;
  return 3 - i;
}

getPath(i: number, total: number): string {
  const isFirst = i === 0;
  const isLast = i === total - 1;
  if (isFirst)
    return 'M 0,52 L 0,14 Q 0,0 14,0 L 182,0 Q 196,0 200,26 L 200,52 Z';
  if (isLast)
    return 'M 0,26 Q 4,0 32,0 L 186,0 Q 200,0 200,14 L 200,52 L 0,52 Z';
  return 'M 0,26 Q 4,0 32,0 L 182,0 Q 196,0 200,26 L 200,52 L 0,52 Z';
}




getStateV2(i: number): 'done' | 'active' | 'pending' {
  if (i < this.activeTab) return 'done';
  if (i === this.activeTab) return 'active';
  return 'pending';
}

getTabFillV2(i: number): string {
  const s = this.getState(i);
  if (s === 'done') return '#d1f0dc';
  if (s === 'active') return '#edfaf2';
  return '#f0f0f0';
}

getTabStrokeV2(i: number): string {
  const s = this.getState(i);
  if (s === 'done') return '#7ecfa0';
  if (s === 'active') return '#4db87a';
  return '#d0d0d0';
}

getTabTextColorV2(i: number): string {
  const s = this.getState(i);
  if (s === 'pending') return '#aaa';
  return '#155d30';
}

getZIndexV2(i: number): number {
  if (i === this.activeTab) return 10;
  if (i < this.activeTab) return 5 + i;
  return 3 - i;
}

getPathV2(i: number, total: number): string {
  const isFirst = i === 0;
  const isLast = i === total - 1;
  if (isFirst)
    return 'M 0,52 L 0,14 Q 0,0 14,0 L 182,0 Q 196,0 200,26 L 200,52 Z';
  if (isLast)
    return 'M 0,26 Q 4,0 32,0 L 186,0 Q 200,0 200,14 L 200,52 L 0,52 Z';
  return 'M 0,26 Q 4,0 32,0 L 182,0 Q 196,0 200,26 L 200,52 L 0,52 Z';
}



getTabZIndex(i: number) {
  if (i === this.activeTab) return 10;
  if (i < this.activeTab) return 5 + i;
  return 3 - i;
}

getTabClipPath(i: number): string {
  const total = this.tabs.length;
  const isFirst = i === 0;
  const isLast  = i === total - 1;
  const aw = 20;  // chevron arrow / notch width in px
  const cr = 10;  // outer corner chamfer size in px

  if (isFirst && isLast) {
    // Single tab – octagon (chamfered on all four corners)
    return `polygon(${cr}px 0%, calc(100% - ${cr}px) 0%, 100% ${cr}px, ` +
           `100% calc(100% - ${cr}px), calc(100% - ${cr}px) 100%, ${cr}px 100%, ` +
           `0% calc(100% - ${cr}px), 0% ${cr}px)`;
  }
  if (isFirst) {
    // Chamfered top-left & bottom-left, chevron arrow on right
    return `polygon(${cr}px 0%, calc(100% - ${aw}px) 0%, 100% 50%, ` +
           `calc(100% - ${aw}px) 100%, ${cr}px 100%, ` +
           `0% calc(100% - ${cr}px), 0% ${cr}px)`;
  }
  if (isLast) {
    // Chevron notch on left, chamfered top-right & bottom-right
    return `polygon(${aw}px 0%, calc(100% - ${cr}px) 0%, 100% ${cr}px, ` +
           `100% calc(100% - ${cr}px), calc(100% - ${cr}px) 100%, ` +
           `${aw}px 100%, 0% 50%)`;
  }
  // Middle: chevron notch on left, chevron arrow on right
  return `polygon(${aw}px 0%, calc(100% - ${aw}px) 0%, ` +
         `100% 50%, calc(100% - ${aw}px) 100%, ${aw}px 100%, 0% 50%)`;
}

/** Returns a CSS filter value to add a subtle outline/shadow around the tab shape. */
getTabFilter(i: number): string {
  const s = this.getState(i);
  if (s === 'active') return 'drop-shadow(0 2px 6px rgba(29,121,66,0.22))';
  return 'none';
}

  public paymentUri: any;
  public paymentsuccessuri: any;
  public customerid: any;
  public publicapikey: any;
  public cardType: string = '';
  public invalidcreditcard: boolean = false;
  public recaptchaResponse: any;
  public fusbillinfocaptchavalue: any;
  childTableRowsLength: number = 0;
  childInfoModalAddAndUpdateButton: string = '';
  BenficairyModalAddAndUpdateButton: string = '';
  noOfChildrenChangedValue: any = 1;
  showModal = false;
  showDeleteModal = false;
  showModelDialog = false;
  ShowModelPopup = false;
  showPADModelDiaslog = false;
  modalMessage = 'Do you want to proceed?';
  deleteChildIndex: any;
  editChildInfo: any;
  editChildIndex: any;
  editBenficiaryIndex: any;
  spouseplaceholdername: any;
  checkedradioValue: boolean = false;
  pdfData: any;
  formConfigResult: any;
  public disabledelement: any;
  planobjdata: any = {};
  public planAmount: any;
  // planobjdata: { packageId: any; packageName: any; planproductname: any; groupid: any; groupName: any; id: any; name: any; planLevel: any; planLevelParent: any; fusebillPlanID: any; planFrequencyID: any; isBundle: any; coverage: any; planCoverage: any; bundledProducts: never[]; products: never[]; };
  productobj: any;
  public planssummarymain: any = [];
  public planssummarymainLife: any = [];
  public planssummaryopt: any = [];
  public plansskumain: any = [];
  public plandetailsobjvalue: any;
  public optionstitle: any = [];
  paymentForm2: any;
  finalenrollemntsummary: any = [];
  finalenrollemntsummaryLife: any = [];
  planSummaryMainResult: any = [];
  banknameres: any;
  bankerrormsg: any;
  public verifybutton: boolean = false;
  public verifybankdetails: boolean = false;
  bankverifyDetails: any;
  bankfile: any;
  isFileUploaded: boolean = false;
  bankinvalidPostalCode: boolean = false;
  pdfscrc: any = 'https://api.groupbenefitz.ca/app/server/en/terms-conditions-en.pdf'
  header: any;
  failedarray: any = [];
  signatureNeeded: any;
  creditCradInvalidProvince: any;
  showClearButton: boolean = false;
  hidePlanFeatures: boolean = true;
  heightCheck: any;
  checked: { [userId: string]: boolean } = {};
  missingInfo: any = [];
  missingInformation = false;
  noProvincialCoverageModal = false;
  private _suppressPHCModal = false;
  planOptionsModel = false;
  optionmessage: any;
  planoptionsValues: any = [];
  link: any;
  generatePADaggrement: any;
  padAggrementModel = false;
  padAggrementFinalModel = false;
  public signaturestatus: boolean = true;
  public rejectPADModel: boolean = true;
  public agreestatus: boolean = false;
  signModelForBankPay = false;
  closePADModel = false;
  signaturecheckvalue1cc: boolean = false;
  public signaturemessagecc: boolean = false;
  public signaturecheckcc: boolean = true;
  /** CC signature pad (signaturePad1) — has drawing → true */
  signaturecheckCC: boolean = false;
  /** Payment method selected by planCoverafeFunctionCorp / paymentmethod() */
  public bankpaymentmethod: any;
  paymentemail: any;
  public signaturecheckvalue1: boolean = false;
  public signaturemessagepad: boolean = false;
  public acceptaggrepad: boolean = false;
  public padaggrementerror: any;
  public signaturecheck: boolean = true;
  public signaturemessage: boolean = false;
  /** NHLAA: must check company-paid plan confirmation before submit (true = not yet confirmed) */
  companyplansCheck: boolean = true;
  /** NHLAA: must check upgrade plan confirmation before submit */
  upgradeplansCheck: boolean = false;
  showpaderrorMessage: boolean = false;
  showagree: boolean = true;
  ShowModelPopupTitle: any;
  ShowModelPopupMessage: any;
  invalidCardDetails: boolean = false;
  public showexpiryyearerror: boolean = false;
  public showexpirymontherror: boolean = false;
  public futureexpiredate: boolean = false;
  visitedTabs: Set<string> = new Set<string>();
  imageDisplayShow = false;
  questionaries = false;
  benficiary = false
  public normalview: boolean = false;
  public pdfview: boolean = false;
  public currencySymbol: any;
  showPageNotFound: any;


  public formData: any;
  public allFormData: any = {};
  public lastUpdatedType: any = "";
  public signUpData: any = {};
  public premiums: any = {};
  planCoverageName: any;
  insuranceplanid: any;
  smokerCheckValue: any;
  acceptanceCoverage: any;
  questions: any = [
    { label: '3) In the last 12 months, have you used, in any form whatsoever, tobacco, nicotine or cannabis mixed with tobacco?' },
    { label: '4) Have you flown as a pilot, student or crew member in the last two years or do you have any intention to do so?' },
    { label: '5) Have you engaged in or do you intend to participate in scuba diving, parachuting or other hazardous sport or activity?' },
    { label: '6) Do you intend to travel or reside outside Canada or the United States for more than a month?' },
    { label: '7) Have you had a request for life, disability or critical illness insurance declined, postponed, rated or modified in any way?' },
    { label: '8) Are you now actively engaged in your occupation on a full-time basis? If “No”, please provide details including reason why you are not working on a full-time basis.' },
    { label: '9) Have you ever had or ever been treated for cancer, tumour, cyst, polyp or other growth, moles, anemia, blood disorder or any form of malignant disease?' },
    { label: '10) Have you ever had or have you ever been treated for chest pain, angina, heart attack, high blood pressure, abnormal ECG, stroke, paralysis, transient ischemic attack (TIA), elevated cholesterol, or other disorders of the heart or aorta, blood vessels or circulatory system? Diabetes, pancreatitis,thyroid or other endocrine disorder? Lung or other respiratory disease or disorder? Any disorder of the eyes (excluding near or far sightedness), ears,vocal chords or larynx including loss of speech?' },
    { label: '11) Have you ever been treated for or diagnosed with kidney, bladder, prostate (including an elevated PSA test result) or breast disorder (including cysts,lumps, biopsy or abnormal mammogram or ultrasound) or other genitourinary disorder, hepatitis B or C (including carrier), cirrhosis or other liver disorder, ulcerative colitis, Crohn’s disease or other disorder of the gastrointestinal tract?' },
    { label: '12) Have you ever had or have you ever been treated for dizziness, seizures, epilepsy, tremor, paresthesia, loss of balance, numbness, multiple sclerosis,Alzheimer’s disease, Parkinson’s disease, amyotrophic lateral sclerosis (ALS) or any other neurological disorder? Stress, anxiety, depression or any other psychiatric disorder? Disease or disorder of muscles, ligaments, tendons, bones or joints including but not limited to arthritis, lupus in any form,amputation or deformity?' },
    { label: '13) Have you ever used marijuana, heroin, morphine, cocaine, LSD, barbiturates, amphetamines, or any other drug or narcotic, except as prescribed by your physician?' },
    { label: '14) a). Do you presently drink more than 12 alcoholic beverages per week? If “Yes”, state number, kind and frequency consumed.' },
    { label: '14) b). Have you ever changed your pattern of drinking (increased or decreased), received advice or treatment for, or attended any rehabilitation program for alcohol or drug use?' },
    { label: '15) Have you any condition for which hospitalization, further testing, investigation or surgery has been advised, or which have not yet been done, or for which you are still awaiting results?' },
    { label: '16) Are you taking any prescribed medication? If “Yes”, state name of medication and reason for use.' },
    { label: '17) Are you aware of any symptoms or complaints regarding your health for which you have not yet consulted a physician or received treatment?' },
    { label: '18) Have you been absent from work for more than seven consecutive days within the past year due to sickness or injury?' },
    { label: '19) Has there been a variation in your weight in the past year? If “Yes”, please provide details including reason and number of pounds/kilograms gained or lost.' },
    { label: '20) Females only: Are you currently pregnant? If “Yes”, please provide your estimated due date and advise of any complications with current or past pregnancies.' },
    { label: '21) During the past 10 years, have you consulted a physician, received treatment or been hospitalized, had surgery or any test (other than routine checkup or minor injury) for any disease, disorder or ailment not already mentioned?' },
    { label: '22) Have you ever received or claimed benefits or a pension for sickness, injury or impairment?' },
    { label: '23) o you have any pending criminal offences, criminal convictions, had your driver’s license suspended, or within the past 3 years been convicted of more than 3 traffic violations?' }

  ];
  tableForm!: FormGroup;
  beneficariesDetails: any;
  showaddmorebenficiary = true;
  benficiaryCountMessage: any;
  beneficiaryError = false;
  beneficiaryErrorMessage = ''
  iafgCheck: any;

 
  formFieldsConfig: any = formFields; 
  formType: string = 'gig';
  visibleFields: Set<string> = new Set<string>();

  iafginfo = false;
  memberDateofBirth = false;
  memberAgeOverError: string = '';
  minValue = 0;
  maxValue: any;
  sliderValue: any;
  cutoffValue: any;
  units: any = [];

  greenWidth: any;
  orangeWidth: any;
  filledWidth: any;
  cutoffWidth: any;
  rangeValues: any = [];
  names: any[] = [
    { label: 'Guaranteed', position: 10 },    // Display "Start" at 0%
    { label: 'Pending', position: 0 }, // Display "Quarter" at 25%

  ];
  greenValue: any;
  yellowValue: any;
  languageData: any;
  CreditCradFirstName: any;
  CreditCradLastName: any;
  trusteeCheck: boolean = false
  isInitialLoad = true;
  public allValidations: any = {};
  paymentPlatform: any = 'Staxbill';
  SpouseDetails: any = {};
  spouseSynonyms = [
    "spouse",
    "partner",
    "husband",
    "wife",
    "consort",
    "mate",
    "companion",
    "helpmeet",
    "significant other",
    "better half",
    "life partner",
    "other half",
    "hubby",
    "missis",
    "missus",
    "wifey",
    "helpmate"
  ];
  smokerInformation: any = '';
  salary: any = '';
  earningSummaryOptions: any = {
    HOURLY: 'Hourly',
    WEEKLY: 'Weekly',
    FORTNIGHTLY: 'Bi-weekly',
    MONTHLY: 'Monthly',
    YEARLY: 'Annually',
  }
  showMedcanForm: boolean = false;
  multiSelectPlansTotal: any;
  selectedCount = 1; // Member is selected by default
  memberSelected = true; // Always true and disabled
  spouseSelected = false;
  childrenSelected: boolean[] = [];
  validationInputData: any = {};
  isMedcanPopUpSubmitted: any = false;
  medcanSubmitCount: number = 1;
  showMultiCountChanges: any = true;
  planScopeDetails: any = [];
  wawanesaEarningsFrequencyList: any = [];
  smokerDetails:any= {};
  medcanPlanName: any = "Medcan";
  originalMedcanPrice: any = 0;
  doctorGender: any = '';
  doctorSpouseGender:string = '';
  doctorSelfGender:string = '';
  clinicSelection: any[] = [];
  doctorGenderinfoChild:any = [];
  clinicSpouseSelection: any='yes';
  clinicSelfSelection: any='no';
  currChild: any = {};
  currChildType: any = "SPOUSE";
  currChildIndex: any = 1;
  clinicSubmitAttempted: any = false;
  staticCalc: any = 0;
  currFormType: any = "gig";
  activeFields: Record<string, Record<string, any>> = {};
  activeSections: string[] = [];
  formFieldsUpdated:any = {}
  allsectionData: any = {};
  spouseProvineList: any;
  spouseProvinceOfCoverageList: any;
  provinceOfCoverageList: any;
  vikingStartDate:any= '2026-07-01';

  constructor(
    private Shared: SharedService,
    private renderer: Renderer2,
    private _SignupformService: SignupformService,
    private _CorporateService: CorporateService,
    private _PhoneNumberPipe: PhoneNumberPipe,
    private formBuilder: FormBuilder,
    public _CustomDatePipe: CustomDatePipe,
    public elementRef: ElementRef,
    public _decimalPipe: DecimalPipe,
    private meta: Meta,
    public router: Router, private route: ActivatedRoute, public toastrService: ToastrService,
    private commonSerivce: CommonService
  ) {

    this.minDate = new Date();
    const today = new Date();
    this.minDate.setFullYear(today.getFullYear() - 74);
    this.minDate.setMonth(0); // January
    this.minDate.setDate(1); // 1st

    // Set maxDate to December 31st, 2030
    this.maxDate = new Date();
    this.maxDate.setFullYear(today.getFullYear() - 16);
    this.maxDate.setMonth(new Date().getMonth()); // current month
    this.maxDate.setDate(new Date().getDate()); // current date

    this.childminDate = new Date();
    this.childminDate.setFullYear(today.getFullYear() - 21);
    this.childminDate.setMonth(0); // January
    this.childminDate.setDate(1); // 1st

    // Set maxDate to December 31st, 2030
    this.childmaxDate = new Date();
    this.childmaxDate.setFullYear(today.getFullYear());
    this.childmaxDate.setMonth(new Date().getMonth()); // current month
    this.childmaxDate.setDate(new Date().getDate()); // current date

    this.bsConfig = {
      containerClass: 'theme-default',
      dateInputFormat: 'MM-DD-YYYY',
      minDate: this.minDate,
      maxDate: this.maxDate,
    };
    this.tableForm = this.formBuilder.group({
      rows: this.formBuilder.array([])
    });
    this.addRow();
    // this.benficiaryForm = this.formBuilder.group(
    //   {
    //     customerType: [''],
    //     // type: ['', Validators.required],
    //     firstName: [
    //       '',
    //       Validators.compose([Validators.required, Validators.minLength(1)]),
    //     ],
    //     lastName: [
    //       '',
    //       Validators.compose([Validators.required, Validators.minLength(1)]),
    //     ],
    //     isMinor: [''],
    //     dob: ['', Validators.required],
    //     relationship: ['', Validators.required],
    //     contingentFirstName: [''],
    //     contingentLastName: [''],
    //     percentage: ['', Validators.required],
    //     trusteeFirstName: [''],
    //     trusteeLastName: [''],
    //     trusteeRelation: [''],

    //     gender: ['', Validators.required],
    //     relationshipSpecific: [''],
    //   })

    this.wawanessaForm = this.formBuilder.group({
      smoker: ['', Validators.required],
      earningsAmount: ['', [Validators.required, Validators.min(1)]],
      earningsFrequency: ['', Validators.required],
    })


    this.iafggenderForm = this.formBuilder.group(
      {

        memberinfo: ['', Validators.required],
        gender: [''],
        spouseinfo: [''],
        spousegender: ['']
      })


    this.insuranceForm = this.formBuilder.group({
      memberHeight: [''],
      memberHeightUnit: [''],
      memberWeight: [''],
      memberWeightUnit: [''],
      spouseHeight: [''],
      spouseHeightUnit: [''],
      spouseWeight: [''],
      spouseWeightUnit: [''],
      ...this.questions.reduce((acc: any, _: any, index: number) => {
        acc[`memberQuestion${index + 1}`] = [''];
        acc[`spouseQuestion${index + 1}`] = [''];
        return acc;
      }, {})

    });

    this.paymentForm = this.formBuilder.group({
      cutomerId: [''],
      PublicApiKey: [''],
      SuccessUri: [''],
      FailUri: [''],
      FirstName: ['', Validators.required],
      LastName: ['', Validators.required],
      email: [''],
      paymentRadioCheck: ['', Validators.required],
      CardNumber: [
        '',
        Validators.compose([Validators.required, creditcardvalidation]),
      ],
      ExpirationMonth: ['', Validators.required],
      ExporationYear: ['', Validators.required],
      cvv: [
        '',
        Validators.compose([Validators.required, Validators.minLength(3)]),
      ],

      // signature:["", Validators.required],
      nameonthecard: [''],

      // aptcheck: ["", Validators.compose([apt_suitecheck])],
      aptcheck: [''],

      streetaddress: ['', Validators.required],
      streetaddressline2: [''],
      city: ['', Validators.required],
      province: ['', Validators.required],
      postalcode: ['', Validators.compose([Validators.required])],
      recaptchaReactive: ['', Validators.required],
    });

    this.bankpayForm = this.formBuilder.group({
      banknumber: [
        '',
        Validators.compose([Validators.required, checkbanknumber]),
      ],

      transitnumber: [
        '',
        Validators.compose([Validators.required, checktransitnumber]),
      ],
      accountnumber: [
        '',
        Validators.compose([Validators.required, checkaccountnumber]),
      ],
      bankname: ['', Validators.required],
      voidcheck: ['', Validators.compose([Validators.required])],
      checkbankdetails: [''],
      // bankaptcheck: ["", Validators.compose([apt_suitecheck])],
      bankaptcheck: [''],
      bankstreetaddress: ['', Validators.required],
      bankstreetaddressline2: [''],
      bankcity: ['', Validators.required],
      bankprovince: ['', Validators.required],
      bankpostalcode: ['', Validators.compose([Validators.required])],
    });
  }



  private readonly permanentControls: Record<string, any> = {
    recaptchaReactivePerInfo: new FormControl(''),
    no_of_children:           new FormControl(''),
  };

  // controlNameMap removed – mappings are now derived dynamically
  //         from formFieldsUpdated via buildVisibilityLookups()


  // ── Dynamic lookup maps built from formFieldsUpdated (or future DB data) ──────
  // fieldKey  (e.g. 'first_name', 'hasPHR')      →  control name (e.g. 'firstName')
  private fieldKeyToControlName: Record<string, string> = {};
  // field.field  (e.g. 'has_phr', 'hasSpouseCob') →  control name
  private fieldIdToControlName:  Record<string, string> = {};

  /**
   * Scans the field-config object (formFieldsUpdated or a future DB payload) and
   * builds the two lookup maps used by getFormControlName() and isFieldVisible().
   * Call this whenever the config data changes (currently once after buildActiveFields).
   */
  private buildVisibilityLookups(config: any = this.formFieldsUpdated): void {
    this.fieldKeyToControlName = {};
    this.fieldIdToControlName  = {};

    for (const sKey of Object.keys(config)) {
      const section = config[sKey];
      if (!section || typeof section !== 'object') continue;

      // Top-level field (e.g. terms_and_conditions, advisor_disclosuer)
      if ('type' in section) {
        if (section.control_name) {
          this.fieldKeyToControlName[sKey] = section.control_name;
        }
        if (section.field && section.control_name) {
          this.fieldIdToControlName[section.field] = section.control_name;
        }
        continue;
      }

      // Normal section containing child field definitions
      for (const fKey of Object.keys(section)) {
        const fObj = section[fKey];
        if (!fObj || typeof fObj !== 'object') continue;

        if (fObj.control_name) {
          this.fieldKeyToControlName[fKey] = fObj.control_name;
        }
        if (fObj.field && fObj.control_name) {
          this.fieldIdToControlName[fObj.field] = fObj.control_name;
        }
      }
    }
  }

  /**
   * Resolves the Angular FormControl name for a field.
   * Accepts either:
   *   - a field CONFIG OBJECT  (has .control_name / .field)
   *   - a STRING field key     (looked up in the dynamic map built from config data)
   */
  getFormControlName(fieldOrKey: any): string {
    if (typeof fieldOrKey === 'string') {
      // Dynamic lookup – no static map needed
      return this.fieldKeyToControlName[fieldOrKey] ?? fieldOrKey;
    }
    // Object: prefer control_name, fall back to field property
    return fieldOrKey?.control_name ?? fieldOrKey?.field ?? '';
  }

  get rows(): FormArray {
    return this.tableForm.get('rows') as FormArray;
  }

  addRow() {
    const row = this.formBuilder.group({
      firstName: [
        '',
        Validators.compose([Validators.required, Validators.minLength(1)]),
      ],
      lastName: [
        '',
        Validators.compose([Validators.required, Validators.minLength(1)]),
      ],
      relationship: ['', Validators.required],
      percentage: ['', Validators.required]
    });
    this.rows.push(row);
  }

  removeRow(index: number) {
    this.rows.removeAt(index);
  }
  @ViewChild(SignaturePad) signaturePad!: SignaturePad;
  /** CC payment signature pad — referenced in the CC section of the summary tab */
  @ViewChild('signaturePad1') signaturePad1!: SignaturePad;

  // @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
  //   e.preventDefault();
  // }
  signaturePadOptions: Object = {


    'canvasWidth': 400,
    'canvasHeight': 150
  };
  public cartcheckvalue: boolean = true;
  public plansnexttab: boolean = true;

  // @ViewChild('sigPad')
  // sigPad!: ElementRef<HTMLCanvasElement>;
  // @ViewChild('sigPad') sigPad;
  sigPadElement: any;
  context: any;
  isDrawing = false;
  img: any;
  // @ViewChild('sigPad', { static: false }) sigPad!: ElementRef<HTMLCanvasElement>;

  @ViewChild('canvasElement', { static: false }) canvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasElementpad', { static: false }) canvaspad!: ElementRef<HTMLCanvasElement>;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChild('scrollContainerPlans') scrollContainerPlans!: ElementRef;
  @ViewChild('optionNumberInput') optionNumberInput!: ElementRef;
  @ViewChild('optionPlanDetailsObj') optionPlanDetailsObj!: ElementRef;
  @ViewChild('planCheckdetails') planCheckdetails!: ElementRef;
  @ViewChildren('optionUnseelct') checkboxes!: QueryList<ElementRef>;


  private ctx: CanvasRenderingContext2D | null = null;
  private ctxpad: CanvasRenderingContext2D | null = null;
  private resizeObserver: ResizeObserver | null = null;
  private drawing = false;
  sigPadElementpad: any;
  contextpad: any;
  isDrawingpad = false;

  @ViewChild('sigPad') sigPad: any;
  coverageValue: any;
  minimumCoverage: any; // Set minimum coverage threshold
  extraCoverage: any;
  extraCoverage1: any;
  showSpouseSignature = false;
  showIAFGerrorMessage = false;
  ConfirmModel = false;
  showyellowbar = false
  criticalplancheck = false
  termLifeplancheck = false
  savedFormData: any = {};  // local variable to hold form data

  ngOnInit(): void {

    // setTimeout(() => this.initializeCanvas(), 20000);



    this.currFormType = "gig"


    this.getLanguageTokens()
    this.updateSlider()

    // setTimeout(() => this.initializeCanvas(), 20000);
    // setTimeout(() => this.initializeCanvaspad(), 40000);
    sessionStorage.setItem("timeStamp", new Date().getTime().toString())
    sessionStorage.removeItem("subscriptionCalled");

    this.getIPAddress()
    this.postAnalyticsData()
    this.commonSettings()
    // this.getUserDetails()

    setInterval(() => {

      this.postAnalyticsData()
    }, 30000);

    sessionStorage.setItem("lanToken", 'en')

    sessionStorage.removeItem("fileurl")
    sessionStorage.removeItem("filename")
    sessionStorage.removeItem("signature")
    // this.paymentUri = environment.app.globalgrp + "#/paymentResponse";

    // this.paymentsuccessuri = environment.app.globalgrp + "#/paymentResponse";

    // this.customerid = sessionStorage.getItem("customerId");
    // this.publicapikey = sessionStorage.getItem("publicApiKey");

    // this.sigPadElement = this.sigPad.nativeElement;

    // this.context = this.sigPadElement.getContext('2d');
    // this.context.strokeStyle = 'black';

    if (sessionStorage.getItem("formlink")) {
      this.link = sessionStorage.getItem("formlink")
    } else {
      this.link = sessionStorage.getItem("formlink")

    }

    if (sessionStorage.getItem("paymentMethod")) {
    } else {
      sessionStorage.setItem("paymentMethod", "CC");
    }

    //localgrp
    //globalgrp
    this.fusbillinfocaptchavalue = '6LfVtGwUAAAAALHn9Ycaig9801f6lrPmouzuKF11';
    this.paymentUri = environment.app.globalgrp + this.link + "#/payment/form";

    this.paymentsuccessuri = environment.app.globalgrp + this.link + "#/payment/form";

    this.customerid = sessionStorage.getItem("customerId");
    this.publicapikey = sessionStorage.getItem("publicApiKey");
    // this.testFun();

    let form = 'SHZMOxgC0301';

    this.currForm = this.route.snapshot.params['tierId'] ? "CORP" : "GIG"
 
    // console.log(this.route.snapshot.params['formLink'])
    if (this.route.snapshot.params['formLink'] != undefined && this.currForm == "GIG") {
      this._SignupformService.getDataConfig(this.route.snapshot.params['formLink']).subscribe({
        next: (result: any) => {
          // console.log(result);

          if (result.status == "200") {
            if (result.data.waddellForm) {
              window.open(environment.app.waddellink + this.route.snapshot.params['formLink'], "_self")

            }
            if (result.data.iafgOnly) {


              window.open(environment.app.iafglink + this.route.snapshot.params['formLink'], "_self")

            }

            if (result.data?.cdhppOnly) {
              this.hidePlanFeatures = false
              this.heightCheck = 22
            }
            else {
              this.heightCheck = 16
            }


            if(result.data?.wawanesaEarningsFrequencyList && result.data?.wawanesaEarningsFrequencyList?.length > 0){
              this.wawanesaEarningsFrequencyList = result.data?.wawanesaEarningsFrequencyList ?? [
                {
                  "label": "Hourly",
                  "value": "Hourly"
                },
                {
                  "label": "Weekly",
                  "value": "Weekly"
                },
                {
                  "label": "Bi-weekly",
                  "value": "Bi-weekly"
                },
                {
                  "label": "Monthly",
                  "value": "Monthly"
                },
                {
                  "label": "Annually",
                  "value": "Annually"
                }
              ]
            }

            this.configplanEnrollmentDateFull =
              result.data.validations.customer.planEnrollmentDatesFullMonth;
            this.paymentPlatform = result.data?.form?.broker?.paymentPlatform;
            let brokerspecific
            if (result.data.form.broker.customData) {
              brokerspecific = typeof result.data.form.broker.customData == 'string' ? JSON.parse(result.data.form.broker.customData) : result.data.form.broker.customData



              // if (brokerspecific['attachWawanesaForm'] && brokerspecific['attachWawanesaForm'] === true) {
              //   this.configplanEnrollmentDateFull = result.data.validations.customer.planEnrollmentDatesSpecificFullMonth;
              // } else {
              //   this.configplanEnrollmentDateFull = result.data.validations.customer.planEnrollmentDatesFullMonth;
              // }

              if (brokerspecific['hidePlanEnrollmentDate'] && brokerspecific['hidePlanEnrollmentDate'] === true) {
                // alert(brokerspecific['defaultPlanEnrollmentDate'])
                this.configplanEnrollmentDateFull = []
                this.configplanEnrollmentDateFull.push(brokerspecific['defaultPlanEnrollmentDateMonth']);
                this.enrollmentDateLocked = true; // prevent buildEnrollmentDates() from overwriting
              }
              // } else {

              //   this.configplanEnrollmentDateFull = result.data.validations.customer.planEnrollmentDatesFullMonth;
              // }

              if (brokerspecific['showBeneficiaryInformation'] && brokerspecific['showBeneficiaryInformation'] === true) {
                this.showBenificiaryForm = true
                this.showBenificiaryFormCond = true
                // this.benficiary = true

              }else {
                this.showBenificiaryForm = false
                this.showBenificiaryFormCond = false
                // this.benficiary = false


              }
            }

           
            
            if (result.data.kixcareOnly) {


              window.open(environment.app.kixcare + this.route.snapshot.params['formLink'], "_self")

            }
            if (result.data.phrOnly) {
              // alert("1")
              this.phrOption = true;
              // console.log('this.phrOption',this.phrOption)
            }
            else {
              // alert("2")
              this.phrOption = false;
            }
            this.iafgCheck = result.data.iafg
            sessionStorage.setItem("formlink", this.route.snapshot.params['formLink']);
            sessionStorage.setItem("enableCloey", result.data?.form?.broker?.enableCloey);

            let showAgenq = false;
            let agentContainer: any = document.getElementById('agent-container');
            showAgenq = sessionStorage.getItem("enableCloey") == "true" ? true : false;

            console.log('showAgenq', showAgenq)
            if (showAgenq) {
              console.log('agentContainer true', agentContainer)
              agentContainer.style.display = 'flex';
            } else {
              console.log('agentContainer false', agentContainer)
              agentContainer.style.display = 'none';
            }

            this.formConfigResult = result.data;
            console.log(typeof result.data.dynamicAllFormFields)
            // this.formFieldsUpdated = typeof result.data.dynamicAllFormFields == 'string' ? JSON.parse(result.data.dynamicAllFormFields) : result.data.dynamicAllFormFields;
            this.formFieldsUpdated = formFieldsUpdated;
            this.determineFormType(); // ← dynamic field visibility


            if(result.data.vikingCare){
              this.buildActiveBeneficiaryFields()
            }
            this.configprovinceres = result.data.provinces.sort((a: any, b: any) =>
              a.shortName > b.shortName ? 1 : -1
            );
            this.languageTokensArray = result.data.language_details.languageTokens;
            this.beneficariesDetails = result.data.validations.beneficiaries;
            console.log(result.data.validations.all)
            this.allValidations = result.data.validations.all;


            // this.configplanEnrollmentDateFull =
            //   result.data.validations.customer.planEnrollmentDatesFullMonth;
            setTimeout(() => {
              this.pdfData = this.formConfigResult.links.termsConditions;

            }, 10000);
            // this.lang = {};

            // for (let token of this.languageTokensArray) {
            //   this.lang[token.key] = token.value;
            // }
            sessionStorage.setItem(
              "brokerlogo",
              environment.app.logourl + this.formConfigResult.logo
            );
            sessionStorage.setItem("parentBrokerLogo", '');

            sessionStorage.setItem(
              "brokerlink",
              // environment.app.grp + result.data.form.broker.link
              environment.app.grp + result.data.link

            );
            sessionStorage.setItem(
              "formName",
              // environment.app.grp + result.data.form.broker.link
              result.data.form.name

            );

            result.data.form.name
            sessionStorage.setItem(
              "provincelist",
              JSON.stringify(result.data.broker_licensed_provinces)
            );
            sessionStorage.setItem(
              "countrydetails",
              JSON.stringify(result.data.countries)
            );
            this.meta.updateTag(
              { name: 'keywords', content: this.formConfigResult.form.keywords },
              'name=keywords'
            );
            this.meta.updateTag(
              {
                name: 'description',
                content: this.formConfigResult.form.description,
              },
              'name=description'
            );

            // this.meta.updateTag({
            //   property: "og:url",
            //   content: environment.app.globalgrp + this.router.url,
            // });
            this.meta.updateTag({
              property: 'og:title',
              content: this.formConfigResult.form.broker.name,
            });
            this.meta.updateTag({ property: 'og:type', content: '' });
            this.meta.updateTag({
              property: 'og:image',
              content: environment.app.grp + this.formConfigResult.logo,
            });
            this.meta.updateTag({
              property: 'og:description',
              content: this.formConfigResult.form.broker.description,
            });

            if (
              !this.formConfigResult.form.broker.discoverable ||
              this.formConfigResult.form.broker.discoverable == 0
            ) {
              this.meta.addTag({ name: 'robots', content: 'noindex' });
            }
          }
          else {
            this.router.navigate(["/"]);
            sessionStorage.setItem("pagelink", "GIG");
            this.ShowModelPopup = true
            this.ShowModelPopupMessage = result.message ? result.message : result.error
            this.ShowModelPopupTitle = this.lang.Info

          }


        },
        error: (error) => {
          if ([0, 500, 501, 502, 503].includes(error.status)) {


            this.ShowModelPopup = true
            this.ShowModelPopupMessage = this.lang?.Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience ?? 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.';
            this.ShowModelPopupTitle = this.lang?.Info ?? 'Info'
          }
          else {
            this.router.navigate(["/"]);
            sessionStorage.setItem("pagelink", "GIG");
            this.ShowModelPopup = true
            this.ShowModelPopupMessage = error.error.message
              ? error.error.message
              : error.error.error,
              this.ShowModelPopupTitle = this.lang.Info
            // Swal.fire({
            //   title: this.lang.Info,
            //   html: error.error.message
            //     ? error.error.message
            //     : error.error.error,

            //   showCancelButton: false,
            //   width: "30%",
            //   confirmButtonText: "Ok",
            //   // customClass: {
            //   //   header: 'swal-header-orange',
            //   //   popup: 'custom-swal-dialog',
            //   //   confirmButton: 'custom-ok-button-class',
            //   // }
            // }).then((result) => {
            //   if (result.value) {
            //     this.router.navigate(["error"]);
            //     if (
            //       error.error.message.includes("incomplete") ||
            //       error.error.message.includes(
            //         "The email address already exists"
            //       )
            //     ) {
            //       let formLink = sessionStorage.getItem("formlink");
            //       sessionStorage.clear();
            //       this.router.navigate([formLink]);
            //       window.location.reload();
            //     }
            //   } else {
            //   }
            // });
          }
        },
      });
    } else {
       if (this.route.snapshot.params['formLink'] != undefined && this.route.snapshot.params['tierId'] != undefined && this.currForm == "CORP") {
          this._CorporateService.getCorporateData(this.route.snapshot.params['formLink'], this.route.snapshot.params['tierId'], this.route.snapshot.params['employeeLink'] ?? '').subscribe({
                next: (result: any) => {
                  // //console.log(result);
        
                  if (result.status == "200") {
                    this.showContent = true
                    // if (confirm('Are you sure to delete?')) {
                    //   alert("!")
                    // }
                    // if (result.data.waddellForm) {
                    //   window.open(environment.app.waddellink, "_self")
                    // }


                    // get the broker custom data

                    let brokerCustomData = JSON.parse(result?.data?.form?.broker?.customData ?? "{}");
                    let clinicOptionsApplicablePlanLevels = result?.data?.clinicOptionsApplicablePlanLevels ?? [];
                    sessionStorage.setItem("clinicOptionsApplicablePlanLevels", JSON.stringify(clinicOptionsApplicablePlanLevels));


                    let brokerData_ = result?.data?.form?.broker ?? {};

                    sessionStorage.setItem("currBroker", JSON.stringify(brokerData_))

                    if(brokerCustomData){
                      this.signupFormDynamicStyles = brokerCustomData?.signupFormConfigurations?.css ?? null;
                      this.signupFormConfigurationsOverride = brokerCustomData?.signupFormConfigurationsOverride
                      this.hideCompanyPaidPlans = brokerCustomData?.signupFormConfigurations?.hideCompanyPaidPlans
                      this.hidePlanCategorization = brokerCustomData?.signupFormConfigurations?.hidePlanCategorization
                      this.plansTemplate = brokerCustomData?.signupFormConfigurations?.plansTemplate
                      this.sendTrueOrFalseForAddedToPolicy = brokerCustomData?.signupFormConfigurations?.sendTrueOrFalseForAddedToPolicy
                    }
        
        
                    
                    if (result.data.waddellForm) {
        
                      window.open(environment.app.waddellink + this.route.snapshot.params['formLink'], "_self")
                    }
                    if (result.data.iafgOnly) {
        
                      window.open(environment.app.iafglink + "/corporate/" + this.route.snapshot.params['formLink'], "_self")
                    }


        
                    this.configplanEnrollmentDateFull =
                      result.data.validations.customer.planEnrollmentDatesFullMonth;
                    this.paymentPlatform = result?.data?.form?.broker?.paymentPlatform ?? 'Staxbill';
                    console.log('this.paymentPlatform', this.paymentPlatform)
                    sessionStorage.setItem('paymentPlatform', this.paymentPlatform);
                    let brokerspecific
                    if (result?.data?.form?.broker?.customData) {
                      brokerspecific = typeof result.data.form.broker.customData == 'string' ? JSON.parse(result.data.form.broker.customData) : result.data.form.broker.customData
        
                      if (brokerspecific['planEnrollmentDateType'] && brokerspecific['planEnrollmentDateType'] == 'calendar') {
                        this.showCalendar = true;
                      } else {
                        this.showCalendar = false;
                      }
                      if (brokerspecific['planEnrollmentDatesSpecific'] && brokerspecific['planEnrollmentDatesSpecific'] === true) {
                        this.configplanEnrollmentDateFull = result.data.validations.customer.planEnrollmentDatesSpecificFullMonth;
                      } else {
                        this.configplanEnrollmentDateFull = result.data.validations.customer.planEnrollmentDatesFullMonth;
                      }
        
        
                      if (brokerspecific['showBeneficiaryInformation'] && brokerspecific['showBeneficiaryInformation'] === true) {
                        this.showBenificiaryForm = true
                        this.showBenificiaryFormCond = true
                        // this.benficiary = true
        
                      } else {
                        this.showBenificiaryForm = false
                        this.showBenificiaryFormCond = false
                        // this.benficiary = false
        
        
                      }
                    }
        
        
                    sessionStorage.setItem("enableCloey", result.data?.form?.broker?.enableCloey);
        
                    let showAgenq = false;
                    let agentContainer: any = document.getElementById('agent-container');
                    showAgenq = sessionStorage.getItem("enableCloey") == "true" ? true : false;
        
                    console.log('showAgenq', showAgenq)
                    if (showAgenq) {
                      console.log('agentContainer true', agentContainer)
                      agentContainer.style.display = 'flex';
                    } else {
                      console.log('agentContainer false', agentContainer)
                      agentContainer.style.display = 'none';
                    }
        
                    this.corporateAutoPlanSelection =
                      result.data.form.broker.corporateAutoPlanSelection;
                    this.beneficariesDetails = result.data.validations.beneficiaries
        
                    sessionStorage.setItem("formlink", this.route.snapshot.params['formLink']);
                    this.employercheck = result.data.form.requireEmployerName == true ? true : false;
        
                    if (this.employercheck == true) {
                      this.userForm
                        .get('employername')
                        ?.setValidators([Validators.required]);
                      this.userForm.get('employername')?.updateValueAndValidity();
        
                    }
        
                    else {
                      this.userForm.get('employername')?.clearValidators();
                      this.userForm.get('employername')?.updateValueAndValidity();
                    }
                    this.formConfigResult = result.data;
                    // Load field config from commonFunction (same as GIG flow)
                    console.log(typeof result.data.dynamicAllFormFields)
                    // this.formFieldsUpdated = typeof result.data.dynamicAllFormFields == 'string' ? JSON.parse(result.data.dynamicAllFormFields) : result.data.dynamicAllFormFields;
                    this.formFieldsUpdated = formFieldsUpdated;
                    this.determineFormType()

                    this.customerPaymentMethod =
                      this.formConfigResult?.form?.broker?.useCreditCardPaymentMethod ? 'CC' :
                        this.formConfigResult?.form?.broker?.usePadPaymentMethod ? 'PAD' : ''
                    sessionStorage.setItem('payment', this.customerPaymentMethod)
        
                    // 608 - turbo drill
                    if (result.data.phrOnly) {
                      // alert("1")
                      this.phrOption = true;
                      // console.log('this.phrOption',this.phrOption)
                    }
                    else {
                      // alert("2")
                      this.phrOption = false;
                    }
        
                    sessionStorage.setItem("portal", "corporate");
                    sessionStorage.setItem("formlink", this.route.snapshot.params['formLink']);
                    sessionStorage.setItem("tierKey", this.route.snapshot.params['tierId']);
                    sessionStorage.setItem("employeelink", this.route.snapshot.params['employeeLink']);
        
                    this.applicantFirstName = result?.data?.employee?.firstName || "";
                    this.applicantLastName = result?.data?.employee?.lastName || "";
                    this.applicantEmail = result?.data?.employee?.email || "";
                    this.applicantPhoneNumber = result?.data?.employee?.phone || "";
                    this.companyName = result?.data?.form?.broker?.name || "";
                    // Prefill company_name field for NHLAA CORP (field is read-only/disabled)
                    if (this.currFormType === 'nhlaa' && this.companyName) {
                      const companyCtrl = this.userForm.get('company_name');
                      if (companyCtrl) companyCtrl.setValue(this.companyName, { emitEvent: false });
                    }
                    this.applicantDateofhire = ""
                    this.deltaCompanyTax = result?.data?.deltaCompanyTax;
                    (this.payrolldeduction = [
                      {
                        display: "Employee's payroll deduction",
                        label: "YES",
                      },
                      {
                        display: "Employee direct pay through CC/PAD",
                        label: "NO",
                      },
                    ]),
                      this.configprovinceres = result?.data?.provinces?.sort((a: any, b: any) =>
                        a.shortName > b.shortName ? 1 : -1
                      );
                    if (result.data?.working_provinces) {
                      this.configpworkingrovinceres = result.data?.working_provinces.sort(
                        (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
                      );
                    } else {
                      this.configpworkingrovinceres = result.data?.provinces.sort((a: any, b: any) =>
                        a.shortName > b.shortName ? 1 : -1
                      );
                    }
                    this.applicantPlanEnrollmentDate = this._CustomDatePipe.transform(result.data?.form?.broker?.policyStartDate) || ""
        
                    this.languageTokensArray = result.data?.language_details?.languageTokens;
        
                    setTimeout(() => {
                      this.pdfData = this.formConfigResult.links.termsConditions;
        
                    }, 10000);
                    // this.lang = {};
        
                    // for (let token of this.languageTokensArray) {
                    //   this.lang[token.key] = token.value;
                    // }
                    sessionStorage.setItem(
                      "brokerlogo",
                      environment.app.logourl + this.formConfigResult.logo
                    );
                    sessionStorage.setItem(
                      "brokerlink",
                      // environment.app.grp + result.data.form.broker.link
                      environment.app.grp + result.data?.link
        
                    );
                    sessionStorage.setItem(
                      "formName",
                      // environment.app.grp + result.data.form.broker.link
                      result.data.form.name
        
                    );
                    this.formName_ = result.data.form.name ?? ""
                    this.isdandjform = this.formName_.replace(/\s/g, "").toLowerCase().includes("d&j")
                    const control = this.userForm.get('hours_per_week');
        
                    control?.setValidators([
                      Validators.required,
                      validatehoursperweek(this.isdandjform)
                    ]);
        
                    if (this.isdandjform) {
                      this.showBenificiaryFormCond = true
                      const today = new Date();
                      this.minDate.setFullYear(today.getFullYear() - 80);
                      this.bsConfig.minDate = this.minDate;
                    }
        
                    control?.updateValueAndValidity();
        
                    this.usePADPaymentMethod = result.data?.form?.usePadPaymentMethod;
        
                    this.useCreditCardPaymentMethod =
                      result.data.form.useCreditCardPaymentMethod;
        
                    this.requireSpouseEmail = result.data?.form?.requireSpouseEmail;
        
                    this.requireDentalHealthCoverage =
                      result.data.form.requireDentalHealthCoverage;
        
                    this.warnRequiredDependantMedicalExam =
                      result.data.form.warnRequiredDependantMedicalExam;
        
                    sessionStorage.setItem(
                      "provincelist",
                      JSON.stringify(result.data.broker_licensed_provinces)
                    );
                    this.brokerType = result.data.form.formType;
        
                    sessionStorage.setItem("brokerType", this.brokerType);
        
        
        
        
        
                    // this._sanitizer.bypassSecurityTrustHtml(termsApply)
        
                    if (result.data.form !== null) {
                      // this.brokerConfig = result.data.form.broker.logo || "";
        
                      if (result.data.logo) {
                        if (result.data.logo.includes("https://")) {
                          this.brokerConfig = null;
                        } else {
                          this.brokerConfig =
                            environment.app.logourl + result.data.logo;
                        }
                      } else {
                        this.brokerConfig = null;
                      }
        
                      //this.consoleMessage(this.brokerConfig)
        
                      sessionStorage.setItem("brokerlogo", this.brokerConfig);
                      this.payrolldeduction =  result?.data?.form?.broker?.payrollDeduction == "NO" ? false : true;
                      sessionStorage.setItem(
                        "payrollDeduction",
                        result.data.form.broker.payrollDeduction
                      );
                      sessionStorage.setItem(
                        "brokerlink",
                        // environment.app.grp + result.data.form.broker.link
                        environment.app.grp + result.data.link
                      );
        
                      let parentlogo: any = null;
                      if (
                        result.data.parentLogo &&
                        result.data.parentLogo != result.data.logo
                      ) {
                        parentlogo = environment.app.logourl + result.data.parentLogo;
                      }
                      sessionStorage.setItem("parentBrokerLogo", parentlogo);
                    } else {
                      this.router.navigate(["/"]);
                      sessionStorage.setItem("pagelink", "Corporate");
        
                    }
        
                    this.configPlanEnrollmentDate =
                      result.data.validations.customer.planEnrollmentDatesFullMonth;
                    sessionStorage.setItem(
                      "countrydetails",
                      JSON.stringify(result.data.countries)
                    );
        
                    result.data.countries.forEach((element: any) => {
                      this.currency = element.currency;
                      this.currencySymbol = element.currencySymbol;
                    });
        
                    sessionStorage.setItem(
                      "provincelist",
                      JSON.stringify(result.data.broker_licensed_provinces)
                    );
                    sessionStorage.setItem(
                      "countrydetails",
                      JSON.stringify(result.data.countries)
                    );
                    this.meta.updateTag(
                      { name: 'keywords', content: this.formConfigResult.form.keywords },
                      'name=keywords'
                    );
                    this.meta.updateTag(
                      {
                        name: 'description',
                        content: this.formConfigResult.form.description,
                      },
                      'name=description'
                    );
        
                    // this.meta.updateTag({
                    //   property: "og:url",
                    //   content: environment.app.globalgrp + this.router.url,
                    // });
                    this.meta.updateTag({
                      property: 'og:title',
                      content: this.formConfigResult.form.broker.name,
                    });
                    this.meta.updateTag({ property: 'og:type', content: '' });
                    this.meta.updateTag({
                      property: 'og:image',
                      content: environment.app.grp + this.formConfigResult.logo,
                    });
                    this.meta.updateTag({
                      property: 'og:description',
                      content: this.formConfigResult.form.broker.description,
                    });
        
                    if (
                      !this.formConfigResult.form.broker.discoverable ||
                      this.formConfigResult.form.broker.discoverable == 0
                    ) {
                      this.meta.addTag({ name: 'robots', content: 'noindex' });
                    }
                  }
                  else {
                    this.showContent = false
                    this.router.navigate(["/"]);
                    sessionStorage.setItem("pagelink", "Corporate");
        
                    this.ShowModelPopup = true
                    this.ShowModelPopupMessage = result.message ? result.message : result.error
                    this.ShowModelPopupTitle = this.lang.Info
                    this.showPageNotFound = result.message ? result.message : result.error
        
                  }
        
        
                },
                error: (error) => {
                  if ([0, 500, 501, 502, 503].includes(error.status)) {
        
                    this.showContent = false
                    this.ShowModelPopup = true
                    this.ShowModelPopupMessage = this.lang?.Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience ?? 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.';
                    this.ShowModelPopupTitle = this.lang?.Info ?? 'Info'
                  }
                  else {
                    this.showContent = false
                    this.router.navigate(["/"]);
                    sessionStorage.setItem("pagelink", "Corporate");
                    // <app-header> </app-header>
                    // <app-footer></app-footer>
        
                    this.ShowModelPopup = true
                    this.ShowModelPopupMessage = error.error.message
                      ? error.error.message
                      : error.error.error,
                      this.ShowModelPopupTitle = this.lang.Info
                    // Swal.fire({
                    //   title: this.lang.Info,
                    //   html: error.error.message
                    //     ? error.error.message
                    //     : error.error.error,
        
                    //   showCancelButton: false,
                    //   width: "30%",
                    //   confirmButtonText: "Ok",
                    //   // customClass: {
                    //   //   header: 'swal-header-orange',
                    //   //   popup: 'custom-swal-dialog',
                    //   //   confirmButton: 'custom-ok-button-class',
                    //   // }
                    // }).then((result) => {
                    //   if (result.value) {
                    //     this.router.navigate(["error"]);
                    //     if (
                    //       error.error.message.includes("incomplete") ||
                    //       error.error.message.includes(
                    //         "The email address already exists"
                    //       )
                    //     ) {
                    //       let formLink = sessionStorage.getItem("formlink");
                    //       sessionStorage.clear();
                    //       this.router.navigate([formLink]);
                    //       window.location.reload();
                    //     }
                    //   } else {
                    //   }
                    // });
                  }
                },
              });
       } else {
         // Neither GIG (no formLink) nor CORP (no tierId) — redirect to root
         this.router.navigate(["/"]);
         sessionStorage.setItem("pagelink", this.currForm);
       }
    }
    // this.demofill()
  }


  determineFormType(): void {

    // Start from the route-level form type (GIG or CORP), then override from API flags
    this.currFormType = this.currForm?.toLowerCase() ?? 'gig'; // normalise to lowercase ('gig'/'corp')
    if (this.formConfigResult?.iafg) this.currFormType = 'iafg';
    if (this.formConfigResult?.nhla) this.currFormType = 'nhlaa';
    if (this.formConfigResult?.allstateCI) this.currFormType = 'allstate';
    if (this.formConfigResult?.dandj) this.currFormType = 'dandj';
    if (this.formConfigResult?.vikingCare)  this.currFormType = 'viking';


    // Written on both branches: sessionStorage survives a form switch inside the same tab,
    // so a stale 'true' would keep NHLAA-only styling on the next form the user opens.
    sessionStorage.setItem("isNhlaaSignup", this.currFormType == "nhlaa" ? 'true' : 'false')

    // this.buildEnrollmentDates(); // adjust plan enrollment date options based on form type
    this.buildActiveFields();

    // Company name prefill is handled separately after companyName is assigned from API data
  }

  /**
   * Builds the plan enrollment date dropdown options dynamically.
   *
   * - For viking:  start from vikingStartDate if the normal next-month window starts before it,
   *                otherwise fall back to normal (handles "from [vikingStartDate's month] show normal").
   * - For others:  start from next calendar month.
   *
   * Always produces 3 consecutive first-of-month options in "MMM-DD-YYYY" format.
   */
  private buildEnrollmentDates(): void {
    // Broker has hard-set a specific enrollment date — don't override it
    if (this.enrollmentDateLocked) return;

    const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const today = new Date();

    // First day of next calendar month (the normal earliest enrollment date)
    const normalStart = new Date(today.getFullYear(), today.getMonth() + 1, 1);

    let startDate: Date;

    if (this.currFormType === 'viking') {
      // Local midnight: new Date('2026-07-01') is UTC midnight, which is 30 June locally
      // in North America and would open the enrollment window a month early there.
      const vikingStart = toLocalDate(this.vikingStartDate) ?? normalStart;
      // If we haven't yet reached vikingStartDate, push start forward to it.
      // Once normalStart >= vikingStart the regular window is already at or past viking's start,
      // so we just use normal — this naturally handles "from that month show normal".
      startDate = normalStart < vikingStart ? vikingStart : normalStart;
    } else {
      startDate = normalStart;
    }

    // Generate 3 consecutive first-of-month labels
    this.configplanEnrollmentDateFull = [];
    for (let i = 0; i < 3; i++) {
      const d = new Date(startDate.getFullYear(), startDate.getMonth() + i, 1);
      this.configplanEnrollmentDateFull.push(
        `${MONTHS[d.getMonth()]}-01-${d.getFullYear()}`
      );
    }
  }


getSectionFieldKeys(sectionKey: string): string[] {
  const section = this.activeFields[sectionKey];


  if (!section) return [];

  this.allsectionData = {
    ...this.allsectionData,
    ...section
  };

  // Support per-form-type render order overrides (form_order.nhlaa etc.) so that
  // specific fields can be repositioned in the grid for one form type without
  // affecting any other form types.
  return Object.keys(section).sort((a, b) => {
    const aId = section[a].form_order?.[this.currFormType] ?? section[a].id ?? 0;
    const bId = section[b].form_order?.[this.currFormType] ?? section[b].id ?? 0;
    return aId - bId;
  });
}


isSectionVisible(sectionKey: string): boolean {
  const section = this.activeFields[sectionKey];
  if (!section) return false;

  return Object.values(section).some((field: any) =>
    this.isFieldVisible(field)
  );
}


  getSectionLabel(sectionKey: string): string {
    const labels: Record<string, string> = {
      personal_information:  '',
      prior_group_coverage_confirmation:    this.lang?.Prior_Group_Coverage_Confirmation ?? 'Prior Group Coverage Confirmation',
      phr_questions:         '',
      spouse_information:    this.lang?.Spouse_Information ?? 'Spouse Information',
      children_information:  this.lang?.Dependent_Children_Information ?? 'Dependent Children Information',
      // beneficiary_information: this.lang?.Beneficiary_Information ?? 'Beneficiary Information',
      // smoker_information:    this.lang?.Smoker_Information ?? 'Smoker Information',
      terms_section:         '',
    };
    return labels[sectionKey] ?? '';
  }
 
  showDividerBefore(sectionKey: string): boolean {
    return sectionKey !== 'personal_information';
  }


  
 buildActiveFields(): void {
    const result: Record<string, Record<string, any>> = {};
    const sectionOrder: string[] = [];

    const parentKeys = Object.keys(this.formFieldsUpdated as any);

    for (const pKey of parentKeys) {
      const parentObj = (this.formFieldsUpdated as any)[pKey];
      if (!parentObj || typeof parentObj !== 'object') continue;

      if ('type' in parentObj) {
        const field = parentObj;
        if(parentObj['control_name'] == 'countryOrigin'){
          parentObj['options'] = countriesData
        }
        if (field[this.currFormType]) {
          const bucket = 'terms_section';
          if (!result[bucket]) {
            result[bucket] = {};
            sectionOrder.push(bucket);
          }
          result[bucket][pKey] = field;
        }
        continue;
      }

      for (const cKey of Object.keys(parentObj)) {
        const childObj = parentObj[cKey];
        if (!childObj || typeof childObj !== 'object') continue;

        if (childObj.type !== 'blank' && (childObj.control_name === '' || childObj.control_name == null)) continue;

        if (childObj[this.currFormType]) {
          if (!result[pKey]) {
            result[pKey] = {};
            sectionOrder.push(pKey);
          }
          result[pKey][cKey] = childObj;
        }
      }
    }

    this.activeFields   = result;
    this.activeSections = sectionOrder;

    this.buildVisibilityLookups();

    this.buildDynamicForm();
    this.watchComputedFields();
  }


   buildDynamicForm(): void {
    const controls: Record<string, AbstractControl> = {
      ...this.permanentControls,
    };

    for (const sectionKey of this.activeSections) {
      const section = this.activeFields[sectionKey];

      for (const fieldKey of Object.keys(section)) {
        const field       = section[fieldKey];
        const controlName = this.getFormControlName(field);

        if (!controlName) continue;
        if (controls[controlName]) continue;

        const validators = this.buildValidators(field);
        const initialValue = field.type === 'datepciker'
          ? (field.defaultvalue || null)
          : (field.defaultvalue ?? '');
        controls[controlName] = new FormControl(
          initialValue,
          validators
        );
      }
    }

    this.userForm = new FormGroup(controls, { updateOn: 'change' });

    this.syncProvinceToCoverageFields();
  }

  private syncProvinceToCoverageFields(): void {
    const fillCoverageFromProvince = () => {
      const provinceValue = this.userForm.get('province')?.value;
      if (!provinceValue) return;
      const coverageCtrl = this.userForm.get('provinceOfCoverage');
      if (coverageCtrl && !coverageCtrl.value) {
        coverageCtrl.setValue(provinceValue, { emitEvent: false });
        coverageCtrl.markAsTouched();
      }
      const spouseCoverageCtrl = this.userForm.get('spouseProvinceOfCoverage');
      if (spouseCoverageCtrl && !spouseCoverageCtrl.value) {
        spouseCoverageCtrl.setValue(provinceValue, { emitEvent: false });
      }
    };

    const provinceCtrl = this.userForm.get('province');
    if (!provinceCtrl) return;

    // When province changes, fill coverage fields if empty
    provinceCtrl.valueChanges.subscribe(() => fillCoverageFromProvince());

    // When PHC is set to "yes", Province of Coverage becomes visible — fill it immediately
    const phcCtrl = this.userForm.get('provincial_health_coverage');
    if (phcCtrl) {
      phcCtrl.valueChanges.subscribe((val: string) => {
        if (val === 'yes') fillCoverageFromProvince();
        if (val === 'no' && !this._suppressPHCModal && this.currFormType === 'nhlaa') {
          this.noProvincialCoverageModal = true;
        }
      });
    }

    // When spouse health card is set to "yes", Spouse Province of Coverage becomes visible — fill it
    const spouseHealthCardCtrl = this.userForm.get('spouseHealthCard');
    if (spouseHealthCardCtrl) {
      spouseHealthCardCtrl.valueChanges.subscribe((val: string) => {
        if (val === 'yes') {
          const provinceValue = this.userForm.get('province')?.value;
          if (!provinceValue) return;
          const spouseCoverageCtrl = this.userForm.get('spouseProvinceOfCoverage');
          if (spouseCoverageCtrl && !spouseCoverageCtrl.value) {
            spouseCoverageCtrl.setValue(provinceValue, { emitEvent: false });
          }
        }
      });
    }

    // Initial sync for pre-filled data
    fillCoverageFromProvince();
  }

  private watchComputedFields(): void {
    for (const sectionKey of this.activeSections) {
      const section = this.activeFields[sectionKey];
      for (const fieldKey of Object.keys(section)) {
        const field = section[fieldKey];
        if (!field.visible_if_computed || !this.isRequired(field)) continue;

        const controlName = this.getFormControlName(fieldKey);
        const control = this.userForm.get(controlName);
        if (!control) continue;

        const computed = field.visible_if_computed;
        const watchedControlName =
          this.fieldIdToControlName[computed.field] ??
          this.fieldKeyToControlName[computed.field] ??
          computed.field;
        const watchedControl = this.userForm.get(watchedControlName);

        const syncValidator = () => {
          if (this.isFieldVisible(field)) {
            control.setValidators([Validators.required]);
          } else {
            control.clearValidators();
          }
          control.updateValueAndValidity({ emitEvent: false });
        };

        syncValidator();
        if (watchedControl) {
          watchedControl.valueChanges.subscribe(() => syncValidator());
        }
      }
    }
  }


  private buildValidators(field: any): any[] {
    const v: any[] = [];

    // visible_if_computed fields get validators applied dynamically via watchComputedFields()
    if (this.isRequired(field) && !field.visible_if_computed) {
      if (field.type === 'checkbox') {
        // Validators.required passes for `false`; use requiredTrue so unchecked boxes are caught
        v.push(Validators.requiredTrue);
      } else {
        v.push(Validators.required);
      }
    }

    switch (field.type) {
      case 'email':
        v.push(Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/));
        break;

      case 'phone':
        v.push(Validators.minLength(17));
        v.push(Validators.maxLength(17));
        v.push(Validators.pattern(/^[^A-Za-z@#$%&*{}'";:<>?]+$/));
        break;

      case 'text':
        if (field.key === 'postal_code' || field.key === 'spouse_postal_code') {
          v.push(Validators.pattern(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/));
        }
        if (field.control_name === 'nhlaaMemberId') {
          v.push(Validators.pattern(/^\d{1,5}$/));
          v.push(Validators.maxLength(5));
        }
        break;
    }

    return v;
  }


  isRequired(field: any): boolean {
    if (Array.isArray(field.required)) {
      return field.required.includes(this.currFormType);
    }
    return !!field.required;
  }
 
  isFieldDisabled(field: any): boolean {
    if (Array.isArray(field.disabled)) {
      return field.disabled.includes(this.currFormType);
    }
    return !!field.disabled;
  }


onSpouseSameAddressChange(event: any) {
  const isChecked = event.target.checked;



  if(isChecked){
    // get spouseaddress keys
    // get member address keys

    // prefill the spouse information
    console.log(this.userForm.value);
    this.userForm.patchValue({
      spouse_street_address_line1: this.userForm.get('street_address_line1')?.value,
      spouse_street_address_line2: this.userForm.get('street_address_line2')?.value,
      spouseProvince: this.userForm.get('province')?.value,
      spousePostalCode: this.userForm.get('postal_code')?.value,
      spousePoBoxAddress: this.userForm.get('poBoxAddress')?.value,
      spouseCity: this.userForm.get('city')?.value,
      spouseApt: this.userForm.get('apt')?.value,
    });
  }else{
    // empty the spouse address information
     this.userForm.patchValue({
      spouse_street_address_line1: '',
      spouse_street_address_line2: '',
      spouseProvince: '',
      spousePostalCode: '',
      spousePoBoxAddress: '',
      spouseCity: '',
      spouseApt: '',
    });
  }
}


  
isFieldVisible(field: any): boolean {

  if (field.control_name == "has_child" && this.userForm.get(this.getFormControlName('has_child'))?.value == "yes") {
    const noOfChildrenControl = this.userForm.get('no_of_children');
    if (noOfChildrenControl) {
      noOfChildrenControl.setValue(1);
    }
  }

    if (field.visible_if_computed) {
    const computedVisible = this.evaluateComputedCondition(field.visible_if_computed);
    // if also has regular visible_if, both must pass
    if (!computedVisible) return false;
  }

  if (!field.visible_if) return true;

  // ── NEW: handle array of conditions (AND logic) ──────────────
  if (Array.isArray(field.visible_if)) {
    return field.visible_if.every((condition: any) =>
      this.evaluateVisibleIfCondition(condition)
    );
  }
  // ─────────────────────────────────────────────────────────────

  // single condition (existing logic)
  return this.evaluateVisibleIfCondition(field.visible_if);
}


private evaluateComputedCondition(computed: any): boolean {
  const watchControlName =
    this.fieldIdToControlName[computed.field]  ??
    this.fieldKeyToControlName[computed.field] ??
    computed.field;

  const liveValue = this.userForm?.get(watchControlName)?.value;

  switch (computed.type) {

    case 'date_within_days': {
      if (!liveValue) return false;
      // Whole calendar days apart, parsed in local time and compared as UTC so neither
      // the browser timezone nor a DST change in between can shift the count.
      const diffDays = daysBetween(liveValue, new Date());
      if (diffDays === null) return false;
      // show if retirement is within X days from today (past or future)
      return Math.abs(diffDays) <= computed.days;
    }

    // add more types here in future without touching isFieldVisible
    // case 'value_greater_than': ...
    // case 'value_less_than': ...

    default:
      return true;
  }
}

// extracted into reusable method
private evaluateVisibleIfCondition(condition: any): boolean {
  const visibleIfRef = condition.field as string ?? condition.control_name as string;
  const expectedValue = condition.value;

  const watchControlName =
    this.fieldIdToControlName[visibleIfRef]  ??
    this.fieldKeyToControlName[visibleIfRef] ??
    visibleIfRef;

  const liveValue = this.userForm?.get(watchControlName)?.value;

  // boolean (checkbox)
  if (typeof expectedValue === 'boolean') {
    return liveValue === expectedValue || Boolean(liveValue) === expectedValue;
  }

  // array of allowed values (OR logic within one condition)
  if (Array.isArray(expectedValue)) {
    return expectedValue.includes(liveValue);
  }

  // string match
  return liveValue === expectedValue;
}

 
 

  // Add this method to your component
updateValidatorsBasedOnVisibility(): void {
  for (const sectionKey of this.activeSections) {
    const section = this.activeFields[sectionKey];
    for (const fieldKey of Object.keys(section)) {
      const field = section[fieldKey];
      const controlName = this.getFormControlName(fieldKey);
      if (!controlName) continue;

      const control = this.userForm.get(controlName);
      if (!control) continue;

      if (this.isFieldVisible(field)) {
        // restore original validators
        control.setValidators(this.buildValidators(field));
      } else {
        // field is hidden — no validation
        control.clearValidators();
        control.reset(field.type === 'datepciker' ? null : '');
      }
      control.updateValueAndValidity({ emitEvent: false });
    }
  }
}


 
 
  onDateInput(fieldKey: string, event: Event): void {
    this.onDateBlur(fieldKey, event);
  }



onRadioChange(fieldKey: string, event: Event): void {
  // handle non-validator side effects only
  if (fieldKey === 'hasPHRViking' || fieldKey === 'hasPHR') {
    // only the placeholder change — not the validators
    const val = (event.target as HTMLInputElement).value;
    this.spouseplaceholdername = val === 'true'
      ? this.lang.Name_As_Shown_On_Provincial_Health_Card
      : this.lang.First_Name;
  }

  if (fieldKey === 'has_child') {
    const val = (event.target as HTMLInputElement).value;
    if (val !== 'true') {
      // reset child array — this is UI state, not a validator
      this.childInfoAddDataArray = [];
      this.childTableRowsLength = 0;
    }
  }

  if (fieldKey === 'hasPHR') {
    const val = this.userForm.get('provincial_health_coverage')?.value;
    if (val === 'no' && this.currFormType == "nhlaa") {
      this.noProvincialCoverageModal = true;
    }
  }

  // handles ALL validator logic for ALL fields
  this.updateFormOnChange();
}

onDropdownChange(fieldKey: string, event: Event): void {
  if (fieldKey === 'province') this.provincelist(event);
  if (fieldKey === 'province_of_residence') this.provincelist(event);
  if (fieldKey === 'spouseProvince') this.spouseProvincelist(event);
  if (fieldKey === 'spouse_province') this.spouseProvincelist(event);
  if (fieldKey === 'spouse_province_of_coverage') this.spouseProvinceOfCoveragelist(event);
  if (fieldKey === 'province_of_coverage') this.provinceOfCoveragelist(event);
  if (fieldKey === 'gender')   this.genderCheck(event);

  this.updateFormOnChange();
}

onDateBlur(fieldKey: string, event: Event): void {
  const field = this.getFieldByKey(fieldKey);
  if (!field) return;

  const controlName = field.control_name;
  const value = (event as any).target.value;
  const control = this.userForm.get(controlName);
  if (!control) return;

  // Generic reset logic — same across all date fields
  const shouldReset = value === '' || value === 'Invalid date';
  if (shouldReset) {
    control.reset();
    control.markAsTouched();
    return;
  }

  // Age check — only for fields that define it in config
  if (field.age_check) {
    // Completed years, parsed in local time. This was a bare year subtraction on a UTC
    // parse, so a date of birth read as the previous day (and so as a year older on a
    // birthday) in every timezone west of Greenwich.
    const age = calculateAgeFrom(value) ?? -1;
    let { min, max, flag } = field.age_check;
    if(this.currFormType == 'viking'){
      max = 80;
    }
    if (flag && age > min && age < max) {
      (this as any)[flag] = true;
      this.memberAgeOverError = '';
    } else if (flag) {
      (this as any)[flag] = false;
      this.memberAgeOverError = age >= max
        ? `Primary members must be under the age of ${max} when enrolling.`
        : '';
    }
  }

   this.updateFormOnChange();

  // Auto-focus the Previous Employer field when date_of_retirement is within 90 days
  if (fieldKey === 'date_of_retirement') {
    setTimeout(() => {
      const prevEmployerField = this.getFieldByKey('previous_employer');
      if (prevEmployerField && this.isFieldVisible(prevEmployerField)) {
        const el = document.querySelector<HTMLElement>('[formcontrolname="previousEmployer"]');
        if (el) el.focus();
      }
    }, 150); // wait for Angular to render the newly visible section
  }
}


updateFormOnChange(): void {
  // Step 1: clear + reset all hidden fields
  for (const sectionKey of this.activeSections) {
    const section = this.activeFields[sectionKey];
    for (const fieldKey of Object.keys(section)) {
      const field = section[fieldKey];
      const controlName = field.control_name;
      if (!controlName) continue;

      const control = this.userForm.get(controlName);
      if (!control) continue;

      if (!this.isFieldVisible(field)) {
        control.clearValidators();
        // Reset to the field's default value (if any) so that when the field becomes
        // visible again it shows the configured default (e.g. 40 for hours_per_week).
        // Date fields must reset to null (not "") to avoid bsDatepicker showing "Invalid Date".
        const resetValue = field.type === 'datepciker'
          ? (field.defaultvalue || null)
          : (field.defaultvalue ?? '');
        control.reset(resetValue);
        control.updateValueAndValidity({ emitEvent: false });
      } else {
        control.setValidators(this.buildValidators(field));
        control.updateValueAndValidity({ emitEvent: false });
      }
    }
  }
}

private dispatchChangeHandler(fieldKey: string, event: Event): void {
  const field = this.getFieldByKey(fieldKey);
  const methodName = field?.on_change;
  if (methodName && typeof (this as any)[methodName] === 'function') {
    (this as any)[methodName](event);
  }
}

private dispatchBlurHandler(fieldKey: string, event: Event): void {
  const field = this.getFieldByKey(fieldKey);
  const methodName = field?.on_blur;
  if (methodName && typeof (this as any)[methodName] === 'function') {
    (this as any)[methodName](event);
  }
}

// Helper: find field config across all sections by fieldKey
private getFieldByKey(fieldKey: string): any {
  for (const sectionKey of this.activeSections) {
    if (this.activeFields[sectionKey]?.[fieldKey]) {
      return this.activeFields[sectionKey][fieldKey];
    }
  }
  return null;
}

 
  getDateMin(fieldKey: string): Date | undefined {
    const field = this.getFieldByKey(fieldKey);
    if (field?.age_check) {
      const maxAge = fieldKey === 'date_of_birth' && this.currFormType === 'viking'
        ? 80
        : field.age_check.max;
      const d = new Date();
      d.setFullYear(d.getFullYear() - maxAge);
      d.setMonth(0);
      d.setDate(1);
      return d;
    }
    return this.minDate;
  }
 
  getDateMax(fieldKey: string): Date | undefined {
    return fieldKey === 'date_of_birth' ? this.maxDate : undefined;
  }
 
  isAlphaField(fieldKey: string): boolean {
    return [
      'first_name', 'last_name', 'spouse_first_name', 'spouse_last_name',
      'beneficiary_first_name', 'beneficiary_last_name',
      'contingent_beneficiary_first_name', 'contingent_beneficiary_last_name',
    ].includes(fieldKey);
  }

  isDigitsOnlyField(fieldKey: string): boolean {
    return fieldKey === 'nhlaa_member_id';
  }

  /**
   * Viking renders the spouse "Add to plan" checkbox inline beside the has_spouse Yes/No
   * radios rather than as its own grid cell, so it is not missed. True here means the
   * standalone cell is skipped — the control itself is still built and submitted as usual.
   */
  isInlineAddToPlan(fieldKey: string): boolean {
    return this.currFormType === 'viking' && fieldKey === 'spouse_add_to_plan';
  }

  // ── Viking: keep "Add to plan" in step with the coverage chosen on the plans step ────────
  // Couple covers the member plus one dependent, Family covers everyone. Members routinely
  // pick a coverage without ticking "Add to plan", so the two are reconciled here.
  addToPlanChooserModal = false;
  addToPlanChooserOptions: Array<{ key: string; label: string; selected: boolean }> = [];
  addToPlanNoticeModal = false;
  addToPlanNoticeNames: string[] = [];
  addToPlanNoticeCoverage = '';
  /** 'checked' when people were added for the member, 'unchecked' when they were removed. */
  addToPlanNoticeAction: 'checked' | 'unchecked' = 'checked';
  /** Coverage that triggered the last reconciliation — drives how many people may be ticked. */
  private addToPlanCoverageLevel: 'SINGLE' | 'COUPLE' | 'FAMILY' | '' = '';

  /** Single covers the member alone; Couple adds one dependent; Family has no cap. */
  private get addToPlanLimit(): number {
    if (this.addToPlanCoverageLevel === 'SINGLE') return 0;
    if (this.addToPlanCoverageLevel === 'COUPLE') return 1;
    return Number.POSITIVE_INFINITY;
  }

  private get spouseAddToPlanControl(): AbstractControl | null {
    return this.userForm?.get(this.getFormControlName('spouse_add_to_plan')) ?? null;
  }

  /** Spouse (when one was declared) plus every dependent added, with their current flag. */
  private getAddToPlanCandidates(): Array<{ key: string; label: string; checked: boolean }> {
    const candidates: Array<{ key: string; label: string; checked: boolean }> = [];

    if (this.isTruthy(this.userForm?.get('having_spouse')?.value)) {
      const name = `${this.userForm?.get('spouseFirstName')?.value ?? ''} ${this.userForm?.get('spouseLastName')?.value ?? ''}`.trim();
      const spouseWord = this.lang?.Spouse ?? 'Spouse';
      candidates.push({
        key: 'spouse',
        label: name ? `${spouseWord} - ${name}` : spouseWord,
        checked: this.isTruthy(this.spouseAddToPlanControl?.value),
      });
    }

    (this.childInfoAddDataArray ?? []).forEach((child: any, index: number) => {
      const name = `${child?.firstName ?? ''} ${child?.lastName ?? ''}`.trim();
      const dependentWord = this.lang?.Dependent ?? 'Dependent';
      candidates.push({
        key: `child:${index}`,
        label: name ? `${dependentWord} - ${name}` : `${dependentWord} ${index + 1}`,
        checked: this.isTruthy(child?.addedToPlan),
      });
    });

    return candidates;
  }

  /**
   * Writes the flag back everywhere that person is held. The form control and the child array
   * are the sources of truth on step 1, but these rules run on step 2 — by then the payload has
   * already been frozen into validationInputData and the sessionStorage "Data" snapshot, and
   * buildSubmissionData() reads validationInputData, so both have to be updated too.
   */
  private setAddToPlan(key: string, value: boolean): void {
    if (key === 'spouse') {
      this.spouseAddToPlanControl?.setValue(value);
      this.spouseAddToPlanControl?.markAsDirty();

      if (this.validationInputData?.spouseDetails) {
        this.validationInputData.spouseDetails.addedToPolicy = this.formatAddedToPolicy(value);
        // customData mirrors the record, so the nested copy has to move with it
        if (this.validationInputData.spouseDetails.customData) {
          this.validationInputData.spouseDetails.customData.addedToPolicy = this.formatAddedToPolicy(value);
        }
      }
    } else {
      const index = Number(key.split(':')[1]);
      // addedToPlan here is the child modal's own control name, not a payload key
      if (this.childInfoAddDataArray?.[index]) {
        this.childInfoAddDataArray[index].addedToPlan = value;
      }
      if (this.validationInputData?.childrenDetails?.[index]) {
        this.validationInputData.childrenDetails[index].addedToPolicy = this.formatAddedToPolicy(value);
        if (this.validationInputData.childrenDetails[index].customData) {
          this.validationInputData.childrenDetails[index].customData.addedToPolicy = this.formatAddedToPolicy(value);
        }
      }
    }

    this.syncPlanScopeDetailsForAddToPlan(key, value);
    this.persistAddToPlanToStoredData();
  }

  /** Title-cases a stored gender ("male"/"MALE" → "Male") the same way the payload builders do. */
  private normaliseGender(gender: any): string {
    const value = String(gender ?? '');
    return value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : '';
  }

  /**
   * Mirrors the add/remove into planScopeDetails so a person ticked for the plan appears in
   * the scope list, matching the entries onSpouseChange/onChildChange create.
   */
  private syncPlanScopeDetailsForAddToPlan(key: string, value: boolean): void {
    if (!Array.isArray(this.planScopeDetails)) this.planScopeDetails = [];

    if (key === 'spouse') {
      this.planScopeDetails = this.planScopeDetails.filter(
        (person: any) => person.relationShip !== 'SPOUSE'
      );

      if (value) {
        this.planScopeDetails.push({
          firstName: this.capitalize(this.userForm?.get('spouseFirstName')?.value ?? ''),
          lastName:  this.capitalize(this.userForm?.get('spouseLastName')?.value ?? ''),
          relationShip: 'SPOUSE',
          gender: this.normaliseGender(this.userForm?.get('spouseGender')?.value),
          // viking has no clinic doctor-gender step, so the key is left off entirely
          ...(this.currFormType === 'viking' ? {} : { doctorGender: this.doctorSpouseGender ?? '' }),
        });
      }
    } else {
      const index = Number(key.split(':')[1]);
      const child = this.childInfoAddDataArray?.[index];

      this.planScopeDetails = this.planScopeDetails.filter(
        (person: any) => !(person.relationShip === 'CHILDREN' && person.childIndex === index)
      );

      if (value && child) {
        this.planScopeDetails.push({
          firstName: this.capitalize(child.firstName ?? ''),
          lastName:  this.capitalize(child.lastName ?? ''),
          relationShip: 'CHILDREN',
          childIndex: index,
          gender: this.normaliseGender(child.gender),
          // viking has no clinic doctor-gender step, so the key is left off entirely
          ...(this.currFormType === 'viking' ? {} : { doctorGender: '' }),
        });
      }
    }

    sessionStorage.setItem('planScopeDetails', JSON.stringify(this.planScopeDetails));
    sessionStorage.setItem('multiPlanCount', String(this.planScopeDetails.length));
  }

  /** Re-syncs the step 1 sessionStorage snapshot with the flags as they stand now. */
  private persistAddToPlanToStoredData(): void {
    try {
      const raw = sessionStorage.getItem('Data');
      if (!raw) return;

      const stored = JSON.parse(raw);

      if (stored?.spouseDetails && this.validationInputData?.spouseDetails) {
        stored.spouseDetails.addedToPolicy = this.validationInputData.spouseDetails.addedToPolicy;
        delete stored.spouseDetails.addedToPlan;
        if (stored.spouseDetails.customData) {
          stored.spouseDetails.customData.addedToPolicy = this.validationInputData.spouseDetails.addedToPolicy;
        }
      }

      if (Array.isArray(stored?.childrenDetails) && Array.isArray(this.validationInputData?.childrenDetails)) {
        stored.childrenDetails.forEach((child: any, index: number) => {
          const source = this.validationInputData.childrenDetails[index];
          if (!child || !source) return;
          child.addedToPolicy = source.addedToPolicy;
          delete child.addedToPlan;
          if (child.customData) child.customData.addedToPolicy = source.addedToPolicy;
        });
      }

      sessionStorage.setItem('Data', JSON.stringify(stored));
    } catch {
      // a malformed snapshot must never block the enrollment
    }
  }

  /**
   * Viking only. Runs when a plan coverage is ticked on the plans step.
   *  - Family  → tick everyone who is still unticked and say so.
   *  - Couple  → one dependent is covered: tick them automatically when there is only one
   *              candidate, otherwise ask the member which of the spouse/dependents it is.
   * Does nothing when the selection already matches the coverage.
   */
  public syncAddToPlanWithCoverage(coverage: any): void {
    if (this.currFormType !== 'viking') return;

    const level = String(coverage ?? '').trim().toUpperCase();
    if (level !== 'SINGLE' && level !== 'COUPLE' && level !== 'FAMILY') return;

    this.addToPlanCoverageLevel = level;

    const candidates = this.getAddToPlanCandidates();
    if (candidates.length === 0) return;

    if (level === 'SINGLE') {
      // Single covers the member alone — anyone previously added has to come back off,
      // which also unticks the step 1 checkboxes since they bind to the same values.
      const ticked = candidates.filter(c => c.checked);
      if (ticked.length === 0) return;
      ticked.forEach(c => this.setAddToPlan(c.key, false));
      this.showAddToPlanNotice(ticked.map(c => c.label), this.lang?.Single ?? 'Single', 'unchecked');
      return;
    }

    if (level === 'FAMILY') {
      const missing = candidates.filter(c => !c.checked);
      if (missing.length === 0) return;
      missing.forEach(c => this.setAddToPlan(c.key, true));
      this.showAddToPlanNotice(missing.map(c => c.label), this.lang?.Family ?? 'Family');
      return;
    }

    // COUPLE — the member plus exactly one dependent
    const alreadyChecked = candidates.filter(c => c.checked);
    if (alreadyChecked.length === 1) return;

    if (candidates.length === 1) {
      this.setAddToPlan(candidates[0].key, true);
      this.showAddToPlanNotice([candidates[0].label], this.lang?.Couple ?? 'Couple');
      return;
    }

    this.openAddToPlanChooser(candidates);
  }

  private showAddToPlanNotice(
    labels: string[],
    coverageLabel: string,
    action: 'checked' | 'unchecked' = 'checked',
  ): void {
    this.addToPlanNoticeNames = labels;
    this.addToPlanNoticeCoverage = coverageLabel;
    this.addToPlanNoticeAction = action;

    // Auto-adds stay silent (Couple/Family) — the popup there was turned off deliberately.
    // A removal is different: the member ticked those boxes on step 1, so clearing them
    // behind their back would be a surprise. Always announce that one.
    if (action === 'unchecked') {
      this.addToPlanNoticeModal = true;
    }
  }

  closeAddToPlanNotice(): void {
    this.addToPlanNoticeModal = false;
  }

  private openAddToPlanChooser(candidates: Array<{ key: string; label: string; checked: boolean }>): void {
    // Carry existing ticks in, but never seed more than the coverage allows — otherwise
    // hitting Save without touching anything would re-save an over-selection.
    let kept = 0;
    this.addToPlanChooserOptions = candidates.map(candidate => {
      const selected = candidate.checked && kept < this.addToPlanLimit;
      if (selected) kept++;
      return { key: candidate.key, label: candidate.label, selected };
    });
    this.addToPlanChooserModal = true;
  }

  toggleAddToPlanChoice(key: string, checked: boolean): void {
    const option = this.addToPlanChooserOptions.find(o => o.key === key);
    if (!option) return;

    option.selected = checked;

    // Couple covers one dependent, so ticking someone clears whoever was ticked before.
    // Family has no cap and keeps normal multi-select behaviour.
    if (checked && this.addToPlanLimit === 1) {
      this.addToPlanChooserOptions.forEach(other => {
        if (other.key !== key) other.selected = false;
      });
    }
  }

  get addToPlanChoiceMade(): boolean {
    return this.addToPlanChooserOptions.some(option => option.selected);
  }

  confirmAddToPlanChooser(): void {
    this.addToPlanChooserOptions.forEach(option => this.setAddToPlan(option.key, option.selected));
    this.addToPlanChooserModal = false;
  }

  closeAddToPlanChooser(): void {
    this.addToPlanChooserModal = false;
    this.enforceAddToPlanLimit();
  }

  /**
   * Safety net for dismissing the dialog. The chooser opens precisely because the current
   * ticks do not match the coverage, so closing it must not leave two people added under
   * Couple — the first stays, the rest are cleared.
   */
  private enforceAddToPlanLimit(): void {
    const limit = this.addToPlanLimit;
    if (!Number.isFinite(limit)) return;

    const checked = this.getAddToPlanCandidates().filter(candidate => candidate.checked);
    if (checked.length <= limit) return;

    checked.slice(limit).forEach(candidate => this.setAddToPlan(candidate.key, false));
  }

  digitsOnly(event: KeyboardEvent): void {
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  // ── NHLAA Player ID — "01999" prefix + zero padded 5 digit box ────────────
  // Purely cosmetic: the form control (and therefore the API payload) keeps the
  // raw digits the user typed, e.g. typing 1 shows 00001 but still sends "1".
  nhlaaMemberIdFocused = false;
  readonly nhlaaMemberIdPlaceholder = '00000';
  private static readonly NHLAA_ID_LENGTH = 5;

  isNhlaaMemberIdField(fieldKey: string): boolean {
    return this.currFormType === 'nhlaa' && this.getFormControlName(fieldKey) === 'nhlaaMemberId';
  }

  /** Digits currently held by the control, without any padding. */
  private get nhlaaMemberIdRaw(): string {
    const value = String(this.userForm?.get('nhlaaMemberId')?.value ?? '');
    return value
      .replace(/\D/g, '')
      .replace(/^0+/, '')
      .slice(0, GenericSignupFormComponent.NHLAA_ID_LENGTH);
  }

  /** What the box shows: the raw digits right aligned and padded with leading zeros. */
  get nhlaaMemberIdDisplay(): string {
    const raw = this.nhlaaMemberIdRaw;
    return raw ? raw.padStart(GenericSignupFormComponent.NHLAA_ID_LENGTH, '0') : '';
  }

  onNhlaaMemberIdKeydown(event: KeyboardEvent): void {
    if (event.ctrlKey || event.metaKey || event.altKey) {
      return;
    }

    const navigationKeys = ['Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
    if (navigationKeys.includes(event.key)) {
      return;
    }

    const raw = this.nhlaaMemberIdRaw;

    if (event.key === 'Backspace' || event.key === 'Delete') {
      event.preventDefault();
      this.setNhlaaMemberId(raw.slice(0, -1), event.target as HTMLInputElement);
      return;
    }

    event.preventDefault();

    if (!/^[0-9]$/.test(event.key)) {
      return;
    }
    // a leading zero carries no meaning here — the padding already supplies it
    if (!raw && event.key === '0') {
      return;
    }
    if (raw.length >= GenericSignupFormComponent.NHLAA_ID_LENGTH) {
      return;
    }

    this.setNhlaaMemberId(raw + event.key, event.target as HTMLInputElement);
  }

  onNhlaaMemberIdPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pasted = (event.clipboardData?.getData('text') ?? '')
      .replace(/\D/g, '')
      .replace(/^0+/, '')
      .slice(0, GenericSignupFormComponent.NHLAA_ID_LENGTH);
    this.setNhlaaMemberId(pasted, event.target as HTMLInputElement);
  }

  /** Safety net for input that bypasses keydown (autofill, mobile IME, drag & drop). */
  onNhlaaMemberIdInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digits = input.value
      .replace(/\D/g, '')
      .replace(/^0+/, '')
      .slice(0, GenericSignupFormComponent.NHLAA_ID_LENGTH);
    this.setNhlaaMemberId(digits, input);
  }

  onNhlaaMemberIdBlur(): void {
    this.nhlaaMemberIdFocused = false;
    const control = this.userForm?.get('nhlaaMemberId');
    control?.markAsTouched();
    control?.updateValueAndValidity();
  }

  private setNhlaaMemberId(raw: string, input?: HTMLInputElement): void {
    const control = this.userForm?.get('nhlaaMemberId');
    if (!control) return;

    control.setValue(raw);
    control.markAsDirty();

    if (input) {
      // keep the DOM in step even when the control value did not change, and hold the caret at the end
      input.value = this.nhlaaMemberIdDisplay;
      const end = input.value.length;
      input.setSelectionRange(end, end);
    }
  }

  closeNoProvincialCoverageModal(): void {
    this.noProvincialCoverageModal = false;
    this._suppressPHCModal = true;
    this.userForm.get('provincial_health_coverage')?.setValue('');
    this.userForm.get('provincial_health_coverage')?.markAsUntouched();
    this._suppressPHCModal = false;
  }
 
  isUppercaseField(fieldKey: string): boolean {
    return fieldKey === 'postal_code' || fieldKey === 'spouse_postal_code';
  }
 
  getRadioDisabled(fieldKey: string): boolean {
    if (fieldKey === 'hasPHR') return !!this.phrOption;
    return false;
  }



  buildActiveBeneficiaryFields(): void {
  const result: Record<string, Record<string, any>> = {};
  const sectionOrder: string[] = [];

  console.log(beneficiaryData, this.currFormType)
  for (const sectionKey of Object.keys(beneficiaryData)) {
    const section = beneficiaryData[sectionKey];
    for (const fieldKey of Object.keys(section)) {
      const field = section[fieldKey];
      if (!field.control_name) continue;
      if (!field[this.currFormType]) continue;


      if (!result[sectionKey]) {
        result[sectionKey] = {};
        sectionOrder.push(sectionKey);
      }
      result[sectionKey][fieldKey] = field;
    }
  }

  console.log("sectionOrder",sectionOrder)

      console.log(result)


  this.activeBeneficiaryFields = result;
  this.activeBeneficiarySections = sectionOrder;
  this.buildBeneficiaryForm();
}

buildBeneficiaryForm(): void {
  const controls: Record<string, any> = {
    customerType: [''],
    isMinor: [''],
  };

  for (const sectionKey of this.activeBeneficiarySections) {
    const section = this.activeBeneficiaryFields[sectionKey];
    for (const fieldKey of Object.keys(section)) {
      const field = section[fieldKey];
      if (controls[field.control_name]) continue;
      controls[field.control_name] = [
        field.defaultvalue ?? '',
        this.buildBeneficiaryValidators(field)
      ];
    }
  }


  console.log("cas38",controls)

  this.benficiaryForm = this.formBuilder.group(controls);


  this.showBenificiaryForm = true
  this.showBenificiaryFormCond = true
}

buildBeneficiaryValidators(field: any): ValidatorFn[] {
  const v: ValidatorFn[] = [];

  // required array check e.g. "required": ["viking","gig",...]
  if (Array.isArray(field.required) && field.required.includes(this.currFormType)) {
    v.push(Validators.required);
  }

  if (field.type === 'text') {
    v.push(Validators.minLength(1));
  }

  if(field.type == 'email'){
    v.push(Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/));
  }
 
  if(field.type == 'phone'){
    v.push(Validators.minLength(17));
    v.push(Validators.maxLength(17));
    v.push(Validators.pattern(/^[^A-Za-z@#$%&*{}'";:<>?]+$/));
  }

  if (field.field === 'earningsAmount') {
    v.push(Validators.min(1));
  }

  return v;
}

// Reuse existing isFieldVisible but scoped to benficiaryForm
isBeneficiaryFieldVisible(field: any): boolean {
  if (!field.visible_if) return true;
  const expectedValue = field.visible_if.value;
  const watchField = field.visible_if.field;
  const liveValue = this.benficiaryForm?.get(watchField)?.value;
  return Array.isArray(expectedValue)
    ? expectedValue.includes(liveValue)
    : liveValue === expectedValue;
}

getBeneficiaryFieldKeys(sectionKey: string): string[] {
  console.log("activeBeneficiaryFields13: ",this.activeBeneficiaryFields)
  return Object.keys(this.activeBeneficiaryFields[sectionKey] || {});
}

// Call this on beneficiary form changes (same pattern as updateFormOnChange)
updateBeneficiaryValidators(): void {
  for (const sectionKey of this.activeBeneficiarySections) {
    const section = this.activeBeneficiaryFields[sectionKey];
    for (const fieldKey of Object.keys(section)) {
      const field = section[fieldKey];
      const control = this.benficiaryForm?.get(field.control_name);
      if (!control) continue;
      if (!this.isBeneficiaryFieldVisible(field)) {
        control.clearValidators();
        control.reset('');
      } else {
        control.setValidators(this.buildBeneficiaryValidators(field));
      }
      control.updateValueAndValidity({ emitEvent: false });
    }
  }
}



// ── Theme helpers ─────────────────────────────────────────────────────────────
// Default (green) theme — used by GIG, Viking, and any form type not listed in formThemes.
private readonly defaultTheme = {
  stepper: {
    active:    { background: '#dfe9e2', border: '#38a169', color: '#1a6b3a' },
    completed: { background: '#d4edda', border: '#28a745', color: '#155724' },
    disabled:  { background: '#f3f3f3', color: '#999999' },
    circleActive:    '#1a6b3a',
    circleCompleted: '#166d26',
    progressLine:    'linear-gradient(to right, #1a6b3a 0%, #38a169 60%, #68d391 100%)',
    pulseColor:      'rgba(56, 161, 105, 0.4)',
    tickColor: "#ffff"
  }
};

/** Active theme — resolved from formThemes config or falls back to defaultTheme. */
get currentTheme() {
  return (this.signupFormDynamicStyles as any) ?? this.defaultTheme;
}



getTickColor(i:number){
  const s = this.currentTheme.stepper;
  return {
    color: s.tickColor
  }
}

/** Inline styles for the step-number circle (completed / active / disabled). */
getStepperCircleStyle(i: number): Record<string, string> {
  const s = this.currentTheme.stepper;
  // When the completed circle is white (#ffffff), the checkmark must be dark (use completed tab text color).
  const circleBg    = i < this.activeTab ? s.circleCompleted
                    : i === this.activeTab ? s.circleActive
                    : '#e0e0e0';

  // When the completed circle is white (#fff), the ✓ must be dark so it's visible.
  // Otherwise use the theme's completed text colour.
  const completedCircleIsLight =
    s.circleCompleted === '#ffffff' || s.circleCompleted === '#fff' ||
    s.circleCompleted === 'white';
  const circleColor = i < this.activeTab  ? (completedCircleIsLight ? '#000000' : s.completed.color)
                    : i === this.activeTab ? '#fff'
                    : '#999';
  return {
    width: '22px', height: '22px',
    'min-width': '22px',          // prevent flex shrink squishing the circle
    'flex-shrink': '0',
    'border-radius': '50%',
    display: 'inline-flex',
    'align-items': 'center',
    'justify-content': 'center',
    'font-size': '13px',          // slightly larger so ✓ is clearly visible
    'font-weight': '700',
    'line-height': '1',           // remove extra line-height pushing ✓ off-centre
    background: circleBg,
    color: circleColor
  };
}

/** Inline colour overrides for a tab button (active / completed — disabled keeps CSS defaults). */
getTabColorStyle(i: number): Record<string, string> {
  const s = this.currentTheme.stepper;
  if (i === this.activeTab)
    return { background: s.active.background, 'border-color': s.active.border, color: s.active.color };
  if (i < this.activeTab)
    return { background: s.completed.background, 'border-color': s.completed.border, color: s.completed.color };
  return {};
}

/** Inline style for the thin progress line below the stepper. */
getProgressLineStyle(): Record<string, string> {
  return { background: this.currentTheme.stepper.progressLine };
}

// ── CORP (NHLAA) plan data helpers ───────────────────────────────────────────

/**
 * Converts the raw API packages object (keyed by category: paidByCompany,
 * coveredByCompany, paidByEmployee) into a flat array of packages that each
 * carry enriched groups (with categorization) and enriched plans
 * (with productAddonss + productAddonssNames).
 * Only used for currFormType === 'nhlaa'; GIG plansData is built separately.
 */
buildCorpPlansData(rawPackages: any): any[] {
  const result: any[] = [];
  if (!rawPackages || typeof rawPackages !== 'object' || Array.isArray(rawPackages)) {
    return result;
  }

  const categoryMap: Record<string, any> = {
    paidByCompany:    { paidByCompany: 1, coveredByCompany: 0, paidByEmployee: 0 },
    coveredByCompany: { paidByCompany: 0, coveredByCompany: 1, paidByEmployee: 0 },
    paidByEmployee:   { paidByCompany: 0, coveredByCompany: 0, paidByEmployee: 1 },
  };

  Object.keys(rawPackages).forEach((categoryKey: string) => {
    const pkgArray = rawPackages[categoryKey];
    if (!Array.isArray(pkgArray)) return;

    const categorization = categoryMap[categoryKey] ??
      { paidByCompany: 0, coveredByCompany: 0, paidByEmployee: 0 };

    pkgArray.forEach((pkg: any) => {
      // Groups come under different property names per category
      const rawGroups: any[] =
        pkg.groupsCP ?? pkg.groupsCC ?? pkg.groupsEP ?? pkg.groupsOptional ?? pkg.groups ?? [];

      const enrichedGroups = rawGroups.map((group: any) => {
        const enrichedPlans = (group.plans || []).map((plan: any) =>
          this.enrichCorpPlan(plan)
        );
        return { ...group, categorization, plans: enrichedPlans };
      });

      result.push({ ...pkg, groups: enrichedGroups });
    });
  });

  return result;
}

/**
 * Enriches a corp/bundle plan so the tile template can render it.
 *
 * ONE tile per plan:
 *   productAddonssNames = [plan.name]   ← single entry → single tile
 *   productAddonss[plan.name]  ← ONE row: only the corpPossibleCoverage level
 *                                (SINGLE by default; matches corporate signup behaviour
 *                                 of showing only the applicable coverage to the member)
 *
 * Coverage rows are deduplicated by planCoverage and then filtered to
 * corpPossibleCoverage so the tile shows a single checkbox (e.g. "Single")
 * which is then auto-selected + disabled — identical to corporate signup.
 */
private enrichCorpPlan(plan: any): any {
  const coverageByLevel: Record<string, any> = {};
  const levelOrder: string[] = [];

  (plan.productAddons || []).forEach((addon: any) => {
    const lvl: string = addon.planCoverage || 'SINGLE';
    if (!coverageByLevel[lvl]) {
      coverageByLevel[lvl] = {
        ...addon,
        planCoverageUI: addon.product?.name || lvl,
        display: addon.display !== undefined ? addon.display : true,
        // Ensure calculatedTax always has .price, .tax and .total so selectplan
        // can safely read .total without getting undefined → NaN → cartcheckvalue stuck true.
        calculatedTax: addon.calculatedTax
          ? {
              price: addon.calculatedTax.price ?? addon.price ?? 0,
              tax:   addon.calculatedTax.tax   ?? 0,
              total: addon.calculatedTax.total ?? addon.calculatedTax.price ?? addon.price ?? 0,
            }
          : { price: addon.price ?? 0, tax: 0, total: addon.price ?? 0 },
        plan_level: addon.plan_level ?? {
          id: addon.planLevel ?? addon.planlevel?.id ?? 0,
          disallowedPlanLevels: null,
        },
      };
      levelOrder.push(lvl);
    }
  });

  const planKey: string = plan.name || 'Plan';

  // Include ALL coverage levels (SINGLE, COUPLE, FAMILY) so the employee can choose.
  const coverageRows = levelOrder.map(lvl => coverageByLevel[lvl]);

  return {
    ...plan,
    productAddonss:      { [planKey]: coverageRows },
    productAddonssNames: [planKey],
  };
}

/**
 * Auto-selects (and disables) every company-paid corp plan checkbox whose
 * coverage class matches corpPossibleCoverage — mirrors autoSelectCompanyPaidPlans()
 * in corporate-signup.component.ts but scoped only to NHLAA corp tiles.
 */
autoSelectCorpCompanyPaidPlans(): void {
  setTimeout(() => {
    const dom: HTMLElement = this.elementRef.nativeElement;
    // Selector matches the class written by: class="... coverage{{ planCoverageUI | uppercase }}"
    const selector = `.plancv.coverage${this.corpPossibleCoverage}`;
    const checkboxes = dom.querySelectorAll<HTMLInputElement>(selector);

    checkboxes.forEach((checkbox: HTMLInputElement) => {
      if (!checkbox.checked) {
        checkbox.click();  // triggers onCorpCheckboxChange → updates plansummary + enables Next
      }
    });

    // Disable after click settles so user cannot deselect company-paid plans
    setTimeout(() => {
      checkboxes.forEach((checkbox: HTMLInputElement) => {
        checkbox.disabled = true;
        checkbox.style.opacity = '0.7';
        checkbox.style.cursor  = 'not-allowed';
      });
    }, 300);
  }, 200);
}

/**
 * Handles checkbox change for NHLAA corp plan tiles.
 * Separate from onCheckboxChange which is used for GIG/Viking plans.
 */
onCorpCheckboxChange(event: any, plan: any, coverage: any, pkg: any, group: any, k: number): void {
  const checkbox = event.target as HTMLInputElement;
  const isPaidByCompany = group.categorization?.paidByCompany === 1;

  // Company-paid plans: employee cost is $0 — don't add to cart total.
  // Only upgrade (coveredByCompany) and voluntary (paidByEmployee) count.
  const employeePrice: number = isPaidByCompany
    ? 0
    : parseFloat(String(coverage?.calculatedTax?.price ?? coverage?.price ?? 0));

  const plansummary: any[] = JSON.parse(sessionStorage.getItem('plansummary') || '[]');
  let currentTotal: number = parseFloat(sessionStorage.getItem('totalAmount') || '0');

  // Actual plan price (always stored regardless of who pays — needed for summary table).
  // employeePrice is $0 for company-paid and only affects the cart total.
  const actualPrice: number = parseFloat(String(coverage?.price ?? coverage?.calculatedTax?.price ?? 0));

  // Human-readable type label for the summary table "Type" column
  const planType: string =
    group.categorization?.paidByCompany   === 1 ? '100% Company Paid'       :
    group.categorization?.coveredByCompany === 1 ? 'Payroll Deduction (Upgrade)' :
                                                   'CC/PAD (Voluntary)';

  // Build a rich entry that matches the shape corporate signup stores in plansummary /
  // plansummarymain so downstream enrollment processing works the same way.
  const planEntry: any = {
    // ── identifiers ──────────────────────────────────────────────────────
    id:              coverage.id,
    planId:          plan.id,
    planLevel:       coverage.plan_level?.id ?? coverage.planLevel ?? 0,
    packageId:       pkg.id,
    // ── names ────────────────────────────────────────────────────────────
    name:            plan.name,
    planname:        plan.name,
    planproductname: plan.name,
    packagename:     pkg.name,
    groupName:       group.name,
    type:            planType,
    // ── coverage ─────────────────────────────────────────────────────────
    coverage:        coverage.planCoverage,
    planCoverage:    coverage.planCoverage,
    planCoverageUI:  coverage.planCoverageUI,
    // ── pricing — use ACTUAL price for summary table display ──────────────
    planPrice:       actualPrice,
    amount:          actualPrice,
    total:           actualPrice,
    totalPrice:      actualPrice,
    skuTotalPrice:   actualPrice,
    tax:             0,        // tax calc not yet implemented for NHLAA generic form
    gstCheck:        false,
    hstCheck:        false,
    pstCheck:        false,
    // ── category flags (mirrors corporate signup obj fields) ──────────────
    paidByCompany:   group.categorization?.paidByCompany   ?? 0,
    coveredByCompany:group.categorization?.coveredByCompany ?? 0,
    paidByEmployee:  group.categorization?.paidByEmployee  ?? 0,
    // ── products array (corporate signup uses this for tax / detail) ──────
    products: [{
      ...coverage,
      calculatedTax: coverage.calculatedTax ?? { price: actualPrice, tax: 0, total: actualPrice },
    }],
  };

  if (checkbox.checked) {
    plansummary.push(planEntry);
    currentTotal += employeePrice;
  } else {
    const idx = plansummary.findIndex((p: any) =>
      p.id === coverage.id && p.planCoverage === coverage.planCoverage);
    if (idx > -1) plansummary.splice(idx, 1);
    currentTotal = Math.max(0, currentTotal - employeePrice);
  }

  // ── plansummary (flat list, same as corporate signup) ──────────────────
  sessionStorage.setItem('plansummary', JSON.stringify(plansummary));

  // ── plansummarymain = plansummary minus any opt-in packages
  //    (corporate signup splits planSummary into main vs opt arrays)
  const plansummarymain = plansummary.filter(
    (p: any) => (p.packagename ?? '').toLowerCase() !== 'opt-in'
  );
  sessionStorage.setItem('plansummarymain', JSON.stringify(plansummarymain));

  sessionStorage.setItem('totalAmount', String(currentTotal));

  // Refresh cart display — only show amount for upgrade/voluntary (employee-paid)
  this.planAmount = currentTotal > 0
    ? this._decimalPipe.transform(currentTotal, '1.2-2')?.replace(/,/g, '') ?? ''
    : '';
  // For NHLAA: Next is enabled once any plan is selected (including company-paid core plans)
  this.plansnexttab = plansummary.length === 0;
  this.cartcheckvalue = plansummary.length === 0;

  // Rebuild corp summary arrays so companyDealingPlans / payrollCCplansarr etc. are
  // always in sync — mirrors planCoverafeFunction() from corporate-signup.
  this.planCoverafeFunctionCorp();
}

// ─────────────────────────────────────────────────────────────────────────────

/**
 * NHLAA corp equivalent of planCoverafeFunction() from corporate-signup.
 *
 * Reads plansummarymain from sessionStorage (populated by onCorpCheckboxChange)
 * and categorises each selected plan into:
 *   - companyDealingPlans     → 100% company-paid (paidByCompany == 1)
 *   - payrollCCplansarr       → covered-by-company upgrades (coveredByCompany == 1)
 *   - employeeDealingPlansarr → employee-paid voluntary / upgrade delta plans
 *   - directpayCCplansarr     → non-payroll CC plans (subset of covered)
 *   - companySelectedPlans    → all company-facing plans (paid + covered)
 *   - EmployeeSelectedPlans   → employee-facing plans
 *   - allSelectedPlans        → every selected plan
 *
 * Also updates upgradeplansCheck / voluntryplansCheck so the submit guard at
 * gotosumamrypageLogic / creditcardpaysubmit2 works correctly.
 *
 * NOTE: This method is NHLAA-only; existing GIG flow is unaffected.
 */
public planCoverafeFunctionCorp(): void {
  if (this.currFormType !== 'nhlaa') return;

  this.paidEmployeeShare    = 0;
  this.coveredEmployeeShare = 0;

  const planSummaryMain: any[] = JSON.parse(
    sessionStorage.getItem('plansummarymain') || '[]'
  );

  // ── Categorise plans by who pays ─────────────────────────────────────
  const selected_cp_plans = planSummaryMain.filter(
    (p: any) => p.paidByCompany == 1 || p.categorization?.paidByCompany === true
  );
  const selected_cc_plans = planSummaryMain.filter(
    (p: any) => p.coveredByCompany == 1 || p.categorization?.coveredByCompany === true
  );
  const selected_ep_plans = planSummaryMain.filter(
    (p: any) => p.paidByEmployee == 1 || p.categorization?.paidByEmployee === true
  );

  const all_selected_plans:             any[] = [];
  const company_selected_plans:         any[] = [];
  const company_paid_selected_plans:    any[] = [];
  const company_covered_selected_plans: any[] = [];
  const employee_selected_plans:        any[] = [];
  const alloptinplans:                  any[] = [];
  const payrollCCplans:                 any[] = [];
  const directpayCCplans:               any[] = [];

  // ── 100% company-paid plans ───────────────────────────────────────────
  for (const plan of selected_cp_plans) {
    plan.amount = adjustWith2DecimalsForUI(plan.amount ?? plan.planPrice ?? 0);
    plan['amounts'] = {
      company:  plan.amount,
      employee: 0,
      total:    plan.amount,
    };
    plan['categorization'] = { paidByCompany: true, coveredByCompany: false, paidByEmployee: false };
    plan['type']           = '100% Company Paid';
    plan['employeeAmount']   = 0;
    plan['employeeAmountUI'] = '$0.00';
    plan['companyAmount']    = plan.amount;
    plan['companyAmountUI']  = '$' + plan.amount;
    plan['planLevelName']    = plan.groupName || '';
    plan['companyCoveredBasePlan'] = { planId: 0, planName: 'NA', planLevelId: 0, amount: 0, tax: 0, total: 0 };

    all_selected_plans.push(plan);
    company_selected_plans.push(plan);
    company_paid_selected_plans.push(plan);
  }

  // ── Employee-paid voluntary plans ────────────────────────────────────
  for (const plan of selected_ep_plans) {
    plan.amount = adjustWith2DecimalsForUI(plan.products?.[0]?.price ?? plan.planPrice ?? 0);
    plan['amounts'] = {
      company:  0,
      employee: plan.total ?? plan.amount,
      total:    plan.total ?? plan.amount,
    };
    plan['categorization'] = { paidByCompany: false, coveredByCompany: false, paidByEmployee: true };
    plan['type']           = 'CC/PAD (Voluntary)';
    plan['employeeAmount']   = plan['amounts'].employee;
    plan['employeeAmountUI'] = '$' + plan['amounts'].employee;
    plan['companyAmount']    = 0;
    plan['companyAmountUI']  = '$0.00';
    plan['companyCoveredBasePlan'] = { planId: 0, planName: 'NA', planLevelId: 0, amount: 0, tax: 0, total: 0 };

    this.paidEmployeeShare += parseFloat(plan['amounts'].total ?? 0);

    all_selected_plans.push(plan);
    employee_selected_plans.push(plan);
  }

  // ── Covered-by-company upgrade plans (payroll deduction delta) ────────
  for (const plan of selected_cc_plans) {
    // Only process if upgradeCalculation exists (not present for NHLAA basic plans)
    if (plan.upgradeCalculation) {
      plan['amounts'] = {
        company:  plan.upgradeCalculation.baseplanPrice,
        employee: plan.upgradeCalculation.deltaplanPrice,
        total:    plan.upgradeCalculation.combinedplanPrice,
      };
      plan['type'] = 'Payroll Deduction (Upgrade)';
      plan['employeeAmount']   = plan['amounts'].employee;
      plan['employeeAmountUI'] = '$' + plan['amounts'].employee;
      plan['companyAmount']    = plan['amounts'].company;
      plan['companyAmountUI']  = '$' + plan['amounts'].company;

      this.coveredEmployeeShare += parseFloat(plan['amounts'].employee ?? 0);

      all_selected_plans.push(plan);
      company_selected_plans.push(plan);
      company_covered_selected_plans.push(plan);

      if (plan.upgradeCalculation.payroll) {
        payrollCCplans.push(plan);
      } else {
        payrollCCplans.push(plan);
        directpayCCplans.push(plan);
      }
    }
  }

  // ── Combine into final arrays ─────────────────────────────────────────
  const employeeDealingPlans = [...directpayCCplans, ...employee_selected_plans];
  const companyDealingPlans  = [...company_paid_selected_plans, ...payrollCCplans];

  // ── Set class properties (mirrors corporate-signup assignments) ───────
  this.alloptinplans          = alloptinplans;
  this.allSelectedPlans       = all_selected_plans;
  this.companySelectedPlans   = company_selected_plans;
  this.EmployeeSelectedPlans  = employee_selected_plans;
  this.companyCoveredPlans    = company_covered_selected_plans;
  this.directpayCCplansarr    = directpayCCplans;
  this.payrollCCplansarr      = payrollCCplans.sort(
    (a: any, b: any) => a.packageId - b.packageId
  );
  this.companyDealingPlans    = companyDealingPlans.sort(
    (a: any, b: any) => a.packageId - b.packageId
  );
  this.employeeDealingPlansarr = employeeDealingPlans;

  this.totalEmployeeShare  = this.coveredEmployeeShare + this.paidEmployeeShare;
  this.cartDisplayAmount   = this._decimalPipe.transform(this.paidEmployeeShare, '1.2-2');

  // ── Computed display totals (mirrors planCoverafeFunction sumBy calls in corp-signup) ─
  this.allPlansAmountTotal  = sumBy(this.allSelectedPlans, 'amount');
  this.allPlansTotal        = sumBy(this.allSelectedPlans, 'total');
  this.allPlansTotaltax     = sumBy(this.allSelectedPlans, 'tax');

  this.companyPaidTotal     = sumBy(this.companySelectedPlans, 'total');
  this.companyCoveredTotal  = sumBy(this.companyCoveredPlans,  'total');
  this.paidEmployeedTotal   = sumBy(this.EmployeeSelectedPlans, 'total');

  this.companyCoveredCompanyShareTotal   = sumBy(this.companyCoveredPlans, 'companyShareTotal');
  this.companyCoveredEmployeeShareTotal  = sumBy(this.companyCoveredPlans, 'employeeShareTotal');

  this.empDirectpayPlanamountTotal  = sumBy(employeeDealingPlans, 'amount');
  this.empDirectpayPlantaxTotal     = sumBy(employeeDealingPlans, 'tax');
  this.empDirectpayPlangrandTotal   = sumBy(employeeDealingPlans, 'total');

  this.DirectCCpayPlangrandTotal    = sumBy(directpayCCplans, 'total');

  this.companydealingplansTotal      = sumBy(companyDealingPlans, 'amount');
  this.companydealingplanstaxTotal   = sumBy(companyDealingPlans, 'tax');
  this.companydealingplansgrandTotal = sumBy(companyDealingPlans, 'total');

  // ── Confirmation guards (mirrors corp-signup logic) ───────────────────
  // upgradeplansCheck = true when there are payroll upgrade plans to confirm
  this.upgradeplansCheck = this.payrollCCplansarr.length > 0;
  // voluntryplansCheck  = true when employee has voluntary plans to pay
  this.voluntryplansCheck = employeeDealingPlans.length > 0;
  // companyplansCheck   = true until user ticks the confirmation checkbox.
  // Reset to true when plans change so user must re-confirm after any edit.
  this.companyplansCheck = company_paid_selected_plans.length > 0;

  // ── Payment method (controls CC radio checked state) ─────────────────
  if (employeeDealingPlans.length > 0) {
    this.bankpaymentmethod = 'CC';
    this.paymentForm.get('paymentRadioCheck')?.setValue('CC');
    sessionStorage.setItem('paymentMethod', 'CC');
  } else {
    this.bankpaymentmethod = 'NONE';
    this.paymentForm.get('paymentRadioCheck')?.setValue('');
    sessionStorage.setItem('paymentMethod', 'NONE');
  }
}

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns explicit CSS Grid placement styles for key NHLAA phr_questions fields.
 * This guarantees working_hours | hasPHR are side-by-side (row 1) and
 * no_of_working_hours appears below (row 2), regardless of DOM order or sort timing.
 * Returns {} for all other sections / form types.
 */
getFieldGridStyle(sectionKey: string, fieldKey: string): Record<string, string> {
  if ((this.currFormType === 'gig' || this.currFormType === 'corp') && sectionKey === 'phr_questions') {
    // Use longhand grid-column-start/end to avoid shorthand conflict with Tailwind col-span-* classes.
    const L2 = { 'grid-column-start': '1', 'grid-column-end': '3' };  // cols 1-2 (full left 50%)
    const L1 = { 'grid-column-start': '1', 'grid-column-end': '2' };  // col 1 only (25%)
    const R2 = { 'grid-column-start': '3', 'grid-column-end': '5' };  // cols 3-4 (full right 50%)
    const RA = { 'grid-column-start': '3', 'grid-column-end': '4' };  // col 3 (left of right 25%)
    const RB = { 'grid-column-start': '4', 'grid-column-end': '5' };  // col 4 (right of right 25%)
    const gigPlacements: Record<string, Record<string, string>> = {
      'working_hours':              { ...L2, 'grid-row-start': '1', 'grid-row-end': '2' },
      'no_of_working_hours':        { ...L1, 'grid-row-start': '2', 'grid-row-end': '3' },
      'hasPHR':                     { ...R2, 'grid-row-start': '1', 'grid-row-end': '2' },
      'date_of_arrival':            { ...RA, 'grid-row-start': '2', 'grid-row-end': '3' },
      'country_of_origin':          { ...RB, 'grid-row-start': '2', 'grid-row-end': '3' },
      'landed_immigrant':           { ...RA, 'grid-row-start': '3', 'grid-row-end': '4' },
      'landed_status':              { ...RB, 'grid-row-start': '3', 'grid-row-end': '4' },  // DOM-removed when hidden
      'empolyee_coverage_required': { ...RA },  // col 3, auto-row: beside landed_immigrant when landed_status hidden; row 4 when visible
    };
    return gigPlacements[fieldKey] ?? {};
  }

  if (this.currFormType !== 'nhlaa' || sectionKey !== 'phr_questions') return {};

  const workingHoursActive = !!this.activeFields?.['phr_questions']?.['working_hours'];

  if (workingHoursActive) {
    // Legacy: working_hours active — left/right 2-col layout in a 4-col grid
    const col1 = { 'grid-column': '1 / span 2' };
    const col3 = { 'grid-column': '3 / span 2' };
    const placements: Record<string, Record<string, string>> = {
      'working_hours':              { ...col1, 'grid-row': '1' },
      'no_of_working_hours':        { ...col1, 'grid-row': '2' },
      'hasPHR':                     { ...col3, 'grid-row': '1' },
      'date_of_arrival':            col3,
      'landed_immigrant':           col3,
      'landed_status':              col3,
      'country_of_origin':          col3,
      'empolyee_coverage_required': col3,
    };
    return placements[fieldKey] ?? {};
  }

  // NHLAA without working_hours — 6-col grid, 2-row layout:
  // Row 1: hasPHR | date_of_arrival | country_of_origin  (all pinned — no reordering)
  // Row 2: landed_immigrant | landed_status | empolyee_coverage_required
  //        — row 2 items only pinned to row 2, NO column pin, so when landed_status is
  //          hidden (landed_immigrant = No) the gap auto-closes and remaining fields
  //          flow left-to-right with no empty space.
  // 3-col grid — row 1 fully pinned; row 2 partially pinned:
  //   landed_immigrant → always col 1, row 2
  //   landed_status    → always col 2, row 2 (removed from DOM by *ngIf when hidden)
  //   empolyee_coverage_required → NO explicit column → auto-flows to col 2 when
  //     landed_status is hidden (DOM removed), or col 3 when it's visible. No gap.
  const nhlaaPlacement: Record<string, Record<string, string>> = {
    'hasPHR':                     { 'grid-column': '1 / span 4', 'grid-row': '1' },
    'date_of_arrival':            { 'grid-column': '5 / span 2', 'grid-row': '1' },
    'country_of_origin':          { 'grid-column': '7 / span 4', 'grid-row': '1' },
    'landed_immigrant':           { 'grid-column': '1 / span 3', 'grid-row': '2' },
    'landed_status':              { 'grid-column': '4 / span 3', 'grid-row': '2' },
    'empolyee_coverage_required': { 'grid-row': '2' },
  };
  return nhlaaPlacement[fieldKey] ?? {};
}

getFieldColSpan(fieldKey: string, sectionKey?: string): string {
  // personal_information section — 5-col sub-grid for nhlaa and corp.
  // Row 0: plan_enrollment_date(1) | nhlaa_member_id(1) | addempty1(3)
  // Row 1: Street Address(2) | Street Address Line 2(1) | Unit/Apt/Suite(1) | City(1)
  // Row 2: remaining fields each col-span-1
  if ((this.currFormType === 'nhlaa' || this.currFormType === 'corp') && sectionKey === 'personal_information') {
    if (fieldKey === 'plan_enrollment_date') return 'col-span-1';
    if (fieldKey === 'nhlaa_member_id') return 'col-span-1';
    if (fieldKey === 'addempty1') return this.currFormType === 'nhlaa' ? 'col-span-2 sm:col-span-3' : 'col-span-3';
    if (fieldKey === 'first_name') return 'col-span-1 col-start-1';
    if (['last_name', 'email', 'phone_number'].includes(fieldKey)) return 'col-span-1';
    if (fieldKey === 'address_line_1') return 'col-span-2';
    if (fieldKey === 'address_line_2') return 'col-span-1';
    if (fieldKey === 'unit/apt/suite') return 'col-span-1';
    return 'col-span-1';
  }

  if (fieldKey === 'plan_enrollment_date') {
    return 'col-span-full lg:w-1/5';
  }

  // if (fieldKey === 'unit/apt/suite') {
  //   return this.currFormType === 'gig' ? 'col-span-1' : 'col-span-1 col-start-1';
  // }

  // NHLAA phr_questions section (6-col sub-grid):
  // Row 1 fields always col-span-2 (pinned via getFieldGridStyle).
  // Row 2 fields: col-span-2 (33%) when landed_status is visible (3 items),
  //               col-span-3 (50%) when landed_status is hidden (2 items — no gap).
  // NHLAA phr_questions — 3-col grid, all fields col-span-1 (exact 1/3 each).
  // Row 1: hasPHR | date_of_arrival | country_of_origin  (pinned via getFieldGridStyle)
  // Row 2: auto-flow — items fill left-to-right, gap auto-closes when landed_status hidden.
  // spouse_information — 5-col sub-grid for nhlaa and corp.
  // Row 1: First Name(1) | Last Name(1) | Email(1) | Gender(1) | Date of Birth(1)
  // Row 2: has_spouse_COB question (col-span-5, full row)
  // Row 3: Name Of The Carrier(1) | COB Coverage(1) | [3 empty]
  // NHLAA: spans must never exceed the column count of the wrapper at that breakpoint
  // (grid-cols-2 / sm:grid-cols-3 / md:grid-cols-5) — an oversized span makes the browser
  // add implicit columns, which crushes every sibling into a sliver and overlaps the labels.
  if (this.currFormType === 'nhlaa' && sectionKey === 'spouse_information') {
    if (fieldKey === 'has_spouse') return 'col-span-2 sm:col-span-3 md:col-span-5';
    if (['spouse_first_name', 'spouse_last_name', 'spouse_email', 'spouse_gender', 'spouse_dob'].includes(fieldKey)) return 'col-span-1';
    if (fieldKey === 'has_spouse_COB') return 'col-span-2';
    if (fieldKey === 'spouse_carrier') return 'col-span-1';
    if (fieldKey === 'spouse_COB_coverage') return 'col-span-2';
    return 'col-span-1';
  }

  if (this.currFormType === 'corp' && sectionKey === 'spouse_information') {
    if (fieldKey === 'has_spouse') return 'col-span-5';
    if (['spouse_first_name', 'spouse_last_name', 'spouse_email', 'spouse_gender', 'spouse_dob'].includes(fieldKey)) return 'col-span-1';
    if (fieldKey === 'has_spouse_COB') return 'col-span-2';
    if (fieldKey === 'spouse_carrier') return 'col-span-1';
    if (fieldKey === 'spouse_COB_coverage') return 'col-span-2';
    return 'col-span-1';
  }

  if ((this.currFormType === 'gig' || this.currFormType === 'corp') && sectionKey === 'phr_questions') {
    return '';  // placement handled entirely by getFieldGridStyle inline styles
  }

  if (this.currFormType === 'nhlaa' && sectionKey === 'phr_questions') {
    if (fieldKey === 'hasPHR') return 'col-span-4';
    if (fieldKey === 'date_of_arrival') return 'col-span-2';
    if (fieldKey === 'country_of_origin') return 'col-span-4';
    if (fieldKey === 'landed_immigrant') return 'col-span-3';
    if (fieldKey === 'landed_status') return 'col-span-3';
    if (fieldKey === 'empolyee_coverage_required') return 'col-span-4';
    return 'col-span-2';
  }

  // NHLAA spouse section (2-col sub-grid): fully override all field spans.
  // Some gig-section definitions carry customClass.nhlaa = "col-span-4" which
  // overflows a 2-col grid and completely breaks the layout.
  // 50/50 side-by-side pairs  → col-span-1
  // everything else (full row) → col-span-2
  let currField = this.allsectionData[fieldKey];

  let resolved = 'col-span-2';
  if (currField?.customClass && currField?.customClass[this.currFormType]) {
    resolved = currField.customClass[this.currFormType];
  } else if (currField?.customClass && currField?.customClass['all']) {
    resolved = currField.customClass['all'];
  }

  return this.currFormType === 'viking' ? this.toVikingResponsiveSpan(resolved) : resolved;
}

/**
 * Viking's field classes were authored for its 5-column desktop grid, so unprefixed spans
 * like col-span-4 / col-span-5 exceed the 2 columns that exist below md. The browser then
 * invents implicit columns and crushes every field, which is what made the mobile form
 * unreadable. This caps the base span at the columns that actually exist and re-applies the
 * original span at md, leaving any md:/lg: classes the config already declared.
 *
 * Only reached for currFormType === 'viking' — no other form type is touched.
 */
private toVikingResponsiveSpan(classes: string): string {
  const VIKING_BASE_COLUMNS = 2;
  const rest: string[] = [];
  let baseSpan = 0;
  let baseStart = 0;
  let hasMdSpan = false;
  let hasMdStart = false;

  for (const token of String(classes ?? '').split(/\s+/).filter(Boolean)) {
    const span = /^col-span-(\d+)$/.exec(token);
    if (span) { baseSpan = Number(span[1]); continue; }

    const start = /^col-start-(\d+)$/.exec(token);
    if (start) { baseStart = Number(start[1]); continue; }

    if (token.startsWith('md:col-span-')) hasMdSpan = true;
    if (token.startsWith('md:col-start-')) hasMdStart = true;
    rest.push(token);   // col-span-full, md:*, w-*, … pass through untouched
  }

  const out: string[] = [];
  if (baseSpan > 0) {
    out.push(`col-span-${Math.min(baseSpan, VIKING_BASE_COLUMNS)}`);
    if (!hasMdSpan) out.push(`md:col-span-${baseSpan}`);
  }
  // a fixed column start only makes sense once the 5-column grid exists
  if (baseStart > 0 && !hasMdStart) out.push(`md:col-start-${baseStart}`);

  return [...out, ...rest].join(' ');
}
 
  getFieldColSpan_(fieldKey: string): string {
    const fullWidth = ['plan_enrollment_date', 'unit/apt/suite'];
    const halfWidth = [
      'first_name', 'last_name', 'email', 'phone_number',
      'address_line_1', 'address_line_2',
      'has_spouse', 'has_child', 'working_hours', 'working_hours_30',
      'hasPHR', 'terms_and_conditions', 'advisor_disclosuer',
      'smoke',
      'beneficiary_first_name', 'beneficiary_last_name', 'beneficiary_date_of_birth',
      'beneficiary_gender', 'beneficiary_relation', 'beneficiary_percentage',
      'contingent_beneficiary_first_name', 'contingent_beneficiary_last_name',
    ];
    console.log(this.allsectionData)
    if (fullWidth.includes(fieldKey)) return 'md:col-span-4 w-full lg:w-1/2';
    if (!fullWidth.includes(fieldKey)){
      // check custom class is there or not
      let currField = this.allsectionData[fieldKey];
      if(currField?.customClass && currField?.customClass[this.currFormType]){
        return currField?.customClass[this.currFormType]
      }else{
        return 'col-span-2'
      }
    }
    return 'col-span-1';
  }
  /** maxlength attribute for text fields */
  getMaxlength(fieldKey: string): number | null {
    const map: Record<string, number> = {
      first_name: 40, last_name: 40,
      spouse_first_name: 40, spouse_last_name: 40,
    };
    return map[fieldKey] ?? null;
  }
 
  /** minlength attribute for text fields */
  getMinlength(fieldKey: string): number | null {
    const map: Record<string, number> = {
      first_name: 1, last_name: 1,
      spouse_first_name: 1, spouse_last_name: 1,
    };
    return map[fieldKey] ?? null;
  }



  /**
   * Adds Validators.required to visible fields and clears it on hidden fields.
   * Only fields listed here are dynamically managed – everything else keeps its
   * original validator from the formBuilder definition.
   */
  applyFormValidators(): void {
    const managedFields: { [key: string]: any } = {
      date_of_hiring: Validators.required,
      company_name: Validators.required,
      job_title: Validators.required,
      nhlaa_id: Validators.required,
    };

    Object.keys(managedFields).forEach(fieldName => {
      const control = this.userForm.get(fieldName);
      if (control) {
        if (this.visibleFields.has(fieldName)) {
          control.setValidators([managedFields[fieldName]]);
        } else {
          control.clearValidators();
          control.setValue('');
        }
        control.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────

  showPackageName(groups: any) {
    // if (category == 'upgrade') //console.log(groups[0].name)
    // return
    // //console.log(category)

    for (let grp of groups) {
      if (!grp || grp?.length <= 0) {
        return false
      }
      if (!grp || !grp?.plans || grp?.plans?.length <= 0) {
        return false
      } else {
        return true
      }

    }


    return false
  }
  // public getLanguageTokens() {
  //   let body = {
  //     "project": "SignupForm",
  //     "url": "GIG"
  //   }
  //   this.http
  //     .post(environment.app.langApi + 'string/project-url-strings', body, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     })
  //     .subscribe(
  //       (response: any) => {
  //         console.log(response)
  //         this.lang = {};
  //         this.languageData = response.strings
  //         this.selectedLanguage = sessionStorage.getItem("language")
  //         for (let token of response.strings) {
  //           this.lang[token.key] = token[this.selectedLanguage];
  //         }

  //         this.tabs = [
  //           {
  //             title: this.lang.Personal_Information,
  //             content: 'Content for the first tab.',
  //             background: 'bg-gray-200',
  //           },
  //           {
  //             title: this.lang.Plan_Selection,
  //             content: 'Content for the second tab.',
  //             background: 'bg-gray-200',
  //           },
  //           {
  //             title: this.lang.Enrollment_Summary,
  //             content: 'Content for the second tab.',
  //             background: 'bg-gray-200',
  //           },
  //         ];

  //       })
  // }

  public getLanguageTokens() {
    let body = {
      "project": "SignupForm",
      "url": "GIG"
    }
    this.http
      .post(environment.app.langApi + 'string/project-url-strings', body, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (!response || !response.strings || response.strings.length === 0) {
            // fallback to local language strings
            this.loadLocalLanguageStrings();
          } else {
            this.setupLanguage(response.strings);
          }
        },
        (error) => {
          // on error, also fallback to local strings
          this.loadLocalLanguageStrings();
        }
      )
  }

  private loadLocalLanguageStrings() {
    this.setupLanguage(strings);
  }

  private setupLanguage(strings: any) {
    this.lang = {};
    this.languageData = strings;
    this.selectedLanguage = sessionStorage.getItem("language");

    for (let token of strings) {
      this.lang[token.key] = token[this.selectedLanguage];
    }

    // this.tabs = [
    //   {
    //     title: this.lang.Personal_Information,
    //     content: 'Content for the first tab.',
    //     background: 'bg-gray-200',
    //   },
    //   {
    //     title: this.lang.Plan_Selection,
    //     content: 'Content for the second tab.',
    //     background: 'bg-gray-200',
    //   },
    //   {
    //     title: this.lang.Enrollment_Summary,
    //     content: 'Content for the second tab.',
    //     background: 'bg-gray-200',
    //   },
    // ];
  }


  updateSlider() {
    const value = this.sliderValue;
    this.greenWidth = (this.cutoffValue / this.maxValue) * 100;
    this.orangeWidth = 100 - this.greenWidth;
    this.filledWidth = (value / this.maxValue) * 100;
    this.cutoffWidth = this.greenWidth;
  }
  // public demofill() {
  //   // ////this.consoleMessage(this.genRandonString(3));
  //   this.userForm.controls["planEnrollmentDate"].setValue("12-01-2022");
  //   this.userForm.controls["firstName"].setValue("JohnDemo");
  //   this.userForm.controls["lastName"].setValue("Test");
  //   this.userForm.controls["email"].setValue(
  //     "johndemoaitp" + this.genRandonString(3) + "@aitestpro.com"
  //   );
  //   this.userForm.controls["phone_number"].setValue("+1 (989) 898-9898");
  //   this.userForm.controls["apt"].setValue("A");
  //   this.userForm.controls["street_address_line1"].setValue("2 Seyton Dr");
  //   this.userForm.controls["street_address_line2"].setValue("");
  //   this.userForm.controls["city"].setValue("Nepean");
  //   this.userForm.controls["province"].setValue("ON");
  //   this.userForm.controls["postal_code"].setValue("K2K 3E7");
  //   this.userForm.controls["date_of_birth"].setValue("10-01-1980");
  //   this.userForm.controls["gender"].setValue("Male");
  //   this.userForm.controls["date_of_hiring"].setValue("06-09-2024");
  //   this.userForm.controls["date_of_hiring"].setValue("06-09-2024");
  //   this.userForm.controls["company_name"].setValue("Ideabytes");
  //   this.userForm.controls["job_title"].setValue("Employee");
  //   this.userForm.controls["working_20hours"].setValue("true");
  //   this.userForm.controls["provincial_health_coverage"].setValue("true");
  //   this.userForm.controls["having_spouse"].setValue("false");
  //   this.userForm.controls["having_dependent_children"].setValue("false");
  //   this.userForm.controls["termsandconditions"].setValue("true");
  //   this.userForm.controls["disclouseradvisor"].setValue("true");
  //   // this.userForm.controls['recaptchaReactivePerInfo'].setValue(true)

  //   //     termsandconditions: ["", Validators.requiredTrue],
  //   //     disclouseradvisor: ["", Validators.requiredTrue],
  //   //     recaptchaReactivePerInfo: ["", Validators.required],

  //   // this.userForm.setValue("planenrollmentdate")
  //   // this.userForm = fb.group(
  //   //   {
  //   //     planenrollmentdate: ["", Validators.required],
  // }

  public genRandonString(length: any) {
    var chars = "abcdefghijklmnopqrstuvwxyz0123456789";
    var charLength = chars.length;
    var result = "";
    for (var i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * charLength));
    }
    return result;
  }
  ngAfterViewInit(): void {

    // setTimeout(() => {
    //   this.sigPadElement = this.sigPad.nativeElement;

    //   this.context = this.sigPadElement.getContext('2d');
    // }, 10000);

    // setTimeout(() => this.initializeCanvas(), 10000);
    // setTimeout(() => this.initializeCanvaspad(), 40000);

    // this.initializeCanvas();

    //To add the script
    // const script = this.renderer.createElement('script');
    // script.src = 'https://produs-ccs-assurancecard-service.sgsonline.net/assurancecard/be8e7fbc4499573fe387b4612fd65c7190e46c4970fd11ceab8a913201f5357e/cardJs';
    // script.async = true;

    // // Optional styling
    // this.renderer.setStyle(script, 'transform', 'rotate(5deg)');
    // this.renderer.setStyle(script, 'width', '300px');

    // this.renderer.appendChild(this.scriptTarget.nativeElement, script);

  }
  setupResizeObserver(): void {
    this.resizeObserver = new ResizeObserver(() => this.resizeCanvas());
    this.resizeObserver.observe(this.canvas.nativeElement);
  }
  postAnalyticsData() {

    var pageName = sessionStorage.getItem("pageName")

    if (sessionStorage.getItem("ipaddress")) {

      fetch(environment.app.grp + "api/common/analytics", {

        // Adding method type
        method: "POST",

        // Adding body or contents to send
        body: JSON.stringify({
          "ipAddress": sessionStorage.getItem("ipaddress"),
          "timestamp": sessionStorage.getItem("timeStamp"),
          "pageName": pageName ? pageName : "PersonalInfo",
          "gbReferer": window.document.referrer || "",
          "pageUrl": window.location.href
        }),

        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      })
    }

  }
  commonSettings() {
    //   fetch(environment.app.grp+"api/common/settings", { mode: 'cors' })
    //   .then((resp) => resp.json())
    //   .then((res) => {
    //     console.log(res)
    // // sessionStorage.setItem("ipaddress",ip.ip);

    //   });
  }
  getIPAddress() {
    this.getIpAddress();
    return;
    fetch('https://jsonip.com', { mode: 'cors' })
      .then((resp) => resp.json())
      .then((ip) => {

        // //this.consoleMessage(ip)
        sessionStorage.setItem("ipaddress", ip.ip);

      })
      .catch((error) => {
        console.error("Failed to fetch IP address from jsonip:", error);
        this.getIpAddress();
      });
  }

  getIpAddress() {
    this.http
      .get('https://api.groupbenefitz.ca/api/admin/app2')
      .subscribe((response: any) => {
        if (response?.data?.ip != undefined) {
          sessionStorage.setItem('ipaddress', response.data.ip);
        } else {
          console.error("Failed to fetch IP address from app2:", response);
        }
      })
  }

  initializeCanvas(): void {
    if (this.canvas) {
      const canvasElement = this.canvas.nativeElement;
      this.ctx = canvasElement.getContext('2d');
      // this.ctx.strokeStyle = 'red';
      if (this.ctx) {
        // console.log('Canvas context initialized successfully');
        this.resizeCanvas();
        this.setupResizeObserver();
      } else {
        // console.error('Failed to get 2D context');
      }
    } else {
      // console.error('Canvas element is not available');
    }




  }


  initializeCanvaspad(): void {
    if (this.canvaspad) {
      const canvasElementpad = this.canvaspad.nativeElement;
      this.ctxpad = canvasElementpad.getContext('2d');
      // this.ctxpad.strokeStyle = 'red';
      if (this.ctxpad) {
        // console.log('Canvas context initialized successfully');
        this.resizeCanvaspad();
      } else {
        // console.error('Failed to get 2D context');
      }
    } else {
      // console.error('Canvas element is not available');
    }
  }
  resizeCanvas(): void {
    if (this.canvas && this.ctx) {
      const canvasElement = this.canvas.nativeElement;
      canvasElement.width = canvasElement.offsetWidth;
      canvasElement.height = canvasElement.offsetHeight;
      // console.log('Canvas resized:', canvasElement.width, canvasElement.height);
    } else {
      // console.error('Canvas element or context is not available');
    }
  }
  resizeCanvaspad(): void {
    if (this.canvaspad && this.ctxpad) {
      const canvasElementpad = this.canvaspad.nativeElement;
      canvasElementpad.width = canvasElementpad.offsetWidth;
      canvasElementpad.height = canvasElementpad.offsetHeight;
      // console.log('Canvas resized:', canvasElementpad.width, canvasElementpad.height);
    } else {
      // console.error('Canvas element or context is not available');
    }
  }
  startDrawing(event: MouseEvent): void {
    if (this.ctx) {
      this.drawing = true;
      // this.ctx.beginPath();
      // this.ctx.moveTo(event.offsetX, event.offsetY);
      const coords = this.relativeCoords(event);
      this.ctx.moveTo(coords.x, coords.y);
      // console.log('Drawing started at:', event.offsetX, event.offsetY);
    } else {
      // console.error('Context not initialized');
    }

    this.isDrawing = true;

  }

  draw(event: MouseEvent): void {
    if (this.drawing && this.ctx) {
      const coords = this.relativeCoords(event);

      this.ctx.lineTo(coords.x, coords.y);
      this.ctx.stroke();

      // console.log('Drawing at:', event.offsetX, event.offsetY);
    }


  }

  stopDrawing(): void {
    if (this.drawing) {
      this.drawing = false;
      // console.log('Drawing stopped');
    }
  }



  clearCreditCardSignature() {
    const canvasElement = this.canvas.nativeElement;
    // this.ctx.clearRect(0, 0, canvasElement.width, canvasElement.height);
    // this.ctx.beginPath();
    this.signaturecheckvalue1cc = false;
    sessionStorage.removeItem("signature")
    this.signaturemessagecc = true
    this.signaturecheckcc = true
  }

  clearPadSignature() {
    // const canvasElement = this.canvaspad.nativeElement;
    // this.ctxpad.clearRect(0, 0, canvasElement.width, canvasElement.height);
    // this.ctxpad.beginPath();
    // this.signaturecheckvalue1 = false;
    // // this.signaturecheckvalue1 = false;
    // this.signaturemessagepad =true
    // sessionStorage.removeItem("signature")
  }
  // clear(): void {
  //   const canvasElement = this.canvas.nativeElement;
  //   this.ctx.clearRect(0, 0, canvasElement.width, canvasElement.height);
  // }

  save(): void {
    const canvasElement = this.canvas.nativeElement;
    const dataURL = canvasElement.toDataURL('image/png');
    // console.log(dataURL); // Use this data URL to save the image or send it to a server
  }


  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    // console.log(this.signaturePad.toDataURL());
  }
  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
    // console.log('begin drawing');
  }

  clearSignature() {
    this.signaturePad.clear();
    this.signaturecheckvalue1cc = false;
  }

  // ── CC signature pad (signaturePad1) — mirrors corporate-signup equivalents ──

  drawCompleteCC(): void {
    // notified when signaturePad1 onEnd fires
  }

  drawStartCC(): void {
    // notified when signaturePad1 onBegin fires
  }

  clearSignatureCC(): void {
    this.signaturePad1.clear();
    this.signaturecheckCC = false;
  }

  onMouseMoveCredit(e: any): void {
    this.signaturecheckCC = true;
    this.signaturemessagecc = false;
  }

  saveSignature() {
    const base64Data = this.signaturePad.toDataURL();
    // console.log(base64Data);
    // You can send the base64Data to your server here
  }

   get f(): Record<string, AbstractControl> {
    return this.userForm.controls as Record<string, AbstractControl>;
  }

  get b(): { [key: string]: AbstractControl } {
    return this.benficiaryForm.controls as Record<string, AbstractControl>;
  }

  get w(): { [key: string]: AbstractControl } {
    return this.wawanessaForm.controls;
  }

  get IA(): { [key: string]: AbstractControl } {
    return this.iafggenderForm.controls;
  }


  getControl(rowIndex: number, controlName: string) {
    return this.rows.at(rowIndex).get(controlName);
  }
  isControlInvalid(rowIndex: number, controlName: string): boolean {
    const control: any = this.getControl(rowIndex, controlName);
    return control.invalid && (control.dirty || control.touched);
  }

  getErrorMessage(rowIndex: number, controlName: string): string {
    const control: any = this.getControl(rowIndex, controlName);
    if (control.hasError('required')) {
      return `${controlName} is required.`;
    } else if (control.hasError('min')) {
      return `${controlName} must be a positive number.`;
    } else if (control.hasError('pattern')) {
      return `${controlName} can only contain letters and spaces.`;
    }
    return '';
  }
  get payment(): { [key: string]: AbstractControl } {
    return this.paymentForm.controls;
  }
  get bankpay(): { [key: string]: AbstractControl } {
    return this.bankpayForm.controls;
  }

  setActiveTab(index: number) {
    // alert(index)
    this.previousTab = this.activeTab;
    this.activeTab = index;
    this.visitedTabs.add(this.previousTab);
  }
  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e: any) {
    this.drawing = false;
  }


  // onMouseDown(e:any) {

  //   if (this.ctx) {
  //   this.drawing = true;
  //   const coords = this.relativeCoords(e);
  //   this.ctx.moveTo(coords.x, coords.y);
  //   }

  //   //this.consoleMessage("down")
  // }

  // onMouseMove(e:any) {
  //   if (this.drawing && this.ctx) {

  //     const coords = this.relativeCoords(e);
  //     this.ctx.lineTo(coords.x, coords.y);
  //     this.ctx.stroke();
  //     this.signaturecheckvalue1cc = true;
  //     this.signaturemessagecc = false
  //     this.signaturecheckcc = false;
  //     //this.consoleMessage("up")


  // }


  // }

  onMouseMove(e: any) {

    this.signaturecheckvalue1cc = true;
    this.signaturemessagecc = false
    this.showIAFGerrorMessage = false


    // if (this.isDrawing) {
    //   const coords = this.relativeCoords(e);
    //   this.context.lineTo(coords.x, coords.y);
    //   this.context.stroke();
    //   //this.consoleMessage("up")
    //   this.signaturecheckvalue1cc = true;
    //   this.signaturemessagecc = false
    //   this.signaturecheckcc = false;
    // }
  }
  onMouseDown(e: any) {
    this.isDrawing = true;
    // const coords = this.relativeCoords(e);
    // this.context.moveTo(coords.x, coords.y);

    //this.consoleMessage("down")
  }

  // onMouseMove(e) {

  //   if (this.isDrawing) {
  //     const coords = this.relativeCoords(e);
  //     this.context.lineTo(coords.x, coords.y);
  //     this.context.stroke();
  //     //this.consoleMessage("up")
  //     this.signaturecheckvalue1cc = true;
  //     this.signaturemessagecc = false
  //     this.signaturecheckcc = false;
  //   }
  // }
  onMouseDownpad(e: any) {


    if (this.ctxpad) {
      this.isDrawingpad = true;
      const coords = this.relativeCoords(e);
      this.ctxpad.moveTo(coords.x, coords.y);
    }

  }

  onMouseMovepad(e: any) {
    if (this.isDrawingpad && this.ctxpad) {
      const coords = this.relativeCoords(e);
      this.ctxpad.lineTo(coords.x, coords.y);
      this.ctxpad.stroke();
      this.signaturecheckvalue1 = true;
      this.signaturemessagepad = false;
    }
  }


  private relativeCoords(event: any): { x: number, y: number } {
    const bounds = event.target.getBoundingClientRect();
    const cords = {
      clientX: event.clientX || event.changedTouches[0].clientX,
      clientY: event.clientY || event.changedTouches[0].clientY
    };
    const x = cords.clientX - bounds.left;
    const y = cords.clientY - bounds.top;
    return { x, y };
  }

  formatPhoneNumber(event: any) {
    // const input = event.target.value.replace(/\D/g, '');
    // if (input.length <= 3) {
    //   event.target.value = `(${input}`;
    // } else if (input.length <= 6) {
    //   event.target.value = `(${input.slice(0, 3)}) ${input.slice(3)}`;
    // } else {
    //   event.target.value = `(${input.slice(0, 3)}) ${input.slice(
    //     3,
    //     6
    //   )}-${input.slice(6, 10)}`;
    // }
  }
  phoneFormat(event: any) {
    // Defer by one tick so Angular's ControlValueAccessor (also on the `change` event)
    // updates the form control value before we read and reformat it.
    setTimeout(() => {
      const inputValue = this.userForm.get("phone_number")?.value;
      const spouseInputValue = this.userForm.get("spousePhoneNumber")?.value;
      const benifInputValue = this.benficiaryForm?.get("phone_number")?.value;

      if (inputValue) {
        this.userForm.get("phone_number")?.setValue(this._PhoneNumberPipe.transform(inputValue));
      }

      if (benifInputValue) {
        this.benficiaryForm?.get("phone_number")?.setValue(this._PhoneNumberPipe.transform(benifInputValue));
      }

      if (spouseInputValue) {
        this.userForm.get("spousePhoneNumber")?.setValue(this._PhoneNumberPipe.transform(spouseInputValue));
      }
    }, 0);
  }
  public lowercaseEmployerPhoneOrEmail(): void {
    const ctrl = this.userForm.get('employerPhoneOrEmail');
    if (!ctrl) return;
    ctrl.setValue((ctrl.value ?? '').toLowerCase(), { emitEvent: false });
  }

  public formatEmployerPhoneOrEmail(): void {
    const ctrl = this.userForm.get('employerPhoneOrEmail');
    if (!ctrl) return;

    let val: string = (ctrl.value ?? '').toLowerCase().trim();

    // Field is empty — nothing to do
    if (!val) {
      ctrl.setValue('', { emitEvent: false });
      return;
    }

    const digitsOnly = val.replace(/\D/g, '');

    // Phone: entire value is only digits / spaces / + - ()
    const isPhoneLike = /^[\d\s+\-()]+$/.test(val);
    if (isPhoneLike && digitsOnly.length > 0) {
      val = this._PhoneNumberPipe.transform(digitsOnly);
    }
    // Email or other text → keep as-is (already lowercased)

    ctrl.setValue(val, { emitEvent: false });
  }

  alphabatesOnly(event: any) {
    // Names carry apostrophes, hyphens and accents (D’Sean, Ó Súilleabháin, Anne-Marie),
    // so allow every letter plus those separators instead of only A-Z and Latin-1.
    return isNameKeyAllowed(event);
  }
  public paymentmethod(event: any) {
    // this.signaturePad.clear();
    // this.clearPadSignature()
    // this.clearCreditCardSignature()
    if (event.target.value == "PAD") {
      // this.bankpay = true;
      // this.creditcardform = false;
      sessionStorage.setItem("paymentMethod", "PAD");
      // Auto-fill billing address with home address for PAD (address fields are hidden for PAD)
      this.bankpayForm.get('bankstreetaddress')?.setValue(this.userForm.controls['street_address_line1'].value);
      this.bankpayForm.get('bankstreetaddressline2')?.setValue(this.userForm.controls['street_address_line2'].value);
      this.bankpayForm.get('bankcity')?.setValue(this.userForm.controls['city'].value);
      this.bankpayForm.get('bankprovince')?.setValue(this.userForm.controls['province'].value);
      this.bankpayForm.get('bankpostalcode')?.setValue(this.userForm.controls['postal_code'].value);
      sessionStorage.setItem('homeAddress', 'true');
      // $("#bankpay").prop("checked", true);

    } else {

      // this.bankpay = false;
      // this.creditcardform = true;
      sessionStorage.setItem("paymentMethod", "CC");
      // $("#creditcard").prop("checked", true);

      this.bankfile = ""
      this.imagedisplay = false
      this.imagedisplay = ""
      sessionStorage.removeItem("fileurl")
      sessionStorage.removeItem("filename")
      this.isFileUploaded = true
      this.Shared.setMessage("")
      this.bankpayForm.get('voidcheck')?.reset();

      // $('.paymentmethod').not(this).prop('checked', false);
    }
  }

  public provincelist(event: any) {
    // alert(event.target.value)

    if (event.target.value == 'QC') {
      // jQuery("#provinceinfo-modal").modal("show");
    }

    this.configprovinceres?.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provineList = element;
      }
    });

    // ////this.consoleMessage(this.userForm.get('postalcode').value)
    if (this.userForm.controls['postal_code'].value) {
      if (
        this.provineList.zipcodes
          .split(',')
          .indexOf(this.userForm.controls['postal_code'].value[0]) == -1
      ) {
        this.invalidPostalCodeForProvince = true;
        this.userForm.controls['postal_code'].markAsTouched();
      } else {
        this.invalidPostalCodeForProvince = false;
      }

      if (this.userForm.controls['postal_code'].value.length == 0) {
        this.invalidPostalCodeForProvince = false;
      }
    }
  }


  isMemberAddressFilled(): boolean {
    const f = this.userForm?.controls;
    return !!(f?.['street_address_line1']?.value &&
              f?.['city']?.value &&
              f?.['province']?.value &&
              f?.['postal_code']?.value);
  }

  public spouseProvincelist(event: any) {

    if (event.target.value == 'QC') {
      // jQuery("#provinceinfo-modal").modal("show");
    }

    this.configprovinceres?.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        // this.provineList = element;
        this.spouseProvineList = element;

        // this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        // this.provincialZipcodes = element.zipcodes.split(",");
        // this.provincelistid = element.id;
        // this.state_id = parseInt(element.id);
        // this.fusebillid = parseInt(element.fusebillId);
        // this.statename = element.name;
      }
    });

    // Re-validate spouse postal code against the newly selected province
    if (this.userForm.controls['spousePostalCode']?.value) {
      const spousePC = this.userForm.controls['spousePostalCode'].value;
      if (
        this.spouseProvineList?.zipcodes
          ?.split(',')
          .indexOf(spousePC[0]) == -1
      ) {
        this.invalidSpousePostalCodeForProvince = true;
        this.userForm.controls['spousePostalCode'].markAsTouched();
      } else {
        this.invalidSpousePostalCodeForProvince = false;
      }

      if (spousePC.length == 0) {
        this.invalidSpousePostalCodeForProvince = false;
      }
    }
  }
  public spouseProvinceOfCoveragelist(event: any) {
    this.configprovinceres?.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.spouseProvinceOfCoverageList = element;
      }
    });
  }

  public provinceOfCoveragelist(event: any) {
    this.configprovinceres?.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provinceOfCoverageList = element;
      }
    });
  }

  public provincelistpayment(event: any) {
    // alert(event.target.value)

    if (event.target.value == 'QC') {
      // jQuery("#provinceinfo-modal").modal("show");
    }

    this.configprovinceres?.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provineListPayment = element;
        // this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        // this.provincialZipcodes = element.zipcodes.split(",");
        // this.provincelistid = element.id;
        // this.state_id = parseInt(element.id);
        // this.fusebillid = parseInt(element.fusebillId);
        // this.statename = element.name;
      }
    });

    // ////this.consoleMessage(this.userForm.get('postalcode').value)
    if (this.bankpayForm.controls['bankpostalcode'].value) {
      if (
        this.provineListPayment.zipcodes
          .split(',')
          .indexOf(this.bankpayForm.controls['bankpostalcode'].value[0]) == -1
      ) {
        this.bankinvalidPostalCode = true;
        this.bankpayForm.controls['bankpostalcode'].markAsTouched();
      } else {
        this.bankinvalidPostalCode = false;
      }

      if (this.bankpayForm.controls['bankpostalcode'].value.length == 0) {
        this.bankinvalidPostalCode = false;
      }
    }
  }
  public provincelistCreditPayment(event: any) {
    // alert(event.target.value)

    if (event.target.value == 'QC') {
      // jQuery("#provinceinfo-modal").modal("show");
    }

    this.configprovinceres?.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provineListcreditPayment = element;
        // this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        // this.provincialZipcodes = element.zipcodes.split(",");
        // this.provincelistid = element.id;
        // this.state_id = parseInt(element.id);
        // this.fusebillid = parseInt(element.fusebillId);
        // this.statename = element.name;
      }
    });

    // ////this.consoleMessage(this.userForm.get('postalcode').value)
    if (this.paymentForm.controls['postalcode'].value) {
      if (
        this.provineListcreditPayment.zipcodes
          .split(',')
          .indexOf(this.paymentForm.controls['postalcode'].value[0]) == -1
      ) {
        this.creditCradInvalidProvince = true;
        this.paymentForm.controls['postalcode'].markAsTouched();
      } else {
        this.creditCradInvalidProvince = false;
      }

      if (this.paymentForm.controls['postalcode'].value.length == 0) {
        this.creditCradInvalidProvince = false;
      }
    }
  }
  changeTextToUppercase(field: any, event: any) {
    const postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;

    // ── Spouse postal code ────────────────────────────────────────────────────
    if (field === 'spousePostalCode') {
      this.userForm.patchValue({
        spousePostalCode: this.userForm.controls['spousePostalCode'].value?.toUpperCase()
      });
      if (event.target.value.length == 0) {
        this.invalidSpousePostalCodeForProvince = false;
      } else if (
        this.spouseProvineList?.zipcodes?.split(',').indexOf(event.target.value[0]) == -1
      ) {
        this.invalidSpousePostalCodeForProvince = true;
      } else {
        postalRegexp.lastIndex = 0; // reset stateful regex
        this.invalidSpousePostalCodeForProvince =
          event.target.value ? !postalRegexp.test(event.target.value) : false;
      }
      return;
    }

    // ── Member postal code (original behaviour) ───────────────────────────────
    const obj: any = {};
    obj['postal_code'] =
      this.userForm.controls['postal_code'].value?.toUpperCase();

    this.userForm.patchValue(obj);
    if (
      this.provineList.zipcodes.split(',').indexOf(event.target.value[0]) == -1
    ) {
      this.invalidPostalCodeForProvince = true;
    } else {
      this.invalidPostalCodeForProvince = false;
      postalRegexp.lastIndex = 0;
      if (event.target.value && !postalRegexp.test(event.target.value)) {
        this.invalidPostalCodeForProvince = true;
      } else {
        this.invalidPostalCodeForProvince = false;
      }
    }

    if (event.target.value.length == 0) {
      this.invalidPostalCodeForProvince = false;
    }
  }
  changeTextToUppercasePayment(field: any, event: any) {
    const obj: any = {};
    obj['bankpostalcode'] =
      this.bankpayForm.controls['bankpostalcode'].value?.toUpperCase();

    this.bankpayForm.patchValue(obj);
    if (
      this.provineListPayment.zipcodes
        .split(',')
        .indexOf(event.target.value[0]) == -1
    ) {
      this.bankinvalidPostalCode = true;
    } else {
      this.bankinvalidPostalCode = false;
      var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
      if (event.target.value && !postalRegexp.test(event.target.value)) {
        this.bankinvalidPostalCode = true;
      } else {
        this.bankinvalidPostalCode = false;
      }
    }

    if (event.target.value.length == 0) {
      this.bankinvalidPostalCode = false;
    }
  }
  changeTextToUppercaseCreditPayment(field: any, event: any) {
    const obj: any = {};
    obj['postalcode'] =
      this.paymentForm.controls['postalcode'].value?.toUpperCase();

    this.paymentForm.patchValue(obj);
    if (
      this.provineListcreditPayment.zipcodes
        .split(',')
        .indexOf(event.target.value[0]) == -1
    ) {
      this.creditCradInvalidProvince = true;
    } else {
      this.creditCradInvalidProvince = false;
      var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
      if (event.target.value && !postalRegexp.test(event.target.value)) {
        this.creditCradInvalidProvince = true;
      } else {
        this.creditCradInvalidProvince = false;
      }
    }

    if (event.target.value.length == 0) {
      this.creditCradInvalidProvince = false;
    }
  }

  memberinfogenderCheck(event: any) {
    if (event.target.value == 'true') {
      this.iafggenderForm
        .get('gender')
        ?.setValidators([Validators.required]);
    }
    else {
      this.iafggenderForm.get('gender')?.reset();
      this.iafggenderForm.get('gender')?.clearValidators();
    }
  }
  hideIAFGgenderfrom() {
    this.iafginfo = false
  }

  spouseInfoCheck(event: any) {
    if (event.target.value == 'true') {
      this.userForm
        .get('spousefirstname')
        ?.setValidators([Validators.required, Validators.minLength(1)]);
      this.userForm
        .get('spouselastname')
        ?.setValidators([Validators.required, Validators.minLength(1)]);
      this.userForm.get('spousegender')?.setValidators([Validators.required]);
      this.userForm
        .get('spousedateofbirth')
        ?.setValidators([Validators.required]);
      this.userForm
        .get('spousehealthcard')
        ?.setValidators([Validators.required]);
      if (this.userForm.value.provincial_health_coverage == 'false') {
        this.userForm
          .get('coverageRequiredOfDependents')
          ?.setValidators([Validators.required]);
      }
      else {
        this.userForm.get('coverageRequiredOfDependents')?.reset();
        this.userForm.get('coverageRequiredOfDependents')?.clearValidators();
        this.userForm
          .get('coverageRequiredOfDependents')
          ?.updateValueAndValidity();
      }
    } else {
      if (this.userForm.value.having_dependent_children == 'true') {
        if (this.userForm.value.provincial_health_coverage == 'false') {
          this.userForm
            .get('coverageRequiredOfDependents')
            ?.setValidators([Validators.required]);
        }
        else {
          this.userForm.get('coverageRequiredOfDependents')?.reset();
          this.userForm.get('coverageRequiredOfDependents')?.clearValidators();
          this.userForm
            .get('coverageRequiredOfDependents')
            ?.updateValueAndValidity();
        }
      } else {
        // this.showlandeddependentDetails =false;

        // $("#coverageRequiredOfDependentsno").click();
        this.userForm.get('coverageRequiredOfDependents')?.reset();
        this.userForm.get('dependentdateOfArrival')?.reset();
        this.userForm.get('dependentcountryOrigin')?.reset();
        this.userForm.get('dependentLandedImigrant')?.reset();
        this.userForm.get('dependentapplylandedstaus')?.reset();
        this.userForm.get('dependentMorethan3years')?.reset();
        this.userForm.get('coverageRequiredOfDependents')?.clearValidators();
        this.userForm
          .get('coverageRequiredOfDependents')
          ?.updateValueAndValidity();
      }

      this.userForm.get('spousefirstname')?.clearValidators();
      this.userForm.get('spousefirstname')?.updateValueAndValidity();

      this.userForm.get('spouselastname')?.clearValidators();
      this.userForm.get('spouselastname')?.updateValueAndValidity();

      this.userForm.get('spousegender')?.clearValidators();
      this.userForm.get('spousegender')?.updateValueAndValidity();

      this.userForm.get('spousedateofbirth')?.clearValidators();
      this.userForm.get('spousedateofbirth')?.updateValueAndValidity();

      this.userForm.get('spousehealthcard')?.clearValidators();
      this.userForm.get('spousehealthcard')?.updateValueAndValidity();
    }
  }

  spousehealthcard(event: any) {
    if (event.target.value == 'true') {
      this.userForm
        .get('Spousenameofthecarrier')
        ?.setValidators([Validators.required]);
      this.userForm.get('spousecob')?.setValidators([Validators.required]);
    } else {
      this.userForm.get('Spousenameofthecarrier')?.clearValidators();
      this.userForm.get('Spousenameofthecarrier')?.updateValueAndValidity();

      this.userForm.get('spousecob')?.clearValidators();
      this.userForm.get('spousecob')?.updateValueAndValidity();
    }
  }
  workingHoursCheck(event: any) { }
  public formatCreditCardNumber(event: any): void {
    let inputVal = event.target.value.replace(/\s+/g, ''); // Remove existing spaces

    if (inputVal.length > 0) {
      // Format the input with spaces every 4 digits
      inputVal = inputVal.match(/.{1,4}/g).join(' ');
    }
    this.paymentForm.patchValue({ CardNumber: inputVal });

    // this.creditCardForm.patchValue({ CardNumber: inputVal });
  }
  public formatAmericaCreditCardNumber(event: any): void {
    let inputVal = event.target.value.replace(/\s+/g, ''); // Remove existing spaces

    if (inputVal.length > 0) {
      // Format the input with spaces every 4 digits
      // inputVal = inputVal.match(/.{1,4}/g).join(' ');

      inputVal = inputVal.replace(
        /(\d{4})(\d{1,6})?(\d{1,5})?/,
        function (match: any, p1: any, p2: any, p3: any) {
          return p1 + (p2 ? ' ' + p2 : '') + (p3 ? ' ' + p3 : '');
        }
      );
    }
    this.paymentForm.patchValue({ CardNumber: inputVal });
    // if (this.isValidAmexCard(inputVal.replaceAll(' ',''))) {
    //   console.log("This is a valid American Express card number.");
    // } else {
    //   console.log("This is not a valid American Express card number.");
    // }
    // this.creditCardForm.patchValue({ CardNumber: inputVal });
  }
  public isValidAmexCard(cardNumber: any) {
    // Remove any non-digit characters
    const cleanedCardNumber = cardNumber.replace(/\D/g, '');

    // Check if the card number has 15 digits and starts with 34 or 37
    const isAmex = /^3[47]\d{13}$/.test(cleanedCardNumber);

    return isAmex;
  }
  public isValidAmexCardNumber(val: any) {
    // Define the regex pattern for formatted Amex card number
    const amexPattern = /^3[47][0-9]{2} [0-9]{6} [0-9]{5}$/;
    console.log(amexPattern);
    return amexPattern.test(val.replaceAll(' ', ''));
  }
  public creditcardlblurmethod(event: any) {
    // this.postalvalue = event.target.value
    this.validateCreditCardNumber(event);

    let val = event.target.value;

    // console.log(val.slice(0, 2));

    const inputField = this.paymentForm.controls['CardNumber'];
    // this.userForm.controls['postalcode']

    if (val.slice(0, 2) == 34 || val.slice(0, 2) == 37) {
      // this.creditcardvalidationAmerica(val)
      // inputField.setValidators([Validators.required, creditcardvalidationAmerica(val)]);
      // inputField.updateValueAndValidity();

      this.formatAmericaCreditCardNumber(event);
      // this.isValidAmexCardNumber(val)
    } else {
      // this.creditcardvalidation(val)
      // inputField.setValidators([Validators.required, creditcardvalidation(val)]);
      // inputField.updateValueAndValidity();

      this.formatCreditCardNumber(event);
    }

    val = val.replaceAll(' ', '');
    let checksum = 0; // running checksum total
    let j = 1; // takes value of 1 or 2
    // Process each digit one by one starting from the last
    for (let i = val.length - 1; i >= 0; i--) {
      let calc = 0;
      // Extract the next digit and multiply by 1 or 2 on alternative digits.
      calc = Number(val.charAt(i)) * j;

      // If the result is in two digits add 1 to the checksum total
      if (calc > 9) {
        checksum = checksum + 1;
        calc = calc - 10;
      }
      // Add the units element to the checksum total
      checksum = checksum + calc;
      // Switch the value of j
      if (j == 1) {
        j = 2;
      } else {
        j = 1;
      }
    }
    //Check if it is divisible by 10 or not.
    // return (checksum % 10) == 0;
    if (checksum % 10 == 0) {
      this.invalidcreditcard = false;
    } else {
      this.invalidcreditcard = true;
      // console.log("tetshere")
    }

    // if (event.target.value.length == 0) {
    //   this.invalidcreditcard = false;
    //   consol.log("false")
    // }
  }

  validateCreditCardNumber(val: any) {
    const cardImage = document.getElementById('card-image');

    console.log(val.target.value);
    const visaPattern = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    const mastPattern = /^(?:5[1-5][0-9]{14})$/;
    const amexPattern = /^(?:3[47][0-9]{13})$/;
    const discPattern = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;

    const ccNum: string = val.target.value.replaceAll(' ', '');

    const isVisa = visaPattern.test(ccNum) === true;
    const isMast = mastPattern.test(ccNum) === true;
    const isAmex = amexPattern.test(ccNum) === true;
    const isDisc = discPattern.test(ccNum) === true;

    if (isVisa || isMast || isAmex || isDisc) {
      // at least one regex matches, so the card number is valid.
      if (isVisa) {
        // this.cardType = 'Visa card'
        this.cardType = './../../assets/img/visa.svg';
        // Visa-specific logic goes here
      } else if (isMast) {
        // this.cardType = 'Master card'
        this.cardType = './../../assets/img/mastercard.svg';
        // Mastercard-specific logic goes here
      } else if (isAmex) {
        this.cardType = './../../assets/img/american-express.svg';
        // cardImage['src']= 'path/to/amex.png';
        // cardImage.style.display = 'inline';
        // AMEX-specific logic goes here
      } else if (isDisc) {
        this.cardType = './../../assets/img/discover.svg';
        // Discover-specific logic goes here
      }
      // return of (null);
    } else {
      this.cardType = '';
      // cardImage.style.display = 'none';
      // return of({
      //   invalid: true
      // });
      // alert("Please enter a valid card number.");
    }
  }
  resolved(captchaResponse: any) {
    this.recaptchaResponse = captchaResponse;
  }
  filterExpiryDate(event: any) {
    let val = ''

    if (this.paymentForm.controls['ExpirationMonth'].value && this.paymentForm.controls['ExporationYear'].value) {
      val = this.paymentForm.controls['ExpirationMonth'].value + "/" + this.paymentForm.controls['ExporationYear'].value
    }
    // console.log('VAL', val);
    let regex: any = val.match(/^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/);

    if (regex) {
      // console.log('VALID format');
    } else {
      // console.log('INVALID format');
    }

    var exp = new Date(
      this.checkFullYearFormat(1 * regex[2]),
      1 * regex[1],
      1
    ).valueOf();
    var now = new Date();
    var currMonth = new Date(now.getFullYear(), now.getMonth(), 1).valueOf();
    // console.log(currMonth)
    if (exp <= currMonth) {
      this.invalidCardDetails = true
      // alert('Invalid Expiry Date. Date should be greater than current date');


    } else {
      this.invalidCardDetails = false
      // alert('Valid Expiry Date');
    }
  }

  checkFullYearFormat(yearVal: any) {
    var FIXED_YEAR = 50;
    if (yearVal < 100) {
      var nowYear = new Date().getFullYear();
      yearVal += Math.floor(nowYear / 100) * 100;
      if (yearVal > nowYear + FIXED_YEAR) {
        yearVal -= 100;
      } else if (yearVal <= nowYear - 100 + FIXED_YEAR) {
        yearVal += 100;
      }
    }
    return yearVal;
  }
  // public changeexpiryyear(event) {
  //   let today;
  //   let someday;
  //   let expirymonth = this.paymentForm.get("ExpirationMonth").value;

  //   let expiryyear = "20" + event.target.value;

  //   // alert(expiryyear)

  //   var oneDate = moment();
  //   var yearName = oneDate.format("YYYY");

  //   var oneMonth = moment();
  //   var MonthName = oneMonth.format("MM");

  //   if (expiryyear == yearName) {
  //     if (expirymonth < MonthName) {
  //       this.showexpiryyearerror = true;
  //       this.futureexpiredate = false;
  //     } else {
  //       this.showexpiryyearerror = false;
  //       this.showexpirymontherror = false;
  //       // this.showexpiryyearerror =false
  //       today = this.addMonths(new Date(), +6);
  //       someday = new Date();

  //       someday.setFullYear(expiryyear, expirymonth, 0);

  //       if (someday >= today) {
  //         this.futureexpiredate = false;
  //       } else {
  //         this.futureexpiredate = true;
  //         this.showexpiryyearerror = false;
  //         this.showexpirymontherror = false;
  //       }
  //     }
  //   } else {
  //     this.showexpiryyearerror = false;
  //     this.showexpirymontherror = false;
  //     today = this.addMonths(new Date(), +6);
  //     someday = new Date();

  //     someday.setFullYear(expiryyear, expirymonth, 0);
  //     if (expirymonth && expiryyear) {
  //       if (someday >= today) {
  //         this.futureexpiredate = false;
  //       } else {
  //         this.futureexpiredate = true;
  //         this.showexpiryyearerror = false;
  //         this.showexpirymontherror = false;
  //       }
  //     }
  //   }
  // }
  // public addMonths(date:any, months:any) {
  //   date.setMonth(date.getMonth() + months);
  //   return date;
  //   // alert(date)
  // }
  // public changeexpirymonth(event) {
  //   let today;
  //   let someday;

  //   let expiryyear;

  //   if (this.paymentForm.get("ExporationYear").value) {
  //     expiryyear = "20" + this.paymentForm.get("ExporationYear").value;
  //   } else {
  //     expiryyear = this.paymentForm.get("ExporationYear").value;
  //   }

  //   let expirymonth = event.target.value;

  //   var oneDate = moment();
  //   var yearName = oneDate.format("YYYY");

  //   var oneMonth = moment();
  //   var MonthName = oneMonth.format("MM");

  //   if (expiryyear == yearName) {
  //     if (expirymonth < MonthName) {
  //       this.showexpirymontherror = true;
  //       this.futureexpiredate = false;
  //     } else {
  //       this.showexpiryyearerror = false;
  //       this.showexpirymontherror = false;
  //       today = this.addMonths(new Date(), +6);
  //       someday = new Date();

  //       someday.setFullYear(expiryyear, event.target.value, 0);

  //       if (someday >= today) {
  //         this.futureexpiredate = false;
  //       } else {
  //         this.futureexpiredate = true;
  //         this.showexpiryyearerror = false;
  //         this.showexpirymontherror = false;
  //       }
  //     }
  //   } else {
  //     this.showexpirymontherror = false;
  //     this.showexpiryyearerror = false;
  //     this.futureexpiredate = false;

  //     today = this.addMonths(new Date(), +6);
  //     someday = new Date();

  //     someday.setFullYear(expiryyear, event.target.value, 0);
  //     if (expiryyear && event.target.value) {
  //       if (someday >= today) {
  //         this.futureexpiredate = false;
  //       } else {
  //         this.futureexpiredate = true;
  //         this.showexpiryyearerror = false;
  //         this.showexpirymontherror = false;
  //       }
  //     }
  //   }
  // }

  public isMinorCheck(value: any) {
    if (value.target.value == 'true') {


      this.benficiaryForm.get('dob')?.setValidators(Validators.required);
      this.benficiaryForm.get('dob')?.updateValueAndValidity();

      this.benficiaryForm.get('trusteeFirstName')?.setValidators(Validators.required);
      this.benficiaryForm.get('trusteeFirstName')?.updateValueAndValidity();


      this.benficiaryForm.get('trusteeLastName')?.setValidators(Validators.required);
      this.benficiaryForm.get('trusteeLastName')?.updateValueAndValidity();
    } else {
      this.benficiaryForm.get('dob')?.clearValidators();
      this.benficiaryForm.get('dob')?.updateValueAndValidity();

      this.benficiaryForm.get('trusteeFirstName')?.clearValidators();
      this.benficiaryForm.get('trusteeFirstName')?.updateValueAndValidity();


      this.benficiaryForm.get('trusteeLastName')?.clearValidators();
      this.benficiaryForm.get('trusteeLastName')?.updateValueAndValidity();
    }

  }

  // public isChildCheck(value: any) {
  //   if (value.target.value == 'CHILD') {
  //     this.benficiaryForm.get('isMinor')?.setValidators(Validators.required);
  //     this.benficiaryForm.get('isMinor')?.updateValueAndValidity();
  //   } else {
  //     this.benficiaryForm.get('dob')?.reset();
  //     this.benficiaryForm.get('trusteeFirstName')?.reset();
  //     this.benficiaryForm.get('trusteeLastName')?.reset();

  //     this.benficiaryForm.get('isMinor')?.clearValidators();
  //     this.benficiaryForm.get('isMinor')?.updateValueAndValidity();
  //     this.benficiaryForm.get('dob')?.clearValidators();
  //     this.benficiaryForm.get('dob')?.updateValueAndValidity();

  //     this.benficiaryForm.get('trusteeFirstName')?.clearValidators();
  //     this.benficiaryForm.get('trusteeFirstName')?.updateValueAndValidity();


  //     this.benficiaryForm.get('trusteeLastName')?.clearValidators();
  //     this.benficiaryForm.get('trusteeLastName')?.updateValueAndValidity();


  //   }

  // }
  //  public isChildCheck(value: any) {
  //     this.trusteeCheck = false

  //     this.benficiaryForm.get('dob')?.reset();
  //     this.benficiaryForm.get('trusteeFirstName')?.reset();
  //     this.benficiaryForm.get('trusteeLastName')?.reset();
  //     this.benficiaryForm.get('trusteeRelation')?.reset();

  //     if (value.target.value == 'CHILD' ) {
  //       // this.benficiaryForm.get('isMinor')?.setValidators(Validators.required);
  //       // this.benficiaryForm.get('isMinor')?.updateValueAndValidity();
  //       // this.benficiaryForm.get('dob')?.setValidators(Validators.required);
  //       // this.benficiaryForm.get('dob')?.updateValueAndValidity();

  //       this.benficiaryForm.get('trusteeFirstName')?.setValidators(Validators.required);
  //       this.benficiaryForm.get('trusteeFirstName')?.updateValueAndValidity();


  //       this.benficiaryForm.get('trusteeLastName')?.setValidators(Validators.required);
  //       this.benficiaryForm.get('trusteeLastName')?.updateValueAndValidity();

  //       this.benficiaryForm.get('trusteeRelation')?.setValidators(Validators.required);
  //       this.benficiaryForm.get('trusteeRelation')?.updateValueAndValidity();
  //     } else {
  //       // this.benficiaryForm.get('dob')?.reset();
  //       this.benficiaryForm.get('trusteeFirstName')?.reset();
  //       this.benficiaryForm.get('trusteeLastName')?.reset();
  //       this.benficiaryForm.get('trusteeRelation')?.reset();


  //       // this.benficiaryForm.get('dob')?.clearValidators();
  //       // this.benficiaryForm.get('dob')?.updateValueAndValidity();

  //       this.benficiaryForm.get('trusteeFirstName')?.clearValidators();
  //       this.benficiaryForm.get('trusteeFirstName')?.updateValueAndValidity();


  //       this.benficiaryForm.get('trusteeLastName')?.clearValidators();
  //       this.benficiaryForm.get('trusteeLastName')?.updateValueAndValidity();


  //       this.benficiaryForm.get('trusteeRelation')?.clearValidators();
  //       this.benficiaryForm.get('trusteeRelation')?.updateValueAndValidity()


  //     }

  //   }
  public isChildCheck(value: any, autoPopulateSpouseDetails: boolean = false) {
    this.trusteeCheck = false

    this.benficiaryForm.get('dob')?.reset();
    this.benficiaryForm.get('trusteeFirstName')?.reset();
    this.benficiaryForm.get('trusteeLastName')?.reset();
    this.benficiaryForm.get('trusteeRelation')?.reset();

    if (value.target.value == 'CHILD') {
      // this.benficiaryForm.get('isMinor')?.setValidators(Validators.required);
      // this.benficiaryForm.get('isMinor')?.updateValueAndValidity();
      // this.benficiaryForm.get('dob')?.setValidators(Validators.required);
      // this.benficiaryForm.get('dob')?.updateValueAndValidity();

      this.benficiaryForm.get('trusteeFirstName')?.setValidators(Validators.required);
      this.benficiaryForm.get('trusteeFirstName')?.updateValueAndValidity();


      this.benficiaryForm.get('trusteeLastName')?.setValidators(Validators.required);
      this.benficiaryForm.get('trusteeLastName')?.updateValueAndValidity();

      this.benficiaryForm.get('trusteeRelation')?.setValidators(Validators.required);
      this.benficiaryForm.get('trusteeRelation')?.updateValueAndValidity();
    } else {
      // this.benficiaryForm.get('dob')?.reset();
      this.benficiaryForm.get('trusteeFirstName')?.reset();
      this.benficiaryForm.get('trusteeLastName')?.reset();
      this.benficiaryForm.get('trusteeRelation')?.reset();


      // this.benficiaryForm.get('dob')?.clearValidators();
      // this.benficiaryForm.get('dob')?.updateValueAndValidity();

      this.benficiaryForm.get('trusteeFirstName')?.clearValidators();
      this.benficiaryForm.get('trusteeFirstName')?.updateValueAndValidity();


      this.benficiaryForm.get('trusteeLastName')?.clearValidators();
      this.benficiaryForm.get('trusteeLastName')?.updateValueAndValidity();


      this.benficiaryForm.get('trusteeRelation')?.clearValidators();
      this.benficiaryForm.get('trusteeRelation')?.updateValueAndValidity()


    }

    if (autoPopulateSpouseDetails && (
      this.benficiaryForm.value.relationship?.toLowerCase() == 'spouse' ||
      this.spouseSynonyms.includes(this.benficiaryForm.value.relationshipSpecific?.toLowerCase() ?? ''))) {
      console.log('this.benficiaryForm', this.benficiaryForm?.value);
      console.log('this.SpouseDetails', this.SpouseDetails);

      this.benficiaryForm.get('firstName')?.setValue(this.SpouseDetails.firstName);
      this.benficiaryForm.get('lastName')?.setValue(this.SpouseDetails.lastName);

      // The control holds the MM-DD-YYYY text the datepicker parses, which is what the
      // old YYYY-MM-DD string surgery produced. toTypingDate builds it from local date
      // parts and accepts a Date or any of our date strings, so it no longer breaks (or
      // silently reorders the parts) when the spouse details arrive in another shape.
      const formattedDob = toTypingDate(this.SpouseDetails.dob);
      this.benficiaryForm.get('dob')?.setValue(formattedDob);
      this.benficiaryForm.get('gender')?.setValue(this.SpouseDetails.gender);

      console.log('this.SpouseDetails', this.SpouseDetails);
    }
  }
  // public addeditbenficarySubmit() {

  //   if (this.benficiaryForm.invalid) {
  //     console.log(this.benficiaryForm.value);
  //     const invalid: any = [];
  //     const controls: any = this.benficiaryForm.controls;

  //     for (let name in controls) {
  //       if (controls[name].invalid) {
  //         invalid.push(name)
  //       }
  //     }

  //     console.log(invalid)
  //     return;
  //   }

  //   let obj = {
  //     customerType: this.benficiaryForm.value.customerType,
  //     type: "Primary",
  //     firstName: this.benficiaryForm.value.firstName,
  //     lastName: this.benficiaryForm.value.lastName,
  //     isMinor: this.benficiaryForm.value.isMinor || "",
  //     dob: this.benficiaryForm.value.dob || null,
  //     relationship: this.benficiaryForm.value.relationship,
  //     percentage: parseFloat(this.benficiaryForm.value.percentage ?? '0'),
  //     // contingentFirstName: this.benficiaryForm.value.contingentFirstName,
  //     // contingentLastName: this.benficiaryForm.value.contingentLastName,
  //     trusteeFirstName: this.benficiaryForm.value.trusteeFirstName || "",
  //     trusteeLastName: this.benficiaryForm.value.trusteeLastName || "",


  //   };
  //   if (this.BenficairyModalAddAndUpdateButton == 'Add') {
  //     this.addbenificaryData.push(obj);
  //     // this.childTableRowsLength = this.childInfoAddDataArray.length;
  //     // this.userForm
  //     //   .get('no_of_children')
  //     //   ?.setValue(this.childInfoAddDataArray.length);
  //     this.benficiaryForm.reset()
  //     this.benficiaryForm.get('dob')?.reset();
  //     this.benficiaryForm.get('dob')?.clearValidators();
  //     this.addeditbenficiary = false;
  //     sessionStorage.setItem(
  //       'addbenificaryData',
  //       JSON.stringify(this.addbenificaryData)
  //     );
  //     var total = 0;
  //     for (let i = 0; i < this.addbenificaryData.length; i++) {
  //       total += parseFloat(this.addbenificaryData[i].percentage);
  //     }

  //     if (total >= 100) {
  //       this.showaddmorebenficiary = false;
  //     } else {
  //       this.showaddmorebenficiary = true;

  //     }




  //   } else {
  //     // this.benficiaryForm.value?['contactDetails']={}
  //     // this.benficiaryForm.value?['trusteeDetails']={'firstName':'','lastName':''}
  //     console.log(this.addbenificaryData[this.editBenficiaryIndex])
  //     console.log(this.benficiaryForm.value)
  //     this.addbenificaryData[this.editBenficiaryIndex] = obj;
  //     this.addeditbenficiary = false;
  //     console.log(this.addbenificaryData)
  //     sessionStorage.setItem(
  //       'addbenificaryData',
  //       JSON.stringify(this.addbenificaryData)
  //     );
  //     var total = 0;
  //     for (let i = 0; i < this.addbenificaryData.length; i++) {
  //       total += parseFloat(this.addbenificaryData[i].percentage);
  //     }

  //     if (total >= 100) {
  //       this.showaddmorebenficiary = false;
  //     } else {
  //       this.showaddmorebenficiary = true;

  //     }

  //     this.benficiaryForm.reset()
  //     this.benficiaryForm.get('dob')?.reset();
  //     this.benficiaryForm.get('dob')?.clearValidators();
  //   }


  // }
  public addeditbenficarySubmit() {

    // //console.log(this.benficiaryForm.value)
    if (this.benficiaryForm.invalid) {
      // //console.log(this.benficiaryForm.value);
      return;
    }

    if (this.userForm.get('having_spouse')?.value != 'true' && this.benficiaryForm.value.relationship?.toLowerCase() == 'spouse' && this.currFormType != "viking") {
      this.ShowModelPopup = true;
      this.ShowModelPopupMessage = 'Please select yes for Spouse.';
      this.ShowModelPopupTitle = this.lang.Info;

      this.addeditbenficiary = false;
      this.benficiary = false;
      this.gotoPersonalInfoPage();
      return;
    }
    if (this.userForm.get('having_dependent_children')?.value != 'true' && this.benficiaryForm.value.relationship?.toLowerCase() == 'child' && this.currFormType != "viking") {
      this.ShowModelPopup = true;
      this.ShowModelPopupMessage = 'Please select yes for Dependent.';
      this.ShowModelPopupTitle = this.lang.Info;

      this.addeditbenficiary = false;
      this.benficiary = false;
      this.gotoPersonalInfoPage();
      return;
    }

    let obj: any = {
      customerType: "MEMBER",
      type: "Primary",
      firstName: this.capitalize(this.benficiaryForm.value.firstName ?? ""),
      lastName: this.capitalize(this.benficiaryForm.value.lastName ?? ""),
      email: this.benficiaryForm.value.email ?? '',
      phone_number: this.benficiaryForm.value.phone_number ?? '',

      dob: this.formatDobToYMD(this.benficiaryForm.value.dob),
      relationship: this.benficiaryForm.value.relationship ?? "",  // keep lowercase to match dynamic dropdown option values
      percentage: parseFloat(this.benficiaryForm.value.percentage ?? '0'),
      // contingentFirstName: this.benficiaryForm.value.contingentFirstName,
      // contingentLastName: this.benficiaryForm.value.contingentLastName,
      trusteeFirstName: this.benficiaryForm.value.trusteeFirstName ? this.capitalize(this.benficiaryForm.value.trusteeFirstName) : '',
      trusteeLastName: this.benficiaryForm.value.trusteeLastName ? this.capitalize(this.benficiaryForm.value.trusteeLastName) : '',
      trusteeRelation: this.benficiaryForm.value.trusteeRelation ? this.capitalize(this.benficiaryForm.value.trusteeRelation) : '',

      gender: this.benficiaryForm.value.gender,  // keep lowercase to match dynamic dropdown option values

    };
    if (obj.relationship.toLowerCase() == 'other') {
      obj['relationshipSpecific'] = this.benficiaryForm.value.relationshipSpecific ? this.capitalize(this.benficiaryForm.value.relationshipSpecific) : '';
    } else {
      obj['relationshipSpecific'] = '';
    }

    if (this.benficiaryForm.value.relationship?.toLowerCase() == "child") {
      obj.isMinor = this.adult(this.benficiaryForm.value.dob) ? false : true
    } else {
      obj.isMinor = false
    }



    if (this.BenficairyModalAddAndUpdateButton == this.lang.Add) {
      this.addbenificaryData.push(obj);
      // this.childTableRowsLength = this.childInfoAddDataArray.length;
      // this.userForm
      //   .get('no_of_children')
      //   ?.setValue(this.childInfoAddDataArray.length);
      this.benficiaryForm.reset();
      this.addeditbenficiary = false;
      this.benficiary = true;         // restore main modal after add
      sessionStorage.setItem(
        'addbenificaryData',
        JSON.stringify(this.addbenificaryData)
      );
      var total = 0;
      for (let i = 0; i < this.addbenificaryData.length; i++) {
        total += parseFloat(this.addbenificaryData[i].percentage);
      }

      if (total >= 100) {
        this.showaddmorebenficiary = false;
      } else {
        this.showaddmorebenficiary = true;
      }

    } else {
      this.addbenificaryData[this.editBenficiaryIndex] = obj;
      this.addeditbenficiary = false;
      this.benficiary = true;         // restore main modal after update
      sessionStorage.setItem(
        'addbenificaryData',
        JSON.stringify(this.addbenificaryData)
      );
      var total = 0;
      for (let i = 0; i < this.addbenificaryData.length; i++) {
        total += parseFloat(this.addbenificaryData[i].percentage);
      }

      if (total >= 100) {
        this.showaddmorebenficiary = false;
      } else {
        this.showaddmorebenficiary = true;
      }

      this.benficiaryForm.reset();
    }


  }
  public addnewbenficiary() {
    this.benficiary = false;       // hide main modal so add modal is not covered
    this.addeditbenficiary = true;
    this.benficiaryForm.reset();
    this.BenficairyModalAddAndUpdateButton = this.lang.Add || 'Add';
  }
  // Beneficiary dob is stored as a plain YYYY-MM-DD string (no time / timezone) so it
  // survives sessionStorage round-trips without shifting a day.
  public formatDobToYMD(date: any) {
    if (!date) {
      return null;
    }
    // already in YYYY-MM-DD
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
    // toApiDate builds and reads the date from local year/month/day parts only, so a
    // value that arrived as 'YYYY-MM-DD' is not re-parsed as UTC and handed back a day
    // earlier in Canadian and US timezones.
    return toApiDate(date) || date;
  }

  // Reverse of formatDobToYMD - the datepicker control needs a real Date when editing.
  public parseDobToDate(value: any) {
    if (!value || value instanceof Date) {
      return value;
    }
    // Handles YYYY-MM-DD, MM-DD-YYYY and MMM-DD-YYYY, always producing local midnight.
    return toLocalDate(value) ?? value;
  }

  public adult(date: any) {

    // Same rule as before - 18 completed years - but parsed in local time so a date of
    // birth does not read as the previous day west of Greenwich.
    const age = calculateAgeFrom(date);
    // An unparseable date is not evidence of adulthood, so keep the minor path.
    return age !== null && age >= 18;
  }
  // public savebenficiary(value: any) {
  //   if (this.benficiaryForm.invalid) {
  //     console.log(this.benficiaryForm.value);
  //     return;
  //   }
  //   console.log(JSON.stringify(this.benficiaryForm.value, null, 2));
  //   // alert(this.insurancestatename)
  //   let obj = {
  //     customerType: this.benficiaryForm.value.customerType,
  //     type: "Primary",
  //     firstName: this.benficiaryForm.value.firstName,
  //     lastName: this.benficiaryForm.value.lastName,
  //     isMinor: this.benficiaryForm.value.isMinor || "",
  //     dob: this.benficiaryForm.value.dob || null,
  //     relationship: this.benficiaryForm.value.relationship,
  //     percentage: parseFloat(this.benficiaryForm.value.percentage ?? '0'),
  //     // contingentFirstName: this.benficiaryForm.value.contingentFirstName,
  //     // contingentLastName: this.benficiaryForm.value.contingentLastName,
  //     trusteeFirstName: this.benficiaryForm.value.trusteeFirstName || "",
  //     trusteeLastName: this.benficiaryForm.value.trusteeLastName || "",


  //   };
  //   this.addbenificaryData.push(obj)

  //   console.log(this.addbenificaryData)
  //   this.benficiaryForm.reset()
  //   this.showBenificiaryForm = false;
  //   this.showbenificaryTable = true
  //   let licenceExist = false;



  //   var total = 0;
  //   for (let i = 0; i < this.addbenificaryData.length; i++) {
  //     total += parseFloat(this.addbenificaryData[i].percentage);
  //   }

  //   if (total >= 100) {
  //     this.showaddmorebenficiary = false;
  //   } else {
  //     this.showaddmorebenficiary = true;

  //   }

  //   sessionStorage.setItem(
  //     'addbenificaryData',
  //     JSON.stringify(this.addbenificaryData)
  //   );

  // }
  public savebenficiary(value: any) {
    if (this.benficiaryForm.invalid) {
      console.log(this.benficiaryForm.value);
      // //console.log(this.benficiaryForm.value);
      return;
    }


    console.log("this.userform39939: ",this.userForm)
    if (this.userForm.get('having_spouse')?.value != 'yes' && this.benficiaryForm.value.relationship?.toLowerCase() == 'spouse' && this.currFormType != 'viking') {
      this.ShowModelPopup = true;
      this.ShowModelPopupMessage = 'Please select yes for Spouse.';
      this.ShowModelPopupTitle = this.lang.Info;

      this.addeditbenficiary = false;
      this.benficiary = false;
      this.gotoPersonalInfoPage();
      return;
    }
    if (this.userForm.get('has_child')?.value != 'no' && this.benficiaryForm.value.relationship?.toLowerCase() == 'child' && this.currFormType != 'viking') {
      this.ShowModelPopup = true;
      this.ShowModelPopupMessage = 'Please select yes for Dependent.';
      this.ShowModelPopupTitle = this.lang.Info;

      this.addeditbenficiary = false;
      this.benficiary = false;
      this.gotoPersonalInfoPage();
      return;
    }


    console.log("this.benficiaryForm123: ",this.benficiaryForm)

    // //console.log(JSON.stringify(this.benficiaryForm.value, null, 2));
    // alert(this.insurancestatename)
    let obj: any = {
      customerType: "MEMBER",
      type: "Primary",
      firstName: this.capitalize(this.benficiaryForm.value.firstName ?? ""),
      lastName: this.capitalize(this.benficiaryForm.value.lastName ?? ""),
      email: this.benficiaryForm.value.email ?? '',
      phone_number: this.benficiaryForm.value.phone_number ?? '',
      // isMinor: this.benficiaryForm.value.isMinor ?? "",
      dob: this.formatDobToYMD(this.benficiaryForm.value.dob),
      relationship: this.benficiaryForm.value.relationship ?? "",  // keep lowercase to match dynamic dropdown option values
      percentage: parseFloat(this.benficiaryForm.value.percentage ?? '0'),
      // contingentFirstName: this.benficiaryForm.value.contingentFirstName,
      // contingentLastName: this.benficiaryForm.value.contingentLastName,

      trusteeFirstName: this.benficiaryForm.value.trusteeFirstName ? this.capitalize(this.benficiaryForm.value.trusteeFirstName) : '',
      trusteeLastName: this.benficiaryForm.value.trusteeLastName ? this.capitalize(this.benficiaryForm.value.trusteeLastName) : '',
      trusteeRelation: this.benficiaryForm.value.trusteeRelation ? this.capitalize(this.benficiaryForm.value.trusteeRelation) : '',

      gender: this.benficiaryForm.value.gender,  // keep lowercase to match dynamic dropdown option values

    };
    if (obj.relationship.toLowerCase() == 'other') {
      obj['relationshipSpecific'] = this.benficiaryForm.value.relationshipSpecific ? this.capitalize(this.benficiaryForm.value.relationshipSpecific) : '';
    } else {
      obj['relationshipSpecific'] = '';
    }

    if (this.benficiaryForm.value.relationship?.toLowerCase() == "child") {
      console.log(this.adult(this.benficiaryForm.value.dob))
      obj.isMinor = this.adult(this.benficiaryForm.value.dob) ? false : true
    } else {
      obj.isMinor = false
    }
    this.addbenificaryData.push(obj)

    console.log(this.addbenificaryData)

    // //console.log(this.addbenificaryData)
    this.benficiaryForm.reset()
    this.showBenificiaryForm = false;
    this.showbenificaryTable = true
    let licenceExist = false;



    var total = 0;
    for (let i = 0; i < this.addbenificaryData.length; i++) {
      total += parseFloat(this.addbenificaryData[i].percentage);
    }

    if (total >= 100) {
      this.showaddmorebenficiary = false;
    } else {
      this.showaddmorebenficiary = true;

    }

    sessionStorage.setItem(
      'addbenificaryData',
      JSON.stringify(this.addbenificaryData)
    );

  }
  public deleteBenficiary(license: any, i: number) {
    Swal.fire({
      title: this.lang.Alert,
      text: this.lang.Are_you_sure_you_want_to_delete_this_Benficiary,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.addbenificaryData.splice(i, 1);

        if (this.addbenificaryData.length == 0) {
          this.showBenificiaryForm = true;
          this.showbenificaryTable = false
        } else {
          this.showBenificiaryForm = false;
          this.showbenificaryTable = true
        }
        // sessionStorage.setItem(
        //   'addlicenseformData',
        //   JSON.stringify(this.addlicenseformData)
        // );
        sessionStorage.setItem(
          'addbenificaryData',
          JSON.stringify(this.addbenificaryData)
        );
        var total = 0;
        for (let i = 0; i < this.addbenificaryData.length; i++) {
          total += parseFloat(this.addbenificaryData[i].percentage);
        }

        if (total >= 100) {
          this.showaddmorebenficiary = false;
        } else {
          this.showaddmorebenficiary = true;

        }
        // const validateBeneficiaries = this.addbenificaryData.reduce((acc: any, obj: any) => {

        //   if (!acc[obj.type]) {
        //     acc[obj.type] = 0;
        //   }
        //   acc[obj.type] += parseFloat(obj.percentage);
        //             return acc;
        // }, {});

        // for (const key in validateBeneficiaries) {

        //   if (validateBeneficiaries.hasOwnProperty(key)) {

        //     console.log(`The type ${key} with perc: ${validateBeneficiaries[key]}`);

        //     if (validateBeneficiaries[key] > 100) {
        //       this.beneficiaryErrorMessage += `${key} type has percentage issue. \n`
        //       this.showaddmorebenficiary =true
        //     }
        //     if (validateBeneficiaries[key] < 100) {
        //       this.beneficiaryErrorMessage += `${key} type has percentage issue. \n`
        //       this.showaddmorebenficiary =true        }
        //     if (validateBeneficiaries[key] == 100) {
        //       this.showaddmorebenficiary =false

        //     }
        //     // else{
        //     //   this.benficiaryCount =true
        //     //   this.benficiaryCountMessage='Please Enter Benefeciary Percentage equal to 100'
        //     // }
        //   }
        // }

        // if (this.beneficiaryErrorMessage != "") {
        //   //error
        // return false;
        // }
      }
    });
  }
  public finalbenificiarySubmit() {
    var total = 0;
    for (let i = 0; i < this.addbenificaryData.length; i++) {
      total += parseFloat(this.addbenificaryData[i].percentage);
    }
    // if(total==100){
    // this.benficiary =false

      if(this?.wawanessaForm?.value?.smoker){
        this.smokerDetails = {
          smoker: this?.wawanessaForm?.value?.smoker ?? "false",
          earningsFrequency: this?.wawanessaForm?.value?.earningsFrequency ?? "",
          earningsAmount: this?.wawanessaForm?.value?.earningsAmount ?? "0"
        };

        sessionStorage.setItem("smokerDetails", JSON.stringify(this.smokerDetails))
      }

    const validateBeneficiaries = this.addbenificaryData.reduce((acc: any, obj: any) => {
      const compositeKey = `${obj.customerType}_${obj.type}`;
      if (!acc[compositeKey]) {
        acc[compositeKey] = 0;
      }
      acc[compositeKey] += parseFloat(obj.percentage);
      return acc;
    }, {});

    let beneficiaryError = "";
    for (const key in validateBeneficiaries) {
      if (validateBeneficiaries.hasOwnProperty(key)) {
        const [customerType, type] = key.split("_");
        console.log(`The customerType ${customerType} and type ${type} with perc: ${validateBeneficiaries[key]}`);

        if (validateBeneficiaries[key] != 100) {
          beneficiaryError += `CustomerType ${customerType} and type ${type} has percentage issue. \n`
        }
      }
    }




    if (beneficiaryError != "") {
      this.benficiaryCount = true
      this.benficiaryCountMessage = this.lang.Distributed_percentages_must_equal_100_and_not_more
      return false;
    }

    else {
      this.benficiary = false

    }

  }



  public benficiaryconfirm() {
    this.benficiaryCount = false
  }

  /**
   * Given a form control name and a raw stored value, finds the matching option
   * value in activeBeneficiaryFields using a case-insensitive comparison.
   * This handles saved data that may have different casing (e.g. "Spouse" vs "spouse",
   * "commonlaw" vs "commonLaw") and returns the exact option value the dropdown expects.
   */
  private normalizeToOptionValue(controlName: string, value: string): string {
    if (!value) return '';
    for (const sectionKey of this.activeBeneficiarySections) {
      const section = this.activeBeneficiaryFields[sectionKey];
      for (const fieldKey of Object.keys(section || {})) {
        const field = section[fieldKey];
        if (field.control_name === controlName && Array.isArray(field.options)) {
          // Exact match first
          const exact = field.options.find((opt: any) => opt.value === value);
          if (exact) return exact.value;
          // Case-insensitive fallback
          const ci = field.options.find(
            (opt: any) => opt.value.toLowerCase() === value.toLowerCase()
          );
          if (ci) return ci.value;
        }
      }
    }
    return value; // fallback: return original if no option matched
  }
  public editbenficiary(e: any, i: any, broker: any) {
    this.benficiary = false;       // hide main modal so edit modal is not covered
    this.addeditbenficiary = true;
    // //console.log(broker)

    if (broker.isMinor == true) {

      // this.benficiaryForm.get('isMinor')?.setValidators(Validators.required);
      // this.benficiaryForm.get('isMinor')?.updateValueAndValidity();


      // this.benficiaryForm.get('dob')?.setValidators(Validators.required);
      // this.benficiaryForm.get('dob')?.updateValueAndValidity();

      this.benficiaryForm.get('trusteeFirstName')?.setValidators(Validators.required);
      this.benficiaryForm.get('trusteeFirstName')?.updateValueAndValidity();


      this.benficiaryForm.get('trusteeLastName')?.setValidators(Validators.required);
      this.benficiaryForm.get('trusteeLastName')?.updateValueAndValidity();

      this.benficiaryForm.get('trusteeRelation')?.setValidators(Validators.required);
      this.benficiaryForm.get('trusteeRelation')?.updateValueAndValidity();

    } else {
      // this.benficiaryForm.get('isMinor')?.clearValidators();
      // this.benficiaryForm.get('isMinor')?.updateValueAndValidity();

      // this.benficiaryForm.get('dob')?.clearValidators();
      // this.benficiaryForm.get('dob')?.updateValueAndValidity();

      this.benficiaryForm.get('trusteeFirstName')?.clearValidators();
      this.benficiaryForm.get('trusteeFirstName')?.updateValueAndValidity();


      this.benficiaryForm.get('trusteeLastName')?.clearValidators();
      this.benficiaryForm.get('trusteeLastName')?.updateValueAndValidity();

      this.benficiaryForm.get('trusteeRelation')?.clearValidators();
      this.benficiaryForm.get('trusteeRelation')?.updateValueAndValidity();
    }
    // Normalize dropdown fields so they match the exact option values in activeBeneficiaryFields.
    // Uses case-insensitive lookup instead of raw toLowerCase(), which would break camelCase
    // option values like "commonLaw" (→ "commonlaw") or "nonBinary" (→ "nonbinary").
    const normalizedBroker = {
      ...broker,
      // dob is stored as YYYY-MM-DD; bsDatepicker needs a Date back
      dob: this.parseDobToDate(broker.dob),
      relationship: this.normalizeToOptionValue('relationship', broker.relationship || ''),
      gender:       this.normalizeToOptionValue('gender',       broker.gender       || ''),
      // Re-add % suffix so the input shows e.g. "50%" when editing
      percentage:   (broker.percentage != null && broker.percentage !== '')
                      ? `${broker.percentage}%`
                      : '',
    };
    this.benficiaryForm.patchValue(normalizedBroker);
    // Trigger visibility/validator update after patching
    this.updateBeneficiaryValidators();

    this.editBenficiaryIndex = i;
    this.BenficairyModalAddAndUpdateButton = this.lang.Update;

  }
  public editbenficiary12(e: any, i: any, broker: any) {
    this.addeditbenficiary = true
    console.log(broker)

    if (broker.isMinor == "true") {

      this.benficiaryForm.get('isMinor')?.setValidators(Validators.required);
      this.benficiaryForm.get('isMinor')?.updateValueAndValidity();


      this.benficiaryForm.get('dob')?.setValidators(Validators.required);
      this.benficiaryForm.get('dob')?.updateValueAndValidity();

      this.benficiaryForm.get('trusteeFirstName')?.setValidators(Validators.required);
      this.benficiaryForm.get('trusteeFirstName')?.updateValueAndValidity();


      this.benficiaryForm.get('trusteeLastName')?.setValidators(Validators.required);
      this.benficiaryForm.get('trusteeLastName')?.updateValueAndValidity();

    } else {
      this.benficiaryForm.get('isMinor')?.clearValidators();
      this.benficiaryForm.get('isMinor')?.updateValueAndValidity();

      this.benficiaryForm.get('dob')?.clearValidators();
      this.benficiaryForm.get('dob')?.updateValueAndValidity();

      this.benficiaryForm.get('trusteeFirstName')?.clearValidators();
      this.benficiaryForm.get('trusteeFirstName')?.updateValueAndValidity();


      this.benficiaryForm.get('trusteeLastName')?.clearValidators();
      this.benficiaryForm.get('trusteeLastName')?.updateValueAndValidity();
    }
    this.benficiaryForm.patchValue(broker)

    this.editBenficiaryIndex = i;
    this.BenficairyModalAddAndUpdateButton = 'Update';

  }
  public checkpercentagevalue(event: any) {
    const input = event.target as HTMLInputElement;
    // Strip any existing % to isolate the raw numeric portion
    const raw = input.value.replace(/%/g, '').trim();

    if (!raw) {
      // Nothing typed yet — keep field empty (no lone % symbol)
      this.benficiaryForm.controls['percentage'].setValue('', { emitEvent: false });
      return;
    }

    const num = parseFloat(raw);

    if (isNaN(num) || num > 100) {
      this.benficiaryForm.controls['percentage'].reset();
      this.benficiaryForm.controls['percentage'].markAsTouched();
      return;
    }

    // Append % and move cursor to just before it so continued typing works naturally
    const newVal = `${raw}%`;
    this.benficiaryForm.controls['percentage'].setValue(newVal, { emitEvent: false });
    const cursorPos = newVal.length - 1; // position before '%'
    setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);
  }
  public provincialCoverageHealth(value: any) {
    // alert("test")
    if (value.target.value === 'true') {
      this.spouseplaceholdername = this.lang.Name_As_Shown_On_Provincial_Health_Card;

      this.userForm.get('dateOfArrival')?.clearValidators();
      this.userForm.get('dateOfArrival')?.updateValueAndValidity();
      this.userForm.get('isEmployeeImigrant')?.clearValidators();
      this.userForm.get('isEmployeeImigrant')?.updateValueAndValidity();
      this.userForm.get('applylandedstaus')?.clearValidators();
      this.userForm.get('applylandedstaus')?.updateValueAndValidity();
      this.userForm.get('countryOrigin')?.clearValidators();
      this.userForm.get('countryOrigin')?.updateValueAndValidity();
      this.userForm.get('coverageRequiredOfEmployee')?.clearValidators();
      this.userForm.get('coverageRequiredOfEmployee')?.updateValueAndValidity();



      if (this.userForm.get('having_spouse')?.value === 'true' || this.userForm.get('having_dependent_children')?.value === 'true') {

        this.userForm.get('coverageRequiredOfDependents')?.clearValidators();
        this.userForm.get('coverageRequiredOfDependents')?.reset();
        this.userForm.get('coverageRequiredOfDependents')?.updateValueAndValidity();


      } else {
        this.userForm.get('coverageRequiredOfDependents')?.clearValidators();
        this.userForm.get('coverageRequiredOfDependents')?.reset();
        this.userForm.get('coverageRequiredOfDependents')?.updateValueAndValidity();



      }
    } else {
      this.spouseplaceholdername = this.lang.First_Name;

      this.userForm.get('dateOfArrival')?.setValidators(Validators.required);
      this.userForm
        .get('isEmployeeImigrant')
        ?.setValidators(Validators.required);
      this.userForm.get('countryOrigin')?.setValidators(Validators.required);
      this.userForm
        .get('coverageRequiredOfEmployee')
        ?.setValidators(Validators.required);
      // this.checkhealthcardstatus = true;
      if (this.userForm.get('having_spouse')?.value == 'true' || this.userForm.get('having_dependent_children')?.value == 'true') {


        this.userForm
          .get('coverageRequiredOfDependents')
          ?.setValidators([Validators.required]);
        this.userForm.get('coverageRequiredOfDependents')?.updateValueAndValidity();


      }
      else {
        this.userForm.get('coverageRequiredOfDependents')?.reset();
        this.userForm.get('coverageRequiredOfDependents')?.clearValidators();
        this.userForm.get('coverageRequiredOfDependents')?.updateValueAndValidity();

      }
    }


  }

  public landedimmigrantStatus(value: any) {
    // alert("test")
    if (value.target.value == 'true') {
      this.userForm.get('applylandedstaus')?.clearValidators();
      this.userForm.get('applylandedstaus')?.updateValueAndValidity();
    } else {
      this.userForm.get('applylandedstaus')?.setValidators(Validators.required);
      this.userForm.get('applylandedstaus')?.updateValueAndValidity();

      // this.checkhealthcardstatus = true;
    }
  }

  public dependentCoverage(value: any) {
    if (value.target.value == 'true') {
      this.userForm
        .get('dependentdateOfArrival')
        ?.setValidators(Validators.required);
      this.userForm
        .get('dependentLandedImigrant')
        ?.setValidators(Validators.required);
      this.userForm
        .get('dependentMorethan3years')
        ?.setValidators(Validators.required);
      this.userForm
        .get('dependentcountryOrigin')
        ?.setValidators(Validators.required);
    } else {
      this.userForm.get('dependentdateOfArrival')?.clearValidators();
      this.userForm.get('dependentdateOfArrival')?.updateValueAndValidity();

      this.userForm.get('dependentLandedImigrant')?.clearValidators();
      this.userForm.get('dependentLandedImigrant')?.updateValueAndValidity();

      this.userForm.get('dependentapplylandedstaus')?.clearValidators();
      this.userForm.get('dependentapplylandedstaus')?.updateValueAndValidity();

      this.userForm.get('dependentMorethan3years')?.clearValidators();
      this.userForm.get('dependentMorethan3years')?.updateValueAndValidity();

      this.userForm.get('dependentcountryOrigin')?.clearValidators();
      this.userForm.get('dependentcountryOrigin')?.updateValueAndValidity();
      // this.checkhealthcardstatus = true;
    }
  }

  public dependentLandedImigrant(value: any) {
    // alert("test")
    if (value.target.value == 'true') {
      this.userForm.get('dependentapplylandedstaus')?.clearValidators();
      this.userForm.get('dependentapplylandedstaus')?.updateValueAndValidity();
    } else {
      this.userForm
        .get('dependentapplylandedstaus')
        ?.setValidators([Validators.required]);
      // this.checkhealthcardstatus = true;
    }
  }

  public havingchildren(event: any) {
    //this.consoleMessage("havingchildren: ");
    if (event.target.value == 'true') {
      this.userForm
        .get('no_of_children')
        ?.setValue(this.noOfChildrenChangedValue);

      if (this.userForm.value.provincial_health_coverage == 'false') {
        this.userForm
          .get('coverageRequiredOfDependents')
          ?.setValidators([Validators.required]);
      }
    } else {
      if (this.userForm.value.having_spouse == 'true') {
        if (this.userForm.value.provincial_health_coverage == 'false') {
          this.userForm
            .get('coverageRequiredOfDependents')
            ?.setValidators([Validators.required]);
        }
      } else {
        // this.showlandeddependentDetails =false;

        // $("#coverageRequiredOfDependentsno").click();
        this.userForm.get('coverageRequiredOfDependents')?.reset();
        this.userForm.get('dependentdateOfArrival')?.reset();
        this.userForm.get('dependentcountryOrigin')?.reset();
        this.userForm.get('dependentLandedImigrant')?.reset();
        this.userForm.get('dependentapplylandedstaus')?.reset();
        this.userForm.get('dependentMorethan3years')?.reset();
        this.userForm.get('coverageRequiredOfDependents')?.clearValidators();
        this.userForm
          .get('coverageRequiredOfDependents')
          ?.updateValueAndValidity();
      }

      // this.childrenhealthinformation = false;
      this.childInfoAddDataArray.shift();
      this.childTableRowsLength = this.childInfoAddDataArray.length;
      this.userForm.get('childrenDetails')?.reset();
      this.userForm.get('childrenDetails')?.clearValidators();
      this.userForm.get('no_of_children')?.clearValidators();
      this.userForm.get('no_of_children')?.updateValueAndValidity();
    }
  }

  public childAddFun() {
    this.showModal = true;
    this.childInfoModalAddAndUpdateButton = this.lang.Add;
    this.editChildInfo = ''
  }
  public termandconditions() {
    this.showModelDialog = true;
    this.pdfData = this.formConfigResult.links.termsConditions;
    this.header = this.lang.Terms_Conditions
  }

  public advisorDisclousre() {
    this.showModelDialog = true;
    this.pdfData = this.formConfigResult.links.disclosureAgreement;
    this.header = this.lang.Advisor_Disclosure
  }

  public DeleteChild(index: any) {
    this.deleteChildIndex = index;
    this.showDeleteModal = true;
  }
  public EditChild(index: any) {
    this.editChildIndex = index;
    this.childInfoModalAddAndUpdateButton = this.lang.Update;
    this.showModal = true;

    this.editChildInfo = this.childInfoAddDataArray[index];

    console.log(this.editChildInfo);
  }
  onConfirmed(confirmed: boolean) {
    if (confirmed) {
      // console.log(this.deleteChildIndex);

      this.childInfoAddDataArray.splice(this.deleteChildIndex, 1);
      this.showDeleteModal = false;
      // console.log('Confirmation result:', confirmed);
      this.childTableRowsLength = this.childInfoAddDataArray.length;
      this.userForm
        .get('no_of_children')
        ?.setValue(this.childInfoAddDataArray.length);

      if (this.childInfoAddDataArray.length == 0) {
        this.userForm.get('having_dependent_children')?.setValue('false');
        this.userForm.get('no_of_children')?.clearValidators();
        this.userForm.get('no_of_children')?.updateValueAndValidity();
      }
    } else {
      this.showDeleteModal = false;
    }
  }

  onPdfConfirmed(confirmed: boolean) {
    if (confirmed) {
      this.showModelDialog = false;
    } else {
      this.showModelDialog = false;
    }
  }
  onPADPdfConfirmed(confirmed: boolean) {
    if (confirmed) {
      this.showPADModelDiaslog = false;
    } else {
      this.showPADModelDiaslog = false;
      this.acceptAggrement()
    }
  }
  onClosedModelpopup(confirmed: boolean) {
    if (confirmed) {
      this.ShowModelPopup = false;
    } else {
      this.ShowModelPopup = false;
    }
  }

  public acceptAggrement() {
    setTimeout(() => {

      let inputData = {
        "url": sessionStorage.getItem("fileurl"),
        "filename": sessionStorage.getItem("filename"),
        "signature": sessionStorage.getItem("signature")
      }

      this._SignupformService.padsignature(inputData).subscribe((result: any) => {
        if (result.status == "200") {

          this.showPADModelDiaslog = true
          this.pdfData = result.data.url
          this.header = "PAD Agreement"
          sessionStorage.setItem("failed", "")


        } else {
          this.failedarray.push("updatePAD")
          //this.consoleMessage(this.failedarray)
          sessionStorage.setItem("failed", JSON.stringify(this.failedarray))

        }

      })




    }, 1000);
  }

  onSubmitForm(data: any) {
    this.childInfoAddDataArray[this.childTableEditRowIndex];
    // console.log('Form submitted:', data);
    if (this.childInfoModalAddAndUpdateButton == this.lang.Add) {
      this.childInfoAddDataArray.push(data);
      this.childTableRowsLength = this.childInfoAddDataArray.length;
      this.userForm
        .get('no_of_children')
        ?.setValue(this.childInfoAddDataArray.length);

      // console.log(this.childTableRowsLength);
      // console.log(this.childInfoAddDataArray);

      this.showModal = false;
    } else {
      this.childInfoAddDataArray[this.editChildIndex] = data;
      this.showModal = false;
    }
  }

  onCloseModal() {
    this.showModal = false;
  }
  onClose() {
    this.benficiary = false
  }
  onCloseaddeditbenificary() {
    this.addeditbenficiary = false;
    this.benficiaryForm.reset();
    this.benficiary = true;        // restore main modal
  }
  deleteChildrenSwal(index: any) {
    // Swal.fire({
    //   title: this.lang.Info,
    //   text: "Are you sure you want to delete?",
    //   showCancelButton: true,
    //   confirmButtonColor: "#10104d",
    //   cancelButtonColor: "#10104d",
    //   width: "30%",
    //   confirmButtonText: "Yes",
    //   customClass: {
    //     header: 'swal-header-orange',
    //     popup: 'custom-swal-dialog',
    //     confirmButton: 'custom-ok-button-class',
    //   }
    // }).then((result:any) => {
    //   if (result.value) {
    //     this.childInforTableDelete(index);
    //   }
    // });
  }

  childInforTableDelete(index: any) {
    if (this.childInfoAddDataArray.length == 1) {
      // document.getElementById('Dependentchildrenno').click();
    }

    this.childInfoAddDataArray.splice(index, 1);
    this.noOfChildrenChangedValue = this.childInfoAddDataArray.length;

    this.childTableRowsLength = this.childInfoAddDataArray.length;
  }

  public childdsiablility(value: any) {
    // this.childendisability = value.target.checked;
  }


  private applyTransform(value: any, transform: string): any {
  switch (transform) {
    case 'boolean': return value === 'true' || value === true || value === 'yes';
    case 'date':    return value ? this._CustomDatePipe.transform(value) : '';
    case 'capitalize': return value ? this.capitalize(value) : '';
    case 'int':     return value ? parseInt(value) : 0;
    case 'raw':
    default:        return value ?? '';
  }
}


private buildDynamicInputData(): Record<string, any> {
  const toCamelCase = (s: string) => s.replace(/_([a-z0-9])/g, (_, c: string) => c.toUpperCase());
  const formVal = this.userForm.value;
  const output: Record<string, any> = {};

  for (const sectionKey of this.activeSections) {
    const section = this.activeFields[sectionKey];
    for (const fieldKey of Object.keys(section)) {
      const field = section[fieldKey];
      const controlName = field.control_name;

      // skip fields with no control_name
      if (!controlName) continue;

      // skip hidden fields
      if (!this.isFieldVisible(field)) continue;

      const rawValue = formVal[controlName] ?? '';
      // Use output_key if provided, otherwise camelCase the control_name
      const outputKey = field.output_key ?? toCamelCase(controlName);
      output[outputKey] = this.applyTransform(rawValue, field.output_transform || 'raw');
    }
  }

  return output;
}

  onSubmit(value: any, tabId: number): void {
    // let data = this.userForm.value;
    // console.log(data)
    // this.submitted = true;

    // console.log(this.tabIndex)
    this.savedFormData = value;  // Save form data

    let obj: any = {
      dob: value.date_of_birth,
      age: this.calculateAge(value.date_of_birth),
      gender: value.gender,
      havingSpouse: value.having_spouse === "true" ? true : false,
    };

    if (value.havingspouse === "true") {
      obj.spouseDetails = {
        dob: value.spousedateofbirth,
        age: this.calculateAge("02-08-2004"),
        gender: value.spousegender,
      };
    }
    //clearing allform Data when clicking on previous and loading
    this.allFormData = {}
    // this._SignupformService.lifeInsurance(obj).subscribe((result: any) => {
    //   this.premiums = result.data;
    //   console.log({ result });
    // });

    if (this.userForm.invalid || this.invalidPostalCodeForProvince==true || this.invalidSpousePostalCodeForProvince==true) {
      this.userForm.markAllAsTouched();
      const invalid: any = [];
      const controls: any = this.userForm.controls;
      //this.consoleMessage(controls)







      // childrenDetails: this.formBuilder.array([this.initChildDetails()]),
      // childrenDetails:  new FormControl(''),

      for (let name in controls) {
        if (controls[name].invalid) {
          if (name == 'dependentdateOfArrival') {
            name = this.lang.Select_dependent_Date_of_Arriaval;
          }
          if (name == 'dependentLandedImigrant') {
            name = this.lang.Select_dependent_Date_of_Arriaval;
          }
          if (name == 'dependentMorethan3years') {
            name = this.lang.Select_dependent_living_status_in_Canada;
          }
          if (name == 'coverageRequiredOfDependents') {
            name = this.lang.Select_dependent_coverage;
          }
          if (name == 'dependentapplylandedstaus') {
            name = this.lang.Select_dependent_apply_landed_immigrant;
          }
          if (name == 'dependentcountryOrigin') {
            name = this.lang.Select_dependent_Country_Origin;
          }
          if (name == 'dateOfArrival') {
            name = this.lang.Select_employee_date_of_arrival;
          }
          if (name == 'isEmployeeImigrant') {
            name = this.lang.Select_employee_immigrant_status;
          }
          if (name == 'applylandedstaus') {
            name = this.lang.Select_employee_apply_landed_status;
          }
          if (name == 'countryOrigin') {
            name = this.lang.Select_employee_country_of_origin;
          }
          if (name == 'coverageRequiredOfEmployee') {
            name = this.lang.Select_employee_coverage;
          }
          if (name == 'planEnrollmentDate') {
            name = this.lang.Select_Plan_Enrollment_Date;
          }
          if (name == 'firstName') {
            name = this.lang.Enter_First_Name;
          }
          if (name == 'lastName') {
            name = this.lang.Enter_Last_Name;
          }
          if (name == 'email') {
            name = this.lang.Enter_Email;
          }
          if (name == 'phone_number') {
            name = this.lang.Enter_Phone_Number;
          }
          if (name == 'street_address_line1') {
            name = this.lang.Enter_Street_Address;
          }
          if (name == 'city') {
            name = this.lang.Enter_City;
          }
          if (name == 'province') {
            name = this.lang.Select_Province_of_Residence;
          }
          if (name == 'workingProvince') {
            name = this.lang.Select_Province_of_Employment;
          }
          if (name == 'postal_code') {
            name = this.lang.Enter_Postal_Code;
          }
          if (name == 'gender') {
            name = this.lang.Select_Gender;
          }
          if (name == 'date_of_hiring') {
            name = this.lang.Select_Date_of_hire;
          }
          if (name == 'date_of_birth') {
            name = this.lang.Select_Date_of_birth;
          }
          if (name == 'dob') {
            name = this.lang.Select_Date_of_birth || 'Select Date of Birth';
          }
          if (name == 'maritalType') {
            name = 'Select Marital Status';
          }
          if (name == 'provinceOfCoverage') {
            name = 'Select Province of Coverage';
          }
          if (name == 'provinceHealthCareNumber') {
            name = 'Enter Province Health Card Number';
          }
          if (name == 'spouseFirstName') {
            name = this.lang.Enter_Spouse_First_Name || 'Enter Spouse First Name';
          }
          if (name == 'spouseLastName') {
            name = this.lang.Enter_Spouse_Last_Name || 'Enter Spouse Last Name';
          }
          if (name == 'spouseGender') {
            name = this.lang.Select_Spouse_Gender || 'Select Spouse Gender';
          }
          if (name == 'spouseDateOfBirth') {
            name = this.lang.Select_Spouse_Date_of_birth || 'Select Spouse Date of Birth';
          }
          if (name == 'spouseProvinceOfCoverage') {
            name = 'Select Spouse Province of Coverage';
          }
          if (name == 'spouseProvinceHealthCareNumber') {
            name = 'Enter Spouse Province Health Card Number';
          }
          if (name == 'previousEmployer') {
            name = 'Enter Previous Employer';
          }
          if (name == 'employerPhoneOrEmail') {
            name = 'Enter Employer Phone or Email';
          }
          if (name == 'previousBenefitProvider') {
            name = 'Enter Previous Benefit Provider';
          }
          if (name == 'certificatePolicyNumber') {
            name = 'Enter Certificate/Policy Number';
          }
          if (name == 'lastDayOfGroupBenefits') {
            name = 'Select Last Day of Group Benefits';
          }
          if (name == 'company_name') {
            name = this.lang.Enter_Company_Name;
          }
          if (name == 'job_title') {
            name = this.lang.Enter_Job_Title;
          }
          if (name == 'working_20hours') {
            name = this.lang.Choose_work_hours_status;
          }
          if (name == 'hours_per_week') {
            name = this.lang.Enter_Hours_per_week;
          }
          if (name == 'provincial_health_coverage') {
            name = this.lang.Choose_Health_Card_status;
          }
          if (name == 'having_spouse') {
            name = this.lang.Choose_Spouse_status;
          }
          if (name == 'spousefirstname') {
            name = this.lang.Enter_Spouse_First_Name;
          }
          if (name == 'spouselastname') {
            name = this.lang.Enter_Spouse_Last_Name;
          }
          if (name == 'spousegender') {
            name = this.lang.Select_Spouse_Gender;
          }
          if (name == 'spouseemail') {
            name = this.lang.Enter_Spouse_Email;
          }
          if (name == 'spousedateofbirth') {
            name = this.lang.Select_Spouse_Date_of_birth;
          }
          if (name == 'having_dependent_children') {
            name = this.lang.Choose_Dependent_Children_status;
          }
          if (name == 'spousehealthcard' || name == 'spouseHealthCard') {
            name = this.lang.Choose_Spouse_Insurance_status || 'Choose Spouse Health Card Status';
          }
          if (name == 'Spousenameofthecarrier' || name == 'SpouseNameOfTheCarrier') {
            name = this.lang.Enter_Spouse_name_of_Carrier || 'Enter Spouse Name of Carrier';
          }
          if (name == 'spousecob') {
            name = this.lang.Select_Spouse_COB;
          }
          if (name == 'termsandconditions') {
            name = this.lang.Select_Terms_and_Conditions;
          }
          if (name == 'disclouseradvisor' || name == 'disclosureadvisor') {
            name = this.lang.Select_Advisor_Disclosure || 'Please Read Advisor Disclosure';
          }
          if (name == 'dateOfRetirement') {
            name = 'Select Date of Retirement';
          }
          if (name == 'dateOfMarriage') {
            name = 'Select Date of Marriage';
          }
          if (name == 'addToPlan' || name == 'addedToPlan') {
            name = 'Select Add to Plan';
          }
          if (name == 'spouseSameAddressAsMember') {
            name = 'Select Spouse Same Address';
          }
          if (name == 'spouse_street_address_line1') {
            name = 'Enter Spouse Street Address';
          }
          if (name == 'spouseCity') {
            name = 'Enter Spouse City';
          }
          if (name == 'spouseProvince') {
            name = 'Select Spouse Province';
          }
          if (name == 'spousePostalCode') {
            name = 'Enter Spouse Postal Code';
          }
          if (name == 'has_child') {
            name = this.lang.Choose_Dependent_Children_status || 'Choose Dependent Children Status';
          }
          invalid.push(name);
        }
      }

      if (this.invalidPostalCodeForProvince==true) {
      // if (this.invalidPostalCodeForProvince) {
        const postalCodeMessage = this.lang.Please_enter_valid_postal_code;
        if (invalid.indexOf(postalCodeMessage) == -1) {
          invalid.push(postalCodeMessage);
        }
      }

      if (this.invalidSpousePostalCodeForProvince==true) {
        const spousePostalCodeMessage = 'Enter valid Spouse Postal Code';
        if (invalid.indexOf(spousePostalCodeMessage) == -1) {
          invalid.push(spousePostalCodeMessage);
        }
      }

      this.missingInformation = true
      // jQuery("#missingInfo-modal").modal("show");

      this.missingInfo = invalid;
      ////this.consoleMessage(invalid)
      return invalid;
    } else {

       const dynamicFields = this.buildDynamicInputData();



      let inputData: any = {
        ...dynamicFields,
        recaptchaCheck: false,
        gRecaptchaResponse: '',
        // Use the dynamic province from the form, not hardcoded 'BC'
        province:          dynamicFields['province']    || this.provineList?.shortName || '',
        provinceId:        parseInt(this.provineList?.id ?? 0),
        country:           'Canada',
        countryId:         1,
        state:             this.provineList?.name       || '',
        stateId:           parseInt(this.provineList?.id ?? 0),
        currency:          'CAD',
        currencySymbol:    '$',
        pageUrl:           window.location.href,
        signature:         '',
        formId:            parseInt(this.formConfigResult.form.id),
        brokerId:          parseInt(this.formConfigResult.form.brokerId),
        termsandconditions: true,
        disclosureAgreement:  true,

        // spouse — still needs structure, but reads dynamically
        spouseDetails: this.buildSpouseDetails(),
        spouseAddress: this.buildSpouseAddress(),


        // children
        childrenDetails: this.buildChildrenArray(),
        noOfChildren: this.buildChildrenArray()?.length ?? 0,

        // phr — only if PHR is false
        ...(dynamicFields['provincial_health_coverage'] === false
          ? { phrDetails: this.buildPhrDetails() }
          : {}),

        //  "fusebillCustomerAddressId":sessionStorage.getItem("fusebillCustomerAddressId") || null
      };

      if(this.currFormType == "nhlaa"){



        let mainDetails: any = {};

        //this.consoleMessage(value.applylandedstaus)
        mainDetails = {
          dateOfArrival:
            this._CustomDatePipe.transform(value.dateOfArrival) || '',
          countryOfOrigin: value.countryOrigin || '',
          isLandedImmigrant: value.isEmployeeImigrant ? Boolean(value.isEmployeeImigrant) : false,
          coverageRequired: value.coverageRequiredOfEmployee ? Boolean(value.coverageRequiredOfEmployee) : false,
          applyingForLandingStatus: value.applylandedstaus
            ? Boolean(value.applylandedstaus)
            : false,
          dependentDetails:
            value.having_dependent_children == 'true' ||
              value.having_dependent_children == 'true'
              ? {
                coverageRequired: value.coverageRequiredOfDependents ?
                  Boolean(value.coverageRequiredOfDependents) : false,
                dateOfArrival:
                  value.coverageRequiredOfDependents == 'true'
                    ? this._CustomDatePipe.transform(
                      value.dependentdateOfArrival
                    )
                    : '',
                countryOfOrigin:
                  value.coverageRequiredOfDependents == 'true'
                    ? value.dependentcountryOrigin
                    : '',
                isLandedImmigrant:
                  value.coverageRequiredOfDependents == 'true'
                    ? Boolean(value.dependentLandedImigrant)
                    : false,
                applyingForLandingStatus: value.dependentMorethan3years
                  ? Boolean(value.dependentMorethan3years)
                  : false,
                stayFor3Months:
                  value.coverageRequiredOfDependents == 'true'
                    ? Boolean(value.dependentMorethan3years)
                    : false,
              }
              : {},
        };



        inputData.employeeKey = sessionStorage.getItem("employeelink");
        inputData.tierKey = sessionStorage.getItem("tierKey");

        if (inputData.tierKey && inputData.tierKey != "undefined") {
          inputData.tierKey = sessionStorage.getItem("tierKey");
        } else {
          inputData.tierKey = "";
        }
        if (inputData.employeeKey && inputData.employeeKey != "undefined") {
          inputData.employeeKey = sessionStorage.getItem("employeelink");
          inputData.employeeGeneric = false;
        } else {
          inputData.employeeKey = "";
          inputData.employeeGeneric = true;
        }

        if (
        inputData.provincialHealthCoverage == false
      ) {
        inputData['phrDetails'] = mainDetails;
      }
        delete inputData.spouseAddress
        if(inputData.spouseDetails && inputData.spouseDetails.customData){
          delete inputData.spouseDetails.customData
        }
      }


      const booleanFields = [
        'provincialHealthCoverage', 'havingSpouse', 'havingDependentChildren',
        'hasChild', 'spousehealthcard', 'isEmployeeImigrant', 'applylandedstaus',
        'coverageRequiredOfEmployee', 'coverageRequiredOfDependents',
        'dependentLandedImigrant', 'dependentMorethan3years',
        'working20hours', 'working30hours', 'spouseProvincialHealthCoverage'
      ];
      for (const boolField of booleanFields) {
        if (boolField in inputData) {
          inputData[boolField] = this.isTruthy(inputData[boolField]);
        }
      }

      // ── Post-process fields for API compatibility ──────────────────────────────
      // 1. Capitalize name/city fields
      const capStr = (s: any): string => this.capitalize(String(s ?? '')) ?? '';
      inputData.firstName = capStr(inputData.firstName);
      inputData.lastName  = capStr(inputData.lastName);
      if (inputData.city) inputData.city = capStr(inputData.city);
      const capFirst = (s: string) => s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s;
      if (inputData.gender)       inputData.gender       = capFirst(inputData.gender);
      // if (inputData.maritalType)  inputData.maritalType  = capFirst(inputData.maritalType);
      // if (inputData.maritalStatus) inputData.maritalStatus = capFirst(inputData.maritalStatus);
      inputData.maritalType  = this.maritalStatusNew(inputData);
      inputData.maritalStatus  = this.maritalStatusNew(inputData);
      if (inputData.maritalStatus) inputData.maritalStatus = capFirst(inputData.maritalStatus);
      delete inputData.disclosureadvisor;

      const fmtDate = (v: any): string => v ? (this._CustomDatePipe.transform(v) ?? '') : '';
      inputData.planEnrollmentDate     = fmtDate(inputData.planEnrollmentDate);
      inputData.dob            = fmtDate(inputData.dob ?? inputData.dateOfBirth);
      // delete inputData.dob;
      if(inputData.dateOfHiring)       inputData.dateOfHiring      = fmtDate(inputData.dateOfHiring);
      if (inputData.dateOfMarriage)    inputData.dateOfMarriage    = fmtDate(inputData.dateOfMarriage);
      if (inputData.dateOfRetirement)  inputData.dateOfRetirement  = fmtDate(inputData.dateOfRetirement);
      if (inputData.lastDayOfGroupBenefits) inputData.lastDayOfGroupBenefits = fmtDate(inputData.lastDayOfGroupBenefits);

      if ('hasChild' in inputData) {
        inputData.havingDependentChildren = inputData.hasChild;
        inputData.hasChild = inputData.hasChild;
      }

      // 4. Ensure numeric fields are numbers, not strings
      if (inputData.hoursPerWeek !== undefined && inputData.hoursPerWeek !== '') {
        inputData.hoursPerWeek = parseInt(inputData.hoursPerWeek) || 0;
      }
      if (inputData.noOfChildren !== undefined && inputData.noOfChildren !== '') {
        inputData.noOfChildren = parseInt(inputData.noOfChildren) || 0;
      }

      if (inputData.havingSpouse) {
        [
          'spouseFirstName', 'spouseLastName', 'spouseGender', 'spouseDateOfBirth',
          'spouseHealthCard', 'spouseSameAddressAsMember', 'addToPlan', 'addedToPlan',
          'SpouseNameOfTheCarrier', 'spouseCob',
        ].forEach(k => delete inputData[k]);


        inputData.spouseDetails.maritalType = inputData.maritalType
        // Viking is the only form type with a spouse "Add to plan" checkbox, and
        // buildSubmissionData() reads these back — dropping them there sent undefined.
        if (this.currFormType !== 'viking') {
          delete inputData.spouseDetails.addedToPolicy;
          if (inputData.spouseDetails.customData) {
            delete inputData.spouseDetails.customData.addedToPolicy;
          }
        }
        // maritalType is assigned after buildSpouseDetails ran, so mirror once more
        this.mirrorIntoCustomData(inputData.spouseDetails);

      }

      // 6. Group prior group coverage fields into a nested object
      const priorKeys = [
        'previousEmployer', 'employerPhoneOrEmail', 'previousBenefitProvider',
        'certificatePolicyNumber', 'lastDayOfGroupBenefits',
      ];
      if (priorKeys.some(k => k in inputData)) {
        inputData.priorGroupCoverage = {
          previousEmployer:        inputData.previousEmployer        || '',
          employerPhoneOrEmail:    inputData.employerPhoneOrEmail    || '',
          previousBenefitProvider: inputData.previousBenefitProvider || '',
          certificatePolicyNumber: inputData.certificatePolicyNumber || '',
          lastDayOfGroupBenefits:  inputData.lastDayOfGroupBenefits  || '',
        };
        priorKeys.forEach(k => delete inputData[k]);
      }

      if (this.userForm.get('has_child')?.value === 'yes' && this.childTableRowsLength === 0) {
        this.missingInformation = true;
        this.missingInfo = ['Please add at least one child details'];
        return;
      }


      inputData.formType = this.currFormType;

      this.validationInputData = inputData;

      this.CreditCradFirstName = inputData.firstName
      this.CreditCradLastName = inputData.lastName

      // if(this.userForm.get('having_spouse')?.value == 'false'){
      //   this.beneficariesDetails?.relationship
      // }

     
      if (this.userForm.get('having_dependent_children')?.value === 'true') {
        if (this.childTableRowsLength > 0) {
        }
        else {
          const invalid: any = []
          this.missingInformation = true


          invalid.push('Please add at least one child details');
          this.missingInfo = invalid;
          return invalid;
        };
      }

      // ── Provincial Health Coverage check ──────────────────────────────────────
      // If the field is present in the form and the user selected "No" / "false",
      // block the API call and prompt them to select "Yes".
      const phcControl = this.userForm.get('provincial_health_coverage');
      if (phcControl !== null && phcControl !== undefined) {
        const phcVal = phcControl.value;
        const phcIsFalse =
          phcVal === 'no'    || phcVal === 'NO'    ||
          phcVal === 'false' || phcVal === false;
        if (phcIsFalse) {
          this.missingInformation = true;
          this.missingInfo = [
            'PHR is required to complete registration.'
          ];
          return;
        }
      }

      let loginObservable: Observable<any>;

      if (environment.app.authorizeNet) {
        if(this.currForm == "GIG"){
          if(this.currFormType == 'viking'){
            loginObservable = this._SignupformService.genericValidationV5(inputData);
          }else{
            loginObservable = this._SignupformService.validationV5(inputData);
          }
        }else{
          inputData.provinceOfEmployment = inputData.provinceOfResidence
          inputData.officeAddress = {
            province: inputData?.province,
            state: inputData?.state,
            stateId: inputData?.stateId,
            country: inputData?.country,
            countryId: inputData?.countryId,
            postalCode: inputData?.postalCode,
            streetAddressLine1: inputData?.streetAddressLine1,
            streetAddressLine2: inputData?.streetAddressLine2,
            apt: inputData?.apt,
          };
           if(this.currFormType == 'nhlaa'){
             loginObservable = this._CorporateService.genericValidationV5(inputData); 
            }else{
             loginObservable = this._CorporateService.validationV5(inputData); 
            }
        }
      } else {
        loginObservable = this._SignupformService.validation(inputData);
      }

      loginObservable.subscribe({
        next: (result: any) => {
          if (result.status == '200') {
            if (this.activeTab < this.tabs.length - 1) {
              this.previousTab = this.activeTab;
              this.activeTab++;
              this.visitedTabs.add(this.previousTab);
            }

            // Normalize packages: GIG returns an array; CORP returns an object
            // { paidByCompany: [...], optionalPackages: [...] }.
            // GIG template always expects an array of packages with `groups` (object of arrays).
            // NHLAA corp gets its own corpPlansData via buildCorpPlansData().
            const rawPackages = applyPlanPricingFallback(result.data.packages);
            this.dateOfEligibility = result.data.planEligibilityDate;
            if (Array.isArray(rawPackages)) {
              this.plansData = rawPackages;
            } else if (rawPackages && typeof rawPackages === 'object') {
              const normalized: any[] = [];
              Object.values(rawPackages).forEach((pkgArray: any) => {
                if (Array.isArray(pkgArray)) {
                  pkgArray.forEach((pkg: any) => {
                    if (!pkg.groups) {
                      // Map groupsCP / groupsOptional → groups: { '0': [...] }
                      const src = pkg.groupsCP ?? pkg.groupsOptional ?? pkg.groups ?? [];
                      pkg.groups = { '0': Array.isArray(src) ? src : [] };
                    }
                    normalized.push(pkg);
                  });
                }
              });
              this.plansData = normalized;
            } else {
              this.plansData = [];
            }

            if(result.data.blocks){
              let keys = this.Object.keys(result.data.blocks);

              for(const key of keys){
                if(result.data.blocks[key] && result.data.blocks[key].length > 0){
                  for(const gp of result.data.blocks[key]){
                    let checkKey = "groupsCC"
                    if(key == "coveredByCompany"){
                      checkKey = "groupsCC"
                    }
                    if(key == "paidByCompany"){
                      checkKey = "groupsCP"
                    }
                    if(key == "paidByEmployee"){
                      checkKey = "groupsEP"
                    }


                    let groups = gp[checkKey];
                    if(groups && groups.length > 0){
                      for(const group of groups){
                        if(group && group.signupFormOverrides){
                          this.coveragesOverride = true;
                          this.signupFormOverrides = group.signupFormOverrides
                        }
                      }
                    }
                  }
                }
              }
            }

            // For NHLAA corp, build the enriched corp plan data structure separately.
            // The API (and dummyPlans fallback) returns actual plan data under result.data.blocks,
            // while result.data.packages may be empty. Prefer blocks when available.
            if (this.currFormType === 'nhlaa') {
              const nhlaaSource = (result.data.blocks && Object.keys(result.data.blocks).length > 0)
                ? result.data.blocks
                : rawPackages;
              this.corpPlansData = result;
              // Auto-select + disable the company-paid SINGLE coverage checkbox
              // after Angular renders the tiles (mirrors autoSelectCompanyPaidPlans in corp signup)
            }
            // this.autoSelectCorpCompanyPaidPlans();
            this.allFormData = {}
            this.formData = {}
            sessionStorage.setItem('totalAmount', '0');
            sessionStorage.setItem('totalAmountUI', '0');

            sessionStorage.setItem('plansummary', '[]');
            sessionStorage.setItem('selectedPlans', '{}');
            sessionStorage.setItem('selectedPlansLife', '{}');
            sessionStorage.setItem('plansummarymain', '[]');
            sessionStorage.setItem('plansummaryopt', '[]');
            // sessionStorage.removeItem("paymentMethod")   ////here
            sessionStorage.removeItem('paymentfail');
            sessionStorage.setItem('plansummaryLife', '[]');
            sessionStorage.setItem('planssummarymainLife', '[]');
            sessionStorage.removeItem('addbenificaryData');
            sessionStorage.removeItem("Spousesignature")
            this.addbenificaryData = [];
            this.planAmount = ''
            this.plansnexttab = true;
            let data: any = JSON.parse(sessionStorage.getItem("plansummary") || '[]');
            let obj = {};

            if (data) {

              data.forEach((element: any, index: any) => {
                obj = {
                  planid: element.id,
                };

                setTimeout(() => {

                  const dom: HTMLElement = this.elementRef.nativeElement;
                  const plan: any = dom.querySelector("#plancheck" + element.id);


                  if (element.options && element.options.length > 0) {
                    // $("#plancheck" + element.id).prop("checked", true);
                    element.products.forEach((products: any, index: any) => {
                      const planCheck = this.renderer.selectRootElement("#plancheck" + products.id, true);

                      // console.log(planCheck)
                      this.renderer.setProperty(planCheck, 'checked', true);
                    })
                  } else {
                    element.products.forEach((products: any, index: any) => {
                      // $("#plancheck" + products.id).click();
                      const planCheck = this.renderer.selectRootElement("#plancheck" + products.id, true);

                      // console.log(planCheck)
                      this.renderer.setProperty(planCheck, 'checked', true);
                    })
                  }

                  // $("#plancheck" + element.id).prop("checked", true);
                  // plan.checked =true
                }, 100);

                // this.plancheckarray.push(element.id)
              });

            }
            sessionStorage.setItem("stateid", result.data.province.id);
            sessionStorage.setItem(
              "maritalStatus",
              result.data.customer.maritalStatus
            );

            sessionStorage.setItem(
              "planDetailsArray",
              JSON.stringify(this.plansData)
            );
            setTimeout(() => {
              sessionStorage.setItem('Data', JSON.stringify(inputData));

              sessionStorage.setItem(
                'enrollmentdate',
                inputData.planEnrollmentDate
              );
            }, 2000);

            this.applicantSpousename = value?.spouseDetails?.spousefirstname || "";
            this.applicantfirstname = inputData.firstName;

            // console.log(this.applicantfirstname)

            let childarry:any = []

            inputData.childrenDetails.forEach((element: any) => {
              childarry.push(element.first_name);
            });
            this.applicantChildrenname = childarry || "";
            if (
              value.havingSpouse == "true" &&
              value.havingDependentChildren == "true"
            ) {
              this.completeapplicantinfo =
                this.lang.Based_on_the_information_provided_you_your_spouse
                +
                " " + this.applicantSpousename +
                " " +
                this.lang.and_your_dependent_s +
                " " +
                this.applicantChildrenname +
                " " +
                this.lang.are_eligible_to_apply_for_the_following_plans;
            } else if (value.havingSpouse == "true") {
              this.completeapplicantinfo =
                this.lang.Based_on_the_information_provided_you_your_spouse +
                " " +
                this.applicantSpousename +
                " " +
                this.lang.are_eligible_to_apply_for_the_following_plans;
            } else if (value.havingDependentChildren == "true") {
              this.completeapplicantinfo =
                this.lang.Based_on_the_information_provided_you_and_your_dependent_s +
                " " +
                this.applicantChildrenname +
                " " +
                this.lang.are_eligible_to_apply_for_the_following_plans;
            } else {
              this.completeapplicantinfo = this.lang.Based_on_the_information_provided_you_are_eligible_to_apply_for_the_following_plans;
            }
            sessionStorage.setItem(
              "completeapplicantinfo",
              this.completeapplicantinfo
            );
          } else {


            this.ShowModelPopup = true
            this.ShowModelPopupMessage = result.message
              ? result.message
              : result.error
            this.ShowModelPopupTitle = this.lang.Info
          }
        },
        error: (error) => {
          if ([0, 500, 501, 502, 503].includes(error.status)) {

            this.ShowModelPopup = true
            this.ShowModelPopupMessage = this.lang?.Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience ?? 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.';
            this.ShowModelPopupTitle = this.lang?.Info ?? 'Info'
          } else {



            this.ShowModelPopup = true
            this.ShowModelPopupMessage = error.error.message
              ? error.error.message
              : error.error.error
            this.ShowModelPopupTitle = this.lang.Info
          }
        },
      });
    }
  }


    public async registartionform2(value: any) {
  
  
      this.signatureNeeded = this.signaturePad.isEmpty();
      if (this.signaturePad.isEmpty() == false) {
  
        const base64Data = this.signaturePad.toDataURL();
        // //console.log(base64Data);
        sessionStorage.setItem("signature", base64Data);
  
      }
      else {
        sessionStorage.setItem("signature", "");
        this.signaturemessagecc = true
  
      }
      let inputData = JSON.parse(sessionStorage.getItem("Data") || '{}');
  
      sessionStorage.setItem("paymentMethod", "NONE");
  
      inputData.employeeKey = sessionStorage.getItem("employeelink");
      inputData.tierKey = sessionStorage.getItem("tierKey");
  
      inputData.signature = sessionStorage.getItem("signature") || "";
      inputData.planEnrollmentDate =
        sessionStorage.getItem("enrollmentdate") ||
        inputData.planEnrollmentDate ||
        "";
  
      let provincelist = JSON.parse(sessionStorage.getItem("provincelist") || '');
  
      if (provincelist.includes(inputData.province_id)) {
      } else {
        if (this.formConfigResult.brokershipTransferFeature && this.formConfigResult.assign_default_form == true) {
          inputData.formId = this.formConfigResult.default_form.id;
          inputData.brokershipTransfered = true;
          inputData.originalFormId = this.formConfigResult.form.id;
        } else {
          inputData.brokershipTransfered = false;
        }
      }
  
      if (
        sessionStorage.getItem("fusebillCustomerAddressId")
      ) {
        inputData.fusebillCustomerAddressId =
          sessionStorage.getItem("fusebillCustomerAddressId") || null;
      }
      if (
        sessionStorage.getItem("fusebillCustomerId")
      ) {
        inputData.fusebillCustomerId =
          sessionStorage.getItem("fusebillCustomerId") || null;
      }
      if (
        sessionStorage.getItem("fusebillCustomerBillingAddressId")
      ) {
        inputData.fusebillCustomerBillingAddressId =
          sessionStorage.getItem("fusebillCustomerBillingAddressId") || null;
      }
      if (
        sessionStorage.getItem("customerId")
      ) {
        inputData.customerId = sessionStorage.getItem("customerId") || null;
        // inputData.billing_address.customer_id= parseInt(sessionStorage.getItem("customerId")) || null
      }
      inputData.billing_sameas_homeAddress =
        sessionStorage.getItem("homeAddress") == "true" ? true : false;
  
      if (this.employeeDealingPlansarr.length > 0) {
        if (sessionStorage.getItem("homeAddress") == "true") {
          inputData.billing_address = {
            // "customer_id": parseInt(sessionStorage.getItem("customerId")) || null,
            // "fusebill_customer_id": parseInt(sessionStorage.getItem("fusebillCustomerId")) || null,
            line1: inputData.street_address_line1 || "",
            line2: inputData.street_address_line2 || "",
            city: inputData.city || "",
            state: inputData.province || "",
            state_id: this.provineListcreditPayment?.id,
            fusebillStateId: parseInt(this.provineListcreditPayment?.fusebillId),
            fusebillCountryId: 124,
  
            country: "Canada",
            country_id: 1,
            // ocountry_id: 1,
            postal_zip: inputData.postal_code || "",
            apt: inputData.apt || "",
          };
        }
        else {
          inputData.billing_address = {
            // "customer_id": parseInt(sessionStorage.getItem("customerId")) || null,
            // "fusebill_customer_id": parseInt(sessionStorage.getItem("fusebillCustomerId")) || null,
            line1: this.paymentForm.get("streetaddress")?.value || "",
            line2: this.paymentForm.get("streetaddressline2")?.value || "",
            city: this.paymentForm.get("city")?.value || "",
            state: this.paymentForm.get("province")?.value || "",
            state_id: this.provineList?.fusebillid, // this.fusebillid = parseInt(element.fusebillId);
            // ostate_id:this.state_id
            country: "Canada",
            country_id: 124,
            // ocountry_id: 1,
            postal_zip: this.paymentForm.get("postalcode")?.value || "",
            apt: this.paymentForm.get("aptcheck")?.value || "",
          };
        }
      } else {
        inputData.billing_sameas_homeAddress = true;
        inputData.billing_address = {};
      }
  
      inputData.officeAddress = {
        // "customer_id": parseInt(sessionStorage.getItem("customerId")) || null,
        // "fusebill_customer_id": parseInt(sessionStorage.getItem("fusebillCustomerId")) || null,
        // line1:  "",
        // line2:  "",
        // city:  "",
        province: sessionStorage.getItem("corporateStateName"),
        state: sessionStorage.getItem("corporateStateName"),
        state_id: sessionStorage.getItem("corporateStateId"),
        stateId: sessionStorage.getItem("corporateStateId"),
        // this.fusebillid = parseInt(element.fusebillId);
        // fusebillStateId: '',
        // fusebillCountryId: '',
        country: "Canada",
        country_id: 1,
        countryId: 1,
        // // ocountry_id: 1,
        // postal_zip:  "",
        // apt: "",
      };
      if (
        sessionStorage.getItem("customerId") &&
        sessionStorage.getItem("fusebillCustomerId")
      ) {
        inputData.billing_address.customer_id =
          parseInt(sessionStorage.getItem("customerId") || '0') || 0;
        inputData.billing_address.fusebill_customer_id =
          parseInt(sessionStorage.getItem("fusebillCustomerId") || '0') || 0;
      }
  
      // ////this.consoleMessage(inputData);
  
      if (!this.showPaymenthMethod) {
        this.signaturecheckcc = false;
        this.cartcheckvalue = false;
        this.signaturemessagecc = false;
      } else {
      }
  
      if (this.signaturePad.isEmpty() == true) {
        const invalid = [];
        invalid.push("Draw the Signature");
        // jQuery("#missingInfo-modal").modal("show");
        this.missingInformation = true
  
        this.missingInfo = invalid;
        //this.consoleMessage(invalid)
        return invalid;
      }
      console.log(this.showBenificiaryFormCond)
      if (this.showBenificiaryFormCond) {
  
        console.log(this.addbenificaryData.length)
        if (this.addbenificaryData.length > 0) {
          this.benficiary = false;
  
          const validateBeneficiaries = this.addbenificaryData.reduce((acc: any, obj: any) => {
            const compositeKey = `${obj.customerType}_${obj.type}`;
            if (!acc[compositeKey]) {
              acc[compositeKey] = 0;
            }
            acc[compositeKey] += parseFloat(obj.percentage);
            return acc;
          }, {});
  
          let beneficiaryError = "";
          for (const key in validateBeneficiaries) {
            if (validateBeneficiaries.hasOwnProperty(key)) {
              const [customerType, type] = key.split("_");
              //console.log(`The customerType ${customerType} and type ${type} with perc: ${validateBeneficiaries[key]}`);
  
              if (validateBeneficiaries[key] != 100) {
                beneficiaryError += `CustomerType ${customerType} and type ${type} has percentage issue. \n`
              }
            }
          }
  
          if (beneficiaryError != "") {
            this.benficiaryCount = true
            this.benficiary = true;
            this.benficiaryCountMessage = this.lang.Distributed_percentages_must_equal_100_and_not_more
            return false;
          }
  
          else {
            this.benficiary = false
  
            if (this.addbenificaryData && this.addbenificaryData.length > 0) {
              this.addbenificaryData =
                this.addbenificaryData
                  .map((v: any) => ({
                    ...v, contactDetails: {
                      contingentBeneficiary: {
  
                        firstName: v.contingentFirstName,
  
                        lastName: v.contingentLastName,
  
                      }
                    }, trusteeDetails: {
                      firstName: v.trusteeFirstName || "",
                      lastName: v.trusteeLastName || "",
                      relationship: v.trusteeRelation || "",
                    }
                  }))
              inputData.havingBeneficiaries = true
            }
            else {
              this.benficiary = true;
  
              return false;
            }
            inputData.beneficiariesDetails = this.addbenificaryData
          }
        } else {
          this.benficiary = true;
          if (this.addbenificaryData.length > 0) {
          } else {
            this.showBenificiaryForm = true
          }
          return false;
        }
  
      } else {
        // this.gotosumamrypageLogic()
      }
  
      let activity: any = {};
      activity.action = 'Step 1 of 7 - Corporate registation triggered';
      activity.requestBody = this.paymentForm;
  
      if (this.signaturePad.isEmpty() == false && this.companyplansCheck == false && this.upgradeplansCheck == false) {
        let loginObservable: Observable<any>;
        inputData.dateOfEligibility = this.dateOfEligibility;
        if (this.smokerInformation != '') {
          inputData.smoker = this.smokerInformation;
        }
  
        let dandjinfo = JSON.parse(sessionStorage.getItem("dandjinfo") ?? "{}");
        if (dandjinfo && dandjinfo.earningsAmount) {
          // means there is data
          inputData.smoker = dandjinfo.smoker == "true" ? true : false
          inputData.earningsFrequency = dandjinfo.earningsFrequency
          inputData.earningsAmount = JSON.stringify(dandjinfo.earningsAmount)
        }
  
        if (this.smokerDetails) {
          // means there is data
          inputData.smoker = this.smokerDetails.smoker == "true" ? true : false
          inputData.earningsFrequency = this.smokerDetails.earningsFrequency
          inputData.earningsAmount = JSON.stringify(this.smokerDetails.earningsAmount)
        }
  
        activity.requestBody = {};
        activity.status = 'SUCCESS';
        activity.responseSummary = 'Payment method update triggered successfully';
        // this.buildActivityLogObject(activity, true);
  
        // waiting for a while to let previous add-activity api to hit
        await new Promise(resolve => setTimeout(resolve, 0)).then(() => {
  
          let activity: any = {};
          activity.action = 'Step 2 of 7 - Customer registration';
  
          if (this.paymentPlatform == 'AuthorizeNet') {
            sessionStorage.setItem('v5Api', 'true');
            sessionStorage.setItem('paymentPlatform', 'AuthorizeNet');
            inputData.authorizenetCustomerId = '';
            inputData.authorizenetPaymentId = '';
            inputData.paymentPlatform = 'AuthorizeNet'
            // inputData.fusebill_paymentMethod = '';
  
            activity.url = environment.app.grp + 'api/corporate/customer/v5/registration'
  
            loginObservable = this._CorporateService.loginV5(inputData)
          } else {
            activity.url = environment.app.grp + 'api/corporate/customer/v3/registration'
            loginObservable = this._CorporateService.login1(inputData);
          }
  
          activity.requestBody = inputData;
  
          loginObservable.subscribe((result: any) => {
            if (result.status == "200") {
              activity.status = 'SUCCESS';
              activity.response = result;
              activity.responseSummary = 'Registration done successfully';
              activity.effectedUserId = result.data?.customer?.id;
              // this.buildActivityLogObject(activity, true);
  
              sessionStorage.removeItem("paymentfail");
  
              if (result.data.customer.fusebill) {
                sessionStorage.setItem("fusebillCustomerId", result.data.customer.fusebill.customerId);
                sessionStorage.setItem("publicApiKey", result.data.customer.fusebill.publicApiKey);
                if (result.data.customer.fusebill.customerAddressId) {
                  sessionStorage.setItem("fusebillCustomerAddressId", result.data.customer.fusebill.customerAddressId);
                }
                if (result.data.customer.fusebill.customerBillingAddressId) {
                  sessionStorage.setItem("fusebillCustomerBillingAddressId", result.data.customer.fusebill.customerBillingAddressId);
                }
              }
              sessionStorage.setItem("customerId", result.data.customer.id);
              // sessionStorage.setItem("publicApiKey",result.data.customer.fusebill.publicApiKey)
              sessionStorage.setItem("normalcustomerid", result.data.customer.id);
              sessionStorage.setItem("enrollmentdate", inputData.planEnrollmentDate);
              sessionStorage.setItem("userKey", result.data.userKey);
              this.customerid = result.data.customer.fusebill.customerId;
              this.publicapikey = result.data.customer.fusebill.publicApiKey;
  
              let authorizeNetCustomerId = result.data.customer?.authorizenet?.customerId ?? 0;
              let validAuthorizeId: boolean = false;
              if (!!authorizeNetCustomerId && authorizeNetCustomerId != '-9999' && authorizeNetCustomerId != 0) {
                validAuthorizeId = true;
              }
              if (environment.app.authorizeNet && validAuthorizeId) {
                sessionStorage.setItem('v5Api', 'true')
                sessionStorage.setItem('authorizenetCustomerId', authorizeNetCustomerId);
                sessionStorage.setItem('payment', "CC");
  
                let activity: any = {};
                // activity.action = 'Step 3 of 7 - Authorize profile creation';
                activity.action = 'Member enrollment - Authorizenet Customer Profile';
                activity.status = 'SUCCESS';
                activity.responseSummary = 'Found Authorize profile, using the same id ' + authorizeNetCustomerId;
                activity.effectedUserId = result.data?.customer?.id;
                // this.buildActivityLogObject(activity, true);
  
                activity.responseSummary = 'Skipping this step, as parent payment platform is Staxbill';
                activity.action = 'Step 4 of 7 - Connecting to Authorize';
                // this.buildActivityLogObject(activity, true);
  
                activity.action = 'Step 5 of 7 - Creating payment profile in authorize';
                // this.buildActivityLogObject(activity, true);
  
                activity.action = 'Step 6 of 7 - Updating payment method';
                // this.buildActivityLogObject(activity, true);
  
                // navigate to payment
                this.navigateToPayment(authorizeNetCustomerId, true);
              } else {
                if (this.paymentPlatform == 'AuthorizeNet') {
                  // create profile
                  this.createCorpAuthorizeProfile(result.data.customer.id, this.userForm.get("email")?.value, 'cc', true);
                } else {
                  activity = {};
                  activity.action = 'Step 3 of 7 - Authorize profile creation';
  
                  activity.status = 'SUCCESS';
                  activity.response = {};
                  activity.responseSummary = 'Skipping this step, as parent payment platform is Staxbill';
                  activity.effectedUserId = result.data?.customer?.id;
                  // this.buildActivityLogObject(activity, true);
  
                  activity.action = 'Step 4 of 7 - Connecting to Authorize';
                  // this.buildActivityLogObject(activity, true);
  
                  activity.action = 'Step 5 of 7 - Creating payment profile in authorize';
                  // this.buildActivityLogObject(activity, true);
  
                  activity.action = 'Step 6 of 7 - Updating payment method';
                  // this.buildActivityLogObject(activity, true);
  
                  this.navigateToPayment(this.customerid, true);
                }
              }
            } else {
              if (result.status == "206") {
                activity.status = 'FAILURE';
                activity.response = result;
                activity.responseSummary = result.message;
                // this.buildActivityLogObject(activity, true);
  
                this.ShowModelPopup = true
                this.ShowModelPopupTitle = this.lang.Info
                this.ShowModelPopupMessage = result.message
              } else {
                if (result.error || result.errors) {
                  activity.status = 'FAILURE';
                  activity.response = result;
                  activity.responseSummary = (result.error ? result.error[0].value : result.errors[0].value) ?? 'Customer registration failed';
                  // this.buildActivityLogObject(activity, true);
  
                  this.ShowModelPopup = true
                  this.ShowModelPopupTitle = this.lang.Error
                  this.ShowModelPopupMessage = result.error ? result.error[0].value : result.errors[0].value
                } else {
                  activity.status = 'FAILURE';
                  activity.response = result;
                  activity.responseSummary = result.message;
                  // this.buildActivityLogObject(activity, true);
  
                  this.ShowModelPopup = true
                  this.ShowModelPopupTitle = this.lang.Error
                  this.ShowModelPopupMessage = result.mesage
                }
              }
            }
          },
            (error) => {
              if ([0, 500, 501, 502, 503].includes(error.status)) {
                activity.status = 'FAILURE';
                activity.response = error;
                activity.responseSummary = 'Customer registration failed';
                // this.buildActivityLogObject(activity, true);
  
                this.ShowModelPopup = true
                this.ShowModelPopupTitle = this.lang?.Info ?? 'Info'
                this.ShowModelPopupMessage = this.lang?.Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience ?? 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.';
              }
              else {
                activity.status = 'FAILURE';
                activity.response = error;
                activity.responseSummary = 'Customer registration failed';
                // this.buildActivityLogObject(activity, true);
  
                this.ShowModelPopup = true
                this.ShowModelPopupTitle = this.lang.Info
                this.ShowModelPopupMessage = error.error.message ? error.error.message : error.error.error
              }
            }
          )
        }
        );
      } else {
        this.paymentForm.markAllAsTouched();
  
        if (this.cartcheckvalue == true) {
          this.ShowModelPopup = true
          this.ShowModelPopupTitle = this.lang.Info
          this.ShowModelPopupMessage = "Please check the Plan Selection Page"
        }
        // this.bankscrollToFirstInvalidControl();
      }
    }

  private buildChildrenArray(): any[] {
    let childData:any = this.childInfoAddDataArray.map((element: any) => ({
    firstName:                this.capitalize(element.firstName),
    lastName:                 this.capitalize(element.lastName),
    gender:                   element.gender ? element.gender.charAt(0).toUpperCase() + element.gender.slice(1).toLowerCase() : '',
    dob:              this._CustomDatePipe.transform(element.date_of_birth),
    isChildHavingHealthcard:  element.is_child_having_healthcard === 'true',
    childCarrierName:         element.child_carrier_name || '',
    enrolledInUniversity:     element.enrolledInUniversity === true,
    isDisabled:               element.isDisabled === true,
    graduationDay:            this._CustomDatePipe.transform(element.graduationDay) || '',
    // the child modal stores this under its control_name (addedToPlan); addToPlan is the
    // config's `field` name and is kept as a fallback for older stored rows. Only
    // addedToPolicy is emitted — the payload carries one key, not two.
    addedToPolicy:              this.formatAddedToPolicy(element.addedToPlan ?? element.addToPlan),
  }));


  if(this.currForm == "CORP" && this.currFormType == "nhlaa"){
    childData.forEach((child:any) => {
      delete child.addedToPolicy;
    })
  }

  // mirror after the delete above so a removed key never lingers in customData
  childData.forEach((child:any) => this.mirrorIntoCustomData(child));

  return childData;
}


private isTruthy(val: any): boolean {
  return val === 'true' || val === true || val === 'yes' || val === 1;
}

/**
 * Single formatter for every addedToPolicy we emit. The broker's
 * signupFormConfigurations.sendTrueOrFalseForAddedToPolicy flag decides the wire type:
 * true → boolean true/false, anything else → numeric 1/0.
 * Runs isTruthy on the input first, so it accepts a boolean, 'true', 1 or an
 * already-formatted value and stays correct if applied twice.
 */
private formatAddedToPolicy(value: any): boolean | number {
  const flag = this.isTruthy(value);
  if (this.isTruthy(this.sendTrueOrFalseForAddedToPolicy)) return flag;
  return flag ? 1 : 0;
}

/**
 * Mirrors every top level value of a spouse/child object into its own customData, so the
 * nested copy is a superset of the record. Non-destructive: anything customData already
 * holds (initial, phoneNumber, address, …) wins and is never overwritten. Safe to call more
 * than once — a later pass only fills in keys added since the previous one.
 */
private mirrorIntoCustomData(target: any): void {
  if (!target || typeof target !== 'object') return;
  if (!target.customData || typeof target.customData !== 'object') target.customData = {};

  for (const key of Object.keys(target)) {
    if (key === 'customData') continue;
    if (Object.prototype.hasOwnProperty.call(target.customData, key)) continue;
    target.customData[key] = target[key];
  }
}

/**
 * Reads the spouse "Add to plan" value. The control name comes from the same lookup the
 * template binds through, so a config rename cannot silently make this read the wrong key;
 * the two literals are fallbacks for the control_name / field pair in the config.
 */
private readSpouseAddToPlan(formVal: any): any {
  const controlName = this.getFormControlName('spouse_add_to_plan');
  const candidates = [controlName, 'addedToPlan', 'addToPlan'];
  for (const name of candidates) {
    if (!name) continue;
    const value = formVal?.[name];
    if (value !== undefined && value !== null && value !== '') return value;
  }
  return false;
}

private buildSpouseDetails(): any {
  const formVal = this.userForm.value;
  if (!this.isTruthy(formVal['having_spouse'])) return {};

  const toCamelCase = (s: string) => s.replace(/_([a-z0-9])/g, (_: string, c: string) => c.toUpperCase());

  // Core fields that need special transforms — handled manually
  const spouseData: any = {
    firstName:   this.capitalize(formVal['spouseFirstName']),
    lastName:    this.capitalize(formVal['spouseLastName']),
    email:       formVal['spouseEmail'] || '',
    dob: this._CustomDatePipe.transform(formVal['spouseDateOfBirth']),
    gender:      formVal['spouseGender'] ? formVal['spouseGender'].charAt(0).toUpperCase() + formVal['spouseGender'].slice(1).toLowerCase() : '',
    isSpouseHavingHealthcard: this.isTruthy(formVal['spouseHealthCard']),
    spouseCarrierName: this.isTruthy(formVal['spouseHealthCard']) ? formVal['SpouseNameOfTheCarrier'] : '',
    cobCoverage:       this.isTruthy(formVal['spouseHealthCard']) ? formVal['spouseCob'] : '',
    // resolve the control the same way the template binds it rather than guessing the name
    addedToPolicy:       this.formatAddedToPolicy(this.readSpouseAddToPlan(formVal)),
    customData: {}
  };

  if (this.currFormType === 'viking') {
    spouseData.maritalType = formVal['maritalType']
      ? formVal['maritalType'].charAt(0).toUpperCase() + formVal['maritalType'].slice(1).toLowerCase()
      : '';
  }

  // Control names already handled above — skip them in the dynamic pass
  const handled = new Set([
    'spouseFirstName', 'spouseLastName', 'spouseEmail', 'spouseDateOfBirth',
    'spouseGender', 'spouseHealthCard', 'SpouseNameOfTheCarrier', 'spouseCob',
    'addToPlan', 'addedToPlan', 'having_spouse', 'has_spouse', 'spouseSameAddressAsMember', 'maritalType',
    // address fields go to spouseAddress, not spouseDetails
    'spouse_street_address_line1', 'spouse_street_address_line2',
    'spouseApt', 'spouseCity', 'spouseProvince', 'spousePostalCode', 'spousePoBoxAddress',
  ]);

  // Dynamically route remaining spouse fields: misc:true → customData, else → direct
  const spouseFields = this.activeFields?.['spouse_information'] || {};
  for (const fieldKey of Object.keys(spouseFields)) {
    const field = spouseFields[fieldKey];
    const controlName = field.control_name;
    if (!controlName || handled.has(controlName)) continue;
    if (!this.isFieldVisible(field)) continue;
    const value = formVal[controlName] ?? '';
    const outputKey = field.output_key ?? toCamelCase(controlName);
    if (field.misc) {
      const customKey = outputKey.startsWith('spouse')
        ? outputKey.charAt(6).toLowerCase() + outputKey.slice(7)
        : outputKey;
      spouseData.customData[customKey] = value;
    } else {
      spouseData[outputKey] = value;
    }
  }


  spouseData.customData['address'] = this.buildSpouseAddress();

  this.mirrorIntoCustomData(spouseData);

  return spouseData;
}


private buildSpouseAddress(): any {
  const formVal = this.userForm.value;
  if (!this.isTruthy(formVal['having_spouse'])) return {};

  const sameAddress = this.isTruthy(formVal['spouseSameAddressAsMember']);

  if (sameAddress) {
    return {
      streetAddressLine1: formVal['street_address_line1'] || '',
      streetAddressLine2: formVal['street_address_line2'] || '',
      apt:                formVal['apt'] || '',
      city:               formVal['city'] || '',
      province:           formVal['province'] || '',
      provinceId:         parseInt(this.provineList?.id ?? 0),
      postalCode:         formVal['postal_code'] || '',
      poBoxAddress:       formVal['poBoxAddress'] || '',
    };
  }

  return {
    streetAddressLine1: formVal['spouse_street_address_line1'] || '',
    streetAddressLine2: formVal['spouse_street_address_line2'] || '',
    apt:                formVal['spouseApt'] || '',
    city:               formVal['spouseCity'] || '',
    province:           formVal['spouseProvince'] || '',
    provinceId:         parseInt(this.spouseProvineList?.id ?? 0),
    postalCode:         formVal['spousePostalCode'] || '',
    poBoxAddress:       formVal['spousePoBoxAddress'] || '',
  };
}

private buildPhrDetails(): any {
  const formVal = this.userForm.value;
  return {
    dateOfArrival:   this._CustomDatePipe.transform(formVal['dateOfArrival']) || '',
    countryOfOrigin: formVal['countryOrigin'] || '',
    isLandedImmigrant: Boolean(formVal['isEmployeeImigrant']),
    coverageRequired:  Boolean(formVal['coverageRequiredOfEmployee']),
    applyingForLandingStatus: Boolean(formVal['applylandedstaus']),
    dependentDetails: formVal['has_child'] === 'yes' ? {
      coverageRequired: Boolean(formVal['coverageRequiredOfDependents']),
      dateOfArrival:    formVal['coverageRequiredOfDependents'] === 'true'
        ? this._CustomDatePipe.transform(formVal['dependentdateOfArrival']) : '',
      countryOfOrigin: formVal['coverageRequiredOfDependents'] === 'true'
        ? formVal['dependentcountryOrigin'] : '',
      isLandedImmigrant: formVal['coverageRequiredOfDependents'] === 'true'
        ? Boolean(formVal['dependentLandedImigrant']) : false,
      applyingForLandingStatus: Boolean(formVal['dependentMorethan3years']),
      stayFor3Months: formVal['coverageRequiredOfDependents'] === 'true'
        ? Boolean(formVal['dependentMorethan3years']) : false,
    } : {},
  };
}

  public getSliderBackground(
    rangeValue: any,
    maxRange: any,
    stepCount: any,
    defaultRange: any
  ): any {
    const percentage = (rangeValue / maxRange) * 100;
    let gradientColor = "white";


    // if (percentage >= 8 && stepCount === 25000) {
    //   gradientColor = "green";
    // }
    // return `linear-gradient(to right, ${gradientColor} ${percentage}%, white ${percentage}%)`;



    if (rangeValue <= defaultRange) {
      this.greenValue = (defaultRange / maxRange) * 100;
      this.names = [
        { label: 'Guaranteed', position: this.greenValue },    // Display "Start" at 0%
        { label: 'Pending', position: 100 - this.greenValue }, // Display "Quarter" at 25%

      ];
      this.showyellowbar = false
      return `linear-gradient(to right, green ${(defaultRange / maxRange) * 100}%, lightgray 0%)`;
    } else if (rangeValue > defaultRange) {
      const greenPart = adjustWith2DecimalsForUI((defaultRange / maxRange) * 100);
      console.log(greenPart)
      this.yellowValue = adjustWith2DecimalsForUI((100 - greenPart) * 100);
      // const yellowPart = ((rangeValue - defaultRange) / 4.5) + greenPart;
      const yellowPart = adjustWith2DecimalsForUI((rangeValue / maxRange) * 100)

      console.log(yellowPart)
      this.names = [
        { label: 'Guaranteed', position: greenPart },    // Display "Start" at 0%
        { label: 'Pending', position: yellowPart }, // Display "Quarter" at 25%

      ];
      this.showyellowbar = true
      return `linear-gradient(to right,  green 0%,
      green ${greenPart}%,
      yellow ${greenPart}%,
      yellow ${yellowPart}%,
      lightgray  ${yellowPart}%,
      lightgray  100%)`;
      // return`linear-gradient(to right, green ${greenPart}%, yellow ${yellowPart}%)`;
      // return `linear-gradient(to right, red 30%, yellow 70%)`;
      //  return `linear-gradient(to right, green 0%, green 30%, yellow 30%, yellow 100%)`  working
      //  return `linear-gradient(to right, green 0%, green ${greenPart}%, yellow ${greenPart}%, yellow 100%)`
      //  return `linear-gradient(to right, red ${greenPart}%, yellow ${yellowPart}%)`
      // return`linear-gradient(to right, green 0%, green ${greenPart}%, yellow ${yellowPart}%, yellow 100%)`;

    }
  }

  public isDataAvailable(type: string, category: string, feild?: string): boolean {
    // console.log(this.allFormData)
    // console.log(type)
    // console.log(category)
    // console.log(feild)
    const bool = feild ? !(this.allFormData[type] && this.allFormData[type][category] && this.allFormData[type][category][feild]) : !(this.allFormData[type] && this.allFormData[type][category]);
    return bool
  }
  public isDataAvailableSpouseDataa(type: string, category: string, feild?: string): boolean {
    console.log(this.allFormData)
    console.log(type)
    console.log(category)
    console.log(feild)

    // const bool = feild?this.allFormData[type] && this.allFormData[type][category]:false;
    // return bool

    const bool = feild ? !(this.allFormData[type] && this.allFormData[type][category] && this.allFormData[type][category][feild]) : !(this.allFormData[type] && this.allFormData[type][category]);
    return bool
  }
  public isDataAvailableSpouse(type: string, category: string, feild?: string): boolean {

    if (this.allFormData[type]) {
      console.log(this.allFormData[type]['member'])
    }

    if (this.allFormData[type] && this.allFormData[type]['member']) {
      return false
    }
    else {
      return true
    }


  }
  public generateTicks(maxRange: any, stepCount: any): any[] {
    const ticks = [];
    const totalTicks = maxRange / stepCount;

    for (let i = 0; i <= totalTicks; i++) {
      ticks.push(i * stepCount);
    }

    return ticks;
  }

  public updateTotal(data: any) {
    const memberPremium =
      data.member && data.member.premium > 0 ? data.member.premium : 0;
    const spousePremium =
      data.spouse && data.spouse.premium > 0 ? data.spouse.premium : 0;
    const dependentPremium =
      data.dependent && data.dependent.premium > 0 ? data.dependent.premium : 0;
    const total = memberPremium + spousePremium + dependentPremium;

    return total;
  }
  public updateFormData(
    type: string,
    category: string,
    newData: any,
    remove: boolean = false
  ): void {


    if (this.lastUpdatedType !== type) {
      this.formData = this.allFormData[type]
        ? { ...this.allFormData[type] }
        : {};
    }

    let updatedFormData = { ...this.formData };
    let shouldUpdateTotal = false;
    console.log(updatedFormData)
    if (remove) {
      delete updatedFormData[category];
      delete updatedFormData.total;
    } else if (typeof newData === "object" && newData !== null) {
      updatedFormData[category] = { ...updatedFormData[category], ...newData };
      shouldUpdateTotal = "coverage" in newData || category === "dependent" || "isSmoker" in newData;
    } else {
      updatedFormData[category] = newData;
    }

    if (
      shouldUpdateTotal &&
      ["member", "spouse", "dependent"].includes(category)
    ) {
      updatedFormData.total = this.updateTotal(updatedFormData);
    }

    this.formData = updatedFormData;
    this.allFormData[type] = { ...this.formData };
    // this.allFormData = { ...this.allFormData, [type]: this.formData };
    this.lastUpdatedType = type;
    console.log("formData:", this.allFormData);


  }

  public calculateAge(dob: string) {
    // Unchanged rule (completed years); the parse is now local so 'YYYY-MM-DD' input is
    // not read as the previous day. NaN is kept for unparseable input, as before.
    return calculateAgeFrom(dob) ?? NaN;
  }

  public updatePremium(
    type: string,
    category: string,
    newIsSmokerValue: string
  ) {

    //  if (this.allFormData[type][category]) {
    //   const isSmokerValue = event.target.value=== "yes" ? "smoker" : "nonSmoker";

    //   console.log(isSmokerValue)
    //   let gender:any = this.userForm.value.gender?.toLowerCase()
    //   let value: any = 0;
    //   console.log(this.allFormData[type][category]["coverage"])
    //   value=this.allFormData[type][category]["coverage"][gender][isSmokerValue]
    //   console.log(value)
    //   const premium = (this.allFormData[type][category]["coverage"].maximumCoverageWithoutEvidence * value) / 1000;
    //   console.log(parseFloat(premium.toFixed(2)))
    //   this.updateFormData(type, category, {
    //     isSmoker: isSmokerValue,
    //     premium: parseFloat(premium.toFixed(2))
    //   });
    // }

    console.log(this.allFormData)
    // const coverage = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence;

    const coverage = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence / 25000;
    const isSmoker = newIsSmokerValue === "yes" ? "smoker" : "nonSmoker";
    let value: any = 0;
    let gender: any = this.userForm.value.gender?.toLowerCase()
    let spouseGender: any = this.userForm.value.spousegender?.toLowerCase()

    console.log(spouseGender)

    if (category === "member") {
      value = this.allFormData[type][category]["coverage"]["price"][gender][isSmoker]
    }

    if (category === "spouse") {
      value = this.allFormData[type][category]["coverage"]["price"][spouseGender][isSmoker]
    }
    console.log({ value })

    this.updateFormData(type, category, { constant: value });

    if (coverage > 0) {
      // const premium = (coverage * value) / 1000;

      const premium = (coverage * value);
      return parseFloat(premium.toFixed(2));
    }
    console.log("formData:", this.allFormData);
    return 0;

  }

  public updateDependentPremium(type: string, category: string, coverage: number) {
    // const constant = coverage > 5000 ? 2.56 : 1.28;
    // this.updateFormData(type, category, { constant: constant });

    // const p =
    //   (constant * coverage) / 1000;
    // return parseFloat(p.toFixed(2));
  }

  public onCheckboxChangeP(
    event: any,
    type: string,
    category: string,
    key1: string,
    value1: any,
    key2?: string,
    value2?: any
  ): void {

    console.log(this.allFormData)


    console.log(value1)
    console.log(value1?.member)
    // console.log(value1?.spouse)
    if (category == 'member') {
      this.updateFormData(type, 'member', { coverage: value1.member })
    }
    if (category == 'spouse') {
      if (this.userForm.value.having_spouse === 'true') {
        this.updateFormData(type, 'spouse', { coverage: value1.spouse });
      }
    }



    let planSummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
    if (event.target.checked) {
      this.updateFormData(type, category, { [key1]: value1 });
      const dom: HTMLElement = this.elementRef.nativeElement;
      const plan: any = dom.querySelector("." + category + "-" + type + "-no");
      console.log(plan)
      setTimeout(() => {
        // plan.click()
      }, 100);


    } else {

      console.log(type)
      console.log(category)
      this.updateFormData(type, category, {}, true);

      if (category == 'spouse') {
        this.updateFormData(type, 'member', {}, true);


        const planCheck = this.renderer.selectRootElement("#planCheckLife" + type + "-" + 'MEMBER', true);
        this.renderer.setProperty(planCheck, 'checked', false);
      }
      if (category == 'member') {
        this.updateFormData(type, 'spouse', {}, true);

        planSummaryLife.forEach((element: any, index: any) => {

          if (element.coverage == 'MEMBER & SPOUSE') {
            const planCheck = this.renderer.selectRootElement("#planCheckLife" + type + "-" + 'SPOUSE', true);
            this.renderer.setProperty(planCheck, 'checked', false);
          }

        })

      }
      this.unselectplanLife(event)
    }


  }

  public onInputChangeP(e: Event, type: string, category: string): void {
    const inputElement = e.target as HTMLInputElement;
    if (inputElement && this.allFormData[type][category]) {
      const obj = { [inputElement.name]: inputElement.value };
      this.updateFormData(type, category, obj);
    }
  }




  public handleRangeChangeForDependent(
    value: any,
    type: string,
    category: string
  ): void {
    // if (this.allFormData[type][category]) {
    //   this.updateFormData(type, category, {
    //     // coverage: value,
    //     premium: this.updateDependentPremium(type, category, value),
    //   });
    // }
  }

  //   public handleRadioChange(event: any, type: string, category: string,options:any,plan:any,product:any,pckage:any,group:any,value:any): void {


  //     // console.log(plan)
  //     // console.log(product)
  //     // console.log(pckage)
  //     // console.log(group)

  //     let isSmokerValue = event.target.value;
  //     this.allFormData[type][category].coverage=value

  //     if (this.allFormData[type][category]) {

  //       this.updateFormData(type, category, {
  //         isSmoker: isSmokerValue,
  //         premium: this.updatePremium(type, category, isSmokerValue),
  //       });
  //     }
  //     this.rangeValues = [];
  //     console.log(this.allFormData)
  //     let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
  // let lifeCoverage=''
  // let memberObj:any={}
  // let spouseObj:any={}

  // if(category=="member"){
  //   lifeCoverage="MEMBER"
  // }
  // else{
  // lifeCoverage="MEMBER & SPOUSE"
  // }


  //     let plandetails = event.target.attributes.data.value;

  //     let plandetailsobj = plandetails.split('##');


  //     plansummaryLife.forEach((element:any,index:any) => {

  //       if(element.planname==plandetailsobj[14]){
  //         plansummaryLife.splice(index,1)
  //       }
  //       sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));

  //     })

  //     setTimeout(() => {
  //       // console.log(this.allFormData[type][category].premium)

  //       let obj: any = {
  //         isBundle: plan.isBundle,
  //         // enrollmentDate: moment(
  //         //   this.userForm.get("planenrollmentdate").value,
  //         //   "MM-DD-YYYY"
  //         // ).format("YYYY-MM-DD"),
  //         enrollmentDate: this.userForm.value.planEnrollmentDate
  //           ? this._CustomDatePipe.transform(
  //               this.userForm.value.planEnrollmentDate
  //             )
  //           : undefined,
  //         // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
  //         name: plandetailsobj[14],
  //         details: plandetailsobj[0],
  //         packagename: plandetailsobj[0],
  //         groupName: plandetailsobj[1],
  //         amount: this.allFormData[type].total,
  //         // amount: this.allFormData[type][category].premium,
  //         planCoverage: plandetailsobj[2],
  //         planPrice: adjustWith2DecimalsForUI(this.allFormData[type].total),
  //         amountUI:
  //           '$' +
  //           adjustWith2DecimalsForUI(this.allFormData[type].total),
  //         gst:
  //           plandetailsobj[4] == null ||
  //           plandetailsobj[4] == '' ||
  //           plandetailsobj[4] == undefined ||
  //           plandetailsobj[4] == 'null'
  //             ? 0
  //             : parseFloat(plandetailsobj[4]),
  //         hst:
  //           plandetailsobj[5] == null ||
  //           plandetailsobj[5] == '' ||
  //           plandetailsobj[5] == undefined ||
  //           plandetailsobj[5] == 'null'
  //             ? 0
  //             : parseFloat(plandetailsobj[5]),
  //         pst:
  //           plandetailsobj[6] == null ||
  //           plandetailsobj[6] == '' ||
  //           plandetailsobj[6] == undefined ||
  //           plandetailsobj[6] == 'null'
  //             ? 0
  //             : parseFloat(plandetailsobj[6]),
  //         qst:
  //           plandetailsobj[17] == null ||
  //           plandetailsobj[17] == '' ||
  //           plandetailsobj[17] == undefined ||
  //           plandetailsobj[17] == 'null'
  //             ? 0
  //             : parseFloat(plandetailsobj[17]),
  //         gstCheck:
  //           plandetailsobj[4] == null ||
  //           plandetailsobj[4] == '' ||
  //           plandetailsobj[4] == undefined ||
  //           plandetailsobj[4] == 'null'
  //             ? false
  //             : true,
  //         hstCheck:
  //           plandetailsobj[5] == null ||
  //           plandetailsobj[5] == '' ||
  //           plandetailsobj[5] == undefined ||
  //           plandetailsobj[5] == 'null'
  //             ? false
  //             : true,
  //         pstCheck:
  //           plandetailsobj[6] == null ||
  //           plandetailsobj[6] == '' ||
  //           plandetailsobj[6] == undefined ||
  //           plandetailsobj[6] == 'null'
  //             ? false
  //             : true,
  //         qstCheck:
  //           plandetailsobj[17] == null ||
  //           plandetailsobj[17] == '' ||
  //           plandetailsobj[17] == undefined ||
  //           plandetailsobj[17] == 'null'
  //             ? false
  //             : true,
  //         id: parseFloat(plandetailsobj[7]),
  //         fusebillPlanID:
  //           plandetailsobj[8] == null ||
  //           plandetailsobj[8] == '' ||
  //           plandetailsobj[8] == undefined ||
  //           plandetailsobj[8] == 'null'
  //             ? 0
  //             : parseFloat(plandetailsobj[8]),
  //         planFrequencyID:
  //           plandetailsobj[9] == null ||
  //           plandetailsobj[9] == '' ||
  //           plandetailsobj[9] == undefined ||
  //           plandetailsobj[9] == 'null'
  //             ? 0
  //             : parseFloat(plandetailsobj[9]),
  //         optIn: plandetailsobj[10] == 'true' ? true : false,
  //         planname: plandetailsobj[14],
  //         planLevel: parseInt(plandetailsobj[15]),
  //         packageId: parseInt(plandetailsobj[16]),
  //         options: [],
  //         version:plan.version,
  //         description: plan.description,
  //         insuranceType:plan.insuranceType

  //         //  "disallowedPlanLevels":plandetailsobj[11]
  //       };
  //       if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
  //         if (plandetailsobj[11].includes(plandetailsobj[12])) {
  //         }
  //       }
  //      ///this.consoleMessage(obj)
  //       this.productobj = {
  //         id: product.id,
  //         productId: product.productId,
  //         name: product.name,
  //         planProductId: product.planProductId,
  //         price: this.allFormData[type].total,
  //         tax: this._decimalPipe
  //           .transform(
  //             product.calculatedTax ? product.calculatedTax.tax : 0,
  //             '1.2-2'
  //           )
  //           ?.replace(/,/g, ''),
  //         total: this._decimalPipe
  //           .transform(
  //             product.calculatedTax ? product.calculatedTax.total : 0,
  //             '1.2-2'
  //           )
  //           ?.replace(/,/g, ''),
  //         tax_details:
  //           product.bundledTaxes && product.bundledTaxes.length > 0
  //             ? product.bundledTaxes
  //             : product.taxesDataJSON,
  //         calculatedTax: this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]),
  //         bundledProducts: product.bundledProducts,
  //         planCoverage: lifeCoverage,
  //         planLevel: product.planlevel ? product.planlevel.id : '',
  //         planLevelParent: product.planlevel ? product.planlevel.parentId : '',
  //         description: product.description,
  //         coverage: lifeCoverage,
  //         version:product.version
  //       };

  //       this.productobj.total = this._decimalPipe
  //       .transform(
  //         this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
  //         '1.2-2'
  //       )
  //       ?.replace(/,/g, '')
  //       this.productobj.tax = this._decimalPipe
  //       .transform(
  //         this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
  //         '1.2-2'
  //       )
  //       ?.replace(/,/g, '')

  //       if(category=="member"){

  //         memberObj={
  //       "planStartDate":this.userForm.value.planEnrollmentDate
  //       ? this._CustomDatePipe.transform(
  //           this.userForm.value.planEnrollmentDate
  //         )
  //       : undefined,
  //       "units":(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //       "standardUnits":this.allFormData[type]["member"].coverage.minimumCoverage,
  //       "coverage":"MEMBER",
  //       "guaranteedAcceptance":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >=
  //       this.allFormData[type]["member"].coverage.defaultRange?true:false, //defalutRange
  //       "pendingMedicalQuestionaire":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <
  //       this.allFormData[type]["member"].coverage.defaultRange?true:false,
  //       "smoker":this.allFormData[type]["member"].isSmoker=="yes"?true:false,
  //       "age":this.allFormData[type]["member"].coverage.age,
  //       "gender":this.userForm.value.gender?.toLowerCase(),
  //       "province":"ON",
  //       "provinceId":12,
  //       "amount":this.allFormData[type]["member"].premium,
  //       "tax": adjustWith2DecimalsForUI(this.productobj.tax),
  //       "taxRate":"", //not mandatory,
  //       "taxName":"",
  //       "coverageValue":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //       "premium":this.allFormData[type]["member"].constant,
  //       "total":adjustWith2DecimalsForUI(this.productobj.total),
  //       "coverageUnitPrice":this.allFormData[type]["member"].coverage.coverageUnitPrice,
  //       "defaultRange":this.allFormData[type]["member"].coverage.defaultRange,
  //       "maximumCoverageWithEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
  //       "maximumCoverageWithoutEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //       "minimumCoverage":this.allFormData[type]["member"].coverage.minimumCoverage,
  //         }
  //         obj["member"]= memberObj
  //         obj["spouse"]= {}
  //       }
  //       else{

  //         memberObj={
  //           "planStartDate":this.userForm.value.planEnrollmentDate
  //       ? this._CustomDatePipe.transform(
  //           this.userForm.value.planEnrollmentDate
  //         )
  //       : undefined,
  //           "units":(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //           "standardUnits":this.allFormData[type]["member"].coverage.minimumCoverage,
  //           "coverage":"MEMBER",
  //           "guaranteedAcceptance":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >=
  //           this.allFormData[type]["member"].coverage.defaultRange?true:false, //defalutRange
  //           "pendingMedicalQuestionaire":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <
  //           this.allFormData[type]["member"].coverage.defaultRange?true:false,
  //           "smoker":this.allFormData[type]["member"].isSmoker=="yes"?true:false,
  //           "age":this.allFormData[type]["member"].coverage.age,
  //           "gender":this.userForm.value.gender?.toLowerCase(),
  //           "province":"ON",
  //           "provinceId":12,
  //           "amount":this.allFormData[type]["member"].premium,
  //           "tax": adjustWith2DecimalsForUI(this.productobj.tax),
  //           "taxRate":"", //not mandatory,
  //           "taxName":"",
  //           "coverageValue":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //           "premium":this.allFormData[type]["member"].constant,
  //           "total":adjustWith2DecimalsForUI(this.productobj.total),
  //           "coverageUnitPrice":this.allFormData[type]["member"].coverage.coverageUnitPrice,
  //           "defaultRange":this.allFormData[type]["member"].coverage.defaultRange,
  //           "maximumCoverageWithEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
  //           "maximumCoverageWithoutEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //           "minimumCoverage":this.allFormData[type]["member"].coverage.minimumCoverage,
  //             }
  //             spouseObj={
  //               "planStartDate":this.userForm.value.planEnrollmentDate
  //       ? this._CustomDatePipe.transform(
  //           this.userForm.value.planEnrollmentDate
  //         )
  //       : undefined,
  //               "units":(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //               "standardUnits":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //               "coverage":"MEMBER & SPOUSE",
  //               "guaranteedAcceptance":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >=
  //       this.allFormData[type]["spouse"].coverage.defaultRange?true:false, //defalutRange
  //       "pendingMedicalQuestionaire":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <
  //       this.allFormData[type]["spouse"].coverage.defaultRange?true:false,
  //               "smoker":this.allFormData[type]["spouse"].isSmoker=="yes"?true:false,
  //               "age":this.allFormData[type]["spouse"].coverage.age,
  //               "gender":this.userForm.value.spousegender?.toLowerCase(),
  //               "province":"ON",
  //               "provinceId":12,
  //               "amount":this.allFormData[type]["spouse"].premium,
  //               "tax":adjustWith2DecimalsForUI(this.productobj.tax),
  //               "taxRate":"", //not mandatory,
  //               "taxName":"",
  //               "coverageValue":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //               "premium":this.allFormData[type]["spouse"].constant,
  //               "total":adjustWith2DecimalsForUI(this.productobj.total),
  //               "coverageUnitPrice":this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
  //               "defaultRange":this.allFormData[type]["spouse"].coverage.defaultRange,
  //               "maximumCoverageWithEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
  //               "maximumCoverageWithoutEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //               "minimumCoverage":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //                 }

  //       obj["member"]= memberObj
  //       obj["spouse"]= spouseObj
  //       }

  //       let obj1: any = {
  //         packageId: plan.packageId,
  //         packageName: pckage.name,

  //         planproductname: this.productobj.name,

  //         groupid: plan.planLevel,
  //         groupName: group.name,
  //         id: plan.id,
  //         name: plan.name,
  //         planLevel: plan.planLevel ? plan.planLevel : group.id,
  //         planLevelParent: group.parentId,
  //         fusebillPlanID: plan.fusebillId,
  //         planFrequencyID: plan.frqMonthly,
  //         isBundle: plan.isBundle,
  //         coverage: lifeCoverage,
  //         planCoverage: product.planCoverage,
  //         bundledProducts: [],
  //         products: [],
  //         version:plan.version

  //       };
  //       obj1.products.push(this.productobj);
  //       //this.consoleMessage(obj1)
  //       // console.log(obj)
  //       // console.log(obj1)
  //       this.addtoplansummaryLife(obj, obj1);
  //     }, 100);
  //     for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 50000) {
  //       this.rangeValues.push(i);
  //     }

  //   }
  // public handleRangeChange(value: any, type: string, category: string,options:any,plan:any,product:any,pckage:any,group:any,event:any,data:any): void {
  //   // console.log(value)
  //   console.log(type)
  //   console.log(event)
  //   this.allFormData[type][category].coverage=data

  //   // this.sliderValue = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence


  //   this.rangeValues = [];

  //   // return values;

  //   // this.minimumCoverage =this.allFormData[type][category].coverage.defaultRange

  //   // this.minimumCoverage = this.allFormData[type][category].coverage.maximumCoverageWithEvidence - this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence
  //   // this.extraCoverage = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence
  //   // if (this.coverageValue > this.minimumCoverage) {
  //   //   this.extraCoverage = this.coverageValue - this.minimumCoverage;
  //   // } else {
  //   //   this.extraCoverage = 0;
  //   // }



  //   if (this.allFormData[type][category]) {
  //     this.updateFormData(type, category, {
  //       // coverage: value,
  //       isSmoker: this.allFormData[type][category].isSmoker,
  //       premium: this.updatePremium(type, category, this.allFormData[type][category].isSmoker),
  //     });
  //   }
  //   let lifeCoverage=''
  //   let memberObj:any={}
  // let spouseObj:any={}
  // if(category=="member"){
  // lifeCoverage="MEMBER"
  // }else{
  // lifeCoverage="MEMBER & SPOUSE"
  // }
  //   console.log(this.plansData)
  //   let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');


  //   let plandetails = event.target.attributes.data.value;

  //   let plandetailsobj = plandetails.split('##');


  //   plansummaryLife.forEach((element:any,index:any) => {

  //     if(element.planname==plandetailsobj[14]){
  //       plansummaryLife.splice(index,1)
  //     }
  //     sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));

  //   })
  //   setTimeout(() => {
  //     // console.log(this.allFormData[type][category].premium)

  //     let obj: any = {
  //       isBundle: plan.isBundle,
  //       // enrollmentDate: moment(
  //       //   this.userForm.get("planenrollmentdate").value,
  //       //   "MM-DD-YYYY"
  //       // ).format("YYYY-MM-DD"),
  //       enrollmentDate: this.userForm.value.planEnrollmentDate
  //         ? this._CustomDatePipe.transform(
  //             this.userForm.value.planEnrollmentDate
  //           )
  //         : undefined,
  //       // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
  //       name: plandetailsobj[14],
  //       details: plandetailsobj[0],
  //       packagename: plandetailsobj[0],
  //       groupName: plandetailsobj[1],
  //       amount: this.allFormData[type].total,
  //       // amount: this.allFormData[type][category].premium,
  //       planCoverage: plandetailsobj[2],
  //       planPrice: adjustWith2DecimalsForUI(this.allFormData[type].total),
  //       amountUI:
  //         '$' +
  //         adjustWith2DecimalsForUI(this.allFormData[type].total),
  //       gst:
  //         plandetailsobj[4] == null ||
  //         plandetailsobj[4] == '' ||
  //         plandetailsobj[4] == undefined ||
  //         plandetailsobj[4] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[4]),
  //       hst:
  //         plandetailsobj[5] == null ||
  //         plandetailsobj[5] == '' ||
  //         plandetailsobj[5] == undefined ||
  //         plandetailsobj[5] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[5]),
  //       pst:
  //         plandetailsobj[6] == null ||
  //         plandetailsobj[6] == '' ||
  //         plandetailsobj[6] == undefined ||
  //         plandetailsobj[6] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[6]),
  //       qst:
  //         plandetailsobj[17] == null ||
  //         plandetailsobj[17] == '' ||
  //         plandetailsobj[17] == undefined ||
  //         plandetailsobj[17] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[17]),
  //       gstCheck:
  //         plandetailsobj[4] == null ||
  //         plandetailsobj[4] == '' ||
  //         plandetailsobj[4] == undefined ||
  //         plandetailsobj[4] == 'null'
  //           ? false
  //           : true,
  //       hstCheck:
  //         plandetailsobj[5] == null ||
  //         plandetailsobj[5] == '' ||
  //         plandetailsobj[5] == undefined ||
  //         plandetailsobj[5] == 'null'
  //           ? false
  //           : true,
  //       pstCheck:
  //         plandetailsobj[6] == null ||
  //         plandetailsobj[6] == '' ||
  //         plandetailsobj[6] == undefined ||
  //         plandetailsobj[6] == 'null'
  //           ? false
  //           : true,
  //       qstCheck:
  //         plandetailsobj[17] == null ||
  //         plandetailsobj[17] == '' ||
  //         plandetailsobj[17] == undefined ||
  //         plandetailsobj[17] == 'null'
  //           ? false
  //           : true,
  //       id: parseFloat(plandetailsobj[7]),
  //       fusebillPlanID:
  //         plandetailsobj[8] == null ||
  //         plandetailsobj[8] == '' ||
  //         plandetailsobj[8] == undefined ||
  //         plandetailsobj[8] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[8]),
  //       planFrequencyID:
  //         plandetailsobj[9] == null ||
  //         plandetailsobj[9] == '' ||
  //         plandetailsobj[9] == undefined ||
  //         plandetailsobj[9] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[9]),
  //       optIn: plandetailsobj[10] == 'true' ? true : false,
  //       planname: plandetailsobj[14],
  //       planLevel: parseInt(plandetailsobj[15]),
  //       packageId: parseInt(plandetailsobj[16]),
  //       options: [],
  //       version:plan.version,
  //       description: plan.description,
  //       insuranceType:plan.insuranceType

  //       //  "disallowedPlanLevels":plandetailsobj[11]
  //     };
  //     if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
  //       if (plandetailsobj[11].includes(plandetailsobj[12])) {
  //       }
  //     }
  //    ///this.consoleMessage(obj)
  //     this.productobj = {
  //       id: product.id,
  //       productId: product.productId,
  //       name: product.name,
  //       planProductId: product.planProductId,
  //       price: this.allFormData[type].total,
  //       tax: this._decimalPipe
  //         .transform(
  //           product.calculatedTax ? product.calculatedTax.tax : 0,
  //           '1.2-2'
  //         )
  //         ?.replace(/,/g, ''),
  //       total: this._decimalPipe
  //         .transform(
  //           product.calculatedTax ? product.calculatedTax.total : 0,
  //           '1.2-2'
  //         )
  //         ?.replace(/,/g, ''),
  //       tax_details:
  //         product.bundledTaxes && product.bundledTaxes.length > 0
  //           ? product.bundledTaxes
  //           : product.taxesDataJSON,
  //       calculatedTax: this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]),
  //       bundledProducts: product.bundledProducts,
  //       planCoverage: lifeCoverage,
  //       planLevel: product.planlevel ? product.planlevel.id : '',
  //       planLevelParent: product.planlevel ? product.planlevel.parentId : '',
  //       description: product.description,
  //       coverage: lifeCoverage,
  //       version:product.version
  //     };

  //     this.productobj.total = this._decimalPipe
  //     .transform(
  //       this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
  //       '1.2-2'
  //     )
  //     ?.replace(/,/g, '')
  //     this.productobj.tax = this._decimalPipe
  //     .transform(
  //       this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
  //       '1.2-2'
  //     )
  //     ?.replace(/,/g, '')
  //     // console.log(this.allFormData)
  //     // console.log(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence )
  //     // console.log(this.allFormData[type]["member"].coverage.defaultRange)
  //     // console.log((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)

  //     // console.log(((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type][category].constant)
  //     if(category=="member"){

  //       memberObj={
  //     "planStartDate":this.userForm.value.planEnrollmentDate
  //     ? this._CustomDatePipe.transform(
  //         this.userForm.value.planEnrollmentDate
  //       )
  //     : undefined,
  //     "units":(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //     "standardUnits":this.allFormData[type]["member"].coverage.minimumCoverage,
  //     "coverage":"MEMBER",
  //     "guaranteedAcceptance":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >=
  //     this.allFormData[type]["member"].coverage.defaultRange?true:false, //defalutRange
  //     "pendingMedicalQuestionaire":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
  //     this.allFormData[type]["member"].coverage.defaultRange?true:false,


  //     "guaranteedAcceptanceAmount":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),
  //     "pendingApprovalAmount":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0 ||0,
  //     "smoker":this.allFormData[type]["member"].isSmoker=="yes"?true:false,
  //     "age":this.allFormData[type]["member"].coverage.age,
  //     "gender":this.userForm.value.gender?.toLowerCase(),
  //     "province":"ON",
  //     "provinceId":12,
  //     "amount":this.allFormData[type]["member"].premium,
  //     "tax": adjustWith2DecimalsForUI(this.productobj.tax),
  //     "taxRate":"", //not mandatory,
  //     "taxName":"",
  //     "coverageValue":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //     "premium":this.allFormData[type]["member"].constant,
  //     "total":adjustWith2DecimalsForUI(this.productobj.total),
  //     "coverageUnitPrice":this.allFormData[type]["member"].coverage.coverageUnitPrice,
  //     "defaultRange":this.allFormData[type]["member"].coverage.defaultRange,
  //     "maximumCoverageWithEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
  //     "maximumCoverageWithoutEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //     "minimumCoverage":this.allFormData[type]["member"].coverage.minimumCoverage,
  //       }
  //       memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).tax
  //       memberObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).total

  //       memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).tax
  //       memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).total

  //       obj["member"]= memberObj
  //       obj["spouse"]= {}

  //       if(this.allFormData[type]['spouse']){
  //         spouseObj={
  //           "planStartDate":this.userForm.value.planEnrollmentDate
  //   ? this._CustomDatePipe.transform(
  //       this.userForm.value.planEnrollmentDate
  //     )
  //   : undefined,
  //           "units":(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //           "standardUnits":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //           "coverage":"MEMBER & SPOUSE",
  //           "guaranteedAcceptance":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >=
  //   this.allFormData[type]["spouse"].coverage.defaultRange?true:false, //defalutRange
  //   "pendingMedicalQuestionaire":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <
  //   this.allFormData[type]["spouse"].coverage.defaultRange?true:false,
  //   "guaranteedAcceptanceAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),
  //   "pendingApprovalAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000)*this.allFormData[type]["spouse"].constant:0 ||0,
  //           "smoker":this.allFormData[type]["spouse"].isSmoker=="yes"?true:false,
  //           "age":this.allFormData[type]["spouse"].coverage.age,
  //           "gender":this.userForm.value.spousegender?.toLowerCase(),
  //           "province":"ON",
  //           "provinceId":12,
  //           "amount":this.allFormData[type]["spouse"].premium,
  //           "tax":adjustWith2DecimalsForUI(this.productobj.tax),
  //           "taxRate":"", //not mandatory,
  //           "taxName":"",
  //           "coverageValue":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //           "premium":this.allFormData[type]["spouse"].constant,
  //           "total":adjustWith2DecimalsForUI(this.productobj.total),
  //           "coverageUnitPrice":this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
  //           "defaultRange":this.allFormData[type]["spouse"].coverage.defaultRange,
  //           "maximumCoverageWithEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
  //           "maximumCoverageWithoutEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //           "minimumCoverage":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //             }






  //         obj["member"]= memberObj
  //         obj["spouse"]= spouseObj

  //         spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).tax
  //         spouseObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).total

  //         spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000)*this.allFormData[type]["spouse"].constant:0,product.taxesDataJSON??[]).tax
  //         spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000)*this.allFormData[type]["spouse"].constant:0,product.taxesDataJSON??[]).total
  //           }




  //     }
  //     else{

  //       memberObj={
  //         "planStartDate":this.userForm.value.planEnrollmentDate
  //     ? this._CustomDatePipe.transform(
  //         this.userForm.value.planEnrollmentDate
  //       )
  //     : undefined,
  //         "units":(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //         "standardUnits":this.allFormData[type]["member"].coverage.minimumCoverage,
  //         "coverage":"MEMBER",
  //         "guaranteedAcceptance":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >=
  //         this.allFormData[type]["member"].coverage.defaultRange?true:false, //defalutRange
  //         "pendingMedicalQuestionaire":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <
  //         this.allFormData[type]["member"].coverage.defaultRange?true:false,
  //         "guaranteedAcceptanceAmount":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),
  //         "pendingApprovalAmount":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0 ||0,
  //         "smoker":this.allFormData[type]["member"].isSmoker=="yes"?true:false,
  //         "age":this.allFormData[type]["member"].coverage.age,
  //         "gender":this.userForm.value.gender?.toLowerCase(),
  //         "province":"ON",
  //         "provinceId":12,
  //         "amount":this.allFormData[type]["member"].premium,
  //         "tax":adjustWith2DecimalsForUI(this.productobj.tax),
  //         "taxRate":"", //not mandatory,
  //         "taxName":"",
  //         "coverageValue":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //         "premium":this.allFormData[type]["member"].constant,
  //         "total":adjustWith2DecimalsForUI(this.productobj.total),
  //         "coverageUnitPrice":this.allFormData[type]["member"].coverage.coverageUnitPrice,
  //     "defaultRange":this.allFormData[type]["member"].coverage.defaultRange,
  //     "maximumCoverageWithEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
  //     "maximumCoverageWithoutEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //     "minimumCoverage":this.allFormData[type]["member"].coverage.minimumCoverage,
  //           }
  //           spouseObj={
  //             "planStartDate":this.userForm.value.planEnrollmentDate
  //     ? this._CustomDatePipe.transform(
  //         this.userForm.value.planEnrollmentDate
  //       )
  //     : undefined,
  //             "units":(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //             "standardUnits":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //             "coverage":"MEMBER & SPOUSE",
  //             "guaranteedAcceptance":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >=
  //     this.allFormData[type]["spouse"].coverage.defaultRange?true:false, //defalutRange
  //     "pendingMedicalQuestionaire":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <
  //     this.allFormData[type]["spouse"].coverage.defaultRange?true:false,
  //     "guaranteedAcceptanceAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type][category].constant),
  //     "pendingApprovalAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000)*this.allFormData[type]["spouse"].constant:0 ||0,
  //     "smoker":this.allFormData[type]["spouse"].isSmoker=="yes"?true:false,
  //             "age":this.allFormData[type]["spouse"].coverage.age,
  //             "gender":this.userForm.value.spousegender?.toLowerCase(),
  //             "province":"ON",
  //             "provinceId":12,
  //             "amount":this.allFormData[type]["spouse"].premium,
  //             "tax":adjustWith2DecimalsForUI(this.productobj.tax),
  //             "taxRate":"", //not mandatory,
  //             "taxName":"",
  //             "coverageValue":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //             "premium":this.allFormData[type]["spouse"].constant,
  //             "total":adjustWith2DecimalsForUI(this.productobj.total),
  //             "coverageUnitPrice":this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
  //     "defaultRange":this.allFormData[type]["spouse"].coverage.defaultRange,
  //     "maximumCoverageWithEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
  //     "maximumCoverageWithoutEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //     "minimumCoverage":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //               }

  //     obj["member"]= memberObj
  //     obj["spouse"]= spouseObj
  //     memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).tax
  //     memberObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).total
  //     spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).tax
  //     spouseObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["sposue"].constant),product.taxesDataJSON??[]).total

  //     memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).tax
  //     memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).total

  //     spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).tax
  //     spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).total

  //     }

  //     let obj1: any = {
  //       packageId: plan.packageId,
  //       packageName: pckage.name,

  //       planproductname: this.productobj.name,

  //       groupid: plan.planLevel,
  //       groupName: group.name,
  //       id: plan.id,
  //       name: plan.name,
  //       planLevel: plan.planLevel ? plan.planLevel : group.id,
  //       planLevelParent: group.parentId,
  //       fusebillPlanID: plan.fusebillId,
  //       planFrequencyID: plan.frqMonthly,
  //       isBundle: plan.isBundle,
  //       coverage: lifeCoverage,
  //       planCoverage: product.planCoverage,
  //       bundledProducts: [],
  //       products: [],
  //       version:plan.version

  //     };
  //     obj1.products.push(this.productobj);
  //     //this.consoleMessage(obj1)
  //     // console.log(obj)
  //     // console.log(obj1)
  //     this.addtoplansummaryLife(obj, obj1);
  //   }, 100);
  //   for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 50000) {
  //     this.rangeValues.push(i);
  //   }
  // }
  // public handleRadioChange(event: any, type: string, category: string,options:any,plan:any,product:any,pckage:any,group:any,value:any): void {


  //   // console.log(plan)
  //   this.rangeValues =[]

  //   let isSmokerValue = event.target.value;
  //   this.allFormData[type][category].coverage=value

  //   if (this.allFormData[type][category]) {

  //     this.updateFormData(type, category, {
  //       isSmoker: isSmokerValue,
  //       premium: this.updatePremium(type, category, isSmokerValue),
  //     });
  //   }

  //   console.log(this.allFormData)
  //   let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
  // let lifeCoverage=''
  // let memberObj:any={}
  // let spouseObj:any={}

  // if(category=="member"){
  // lifeCoverage="MEMBER"
  // }
  // else{
  // lifeCoverage="MEMBER & SPOUSE"
  // }

  // if(this.allFormData[type]['spouse']){
  //   lifeCoverage="MEMBER & SPOUSE"

  // }

  //   let plandetails = event.target.attributes.data.value;

  //   let plandetailsobj = plandetails.split('##');


  //   plansummaryLife.forEach((element:any,index:any) => {

  //     if(element.planname==plandetailsobj[14]){
  //       plansummaryLife.splice(index,1)
  //     }
  //     sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));

  //   })

  //   setTimeout(() => {
  //     // console.log(this.allFormData[type][category].premium)

  //     let obj: any = {
  //       isBundle: plan.isBundle,
  //       // enrollmentDate: moment(
  //       //   this.userForm.get("planenrollmentdate").value,
  //       //   "MM-DD-YYYY"
  //       // ).format("YYYY-MM-DD"),
  //       enrollmentDate: this.userForm.value.planEnrollmentDate
  //         ? this._CustomDatePipe.transform(
  //             this.userForm.value.planEnrollmentDate
  //           )
  //         : undefined,
  //       // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
  //       name: plandetailsobj[14],
  //       details: plandetailsobj[0],
  //       packagename: plandetailsobj[0],
  //       groupName: plandetailsobj[1],
  //       amount: this.allFormData[type].total,
  //       // amount: this.allFormData[type][category].premium,
  //       planCoverage: plandetailsobj[2],
  //       planPrice: adjustWith2DecimalsForUI(this.allFormData[type].total),
  //       amountUI:
  //         '$' +
  //         adjustWith2DecimalsForUI(this.allFormData[type].total),
  //       gst:
  //         plandetailsobj[4] == null ||
  //         plandetailsobj[4] == '' ||
  //         plandetailsobj[4] == undefined ||
  //         plandetailsobj[4] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[4]),
  //       hst:
  //         plandetailsobj[5] == null ||
  //         plandetailsobj[5] == '' ||
  //         plandetailsobj[5] == undefined ||
  //         plandetailsobj[5] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[5]),
  //       pst:
  //         plandetailsobj[6] == null ||
  //         plandetailsobj[6] == '' ||
  //         plandetailsobj[6] == undefined ||
  //         plandetailsobj[6] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[6]),
  //       qst:
  //         plandetailsobj[17] == null ||
  //         plandetailsobj[17] == '' ||
  //         plandetailsobj[17] == undefined ||
  //         plandetailsobj[17] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[17]),
  //       gstCheck:
  //         plandetailsobj[4] == null ||
  //         plandetailsobj[4] == '' ||
  //         plandetailsobj[4] == undefined ||
  //         plandetailsobj[4] == 'null'
  //           ? false
  //           : true,
  //       hstCheck:
  //         plandetailsobj[5] == null ||
  //         plandetailsobj[5] == '' ||
  //         plandetailsobj[5] == undefined ||
  //         plandetailsobj[5] == 'null'
  //           ? false
  //           : true,
  //       pstCheck:
  //         plandetailsobj[6] == null ||
  //         plandetailsobj[6] == '' ||
  //         plandetailsobj[6] == undefined ||
  //         plandetailsobj[6] == 'null'
  //           ? false
  //           : true,
  //       qstCheck:
  //         plandetailsobj[17] == null ||
  //         plandetailsobj[17] == '' ||
  //         plandetailsobj[17] == undefined ||
  //         plandetailsobj[17] == 'null'
  //           ? false
  //           : true,
  //       id: parseFloat(plandetailsobj[7]),
  //       fusebillPlanID:
  //         plandetailsobj[8] == null ||
  //         plandetailsobj[8] == '' ||
  //         plandetailsobj[8] == undefined ||
  //         plandetailsobj[8] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[8]),
  //       planFrequencyID:
  //         plandetailsobj[9] == null ||
  //         plandetailsobj[9] == '' ||
  //         plandetailsobj[9] == undefined ||
  //         plandetailsobj[9] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[9]),
  //       optIn: plandetailsobj[10] == 'true' ? true : false,
  //       planname: plandetailsobj[14],
  //       planLevel: parseInt(plandetailsobj[15]),
  //       packageId: parseInt(plandetailsobj[16]),
  //       options: [],
  //       version:plan.version,
  //       description: plan.description,
  //       insuranceType:plan.insuranceType

  //       //  "disallowedPlanLevels":plandetailsobj[11]
  //     };
  //     if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
  //       if (plandetailsobj[11].includes(plandetailsobj[12])) {
  //       }
  //     }
  //    ///this.consoleMessage(obj)
  //     this.productobj = {
  //       id: product.id,
  //       productId: product.productId,
  //       name: product.name,
  //       planProductId: product.planProductId,
  //       price:adjustWith2DecimalsForUI(this.allFormData[type].total),
  //       tax: this._decimalPipe
  //         .transform(
  //           product.calculatedTax ? product.calculatedTax.tax : 0,
  //           '1.2-2'
  //         )
  //         ?.replace(/,/g, ''),
  //       total: this._decimalPipe
  //         .transform(
  //           product.calculatedTax ? product.calculatedTax.total : 0,
  //           '1.2-2'
  //         )
  //         ?.replace(/,/g, ''),
  //       tax_details:
  //         product.bundledTaxes && product.bundledTaxes.length > 0
  //           ? product.bundledTaxes
  //           : product.taxesDataJSON,
  //       calculatedTax: this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]),
  //       bundledProducts: product.bundledProducts,
  //       planCoverage: lifeCoverage,
  //       planLevel: product.planlevel ? product.planlevel.id : '',
  //       planLevelParent: product.planlevel ? product.planlevel.parentId : '',
  //       description: product.description,
  //       coverage: lifeCoverage,
  //       version:product.version
  //     };

  //     this.productobj.total = this._decimalPipe
  //     .transform(
  //       this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
  //       '1.2-2'
  //     )
  //     ?.replace(/,/g, '')
  //     this.productobj.tax = this._decimalPipe
  //     .transform(
  //       this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
  //       '1.2-2'
  //     )
  //     ?.replace(/,/g, '')


  //     if(category=="member"){

  //       memberObj={
  //     "planStartDate":this.userForm.value.planEnrollmentDate
  //     ? this._CustomDatePipe.transform(
  //         this.userForm.value.planEnrollmentDate
  //       )
  //     : undefined,
  //     "units":(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //     "standardUnits":this.allFormData[type]["member"].coverage.minimumCoverage,
  //     "coverage":"MEMBER",
  //     "guaranteedAcceptance":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
  //     this.allFormData[type]["member"].coverage.defaultRange?true:false, //defalutRange
  //     "pendingMedicalQuestionaire":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
  //     this.allFormData[type]["member"].coverage.defaultRange?true:false,
  //     // "guaranteedAcceptanceAmount":this.allFormData[type]["member"].coverageValue <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverageValue/25000)*this.allFormData[type][category].constant):this.allFormData[type]["member"].coverage.defaultRange,

  //     "guaranteedAcceptanceAmount":adjustWith2DecimalsForUI(this.allFormData[type]["member"].coverageValue <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverageValue/25000)*this.allFormData[type][category].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type][category].constant)),
  //     "pendingApprovalAmount":adjustWith2DecimalsForUI(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type][category].constant:0 )||0,
  //     "smoker":this.allFormData[type]["member"].isSmoker=="yes"?true:false,
  //     "age":this.allFormData[type]["member"].coverage.age,
  //     "gender":this.userForm.value.gender?.toLowerCase(),
  //     "province":"ON",
  //     "provinceId":12,
  //     "amount":this.allFormData[type]["member"].premium,
  //     "tax": adjustWith2DecimalsForUI(this.productobj.tax),
  //     "taxRate":"", //not mandatory,
  //     "taxName":"",
  //     "coverageValue":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //     "premium":this.allFormData[type]["member"].constant,
  //     "total":adjustWith2DecimalsForUI(this.productobj.total),
  //     "coverageUnitPrice":this.allFormData[type]["member"].coverage.coverageUnitPrice,
  //     "defaultRange":this.allFormData[type]["member"].coverage.defaultRange,
  //     "maximumCoverageWithEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
  //     "maximumCoverageWithoutEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //     "minimumCoverage":this.allFormData[type]["member"].coverage.minimumCoverage,
  //       }

  //       memberObj["guaranteedAcceptanceTax"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverageValue <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverageValue/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).tax)
  //       memberObj["guaranteedAcceptanceTotal"] =adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverageValue <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverageValue/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).total)

  //       memberObj["pendingApprovalTax"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).tax)
  //       memberObj["pendingApprovalTotal"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).total)

  //       obj["member"]= memberObj
  //       obj["spouse"]= {}
  //       if(this.allFormData[type]['spouse']){
  //       spouseObj={
  //         "planStartDate":this.userForm.value.planEnrollmentDate
  // ? this._CustomDatePipe.transform(
  //     this.userForm.value.planEnrollmentDate
  //   )
  // : undefined,
  //         "units":(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //         "standardUnits":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //         "coverage":"MEMBER & SPOUSE",
  //         "guaranteedAcceptance":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
  // this.allFormData[type]["spouse"].coverage.defaultRange?true:false, //defalutRange
  // "pendingMedicalQuestionaire":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
  // this.allFormData[type]["spouse"].coverage.defaultRange?true:false,
  // "guaranteedAcceptanceAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type][category].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type][category].constant),
  // "pendingApprovalAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000)*this.allFormData[type][category].constant:0 ||0,
  //         "smoker":this.allFormData[type]["spouse"].isSmoker=="yes"?true:false,
  //         "age":this.allFormData[type]["spouse"].coverage.age,
  //         "gender":this.userForm.value.spousegender?.toLowerCase(),
  //         "province":"ON",
  //         "provinceId":12,
  //         "amount":this.allFormData[type]["spouse"].premium,
  //         "tax":adjustWith2DecimalsForUI(this.productobj.tax),
  //         "taxRate":"", //not mandatory,
  //         "taxName":"",
  //         "coverageValue":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //         "premium":this.allFormData[type]["spouse"].constant,
  //         "total":adjustWith2DecimalsForUI(this.productobj.total),
  //         "coverageUnitPrice":this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
  //         "defaultRange":this.allFormData[type]["spouse"].coverage.defaultRange,
  //         "maximumCoverageWithEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
  //         "maximumCoverageWithoutEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //         "minimumCoverage":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //           }






  //       obj["member"]= memberObj
  //       obj["spouse"]= spouseObj

  //       spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type][category].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type][category].constant),product.taxesDataJSON??[]).tax
  //       spouseObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type][category].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type][category].constant),product.taxesDataJSON??[]).total

  //       spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000)*this.allFormData[type][category].constant:0,product.taxesDataJSON??[]).tax
  //       spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000)*this.allFormData[type][category].constant:0,product.taxesDataJSON??[]).total
  //         }
  //     }
  //     else{

  //       memberObj={
  //         "planStartDate":this.userForm.value.planEnrollmentDate
  //     ? this._CustomDatePipe.transform(
  //         this.userForm.value.planEnrollmentDate
  //       )
  //     : undefined,
  //         "units":(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //         "standardUnits":this.allFormData[type]["member"].coverage.minimumCoverage,
  //         "coverage":"MEMBER",
  //         "guaranteedAcceptance":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
  //         this.allFormData[type]["member"].coverage.defaultRange?true:false, //defalutRange
  //         "pendingMedicalQuestionaire":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
  //         this.allFormData[type]["member"].coverage.defaultRange?true:false,
  //         "guaranteedAcceptanceAmount":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),

  //         "pendingApprovalAmount":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0 ||0,
  //         "smoker":this.allFormData[type]["member"].isSmoker=="yes"?true:false,
  //         "age":this.allFormData[type]["member"].coverage.age,
  //         "gender":this.userForm.value.gender?.toLowerCase(),
  //         "province":"ON",
  //         "provinceId":12,
  //         "amount":this.allFormData[type]["member"].premium,
  //         "tax": adjustWith2DecimalsForUI(this.productobj.tax),
  //         "taxRate":"", //not mandatory,
  //         "taxName":"",
  //         "coverageValue":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //         "premium":this.allFormData[type]["member"].constant,
  //         "total":adjustWith2DecimalsForUI(this.productobj.total),
  //         "coverageUnitPrice":this.allFormData[type]["member"].coverage.coverageUnitPrice,
  //         "defaultRange":this.allFormData[type]["member"].coverage.defaultRange,
  //         "maximumCoverageWithEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
  //         "maximumCoverageWithoutEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //         "minimumCoverage":this.allFormData[type]["member"].coverage.minimumCoverage,
  //           }
  //           spouseObj={
  //             "planStartDate":this.userForm.value.planEnrollmentDate
  //     ? this._CustomDatePipe.transform(
  //         this.userForm.value.planEnrollmentDate
  //       )
  //     : undefined,
  //             "units":(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //             "standardUnits":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //             "coverage":"MEMBER & SPOUSE",
  //             "guaranteedAcceptance":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
  //     this.allFormData[type]["spouse"].coverage.defaultRange?true:false, //defalutRange
  //     "pendingMedicalQuestionaire":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
  //     this.allFormData[type]["spouse"].coverage.defaultRange?true:false,
  //     "guaranteedAcceptanceAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type][category].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type][category].constant),
  //     "pendingApprovalAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000)*this.allFormData[type][category].constant:0 ||0,
  //             "smoker":this.allFormData[type]["spouse"].isSmoker=="yes"?true:false,
  //             "age":this.allFormData[type]["spouse"].coverage.age,
  //             "gender":this.userForm.value.spousegender?.toLowerCase(),
  //             "province":"ON",
  //             "provinceId":12,
  //             "amount":this.allFormData[type]["spouse"].premium,
  //             "tax":adjustWith2DecimalsForUI(this.productobj.tax),
  //             "taxRate":"", //not mandatory,
  //             "taxName":"",
  //             "coverageValue":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //             "premium":this.allFormData[type]["spouse"].constant,
  //             "total":adjustWith2DecimalsForUI(this.productobj.total),
  //             "coverageUnitPrice":this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
  //             "defaultRange":this.allFormData[type]["spouse"].coverage.defaultRange,
  //             "maximumCoverageWithEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
  //             "maximumCoverageWithoutEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //             "minimumCoverage":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //               }

  //     obj["member"]= memberObj
  //     obj["spouse"]= spouseObj


  //     memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).tax
  //     memberObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).total

  //     spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).tax
  //     spouseObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).total

  //     memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).tax
  //     memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).total

  //     spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000)*this.allFormData[type]["spouse"].constant:0,product.taxesDataJSON??[]).tax
  //     spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000)*this.allFormData[type]["spouse"].constant:0,product.taxesDataJSON??[]).total

  //     }
  //     let MSguranteeAcceptanceAmount = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceAmount"]+(spouseObj["guaranteedAcceptanceAmount"]??0))
  //       let MSguranteeAcceptancetTAX = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTax"]+(spouseObj["guaranteedAcceptanceTax"]??0))
  //       let MSguranteeAcceptancetTotal = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTotal"]+(spouseObj["guaranteedAcceptanceTotal"]??0))

  //       let MSpendingApprovalAmount = adjustWith2DecimalsForUI(memberObj["pendingApprovalAmount"]+(spouseObj["pendingApprovalAmount"]??0))
  //       let MSpendingApprovalTAX = adjustWith2DecimalsForUI(memberObj["pendingApprovalTax"]+(spouseObj["pendingApprovalTax"]??0))
  //       let MASpendingApprovalTotal = adjustWith2DecimalsForUI(memberObj["pendingApprovalTotal"]+(spouseObj["pendingApprovalTotal"]??0))

  //       let obj1: any = {
  //         packageId: plan.packageId,
  //         packageName: pckage.name,

  //         planproductname: this.productobj.name,

  //         groupid: plan.planLevel,
  //         groupName: group.name,
  //         id: plan.id,
  //         name: plan.name,
  //         planLevel: plan.planLevel ? plan.planLevel : group.id,
  //         planLevelParent: group.parentId,
  //         fusebillPlanID: plan.fusebillId,
  //         planFrequencyID: plan.frqMonthly,
  //         isBundle: plan.isBundle,
  //         coverage: lifeCoverage,
  //         planCoverage: product.planCoverage,
  //         bundledProducts: [],
  //         products: [],
  //         version:plan.version,
  //         guaranteedAcceptanceDetails:{
  //           "amount":MSguranteeAcceptanceAmount,
  //           "tax":MSguranteeAcceptancetTAX,
  //           "total":MSguranteeAcceptancetTotal,
  //           "products": [{
  //             id: product.id,
  //             productId: product.productId,
  //             name: product.name,
  //             planProductId: product.planProductId,
  //             price: adjustWith2DecimalsForUI(this.allFormData[type].total),
  //             tax_details:
  //               product.bundledTaxes && product.bundledTaxes.length > 0
  //                 ? product.bundledTaxes
  //                 : product.taxesDataJSON,
  //             calculatedTax: this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]),
  //             bundledProducts: product.bundledProducts,
  //             planCoverage: lifeCoverage,
  //             planLevel: product.planlevel ? product.planlevel.id : '',
  //             planLevelParent: product.planlevel ? product.planlevel.parentId : '',
  //             description: product.description,
  //             coverage: lifeCoverage,
  //             version:product.version,
  //             total :this._decimalPipe
  //             .transform(
  //               this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]).total : 0,
  //               '1.2-2'
  //             )
  //             ?.replace(/,/g, ''),
  //             tax : this._decimalPipe
  //             .transform(
  //               this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]).tax : 0,
  //               '1.2-2'
  //             )
  //             ?.replace(/,/g, '')
  //           }]


  //         },
  //         pendingApprovalDetails:{
  //           "amount":MSpendingApprovalAmount,
  //           "tax":MSpendingApprovalTAX,
  //           "total":MASpendingApprovalTotal,
  //           "products": [{
  //             id: product.id,
  //             productId: product.productId,
  //             name: product.name,
  //             planProductId: product.planProductId,
  //             price: adjustWith2DecimalsForUI(this.allFormData[type].total),
  //             tax_details:
  //               product.bundledTaxes && product.bundledTaxes.length > 0
  //                 ? product.bundledTaxes
  //                 : product.taxesDataJSON,
  //             calculatedTax: this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]),
  //             bundledProducts: product.bundledProducts,
  //             planCoverage: lifeCoverage,
  //             planLevel: product.planlevel ? product.planlevel.id : '',
  //             planLevelParent: product.planlevel ? product.planlevel.parentId : '',
  //             description: product.description,
  //             coverage: lifeCoverage,
  //             version:product.version,
  //             total :this._decimalPipe
  //             .transform(
  //               this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]).total : 0,
  //               '1.2-2'
  //             )
  //             ?.replace(/,/g, ''),
  //             tax : this._decimalPipe
  //             .transform(
  //               this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]).tax : 0,
  //               '1.2-2'
  //             )
  //             ?.replace(/,/g, '')
  //           }]
  //         },
  //         selectedDetails:{
  //           "amount": adjustWith2DecimalsForUI(this.allFormData[type].total),
  //           "total":adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]).total : 0),

  //           "tax" :adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]).tax : 0),
  //           "products":[this.productobj]
  //         }


  //       };

  //       obj["guaranteedAcceptanceDetails"]=obj1.guaranteedAcceptanceDetails
  //       obj["pendingApprovalDetails"]=obj1.pendingApprovalDetails
  //       obj["selectedDetails"]=obj1.selectedDetails
  //     this.addtoplansummaryLife(obj, obj1);
  //   }, 100);
  //   for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 100000) {
  //     this.rangeValues.push(i);
  //   }

  //   /*
  //     Form Here the code works for auto slection of Smoker in Life and critical
  //      */

  //   //   plansummaryLife.forEach((element:any,index:any) => {


  //   //     if(category=="member"){

  //   //         if(element.member.smoker==isSmokerValue){
  //   //       }
  //   //       else{


  //   //         const dom: HTMLElement = this.elementRef.nativeElement;

  //   //         const plan: any = dom.querySelector("."+"member"+"-" + element.planCoverage + "-"+isSmokerValue);
  //   //         console.log(plan)
  //   //         setTimeout(() => {
  //   //           plan.click()
  //   //         }, 1000);

  //   //     }
  //   //     }
  //   //     if(category=="spouse"){


  //   //         if(element.spouse.smoker==isSmokerValue){
  //   //       }
  //   //       else{


  //   //         const dom: HTMLElement = this.elementRef.nativeElement;

  //   //         const plan: any = dom.querySelector("."+"spouse"+"-" + element.planCoverage + "-"+isSmokerValue);
  //   //         console.log(plan)
  //   //         setTimeout(() => {
  //   //           plan.click()
  //   //         }, 1000);

  //   //     }
  //   //     }




  //   // })
  // }

  //   public handleRangeChange(value: any, type: string, category: string,options:any,plan:any,product:any,pckage:any,group:any,event:any,data:any): void {
  //     // console.log(value)

  //     this.allFormData[type][category].coverage=data
  //     this.rangeValues = [];
  //     // this.sliderValue = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence
  //     this.greenWidth = (this.allFormData[type][category].coverage.defaultRange) / 1000;
  //     this.orangeWidth = 100 - this.greenWidth;
  //     this.filledWidth = (this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.maximumCoverageWithEvidence) * 100;
  //     this.cutoffWidth = this.greenWidth;

  //     console.log(this.greenWidth)
  //     console.log(this.orangeWidth)
  //     console.log(this.filledWidth)
  //     console.log(this.cutoffWidth)

  //     this.minimumCoverage =this.allFormData[type][category].coverage.defaultRange

  //     // this.minimumCoverage = this.allFormData[type][category].coverage.maximumCoverageWithEvidence - this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence
  //     this.extraCoverage = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence
  //     // if (this.coverageValue > this.minimumCoverage) {
  //     //   this.extraCoverage = this.coverageValue - this.minimumCoverage;
  //     // } else {
  //     //   this.extraCoverage = 0;
  //     // }

  //     this.units = Array.from({ length: (this.allFormData[type][category].coverage.maximumCoverageWithEvidence - this.minValue) / 25 + 1 }, (_, i) => i * 25 + this.minValue);
  // console.log(this.units)
  //     if (this.allFormData[type][category]) {
  //       this.updateFormData(type, category, {
  //         // coverage: value,
  //         isSmoker: this.allFormData[type][category].isSmoker,
  //         premium: this.updatePremium(type, category, this.allFormData[type][category].isSmoker),
  //       });
  //     }
  //     let lifeCoverage=''
  //     let memberObj:any={}
  // let spouseObj:any={}
  // if(category=="member"){
  //   lifeCoverage="MEMBER"
  // }else{
  // lifeCoverage="MEMBER & SPOUSE"
  // }
  //     console.log(this.plansData)
  //     let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');


  //     let plandetails = event.target.attributes.data.value;

  //     let plandetailsobj = plandetails.split('##');


  //     plansummaryLife.forEach((element:any,index:any) => {

  //       if(element.planname==plandetailsobj[14]){
  //         plansummaryLife.splice(index,1)
  //       }
  //       sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));

  //     })
  //     setTimeout(() => {
  //       // console.log(this.allFormData[type][category].premium)

  //       let obj: any = {
  //         isBundle: plan.isBundle,
  //         // enrollmentDate: moment(
  //         //   this.userForm.get("planenrollmentdate").value,
  //         //   "MM-DD-YYYY"
  //         // ).format("YYYY-MM-DD"),
  //         enrollmentDate: this.userForm.value.planEnrollmentDate
  //           ? this._CustomDatePipe.transform(
  //               this.userForm.value.planEnrollmentDate
  //             )
  //           : undefined,
  //         // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
  //         name: plandetailsobj[14],
  //         details: plandetailsobj[0],
  //         packagename: plandetailsobj[0],
  //         groupName: plandetailsobj[1],
  //         amount: this.allFormData[type].total,
  //         // amount: this.allFormData[type][category].premium,
  //         planCoverage: plandetailsobj[2],
  //         planPrice: adjustWith2DecimalsForUI(this.allFormData[type].total),
  //         amountUI:
  //           '$' +
  //           adjustWith2DecimalsForUI(this.allFormData[type].total),
  //         gst:
  //           plandetailsobj[4] == null ||
  //           plandetailsobj[4] == '' ||
  //           plandetailsobj[4] == undefined ||
  //           plandetailsobj[4] == 'null'
  //             ? 0
  //             : parseFloat(plandetailsobj[4]),
  //         hst:
  //           plandetailsobj[5] == null ||
  //           plandetailsobj[5] == '' ||
  //           plandetailsobj[5] == undefined ||
  //           plandetailsobj[5] == 'null'
  //             ? 0
  //             : parseFloat(plandetailsobj[5]),
  //         pst:
  //           plandetailsobj[6] == null ||
  //           plandetailsobj[6] == '' ||
  //           plandetailsobj[6] == undefined ||
  //           plandetailsobj[6] == 'null'
  //             ? 0
  //             : parseFloat(plandetailsobj[6]),
  //         qst:
  //           plandetailsobj[17] == null ||
  //           plandetailsobj[17] == '' ||
  //           plandetailsobj[17] == undefined ||
  //           plandetailsobj[17] == 'null'
  //             ? 0
  //             : parseFloat(plandetailsobj[17]),
  //         gstCheck:
  //           plandetailsobj[4] == null ||
  //           plandetailsobj[4] == '' ||
  //           plandetailsobj[4] == undefined ||
  //           plandetailsobj[4] == 'null'
  //             ? false
  //             : true,
  //         hstCheck:
  //           plandetailsobj[5] == null ||
  //           plandetailsobj[5] == '' ||
  //           plandetailsobj[5] == undefined ||
  //           plandetailsobj[5] == 'null'
  //             ? false
  //             : true,
  //         pstCheck:
  //           plandetailsobj[6] == null ||
  //           plandetailsobj[6] == '' ||
  //           plandetailsobj[6] == undefined ||
  //           plandetailsobj[6] == 'null'
  //             ? false
  //             : true,
  //         qstCheck:
  //           plandetailsobj[17] == null ||
  //           plandetailsobj[17] == '' ||
  //           plandetailsobj[17] == undefined ||
  //           plandetailsobj[17] == 'null'
  //             ? false
  //             : true,
  //         id: parseFloat(plandetailsobj[7]),
  //         fusebillPlanID:
  //           plandetailsobj[8] == null ||
  //           plandetailsobj[8] == '' ||
  //           plandetailsobj[8] == undefined ||
  //           plandetailsobj[8] == 'null'
  //             ? 0
  //             : parseFloat(plandetailsobj[8]),
  //         planFrequencyID:
  //           plandetailsobj[9] == null ||
  //           plandetailsobj[9] == '' ||
  //           plandetailsobj[9] == undefined ||
  //           plandetailsobj[9] == 'null'
  //             ? 0
  //             : parseFloat(plandetailsobj[9]),
  //         optIn: plandetailsobj[10] == 'true' ? true : false,
  //         planname: plandetailsobj[14],
  //         planLevel: parseInt(plandetailsobj[15]),
  //         packageId: parseInt(plandetailsobj[16]),
  //         options: [],
  //         version:plan.version,
  //         description: plan.description,
  //         insuranceType:plan.insuranceType

  //         //  "disallowedPlanLevels":plandetailsobj[11]
  //       };
  //       if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
  //         if (plandetailsobj[11].includes(plandetailsobj[12])) {
  //         }
  //       }
  //      ///this.consoleMessage(obj)
  //       this.productobj = {
  //         id: product.id,
  //         productId: product.productId,
  //         name: product.name,
  //         planProductId: product.planProductId,
  //         price: this.allFormData[type].total,
  //         tax: this._decimalPipe
  //           .transform(
  //             product.calculatedTax ? product.calculatedTax.tax : 0,
  //             '1.2-2'
  //           )
  //           ?.replace(/,/g, ''),
  //         total: this._decimalPipe
  //           .transform(
  //             product.calculatedTax ? product.calculatedTax.total : 0,
  //             '1.2-2'
  //           )
  //           ?.replace(/,/g, ''),
  //         tax_details:
  //           product.bundledTaxes && product.bundledTaxes.length > 0
  //             ? product.bundledTaxes
  //             : product.taxesDataJSON,
  //         calculatedTax: this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]),
  //         bundledProducts: product.bundledProducts,
  //         planCoverage: lifeCoverage,
  //         planLevel: product.planlevel ? product.planlevel.id : '',
  //         planLevelParent: product.planlevel ? product.planlevel.parentId : '',
  //         description: product.description,
  //         coverage: lifeCoverage,
  //         version:product.version
  //       };

  //       this.productobj.total = this._decimalPipe
  //       .transform(
  //         this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
  //         '1.2-2'
  //       )
  //       ?.replace(/,/g, '')
  //       this.productobj.tax = this._decimalPipe
  //       .transform(
  //         this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
  //         '1.2-2'
  //       )
  //       ?.replace(/,/g, '')

  //       if(category=="member"){

  //         memberObj={
  //           "planStartDate":this.userForm.value.planEnrollmentDate
  //       ? this._CustomDatePipe.transform(
  //           this.userForm.value.planEnrollmentDate
  //         )
  //       : undefined,
  //       "units":(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //       "standardUnits":this.allFormData[type]["member"].coverage.minimumCoverage,
  //       "coverage":"MEMBER",
  //       "guaranteedAcceptance":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >=
  //       this.allFormData[type]["member"].coverage.defaultRange?true:false, //defalutRange
  //       "pendingMedicalQuestionaire":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <
  //       this.allFormData[type]["member"].coverage.defaultRange?true:false,
  //       "smoker":this.allFormData[type]["member"].isSmoker=="yes"?true:false,
  //       "age":this.allFormData[type]["member"].coverage.age,
  //       "gender":this.userForm.value.gender?.toLowerCase(),
  //       "province":"ON",
  //       "provinceId":12,
  //       "amount":this.allFormData[type]["member"].premium,
  //       "tax":adjustWith2DecimalsForUI(this.productobj.tax),
  //       "taxRate":"", //not mandatory,
  //       "taxName":"",
  //       "coverageValue":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //       "premium":this.allFormData[type]["member"].constant,
  //       "total":adjustWith2DecimalsForUI(this.productobj.total),
  //       "coverageUnitPrice":this.allFormData[type]["member"].coverage.coverageUnitPrice,
  //       "defaultRange":this.allFormData[type]["member"].coverage.defaultRange,
  //       "maximumCoverageWithEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
  //       "maximumCoverageWithoutEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //       "minimumCoverage":this.allFormData[type]["member"].coverage.minimumCoverage,


  //         }
  //         obj["member"]= memberObj
  //         obj["spouse"]= {}
  //       }
  //       else{

  //         memberObj={
  //           "planStartDate":this.userForm.value.planEnrollmentDate
  //       ? this._CustomDatePipe.transform(
  //           this.userForm.value.planEnrollmentDate
  //         )
  //       : undefined,
  //           "units":(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //           "standardUnits":this.allFormData[type]["member"].coverage.minimumCoverage,
  //           "coverage":"MEMBER",
  //           "guaranteedAcceptance":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >=
  //           this.allFormData[type]["member"].coverage.defaultRange?true:false, //defalutRange
  //           "pendingMedicalQuestionaire":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <
  //           this.allFormData[type]["member"].coverage.defaultRange?true:false,
  //           "smoker":this.allFormData[type]["member"].isSmoker=="yes"?true:false,
  //           "age":this.allFormData[type]["member"].coverage.age,
  //           "gender":this.userForm.value.gender?.toLowerCase(),
  //           "province":"ON",
  //           "provinceId":12,
  //           "amount":this.allFormData[type]["member"].premium,
  //           "tax":adjustWith2DecimalsForUI(this.productobj.tax),
  //           "taxRate":"", //not mandatory,
  //           "taxName":"",
  //           "coverageValue":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //           "premium":this.allFormData[type]["member"].constant,
  //           "total":adjustWith2DecimalsForUI(this.productobj.total),
  //           "coverageUnitPrice":this.allFormData[type]["member"].coverage.coverageUnitPrice,
  //       "defaultRange":this.allFormData[type]["member"].coverage.defaultRange,
  //       "maximumCoverageWithEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
  //       "maximumCoverageWithoutEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //       "minimumCoverage":this.allFormData[type]["member"].coverage.minimumCoverage,
  //             }
  //             spouseObj={
  //               "planStartDate":this.userForm.value.planEnrollmentDate
  //       ? this._CustomDatePipe.transform(
  //           this.userForm.value.planEnrollmentDate
  //         )
  //       : undefined,
  //               "units":(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //               "standardUnits":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //               "coverage":"MEMBER & SPOUSE",
  //               "guaranteedAcceptance":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >=
  //       this.allFormData[type]["spouse"].coverage.defaultRange?true:false, //defalutRange
  //       "pendingMedicalQuestionaire":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <
  //       this.allFormData[type]["spouse"].coverage.defaultRange?true:false,
  //               "smoker":this.allFormData[type]["spouse"].isSmoker=="yes"?true:false,
  //               "age":this.allFormData[type]["spouse"].coverage.age,
  //               "gender":this.userForm.value.spousegender?.toLowerCase(),
  //               "province":"ON",
  //               "provinceId":12,
  //               "amount":this.allFormData[type]["spouse"].premium,
  //               "tax":adjustWith2DecimalsForUI(this.productobj.tax),
  //               "taxRate":"", //not mandatory,
  //               "taxName":"",
  //               "coverageValue":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //               "premium":this.allFormData[type]["spouse"].constant,
  //               "total":adjustWith2DecimalsForUI(this.productobj.total),
  //               "coverageUnitPrice":this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
  //       "defaultRange":this.allFormData[type]["spouse"].coverage.defaultRange,
  //       "maximumCoverageWithEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
  //       "maximumCoverageWithoutEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //       "minimumCoverage":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //                 }

  //       obj["member"]= memberObj
  //       obj["spouse"]= spouseObj
  //       }

  //       let obj1: any = {
  //         packageId: plan.packageId,
  //         packageName: pckage.name,

  //         planproductname: this.productobj.name,

  //         groupid: plan.planLevel,
  //         groupName: group.name,
  //         id: plan.id,
  //         name: plan.name,
  //         planLevel: plan.planLevel ? plan.planLevel : group.id,
  //         planLevelParent: group.parentId,
  //         fusebillPlanID: plan.fusebillId,
  //         planFrequencyID: plan.frqMonthly,
  //         isBundle: plan.isBundle,
  //         coverage: lifeCoverage,
  //         planCoverage: product.planCoverage,
  //         bundledProducts: [],
  //         products: [],
  //         version:plan.version

  //       };
  //       obj1.products.push(this.productobj);
  //       //this.consoleMessage(obj1)
  //       // console.log(obj)
  //       // console.log(obj1)
  //       this.addtoplansummaryLife(obj, obj1);
  //     }, 100);
  //     for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 50000) {
  //       this.rangeValues.push(i);
  //     }
  //   }

  // public handleRangeChange(value: any, type: string, category: string,options:any,plan:any,product:any,pckage:any,group:any,event:any,data:any): void {
  //   // console.log(value)
  //   // console.log(type)
  //   // console.log(event)

  //   if(data.maximumCoverageWithoutEvidence==0){
  //     data.maximumCoverageWithoutEvidence=25000
  //   }
  //   this.allFormData[type][category].coverage=data



  //   this.rangeValues = [];

  //   // return values;

  //   this.minimumCoverage =this.allFormData[type][category].coverage.defaultRange

  //   // this.minimumCoverage = this.allFormData[type][category].coverage.maximumCoverageWithEvidence - this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence
  //   this.extraCoverage = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence
  //   // if (this.coverageValue > this.minimumCoverage) {
  //   //   this.extraCoverage = this.coverageValue - this.minimumCoverage;
  //   // } else {
  //   //   this.extraCoverage = 0;
  //   // }



  //   if (this.allFormData[type][category]) {
  //     this.updateFormData(type, category, {
  //       // coverage: value,
  //       isSmoker: this.allFormData[type][category].isSmoker,
  //       premium: this.updatePremium(type, category, this.allFormData[type][category].isSmoker),
  //     });
  //   }
  //   let lifeCoverage=''
  //   let memberObj:any={}
  // let spouseObj:any={}
  // if(category=="member"){
  // lifeCoverage="MEMBER"
  // }else{
  // lifeCoverage="MEMBER & SPOUSE"
  // }
  // if(this.allFormData[type]['spouse']){
  //   lifeCoverage="MEMBER & SPOUSE"

  // }
  //   console.log(this.plansData)
  //   let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');


  //   let plandetails = event.target.attributes.data.value;

  //   let plandetailsobj = plandetails.split('##');


  //   plansummaryLife.forEach((element:any,index:any) => {

  //     if(element.planname==plandetailsobj[14]){
  //       plansummaryLife.splice(index,1)
  //     }
  //     sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));

  //   })
  //   setTimeout(() => {
  //     // console.log(this.allFormData[type][category].premium)

  //     let obj: any = {
  //       isBundle: plan.isBundle,
  //       // enrollmentDate: moment(
  //       //   this.userForm.get("planenrollmentdate").value,
  //       //   "MM-DD-YYYY"
  //       // ).format("YYYY-MM-DD"),
  //       enrollmentDate: this.userForm.value.planEnrollmentDate
  //         ? this._CustomDatePipe.transform(
  //             this.userForm.value.planEnrollmentDate
  //           )
  //         : undefined,
  //       // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
  //       name: plandetailsobj[14],
  //       details: plandetailsobj[0],
  //       packagename: plandetailsobj[0],
  //       groupName: plandetailsobj[1],
  //       amount: this.allFormData[type].total,
  //       // amount: this.allFormData[type][category].premium,
  //       planCoverage: plandetailsobj[2],
  //       planPrice: adjustWith2DecimalsForUI(this.allFormData[type].total),
  //       amountUI:
  //         '$' +
  //         adjustWith2DecimalsForUI(this.allFormData[type].total),
  //       gst:
  //         plandetailsobj[4] == null ||
  //         plandetailsobj[4] == '' ||
  //         plandetailsobj[4] == undefined ||
  //         plandetailsobj[4] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[4]),
  //       hst:
  //         plandetailsobj[5] == null ||
  //         plandetailsobj[5] == '' ||
  //         plandetailsobj[5] == undefined ||
  //         plandetailsobj[5] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[5]),
  //       pst:
  //         plandetailsobj[6] == null ||
  //         plandetailsobj[6] == '' ||
  //         plandetailsobj[6] == undefined ||
  //         plandetailsobj[6] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[6]),
  //       qst:
  //         plandetailsobj[17] == null ||
  //         plandetailsobj[17] == '' ||
  //         plandetailsobj[17] == undefined ||
  //         plandetailsobj[17] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[17]),
  //       gstCheck:
  //         plandetailsobj[4] == null ||
  //         plandetailsobj[4] == '' ||
  //         plandetailsobj[4] == undefined ||
  //         plandetailsobj[4] == 'null'
  //           ? false
  //           : true,
  //       hstCheck:
  //         plandetailsobj[5] == null ||
  //         plandetailsobj[5] == '' ||
  //         plandetailsobj[5] == undefined ||
  //         plandetailsobj[5] == 'null'
  //           ? false
  //           : true,
  //       pstCheck:
  //         plandetailsobj[6] == null ||
  //         plandetailsobj[6] == '' ||
  //         plandetailsobj[6] == undefined ||
  //         plandetailsobj[6] == 'null'
  //           ? false
  //           : true,
  //       qstCheck:
  //         plandetailsobj[17] == null ||
  //         plandetailsobj[17] == '' ||
  //         plandetailsobj[17] == undefined ||
  //         plandetailsobj[17] == 'null'
  //           ? false
  //           : true,
  //       id: parseFloat(plandetailsobj[7]),
  //       fusebillPlanID:
  //         plandetailsobj[8] == null ||
  //         plandetailsobj[8] == '' ||
  //         plandetailsobj[8] == undefined ||
  //         plandetailsobj[8] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[8]),
  //       planFrequencyID:
  //         plandetailsobj[9] == null ||
  //         plandetailsobj[9] == '' ||
  //         plandetailsobj[9] == undefined ||
  //         plandetailsobj[9] == 'null'
  //           ? 0
  //           : parseFloat(plandetailsobj[9]),
  //       optIn: plandetailsobj[10] == 'true' ? true : false,
  //       planname: plandetailsobj[14],
  //       planLevel: parseInt(plandetailsobj[15]),
  //       packageId: parseInt(plandetailsobj[16]),
  //       options: [],
  //       version:plan.version,
  //       description: plan.description,
  //       insuranceType:plan.insuranceType

  //       //  "disallowedPlanLevels":plandetailsobj[11]
  //     };
  //     if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
  //       if (plandetailsobj[11].includes(plandetailsobj[12])) {
  //       }
  //     }
  //    ///this.consoleMessage(obj)
  //     this.productobj = {
  //       id: product.id,
  //       productId: product.productId,
  //       name: product.name,
  //       planProductId: product.planProductId,
  //       price:adjustWith2DecimalsForUI(this.allFormData[type].total),
  //       tax: this._decimalPipe
  //         .transform(
  //           product.calculatedTax ? product.calculatedTax.tax : 0,
  //           '1.2-2'
  //         )
  //         ?.replace(/,/g, ''),
  //       total: this._decimalPipe
  //         .transform(
  //           product.calculatedTax ? product.calculatedTax.total : 0,
  //           '1.2-2'
  //         )
  //         ?.replace(/,/g, ''),
  //       tax_details:
  //         product.bundledTaxes && product.bundledTaxes.length > 0
  //           ? product.bundledTaxes
  //           : product.taxesDataJSON,
  //       calculatedTax: this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]),
  //       bundledProducts: product.bundledProducts,
  //       planCoverage: lifeCoverage,
  //       planLevel: product.planlevel ? product.planlevel.id : '',
  //       planLevelParent: product.planlevel ? product.planlevel.parentId : '',
  //       description: product.description,
  //       coverage: lifeCoverage,
  //       version:product.version
  //     };

  //     this.productobj.total = this._decimalPipe
  //     .transform(
  //       this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
  //       '1.2-2'
  //     )
  //     ?.replace(/,/g, '')
  //     this.productobj.tax = this._decimalPipe
  //     .transform(
  //       this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
  //       '1.2-2'
  //     )
  //     ?.replace(/,/g, '')
  //     // console.log(this.allFormData)
  //     // console.log(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence )
  //     // console.log(this.allFormData[type]["member"].coverage.defaultRange)
  //     // console.log((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)

  //     // console.log(((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type][category].constant)
  //     if(category=="member"){

  //       memberObj={
  //     "planStartDate":this.userForm.value.planEnrollmentDate
  //     ? this._CustomDatePipe.transform(
  //         this.userForm.value.planEnrollmentDate
  //       )
  //     : undefined,
  //     "units":(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //     "standardUnits":this.allFormData[type]["member"].coverage.minimumCoverage,
  //     "coverage":"MEMBER",
  //     "guaranteedAcceptance":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
  //     this.allFormData[type]["member"].coverage.defaultRange?true:false, //defalutRange
  //     "pendingMedicalQuestionaire":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
  //     this.allFormData[type]["member"].coverage.defaultRange?true:false,


  //     "guaranteedAcceptanceAmount":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),
  //     "pendingApprovalAmount":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0 ||0,
  //     "smoker":this.allFormData[type]["member"].isSmoker=="yes"?true:false,
  //     "age":this.allFormData[type]["member"].coverage.age,
  //     "gender":this.userForm.value.gender?.toLowerCase(),
  //     "province":"ON",
  //     "provinceId":12,
  //     "amount":this.allFormData[type]["member"].premium,
  //     "tax": adjustWith2DecimalsForUI(this.productobj.tax),
  //     "taxRate":"", //not mandatory,
  //     "taxName":"",
  //     "coverageValue":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //     "premium":this.allFormData[type]["member"].constant,
  //     "total":adjustWith2DecimalsForUI(this.productobj.total),
  //     "coverageUnitPrice":this.allFormData[type]["member"].coverage.coverageUnitPrice,
  //     "defaultRange":this.allFormData[type]["member"].coverage.defaultRange,
  //     "maximumCoverageWithEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
  //     "maximumCoverageWithoutEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //     "minimumCoverage":this.allFormData[type]["member"].coverage.minimumCoverage,
  //       }
  //       memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).tax
  //       memberObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).total

  //       memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).tax
  //       memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).total

  //       obj["member"]= memberObj
  //       obj["spouse"]= {}

  //       if(this.allFormData[type]['spouse']){
  //         spouseObj={
  //           "planStartDate":this.userForm.value.planEnrollmentDate
  //   ? this._CustomDatePipe.transform(
  //       this.userForm.value.planEnrollmentDate
  //     )
  //   : undefined,
  //           "units":(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //           "standardUnits":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //           "coverage":"MEMBER & SPOUSE",
  //           "guaranteedAcceptance":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
  //   this.allFormData[type]["spouse"].coverage.defaultRange?true:false, //defalutRange
  //   "pendingMedicalQuestionaire":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
  //   this.allFormData[type]["spouse"].coverage.defaultRange?true:false,
  //   "guaranteedAcceptanceAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),
  //   "pendingApprovalAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000)*this.allFormData[type]["spouse"].constant:0 ||0,
  //           "smoker":this.allFormData[type]["spouse"].isSmoker=="yes"?true:false,
  //           "age":this.allFormData[type]["spouse"].coverage.age,
  //           "gender":this.userForm.value.spousegender?.toLowerCase(),
  //           "province":"ON",
  //           "provinceId":12,
  //           "amount":this.allFormData[type]["spouse"].premium,
  //           "tax":adjustWith2DecimalsForUI(this.productobj.tax),
  //           "taxRate":"", //not mandatory,
  //           "taxName":"",
  //           "coverageValue":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //           "premium":this.allFormData[type]["spouse"].constant,
  //           "total":adjustWith2DecimalsForUI(this.productobj.total),
  //           "coverageUnitPrice":this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
  //           "defaultRange":this.allFormData[type]["spouse"].coverage.defaultRange,
  //           "maximumCoverageWithEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
  //           "maximumCoverageWithoutEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //           "minimumCoverage":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //             }






  //         obj["member"]= memberObj
  //         obj["spouse"]= spouseObj

  //         spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).tax
  //         spouseObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).total

  //         spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000)*this.allFormData[type]["spouse"].constant:0,product.taxesDataJSON??[]).tax
  //         spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000)*this.allFormData[type]["spouse"].constant:0,product.taxesDataJSON??[]).total
  //           }




  //     }
  //     else{

  //       memberObj={
  //         "planStartDate":this.userForm.value.planEnrollmentDate
  //     ? this._CustomDatePipe.transform(
  //         this.userForm.value.planEnrollmentDate
  //       )
  //     : undefined,
  //         "units":(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //         "standardUnits":this.allFormData[type]["member"].coverage.minimumCoverage,
  //         "coverage":"MEMBER",
  //         "guaranteedAcceptance":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
  //         this.allFormData[type]["member"].coverage.defaultRange?true:false, //defalutRange
  //         "pendingMedicalQuestionaire":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
  //         this.allFormData[type]["member"].coverage.defaultRange?true:false,
  //         "guaranteedAcceptanceAmount":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),
  //         "pendingApprovalAmount":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0 ||0,
  //         "smoker":this.allFormData[type]["member"].isSmoker=="yes"?true:false,
  //         "age":this.allFormData[type]["member"].coverage.age,
  //         "gender":this.userForm.value.gender?.toLowerCase(),
  //         "province":"ON",
  //         "provinceId":12,
  //         "amount":this.allFormData[type]["member"].premium,
  //         "tax":adjustWith2DecimalsForUI(this.productobj.tax),
  //         "taxRate":"", //not mandatory,
  //         "taxName":"",
  //         "coverageValue":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //         "premium":this.allFormData[type]["member"].constant,
  //         "total":adjustWith2DecimalsForUI(this.productobj.total),
  //         "coverageUnitPrice":this.allFormData[type]["member"].coverage.coverageUnitPrice,
  //     "defaultRange":this.allFormData[type]["member"].coverage.defaultRange,
  //     "maximumCoverageWithEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
  //     "maximumCoverageWithoutEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
  //     "minimumCoverage":this.allFormData[type]["member"].coverage.minimumCoverage,
  //           }
  //           spouseObj={
  //             "planStartDate":this.userForm.value.planEnrollmentDate
  //     ? this._CustomDatePipe.transform(
  //         this.userForm.value.planEnrollmentDate
  //       )
  //     : undefined,
  //             "units":(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
  //             "standardUnits":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //             "coverage":"MEMBER & SPOUSE",
  //             "guaranteedAcceptance":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
  //     this.allFormData[type]["spouse"].coverage.defaultRange?true:false, //defalutRange
  //     "pendingMedicalQuestionaire":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
  //     this.allFormData[type]["spouse"].coverage.defaultRange?true:false,
  //     "guaranteedAcceptanceAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type][category].constant),
  //     "pendingApprovalAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000)*this.allFormData[type]["spouse"].constant:0 ||0,
  //     "smoker":this.allFormData[type]["spouse"].isSmoker=="yes"?true:false,
  //             "age":this.allFormData[type]["spouse"].coverage.age,
  //             "gender":this.userForm.value.spousegender?.toLowerCase(),
  //             "province":"ON",
  //             "provinceId":12,
  //             "amount":this.allFormData[type]["spouse"].premium,
  //             "tax":adjustWith2DecimalsForUI(this.productobj.tax),
  //             "taxRate":"", //not mandatory,
  //             "taxName":"",
  //             "coverageValue":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //             "premium":this.allFormData[type]["spouse"].constant,
  //             "total":adjustWith2DecimalsForUI(this.productobj.total),
  //             "coverageUnitPrice":this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
  //     "defaultRange":this.allFormData[type]["spouse"].coverage.defaultRange,
  //     "maximumCoverageWithEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
  //     "maximumCoverageWithoutEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
  //     "minimumCoverage":this.allFormData[type]["spouse"].coverage.minimumCoverage,
  //               }

  //     obj["member"]= memberObj
  //     obj["spouse"]= spouseObj
  //     memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).tax
  //     memberObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).total
  //     spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).tax
  //     spouseObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).total

  //     memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).tax
  //     memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).total

  //     spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).tax
  //     spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type]["member"].constant:0,product.taxesDataJSON??[]).total

  //     }

  //     let obj1: any = {
  //       packageId: plan.packageId,
  //       packageName: pckage.name,

  //       planproductname: this.productobj.name,

  //       groupid: plan.planLevel,
  //       groupName: group.name,
  //       id: plan.id,
  //       name: plan.name,
  //       planLevel: plan.planLevel ? plan.planLevel : group.id,
  //       planLevelParent: group.parentId,
  //       fusebillPlanID: plan.fusebillId,
  //       planFrequencyID: plan.frqMonthly,
  //       isBundle: plan.isBundle,
  //       coverage: lifeCoverage,
  //       planCoverage: product.planCoverage,
  //       bundledProducts: [],
  //       products: [],
  //       version:plan.version

  //     };
  //     obj1.products.push(this.productobj);
  //     //this.consoleMessage(obj1)
  //     // console.log(obj)
  //     // console.log(obj1)
  //     this.addtoplansummaryLife(obj, obj1);
  //   }, 100);
  //   for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 100000) {
  //     this.rangeValues.push(i);
  //   }
  // }
  public handleRadioChange(event: any, type: string, category: string, options: any, plan: any, product: any, pckage: any, group: any, value: any): void {
    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
    let isSmokerValue = event.target.value;
    let plandetails = event.target.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let smokerCheck: any = ''

    if (isSmokerValue == "no") {
      smokerCheck = false
    }
    else {
      smokerCheck = true
    }

    this.rangeValues = []


    this.allFormData[type][category].coverage = value

    if (this.allFormData[type][category]) {

      this.updateFormData(type, category, {
        isSmoker: isSmokerValue,
        premium: this.updatePremium(type, category, isSmokerValue),
      });
    }

    console.log(this.allFormData)
    let lifeCoverage = ''
    let memberObj: any = {}
    let spouseObj: any = {}

    if (category == "member") {
      lifeCoverage = "MEMBER"
    }
    else {
      lifeCoverage = "MEMBER & SPOUSE"
    }

    if (this.allFormData[type]['spouse']) {
      lifeCoverage = "MEMBER & SPOUSE"

    }







    plansummaryLife.forEach((element: any, index: any) => {

      if (element.planname == plandetailsobj[14]) {
        plansummaryLife.splice(index, 1)
      }
      sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));

    })
    let memberPrice = this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["member"].coverage.defaultRange) / 25000) : 0
    let spousePrice: any;
    if (this.allFormData[type]['spouse']) {
      spousePrice = this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["spouse"].coverage.defaultRange) / 25000) : 0
    }


    setTimeout(() => {
      // console.log(this.allFormData[type][category].premium)

      let obj: any = {
        isBundle: plan.isBundle,
        // enrollmentDate: moment(
        //   this.userForm.get("planenrollmentdate").value,
        //   "MM-DD-YYYY"
        // ).format("YYYY-MM-DD"),
        enrollmentDate: this.userForm.value.planEnrollmentDate
          ? this._CustomDatePipe.transform(
            this.userForm.value.planEnrollmentDate
          )
          : undefined,
        // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
        name: plandetailsobj[14],
        details: plandetailsobj[0],
        packagename: plandetailsobj[0],
        groupName: plandetailsobj[1],
        amount: this.allFormData[type].total,
        // amount: this.allFormData[type][category].premium,
        planCoverage: plandetailsobj[2],
        planPrice: adjustWith2DecimalsForUI(this.allFormData[type].total),
        amountUI:
          '$' +
          adjustWith2DecimalsForUI(this.allFormData[type].total),
        gst:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? 0
            : parseFloat(plandetailsobj[4]),
        hst:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? 0
            : parseFloat(plandetailsobj[5]),
        pst:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? 0
            : parseFloat(plandetailsobj[6]),
        qst:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? 0
            : parseFloat(plandetailsobj[17]),
        gstCheck:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? false
            : true,
        hstCheck:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? false
            : true,
        pstCheck:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? false
            : true,
        qstCheck:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? false
            : true,
        id: parseFloat(plandetailsobj[7]),
        fusebillPlanID:
          plandetailsobj[8] == null ||
            plandetailsobj[8] == '' ||
            plandetailsobj[8] == undefined ||
            plandetailsobj[8] == 'null'
            ? 0
            : parseFloat(plandetailsobj[8]),
        planFrequencyID:
          plandetailsobj[9] == null ||
            plandetailsobj[9] == '' ||
            plandetailsobj[9] == undefined ||
            plandetailsobj[9] == 'null'
            ? 0
            : parseFloat(plandetailsobj[9]),
        optIn: plandetailsobj[10] == 'true' ? true : false,
        planname: plandetailsobj[14],
        planLevel: parseInt(plandetailsobj[15]),
        packageId: parseInt(plandetailsobj[16]),
        options: [],
        version: plan.version,
        description: plan.description,
        insuranceType: plan.insuranceType

        //  "disallowedPlanLevels":plandetailsobj[11]
      };
      if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
        if (plandetailsobj[11].includes(plandetailsobj[12])) {
        }
      }
      ///this.consoleMessage(obj)
      this.productobj = {
        id: product.id,
        productId: product.productId,
        name: product.name,
        planProductId: product.planProductId,
        price: adjustWith2DecimalsForUI(this.allFormData[type].total),
        tax: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.tax : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        total: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.total : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        tax_details:
          product.bundledTaxes && product.bundledTaxes.length > 0
            ? product.bundledTaxes
            : product.taxesDataJSON,
        calculatedTax: this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []),
        bundledProducts: product.bundledProducts,
        planCoverage: lifeCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : '',
        description: product.description,
        coverage: lifeCoverage,
        version: product.version
      };

      this.productobj.total = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')
      this.productobj.tax = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')




        // new

        
      const combinedCalcForProduct = this.calculateCombinedTax(
        adjustWith2DecimalsForUI(this.allFormData[type].total), // dynamic total already computed
        product
      );

      this.productobj.calculatedTax = combinedCalcForProduct;

      this.productobj.price = adjustWith2DecimalsForUI(combinedCalcForProduct.price);
      this.productobj.tax   = this._decimalPipe
        .transform(combinedCalcForProduct.tax, '1.2-2')
        ?.replace(/,/g, '');
      this.productobj.total = this._decimalPipe
        .transform(combinedCalcForProduct.total, '1.2-2')
        ?.replace(/,/g, '');
      
      this.productobj.total = this._decimalPipe
      .transform(
        this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
        '1.2-2'
      )
      ?.replace(/,/g, '')


      if (category == "member") {

        memberObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,
          // "guaranteedAcceptanceAmount":this.allFormData[type]["member"].coverageValue <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverageValue/25000)*this.allFormData[type][category].constant):this.allFormData[type]["member"].coverage.defaultRange,

          "guaranteedAcceptanceAmount": adjustWith2DecimalsForUI(this.allFormData[type]["member"].coverageValue <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverageValue / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant)),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.userForm.value.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }

        memberObj["guaranteedAcceptanceTax"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverageValue <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverageValue / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax)
        memberObj["guaranteedAcceptanceTotal"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverageValue <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverageValue / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total)

        memberObj["pendingApprovalTax"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax)
        memberObj["pendingApprovalTotal"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total)





        //new
        const memberGuaranteedDynamic =
          this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange
            ? (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant
            : (this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant;

        const memberGuaranteedCalc = this.calculateCombinedTax(memberGuaranteedDynamic, product);
        memberObj["guaranteedAcceptanceAmount"] = adjustWith2DecimalsForUI(memberGuaranteedCalc.price);
        memberObj["guaranteedAcceptanceTax"]    = memberGuaranteedCalc.tax;
        memberObj["guaranteedAcceptanceTotal"]  = memberGuaranteedCalc.total;

        // ---- MEMBER pending approval ----
        const memberPendingDynamic = memberPrice * this.allFormData[type]["member"].constant;
        const memberPendingCalc = this.calculateCombinedTax(memberPendingDynamic, product);
        memberObj["pendingApprovalAmount"] = adjustWith2DecimalsForUI(memberPendingCalc.price);
        memberObj["pendingApprovalTax"]    = memberPendingCalc.tax;
        memberObj["pendingApprovalTotal"]  = memberPendingCalc.total;




        obj["member"] = memberObj
        obj["spouse"] = {}
        if (this.allFormData[type]['spouse']) {
          spouseObj = {
            "planStartDate": this.userForm.value.planEnrollmentDate
              ? this._CustomDatePipe.transform(
                this.userForm.value.planEnrollmentDate
              )
              : undefined,
            "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
            "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
            "coverage": "MEMBER & SPOUSE",
            "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
            "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
            "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant),
            "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
            "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
            "age": this.allFormData[type]["spouse"].coverage.age,
            "gender": this.userForm.value.spousegender?.toLowerCase(),
            "province": "ON",
            "provinceId": 12,
            "amount": this.allFormData[type]["spouse"].premium,
            "tax": adjustWith2DecimalsForUI(this.productobj.tax),
            "taxRate": "", //not mandatory,
            "taxName": "",
            "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "premium": this.allFormData[type]["spouse"].constant,
            "total": adjustWith2DecimalsForUI(this.productobj.total),
            "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
            "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
            "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
            "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          }






          obj["member"] = memberObj
          obj["spouse"] = spouseObj

          spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant), product.taxesDataJSON ?? []).tax
          spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant), product.taxesDataJSON ?? []).total

          spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type][category].constant, product.taxesDataJSON ?? []).tax
          spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type][category].constant, product.taxesDataJSON ?? []).total




          //new
          const spouseGuaranteedDynamic =
            this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange
              ? (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant
              : (this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant;

          const spouseGuaranteedCalc = this.calculateCombinedTax(spouseGuaranteedDynamic, product);
          spouseObj["guaranteedAcceptanceAmount"] = adjustWith2DecimalsForUI(spouseGuaranteedCalc.price);
          spouseObj["guaranteedAcceptanceTax"]    = spouseGuaranteedCalc.tax;
          spouseObj["guaranteedAcceptanceTotal"]  = spouseGuaranteedCalc.total;

          // ---- SPOUSE pending approval ----
          const spousePendingDynamic = spousePrice * this.allFormData[type]["spouse"].constant;
          const spousePendingCalc = this.calculateCombinedTax(spousePendingDynamic, product);
          spouseObj["pendingApprovalAmount"] = adjustWith2DecimalsForUI(spousePendingCalc.price);
          spouseObj["pendingApprovalTax"]    = spousePendingCalc.tax;
          spouseObj["pendingApprovalTotal"]  = spousePendingCalc.total;
        }
      }
      else {

        memberObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant),

          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.userForm.value.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }
        spouseObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          "coverage": "MEMBER & SPOUSE",
          "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["spouse"].coverage.age,
          "gender": this.userForm.value.spousegender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["spouse"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["spouse"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
        }

        obj["member"] = memberObj
        obj["spouse"] = spouseObj


        memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax
        memberObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total

        spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).tax
        spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).total

        memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

        spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).tax
        spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).total

      }

      // let MSguranteeAcceptanceAmount = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceAmount"] + (spouseObj["guaranteedAcceptanceAmount"] ?? 0))
      // let MSguranteeAcceptancetTAX = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTax"] + (spouseObj["guaranteedAcceptanceTax"] ?? 0))
      // let MSguranteeAcceptancetTotal = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTotal"] + (spouseObj["guaranteedAcceptanceTotal"] ?? 0))

      // let MSpendingApprovalAmount = adjustWith2DecimalsForUI(memberObj["pendingApprovalAmount"] + (spouseObj["pendingApprovalAmount"] ?? 0))
      // let MSpendingApprovalTAX = adjustWith2DecimalsForUI(memberObj["pendingApprovalTax"] + (spouseObj["pendingApprovalTax"] ?? 0))
      // let MSpendingApprovalTotal = adjustWith2DecimalsForUI(memberObj["pendingApprovalTotal"] + (spouseObj["pendingApprovalTotal"] ?? 0))




      //new

      // ---- MS (Member + Spouse) combined totals ----
      const MSguranteeAcceptanceAmount = adjustWith2DecimalsForUI(
        memberObj["guaranteedAcceptanceAmount"] + (spouseObj["guaranteedAcceptanceAmount"] ?? 0)
      );
      const MSguranteeAcceptancetTAX   = adjustWith2DecimalsForUI(
        memberObj["guaranteedAcceptanceTax"]    + (spouseObj["guaranteedAcceptanceTax"] ?? 0)
      );
      const MSguranteeAcceptancetTotal = adjustWith2DecimalsForUI(
        memberObj["guaranteedAcceptanceTotal"]  + (spouseObj["guaranteedAcceptanceTotal"] ?? 0)
      );

      const MSpendingApprovalAmount = adjustWith2DecimalsForUI(
        memberObj["pendingApprovalAmount"] + (spouseObj["pendingApprovalAmount"] ?? 0)
      );
      const MSpendingApprovalTAX    = adjustWith2DecimalsForUI(
        memberObj["pendingApprovalTax"]    + (spouseObj["pendingApprovalTax"] ?? 0)
      );
      const MSpendingApprovalTotal  = adjustWith2DecimalsForUI(
        memberObj["pendingApprovalTotal"]  + (spouseObj["pendingApprovalTotal"] ?? 0)
      );

      
      let obj1: any = {
        packageId: plan.packageId,
        packageName: pckage.name,

        planproductname: this.productobj.name,

        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: lifeCoverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],
        version: plan.version,
        guaranteedAcceptanceDetails: {
          "amount": MSguranteeAcceptanceAmount,
          "tax": MSguranteeAcceptancetTAX,
          "total": MSguranteeAcceptancetTotal,
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(this.allFormData[type].total),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]


        },
        pendingApprovalDetails: {
          "amount": MSpendingApprovalAmount,
          "tax": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "total": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(this.allFormData[type].total),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]
        },
        selectedDetails: {
          "amount": adjustWith2DecimalsForUI(this.allFormData[type].total),
          "total": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).total : 0),

          "tax": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).tax : 0),
          "products": [this.productobj]
        }


      };

      obj["guaranteedAcceptanceDetails"] = obj1.guaranteedAcceptanceDetails
      obj["pendingApprovalDetails"] = obj1.pendingApprovalDetails
      obj["selectedDetails"] = obj1.selectedDetails
      obj1.products.push(this.productobj);

      this.addtoplansummaryLife(obj, obj1);
    }, 100);
    for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 100000) {
      this.rangeValues.push(i);
    }


    /*
    Form Here the code works for auto slection of Smoker in Life and critical vice versa
     */

    plansummaryLife.forEach((element: any, index: any) => {


      if (category == "member") {

        if (element.member.smoker == isSmokerValue) {
        }
        else {


          const dom: HTMLElement = this.elementRef.nativeElement;

          const plan: any = dom.querySelector("." + "member" + "-" + element.planCoverage + "-" + isSmokerValue);
          console.log(plan)
          setTimeout(() => {
            plan.click()
          }, 1000);

        }
      }
      if (category == "spouse") {


        if (element.spouse.smoker == isSmokerValue) {
        }
        else {


          const dom: HTMLElement = this.elementRef.nativeElement;

          const plan: any = dom.querySelector("." + "spouse" + "-" + element.planCoverage + "-" + isSmokerValue);
          console.log(plan)
          setTimeout(() => {
            plan.click()
          }, 1000);

        }
      }




    })
  }

  public handleRangeChange(value: any, type: string, category: string, options: any, plan: any, product: any, pckage: any, group: any, event: any, data: any): void {
    console.log(value)
    console.log(type)
    console.log(event)
    console.log(data)
    console.log(product)
    console.log(this.allFormData)


    if (data.maximumCoverageWithoutEvidence == 0) {
      data.maximumCoverageWithoutEvidence = 25000
    }
    this.allFormData[type][category].coverage = data

    // this.sliderValue = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence


    this.rangeValues = [];




    if (this.allFormData[type][category]) {
      this.updateFormData(type, category, {
        // coverage: value,
        isSmoker: this.allFormData[type][category].isSmoker,
        premium: this.updatePremium(type, category, this.allFormData[type][category].isSmoker),
      });
    }
    let lifeCoverage = ''
    let memberObj: any = {}
    let spouseObj: any = {}
    if (category == "member") {
      lifeCoverage = "MEMBER"
    } else {
      lifeCoverage = "MEMBER & SPOUSE"
    }

    if (this.allFormData[type]['spouse']) {
      lifeCoverage = "MEMBER & SPOUSE"

    }
    console.log(this.plansData)
    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');


    let plandetails = event.target.attributes.data.value;

    let plandetailsobj = plandetails.split('##');


    plansummaryLife.forEach((element: any, index: any) => {

      if (element.planname == plandetailsobj[14]) {
        plansummaryLife.splice(index, 1)
      }
      sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));

    })
    setTimeout(() => {
      // console.log(this.allFormData[type][category].premium)

      let obj: any = {
        isBundle: plan.isBundle,
        // enrollmentDate: moment(
        //   this.userForm.get("planenrollmentdate").value,
        //   "MM-DD-YYYY"
        // ).format("YYYY-MM-DD"),
        enrollmentDate: this.userForm.value.planEnrollmentDate
          ? this._CustomDatePipe.transform(
            this.userForm.value.planEnrollmentDate
          )
          : undefined,
        // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
        name: plandetailsobj[14],
        details: plandetailsobj[0],
        packagename: plandetailsobj[0],
        groupName: plandetailsobj[1],
        amount: this.allFormData[type].total,
        // amount: this.allFormData[type][category].premium,
        planCoverage: plandetailsobj[2],
        planPrice: adjustWith2DecimalsForUI(this.allFormData[type].total),
        amountUI:
          '$' +
          adjustWith2DecimalsForUI(this.allFormData[type].total),
        gst:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? 0
            : parseFloat(plandetailsobj[4]),
        hst:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? 0
            : parseFloat(plandetailsobj[5]),
        pst:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? 0
            : parseFloat(plandetailsobj[6]),
        qst:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? 0
            : parseFloat(plandetailsobj[17]),
        gstCheck:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? false
            : true,
        hstCheck:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? false
            : true,
        pstCheck:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? false
            : true,
        qstCheck:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? false
            : true,
        id: parseFloat(plandetailsobj[7]),
        fusebillPlanID:
          plandetailsobj[8] == null ||
            plandetailsobj[8] == '' ||
            plandetailsobj[8] == undefined ||
            plandetailsobj[8] == 'null'
            ? 0
            : parseFloat(plandetailsobj[8]),
        planFrequencyID:
          plandetailsobj[9] == null ||
            plandetailsobj[9] == '' ||
            plandetailsobj[9] == undefined ||
            plandetailsobj[9] == 'null'
            ? 0
            : parseFloat(plandetailsobj[9]),
        optIn: plandetailsobj[10] == 'true' ? true : false,
        planname: plandetailsobj[14],
        planLevel: parseInt(plandetailsobj[15]),
        packageId: parseInt(plandetailsobj[16]),
        options: [],
        version: plan.version,
        description: plan.description,
        insuranceType: plan.insuranceType

        //  "disallowedPlanLevels":plandetailsobj[11]
      };
      if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
        if (plandetailsobj[11].includes(plandetailsobj[12])) {
        }
      }
      ///this.consoleMessage(obj)
      this.productobj = {
        id: product.id,
        productId: product.productId,
        name: product.name,
        planProductId: product.planProductId,
        price: adjustWith2DecimalsForUI(this.allFormData[type].total),
        tax: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.tax : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        total: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.total : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        tax_details:
          product.bundledTaxes && product.bundledTaxes.length > 0
            ? product.bundledTaxes
            : product.taxesDataJSON,
        calculatedTax: product.calculatedTax,
        bundledProducts: product.bundledProducts,
        planCoverage: lifeCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : '',
        description: product.description,
        coverage: lifeCoverage,
        version: product.version
      };



      const combinedCalcForProduct = this.calculateCombinedTax(
        adjustWith2DecimalsForUI(this.allFormData[type].total), // dynamic total already computed
        product
      );

      this.productobj.calculatedTax = combinedCalcForProduct;

      this.productobj.price = adjustWith2DecimalsForUI(combinedCalcForProduct.price);
      this.productobj.tax   = this._decimalPipe
        .transform(combinedCalcForProduct.tax, '1.2-2')
        ?.replace(/,/g, '');
      this.productobj.total = this._decimalPipe
        .transform(combinedCalcForProduct.total, '1.2-2')
        ?.replace(/,/g, '');
      
      this.productobj.total = this._decimalPipe
      .transform(
        this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
        '1.2-2'
      )
      ?.replace(/,/g, '')
      console.log("this.productobj.total123: ",this.productobj.total);
      this.productobj.tax = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')
      // console.log(this.allFormData)
      // console.log(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence )
      // console.log(this.allFormData[type]["member"].coverage.defaultRange)
      // console.log((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)

      // console.log(((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type][category].constant)

      let memberPrice = this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["member"].coverage.defaultRange) / 25000) : 0
      let spousePrice: any;
      if (this.allFormData[type]['spouse']) {
        spousePrice = this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["spouse"].coverage.defaultRange) / 25000) : 0
      }

      console.log("checkthis123:")
      console.log("this.allFormData",this.allFormData)
      // console.log(price)
      // console.log(price*this.allFormData[type]["member"].constant)
      // console.log(product.taxesDataJSON)
      // console.log(this.calculateTaxForProductTaxesData(price*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]))
      // console.log(this.calculateTaxForProductTaxesData(price*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).tax)
      // console.log(this.calculateTaxForProductTaxesData(price*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).total)
      if (category == "member") {

        memberObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,


          "guaranteedAcceptanceAmount": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.userForm.value.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }
        memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax
        memberObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total

        memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total


        const memberGuaranteedDynamic =
          this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange
            ? (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant
            : (this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant;

        const memberGuaranteedCalc = this.calculateCombinedTax(memberGuaranteedDynamic, product);
        memberObj["guaranteedAcceptanceAmount"] = adjustWith2DecimalsForUI(memberGuaranteedCalc.price);
        memberObj["guaranteedAcceptanceTax"]    = memberGuaranteedCalc.tax;
        memberObj["guaranteedAcceptanceTotal"]  = memberGuaranteedCalc.total;

        // ---- MEMBER pending approval ----
        const memberPendingDynamic = memberPrice * this.allFormData[type]["member"].constant;
        const memberPendingCalc = this.calculateCombinedTax(memberPendingDynamic, product);
        memberObj["pendingApprovalAmount"] = adjustWith2DecimalsForUI(memberPendingCalc.price);
        memberObj["pendingApprovalTax"]    = memberPendingCalc.tax;
        memberObj["pendingApprovalTotal"]  = memberPendingCalc.total;

        obj["member"] = memberObj
        obj["spouse"] = {}

        if (this.allFormData[type]['spouse']) {
          spouseObj = {
            "planStartDate": this.userForm.value.planEnrollmentDate
              ? this._CustomDatePipe.transform(
                this.userForm.value.planEnrollmentDate
              )
              : undefined,
            "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
            "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
            "coverage": "MEMBER & SPOUSE",
            "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
            "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
            "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant),
            "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
            "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
            "age": this.allFormData[type]["spouse"].coverage.age,
            "gender": this.userForm.value.spousegender?.toLowerCase(),
            "province": "ON",
            "provinceId": 12,
            "amount": this.allFormData[type]["spouse"].premium,
            "tax": adjustWith2DecimalsForUI(this.productobj.tax),
            "taxRate": "", //not mandatory,
            "taxName": "",
            "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "premium": this.allFormData[type]["spouse"].constant,
            "total": adjustWith2DecimalsForUI(this.productobj.total),
            "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
            "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
            "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
            "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          }






          obj["member"] = memberObj
          obj["spouse"] = spouseObj

          spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).tax
          spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).total

          spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).tax
          spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).total



          const spouseGuaranteedDynamic =
            this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange
              ? (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant
              : (this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant;

          const spouseGuaranteedCalc = this.calculateCombinedTax(spouseGuaranteedDynamic, product);
          spouseObj["guaranteedAcceptanceAmount"] = adjustWith2DecimalsForUI(spouseGuaranteedCalc.price);
          spouseObj["guaranteedAcceptanceTax"]    = spouseGuaranteedCalc.tax;
          spouseObj["guaranteedAcceptanceTotal"]  = spouseGuaranteedCalc.total;

          // ---- SPOUSE pending approval ----
          const spousePendingDynamic = spousePrice * this.allFormData[type]["spouse"].constant;
          const spousePendingCalc = this.calculateCombinedTax(spousePendingDynamic, product);
          spouseObj["pendingApprovalAmount"] = adjustWith2DecimalsForUI(spousePendingCalc.price);
          spouseObj["pendingApprovalTax"]    = spousePendingCalc.tax;
          spouseObj["pendingApprovalTotal"]  = spousePendingCalc.total;
        }


      }
      else {

        memberObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.userForm.value.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }
        spouseObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          "coverage": "MEMBER & SPOUSE",
          "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["spouse"].coverage.age,
          "gender": this.userForm.value.spousegender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["spouse"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["spouse"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
        }

        obj["member"] = memberObj
        obj["spouse"] = spouseObj

        // let price = this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000):0*this.allFormData[type]["member"].constant

        //   console.log(price)
        //   console.log(this.calculateTaxForProductTaxesData(price,product.taxesDataJSON??[]))
        memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax
        memberObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total
        spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).tax
        spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).total

        memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

        spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

      }


      console.log(memberObj["pendingApprovalTax"])
      // let MSguranteeAcceptanceAmount = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceAmount"] + (spouseObj["guaranteedAcceptanceAmount"] ?? 0))
      // let MSguranteeAcceptancetTAX = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTax"] + (spouseObj["guaranteedAcceptanceTax"] ?? 0))
      // let MSguranteeAcceptancetTotal = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTotal"] + (spouseObj["guaranteedAcceptanceTotal"] ?? 0))

      // let MSpendingApprovalAmount = adjustWith2DecimalsForUI(memberObj["pendingApprovalAmount"] + (spouseObj["pendingApprovalAmount"] ?? 0))
      // let MSpendingApprovalTAX = adjustWith2DecimalsForUI(memberObj["pendingApprovalTax"] + (spouseObj["pendingApprovalTax"] ?? 0))
      // let MSpendingApprovalTotal = adjustWith2DecimalsForUI(memberObj["pendingApprovalTotal"] + (spouseObj["pendingApprovalTotal"] ?? 0))



        // ---- MS (Member + Spouse) combined totals ----
        const MSguranteeAcceptanceAmount = adjustWith2DecimalsForUI(
          memberObj["guaranteedAcceptanceAmount"] + (spouseObj["guaranteedAcceptanceAmount"] ?? 0)
        );
        const MSguranteeAcceptancetTAX   = adjustWith2DecimalsForUI(
          memberObj["guaranteedAcceptanceTax"]    + (spouseObj["guaranteedAcceptanceTax"] ?? 0)
        );
        const MSguranteeAcceptancetTotal = adjustWith2DecimalsForUI(
          memberObj["guaranteedAcceptanceTotal"]  + (spouseObj["guaranteedAcceptanceTotal"] ?? 0)
        );

        const MSpendingApprovalAmount = adjustWith2DecimalsForUI(
          memberObj["pendingApprovalAmount"] + (spouseObj["pendingApprovalAmount"] ?? 0)
        );
        const MSpendingApprovalTAX    = adjustWith2DecimalsForUI(
          memberObj["pendingApprovalTax"]    + (spouseObj["pendingApprovalTax"] ?? 0)
        );
        const MSpendingApprovalTotal  = adjustWith2DecimalsForUI(
          memberObj["pendingApprovalTotal"]  + (spouseObj["pendingApprovalTotal"] ?? 0)
        );

      let obj1: any = {
        packageId: plan.packageId,
        packageName: pckage.name,

        planproductname: this.productobj.name,

        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: lifeCoverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],
        version: plan.version,
        guaranteedAcceptanceDetails: {
          "amount": MSguranteeAcceptanceAmount,
          "tax": MSguranteeAcceptancetTAX,
          "total": MSguranteeAcceptancetTotal,
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(MSguranteeAcceptanceAmount),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]


        },
        pendingApprovalDetails: {
          "amount": MSpendingApprovalAmount,
          "tax": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "total": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(MSpendingApprovalAmount),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]
        },
        selectedDetails: {
          "amount": adjustWith2DecimalsForUI(this.allFormData[type].total),
          "total": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).total : 0),

          "tax": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).tax : 0),
          "products": [this.productobj]
        }


      };

      obj["guaranteedAcceptanceDetails"] = obj1.guaranteedAcceptanceDetails
      obj["pendingApprovalDetails"] = obj1.pendingApprovalDetails
      obj["selectedDetails"] = obj1.selectedDetails


      obj1.products.push(this.productobj);
      this.addtoplansummaryLife(obj, obj1);
    }, 100);
    for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 100000) {
      this.rangeValues.push(i);
    }
  }



  private getStaticComponentPrice(calculatedTax: any): number {
    if (!calculatedTax?.planProductInfos) return 0;
    return calculatedTax.planProductInfos
      .filter((info: any) => info.componentPrice > 0)
      .reduce((sum: number, info: any) => sum + info.componentPrice, 0);
  }

  private calculateTaxFromPlanProductInfos(
      price: number,
      calculatedTax: any,
      componentType: 'dynamic' | 'static' | 'all' = 'all'
    ): { price: number; tax: number; total: number; planProductInfos: any[] } {
      if (!calculatedTax?.planProductInfos) {
        return { price, tax: 0, total: price, planProductInfos: [] };
      }

      const relevantInfos = calculatedTax.planProductInfos.filter((info: any) => {
        if (componentType === 'dynamic') return info.componentPrice === 0;
        if (componentType === 'static')  return info.componentPrice > 0;
        return true;
      });

      let tax = 0;
      const planProductInfos: any[] = [];

      for (const info of relevantInfos) {
        const taxAmount = adjustWith2DecimalsForUI(price * info.taxRate);
        tax = adjustWith2DecimalsForUI(tax + taxAmount);
        planProductInfos.push({
          ...info,
          price: taxAmount,
          componentTax: taxAmount,
          componentPrice: price,
          componentTotal: adjustWith2DecimalsForUI(price + taxAmount),
        });
      }

      return {
        price: adjustWith2DecimalsForUI(price),
        tax: adjustWith2DecimalsForUI(tax),
        total: adjustWith2DecimalsForUI(price + tax),
        planProductInfos,
      };
    }


  private calculateCombinedTax(
    dynamicPrice: number,
    product: any
  ): { price: number; tax: number; total: number; planProductInfos: any[] } {
    const calculatedTax = product.calculatedTax;
    const staticPrice = this.getStaticComponentPrice(calculatedTax);

    const dynamicCalc = this.calculateTaxFromPlanProductInfos(dynamicPrice, calculatedTax, 'dynamic');
    const staticCalc  = this.calculateTaxFromPlanProductInfos(staticPrice, calculatedTax, 'static');
    this.staticCalc = staticCalc?.price ?? 0;
    return {
      price: adjustWith2DecimalsForUI(dynamicCalc.price + staticCalc.price),
      tax:   adjustWith2DecimalsForUI(dynamicCalc.tax   + staticCalc.tax),
      total: adjustWith2DecimalsForUI(dynamicCalc.total + staticCalc.total),
      planProductInfos: [...dynamicCalc.planProductInfos, ...staticCalc.planProductInfos],
    };
  }

  public calculateTaxForProductTaxesData(price: number, taxesData: any) {
    console.log("price123: ",price)
    console.log(taxesData)
    // [{"tax_name":"PST","tax_code":"0002","plan_product_id":177927,"tax_description":"PST on Health Insurance","business_tax_number":"709505879TR0001","tax_rate":0.09,"tax_sku":"pstonhealthinsurance"}]
    let calculatedTax: any = {}
    let tax: any = 0;
    let planProductIds: any = []
    let planProductInfos: any = []
    if (taxesData && taxesData != undefined && taxesData != null && taxesData != "null") {
      for (const taxData of taxesData) {
        tax += adjustWith2DecimalsForUI(price * taxData.tax_rate);
        planProductIds.push(taxData.plan_product_id);
        let planProductInfo: any = {};
        // planProductInfo.name = taxData.tax_description + " " + (taxData.business_tax_number ?? "");
        planProductInfo.name = taxData.tax_name;
        planProductInfo.description = taxData.tax_description;
        planProductInfo.price = adjustWith2DecimalsForUI(price * taxData.tax_rate);
        planProductInfo.planProductUniqueId = taxData.plan_product_id;
        planProductInfo.isIncluded = true;
        planProductInfo.taxRate = taxData.tax_rate;
        planProductInfo.taxRatePercentage = adjustWith2DecimalsForUI((taxData.tax_rate) * 100) + "%";
        planProductInfos.push(planProductInfo);
      }
    }

    let total = adjustWith2DecimalsForUI(price + tax)
    calculatedTax.price = adjustWith2DecimalsForUI(price);
    calculatedTax.tax = adjustWith2DecimalsForUI(tax);
    calculatedTax.total = adjustWith2DecimalsForUI(total);

    calculatedTax.planProductIds = planProductIds;
    calculatedTax.planProductInfos = planProductInfos;

    return calculatedTax;

  }

  public transformData() {
    let transformedData: any = [];
    let id = 12;

    Object.keys(this.allFormData).forEach(key => {
      const plan = this.allFormData[key];
      if (plan.total > 0) {
        const hasMember: boolean = plan.hasOwnProperty('member');

        const hasSpouse = plan.hasOwnProperty('spouse');
        const hasChildren = plan.hasOwnProperty('dependent');

        const transformedObject: any = {
          name: key.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
          id: id++,
          havingSpouse: hasSpouse,
          havingChildren: hasChildren,
          total: plan.total,
        }

        transformedObject.member = {}

        if (hasMember && plan.member.premium > 0) {
          transformedObject.member = {
            isSmoker: plan.member.isSmoker,
            total: plan.member.premium,
            units: plan.member.coverage,
            // placeOfBirth: plan.member.PlaceOfBirth,
            premium: plan.member.constant
          }
        }

        transformedObject.spouse = {}

        if (hasSpouse && plan.spouse.premium > 0) {
          transformedObject.spouse = {
            isSmoker: plan.spouse.isSmoker,
            total: plan.spouse.premium,
            units: plan.spouse.coverage,
            // placeOfBirth: plan.spouse.PlaceOfBirth,
            premium: plan.spouse.constant

          };
        }

        transformedObject.dependent = []

        if (hasChildren && plan.dependent.premium > 0) {
          const dep = this.signUpData.childrenDetails.map((d: any) => {
            return {
              childFirstName: d.childFirstName,
              childLastName: d.childLastName,
              //  total: plan.dependent.premium/this.signUpData.childrenDetails.length,
              total: plan.dependent.premium,
              units: plan.dependent.coverage,
              premium: plan.dependent.constant,
              // placeOfBirth:
              //   plan.dependent[`${d.childFirstName}-${d.childLastName}`],
            };
          });

          transformedObject.dependent = dep;
          transformedObject.dependent.allDependentPremium = {
            total: plan.dependent.premium,
            units: plan.dependent.coverage,
            premium: plan.dependent.constant
          }

        }

        transformedData.push(transformedObject);
      }
    });

    return transformedData;
  }
  public onCheckboxChange(
    e: any,
    allowMultiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    coverage: any
  ) {
    // e.preventDefault();
    // let multiple = allowMultiple ? Boolean(allowMultiple.data[0]) : false;

    let multiple = allowMultiple == true ? true : false;

    console.log(multiple)
    console.log("optuons3838",options)

    if (e.target.checked) {
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)
      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      console.log(samePlanIdElements)

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;
        //  console.log(elem)

        if (element.checked) {
          element.checked = false;
          this.unselectplan(elem);

        }
      }
      e.target.checked = true
    } else {
      //      this.planCoverageName = ''
      // this.insuranceplanid =''
    }

    // console.log(multiple)

    // console.log(plan)
    // console.log(product)


    //this.consoleMessage(disallowedPlanLevels)

    console.log(disallowedPlanLevels)

    if (disallowedPlanLevels != null) {
      //this.consoleMessage(disallowedPlanLevels)
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );

      // disallowed_elements.forEach((elem: any) => {

      // console.log(disallowed_elements)

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        // elementcv.checked=false

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        //this.consoleMessage(plandetailsobj)

        // console.log(disallowed_plans)   //[1,10,19,20,21]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[20]) //[10]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[19])
        // console.log(plandetailsobj[21])


        // console.log(typeof plandetailsobj[21])
        // console.log(plandetailsobj[12])
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[20])


        let isBundle = plandetailsobj[21] == "true" ? true : false
        // console.log(isBundle)
        if (e.target.checked) {

          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  console.log("1")
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  console.log("2")

                  console.log(elem)

                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  console.log(elem)

                  if (elem.checked) {
                    console.log("checkehd")
                    elem.checked = false;
                    this.unselectplan(elem);
                  }

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  console.log("4")
                  console.log(elem)
                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                  // elem.disabled =true
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

            // else {
            //   if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
            //     //  elem.checked=false
            //     elem.disabled = false;
            //   }
            // }
          }
          if (elem.checked) {

            console.log("elechecked")

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked1")
                  this.unselectplan(elem);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked2")
                  this.unselectplan(elem);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem);
                  // elem.disabled =true
                }
              }

            }
          }
        }
      }
    }

    let sameplanclassname = `newPlan${plan.id}`
    let covergaClassNmae = `coverage${coverage.toUpperCase()}` // //////this.consoleMessage(e)
    let classname = e.target.className.replace(sameplanclassname, '').replace(covergaClassNmae, '');
    classname = classname.split(' ').join('.').replaceAll('..', '.');

    console.log(classname)
    console.log(sameplanclassname)
    // //////this.consoleMessage(classname)
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll(classname);
    // const elements = dom.querySelectorAll(e.target.className);

    // const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);

    // //////this.consoleMessage(elements);

    let element: any;
    let elementcv: any;

    if (!multiple) {
      console.log("multiple elesehere")
      if (e.target.checked) {

        console.log(elements)
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;

          if (element.checked) {

            this.unselectplan(elem);
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {
      }
    }
    else {

      // console.log("elesehere")
      if (e.target.checked) {


        // for (let i = 0; i < samePlanElements.length; i++) {
        //   let elem = samePlanElements[i];
        //   element = elem;

        //   if (element.checked) {

        //     this.unselectplan(elem);
        //     element.checked = false;
        //   }
        // }

        e.checked = true;
        e.target.checked = true;
      } else {
      }
      // alert("!")
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {
        this.selectplan(e.target, options, plan, product, pckage, group, disallowedPlanLevels);
        // Viking: reconcile spouse/dependent "Add to plan" with the coverage just picked
        this.syncAddToPlanWithCoverage(coverage ?? plancoverage);
      } else {
        this.unselectplan(e.target);
      }
    }, 10);
  }
  /**
   * Handles tab navigation requests from CorpPlansEnrollmentComponent.
   * Called via (tabChangeRequest) output binding on <app-corp-plans-enrollment>.
   *
   * @param newTab  Target tab index emitted by the child (0 = personal info, 1 = plans, 2 = summary).
   */
  onCorpTabChange(newTab: number): void {
    if (newTab >= 0 && newTab < this.tabs.length) {
      this.visitedTabs.add(this.activeTab);
      this.previousTab = this.activeTab;
      this.activeTab = newTab;

      // For NHLAA, auto-populate bank billing address from home address when entering payment tab
      if (newTab === 2 && this.currFormType === 'nhlaa') {
        this.bankpayForm?.get('bankstreetaddress')?.setValue(this.userForm.controls['street_address_line1']?.value ?? '');
        this.bankpayForm?.get('bankstreetaddressline2')?.setValue(this.userForm.controls['street_address_line2']?.value ?? '');
        this.bankpayForm?.get('bankcity')?.setValue(this.userForm.controls['city']?.value ?? '');
        this.bankpayForm?.get('bankprovince')?.setValue(this.userForm.controls['province']?.value ?? '');
        this.bankpayForm?.get('bankpostalcode')?.setValue(this.userForm.controls['postal_code']?.value ?? '');
        sessionStorage.setItem('homeAddress', 'true');
      }
    }
  }

  /** Keeps the parent's cart variables in sync with corp-plans-enrollment's planCoverafeFunction output. */
  onCorpCartUpdate(data: { planAmount: any; employeeDealingPlans: any[]; payrollCCPlans: any[]; iafgPlans: any[] }): void {
    this.planAmount             = data.planAmount;
    this.employeeDealingPlansarr = data.employeeDealingPlans;
    this.payrollCCplansarr       = data.payrollCCPlans;
    this.iafgplansCheck          = data.iafgPlans;
  }

  gotoPersonalInfoPage(): void {
    // console.log(this.previousTab);
    this.activeTab--;
    this.planAmount = 0.00
    this.resetSelections();

    // Save form data before navigation
    this.savedFormData = this.userForm.value;
    setTimeout(() => {
      if (this.savedFormData.province) {
        this.userForm?.get('province')?.setValue(this.savedFormData?.province, { emitEvent: true });
      }
      if (this.savedFormData.planEnrollmentDate) {
        this.userForm?.get('planEnrollmentDate')?.setValue(this.savedFormData?.planEnrollmentDate, { emitEvent: true });
      }
      if (this.savedFormData.postal_code) {
        this.userForm?.get('postal_code')?.setValue(this.savedFormData?.postal_code, { emitEvent: true });
      }
    }, 100);
  }

  gotoPlansPage(): void {
    //clear the void check and banknameres
    this.banknameres = ''
    this.imagedisplay = false
    this.voidCheckFileName = ''
    this.normalview = false
    this.pdfview = false

    this.activeTab--;
    this.resetSelections();
    this.isMedcanPopUpSubmitted = false;
    let data: any = JSON.parse(sessionStorage.getItem("plansummary") || '[]');
    let obj = {};

    if (data) {

      data.forEach((element: any, index: any) => {
        obj = {
          planid: element.id,
        };

        setTimeout(() => {

          const dom: HTMLElement = this.elementRef.nativeElement;
          const plan: any = dom.querySelector("#plancheck" + element.id);


          if (element.options && element.options.length > 0) {
            if (element.isBundle) {
              const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);
              const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);

              this.renderer.setProperty(plan, 'checked', true);
              if (element.disallowedPlanLevels != null) {
                //this.consoleMessage(disallowedPlanLevels)
                let disallowed_plans = element.disallowedPlanLevels.split(',');
                const dom1: HTMLElement = this.elementRef.nativeElement;
                const disallowed_elements = dom1.querySelectorAll(
                  ".plansscreen input[type='checkbox']"
                );

                // disallowed_elements.forEach((elem: any) => {

                // console.log(disallowed_elements)

                for (let i = 0; i < disallowed_elements.length; i++) {
                  let elem: any = disallowed_elements[i];
                  // elementcv.checked=false

                  if (!elem.attributes.data) {
                    continue;
                  }

                  let plandetails = elem.attributes.data.value;

                  let plandetailsobj = plandetails.split('##');




                  let isBundle = plandetailsobj[21] == "true" ? true : false
                  // console.log(isBundle)


                  if (!elem.disabled) {

                    if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
                      if (isBundle) {
                        if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                          //  elem.checked=false
                          console.log("1")
                          elem.disabled = true;
                          this.disabledelement =
                            'Already included in GroupBenefitz All-In';
                        }
                      } else {
                        if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                          //  elem.checked=false
                          console.log("2")

                          console.log(elem)

                          elem.disabled = true;
                          this.disabledelement =
                            'Already included in GroupBenefitz All-In';
                        }
                      }

                    }

                    else {

                      if (isBundle) {
                        if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                          console.log(elem)

                          if (elem.checked) {
                            console.log("checkehd")
                            elem.checked = false;
                            this.unselectplan(elem);
                          }

                          elem.disabled = true;

                          this.disabledelement =
                            'Already included in GroupBenefitz All-In';
                        }
                      } else {
                        if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                          console.log("4")
                          console.log(elem)
                          elem.disabled = true;

                          this.disabledelement =
                            'Already included in GroupBenefitz All-In';
                        }
                      }

                    }
                  }





                }
              }
            }
            else {
              element.products.forEach((products: any, index: any) => {
                if (element.coverage) {
                  const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


                  this.renderer.setProperty(plan, 'checked', true);
                }
                else {
                  const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                  this.renderer.setProperty(planCheck, 'checked', true);

                }
                if (element.disallowedPlanLevels != null) {
                  //this.consoleMessage(disallowedPlanLevels)
                  let disallowed_plans = element.disallowedPlanLevels.split(',');
                  const dom1: HTMLElement = this.elementRef.nativeElement;
                  const disallowed_elements = dom1.querySelectorAll(
                    ".plansscreen input[type='checkbox']"
                  );

                  // disallowed_elements.forEach((elem: any) => {

                  // console.log(disallowed_elements)

                  for (let i = 0; i < disallowed_elements.length; i++) {
                    let elem: any = disallowed_elements[i];
                    // elementcv.checked=false

                    if (!elem.attributes.data) {
                      continue;
                    }

                    let plandetails = elem.attributes.data.value;

                    let plandetailsobj = plandetails.split('##');




                    let isBundle = plandetailsobj[21] == "true" ? true : false
                    // console.log(isBundle)


                    if (!elem.disabled) {

                      if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
                        if (isBundle) {
                          if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                            //  elem.checked=false
                            console.log("1")
                            elem.disabled = true;
                            this.disabledelement =
                              'Already included in GroupBenefitz All-In';
                          }
                        } else {
                          if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                            //  elem.checked=false
                            console.log("2")

                            console.log(elem)

                            elem.disabled = true;
                            this.disabledelement =
                              'Already included in GroupBenefitz All-In';
                          }
                        }

                      }

                      else {

                        if (isBundle) {
                          if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                            console.log(elem)

                            if (elem.checked) {
                              console.log("checkehd")
                              elem.checked = false;
                              this.unselectplan(elem);
                            }

                            elem.disabled = true;

                            this.disabledelement =
                              'Already included in GroupBenefitz All-In';
                          }
                        } else {
                          if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                            console.log("4")
                            console.log(elem)
                            elem.disabled = true;

                            this.disabledelement =
                              'Already included in GroupBenefitz All-In';
                          }
                        }

                      }
                    }





                  }
                }
              })
            }

          } else {
            if (element.isBundle) {
              const dom: HTMLElement = this.elementRef.nativeElement;

              console.log(element.coverage)
              const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
              const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);

              this.renderer.setProperty(plan, 'checked', true);



              // planCheck.click()
              if (element.disallowedPlanLevels != null) {
                //this.consoleMessage(disallowedPlanLevels)
                let disallowed_plans = element.disallowedPlanLevels.split(',');
                const dom1: HTMLElement = this.elementRef.nativeElement;
                const disallowed_elements = dom1.querySelectorAll(
                  ".plansscreen input[type='checkbox']"
                );

                // disallowed_elements.forEach((elem: any) => {

                // console.log(disallowed_elements)

                for (let i = 0; i < disallowed_elements.length; i++) {
                  let elem: any = disallowed_elements[i];
                  // elementcv.checked=false

                  if (!elem.attributes.data) {
                    continue;
                  }

                  let plandetails = elem.attributes.data.value;

                  let plandetailsobj = plandetails.split('##');




                  let isBundle = plandetailsobj[21] == "true" ? true : false
                  // console.log(isBundle)


                  if (!elem.disabled) {

                    if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
                      if (isBundle) {
                        if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                          //  elem.checked=false
                          console.log("1")
                          elem.disabled = true;
                          this.disabledelement =
                            'Already included in GroupBenefitz All-In';
                        }
                      } else {
                        if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                          //  elem.checked=false
                          console.log("2")

                          console.log(elem)

                          elem.disabled = true;
                          this.disabledelement =
                            'Already included in GroupBenefitz All-In';
                        }
                      }

                    }

                    else {

                      if (isBundle) {
                        if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                          console.log(elem)

                          if (elem.checked) {
                            console.log("checkehd")
                            elem.checked = false;
                            this.unselectplan(elem);
                          }

                          elem.disabled = true;

                          this.disabledelement =
                            'Already included in GroupBenefitz All-In';
                        }
                      } else {
                        if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                          console.log("4")
                          console.log(elem)
                          elem.disabled = true;

                          this.disabledelement =
                            'Already included in GroupBenefitz All-In';
                        }
                      }

                    }
                  }





                }
              }

            }
            else {
              element.products.forEach((products: any, index: any) => {

                if (element.coverage) {
                  const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


                  this.renderer.setProperty(plan, 'checked', true);
                }
                else {
                  const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                  this.renderer.setProperty(planCheck, 'checked', true);

                }


              })
              if (element.disallowedPlanLevels != null) {
                //this.consoleMessage(disallowedPlanLevels)
                let disallowed_plans = element.disallowedPlanLevels.split(',');
                const dom1: HTMLElement = this.elementRef.nativeElement;
                const disallowed_elements = dom1.querySelectorAll(
                  ".plansscreen input[type='checkbox']"
                );

                // disallowed_elements.forEach((elem: any) => {

                // console.log(disallowed_elements)

                for (let i = 0; i < disallowed_elements.length; i++) {
                  let elem: any = disallowed_elements[i];
                  // elementcv.checked=false

                  if (!elem.attributes.data) {
                    continue;
                  }

                  let plandetails = elem.attributes.data.value;

                  let plandetailsobj = plandetails.split('##');




                  let isBundle = plandetailsobj[21] == "true" ? true : false
                  // console.log(isBundle)


                  if (!elem.disabled) {

                    if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
                      if (isBundle) {
                        if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                          //  elem.checked=false
                          console.log("1")
                          elem.disabled = true;
                          this.disabledelement =
                            'Already included in GroupBenefitz All-In';
                        }
                      } else {
                        if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                          //  elem.checked=false
                          console.log("2")

                          console.log(elem)

                          elem.disabled = true;
                          this.disabledelement =
                            'Already included in GroupBenefitz All-In';
                        }
                      }

                    }

                    else {

                      if (isBundle) {
                        if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                          console.log(elem)

                          if (elem.checked) {
                            console.log("checkehd")
                            elem.checked = false;
                            this.unselectplan(elem);
                          }

                          elem.disabled = true;

                          this.disabledelement =
                            'Already included in GroupBenefitz All-In';
                        }
                      } else {
                        if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                          console.log("4")
                          console.log(elem)
                          elem.disabled = true;

                          this.disabledelement =
                            'Already included in GroupBenefitz All-In';
                        }
                      }

                    }
                  }
                }
              }
            }
            // element.products.forEach((products:any,index:any) => {
            //   // $("#plancheck" + products.id).click();
            //   const planCheck = this.renderer.selectRootElement("#plancheck"+ products.id, true);

            //   // console.log(planCheck)
            //   this.renderer.setProperty(planCheck, 'checked', true);
            // })
          }

          // $("#plancheck" + element.id).prop("checked", true);
          // plan.checked =true
        }, 100);

        // this.plancheckarray.push(element.id)
      });

    }

    let dataLife: any = JSON.parse(sessionStorage.getItem("plansummaryLife") || '[]');

    if (dataLife) {

      dataLife.forEach((element: any, index: any) => {

        setTimeout(() => {

          const dom: HTMLElement = this.elementRef.nativeElement;
          // const plan: any = dom.querySelector("#planCheckLife" + element.planCoverage+"-"+coverage);



          element.products.forEach((products: any, index: any) => {
            // $("#plancheck" + products.id).click();
            if (element.coverage == 'MEMBER') {
              element.coverage = 'MEMBER'
              const planCheck = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + element.coverage, true);

              this.renderer.setProperty(planCheck, 'checked', true);
            } else {
              element.coverage = 'SPOUSE'
              const planCheck = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + element.coverage, true);

              this.renderer.setProperty(planCheck, 'checked', true);
              const planCheck1 = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + 'MEMBER', true);

              this.renderer.setProperty(planCheck1, 'checked', true);
            }
            // if(element.coverage=='MEMBER'){
            //   element.coverage='MEMBER'
            // }else{
            //   element.coverage='SPOUSE'
            // }
            // const planCheck = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage+"-"+element.coverage, true);

            // // console.log(planCheck)
            // this.renderer.setProperty(planCheck, 'checked', true);
          })


          // $("#plancheck" + element.id).prop("checked", true);
          // plan.checked =true
        }, 100);

        // this.plancheckarray.push(element.id)
      });

    }
  }
  // paymentpage(): void{
  //   if (this.activeTab < this.tabs.length - 1) {
  //     this.previousTab = this.activeTab;
  //     this.activeTab++;
  //   }
  // }

  public paymentpage12(tabId: number) {



    this.paymentForm.get('paymentRadioCheck')?.setValue("CC");


    let inputData = JSON.parse(sessionStorage.getItem('Data') || '[]');
    let Data = JSON.parse(sessionStorage.getItem('plansummarymain') || '[]');
    let iafgData = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
    this.paymentemail = inputData.email || this.userForm.get('email')?.value
    this.paymentFirstName = this.capitalize(inputData.firstName) || this.userForm.get('firstName')?.value;
    this.paymentLastName = this.capitalize(inputData.lastName) || this.userForm.get('lastName')?.value

    if (inputData.provincial_health_coverage == false) {
      let phrPlanSelected = Data.filter((p: any) => p.packageId == 10);
      let healthPlanSelected = Data.filter((p: any) => p.packageId == 1);
      let benficiaryList = JSON.parse(sessionStorage.getItem('addbenificaryData') || '[]')




      if (phrPlanSelected.length > 0) {
        if (this.activeTab < this.tabs.length - 1) {
          this.previousTab = this.activeTab;
          this.activeTab++;
          this.visitedTabs.add(this.previousTab);
        }
        this.router.events.subscribe((event) => {
          if (event instanceof NavigationEnd) {
            this.scrollContainer?.nativeElement.scrollTo(0, 0);
          }
        });
        this.imagedisplay = false;
        setTimeout(() => {
          sessionStorage.setItem('pageName', 'Enrollment Summary');
        }, 10);
        this.planssummarymain = JSON.parse(
          sessionStorage.getItem('plansummarymain') || '[]'
        );

        this.planssummaryopt = JSON.parse(
          sessionStorage.getItem('plansummaryopt') || '[]'
        );
        let array: any = [];

        this.planSummaryMainResult =
          array.sort((a: any, b: any) => a.id - b.id) || '';

        this.planssummarymain =
          this.planssummarymain.sort(
            (a: any, b: any) => a.packageId - b.packageId
          ) || '';
        this.finalenrollemntsummary = this.planssummarymain;
        this.finalenrollemntsummaryLife = this.planssummarymainLife

        const combinedArray: any = [];
        const groupedByParent: any = {};
        //  this.paymentForm.get('FirstName')

        for (const obj of this.planSummaryMainResult) {
          //this.consoleMessage(obj)

          const name = obj.packageName;

          const products = obj.products;
          if (!groupedByParent[name]) {
            groupedByParent[name] = [];
          }
          groupedByParent[name] = groupedByParent[name].concat(products);
        }
        // Push grouped child arrays into combinedArray

        for (const name in groupedByParent) {
          combinedArray.push({ name, products: groupedByParent[name] });
        }

        this.planSummaryMainResult = combinedArray;

        let plansData = {
          customerName: inputData.firstName + '' + inputData.lastName,
          contactNum: inputData.phone_number,
          dob: inputData.date_of_birth,
          email: inputData.email,
          process: 'planSelection',
          request: { plans: Data },
        };

        //this.consoleMessage(plansData)
        // this.loginService.savePlan(plansData).subscribe((result: any) => {
        //   //this.consoleMessage(result)
        // })
        // $("#planSelectionInfo").css("display", "block");
      }
      else {
        if (healthPlanSelected.length > 0) {

          this.ShowModelPopup = true
          this.ShowModelPopupMessage = this.lang.Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan;
          this.ShowModelPopupTitle = this.lang.Info
        }
        else {
          this.ShowModelPopup = true
          this.ShowModelPopupMessage = this.lang.Please_select_a_Provincial_Health_Replacement_Plan;
          this.ShowModelPopupTitle = this.lang.Info
        }


      }

    }
    else {

      let iafgPlanSelected = iafgData.filter((p: any) => p.packageId == 13);
      let healthPlanSelected = Data.filter((p: any) => p.packageId == 1);

      let benficiaryList = JSON.parse(sessionStorage.getItem('addbenificaryData') || '[]')
      console.log(iafgPlanSelected)
      console.log(healthPlanSelected)
      if (iafgPlanSelected.length > 0) {
        if (healthPlanSelected.length > 0) {
          console.log("here")
          if (this.activeTab < this.tabs.length - 1) {
            this.previousTab = this.activeTab;
            this.activeTab++;
          }
          setTimeout(() => {
            sessionStorage.setItem('pageName', 'Enrollment Summary');
          }, 10);
          this.planssummarymain = JSON.parse(
            sessionStorage.getItem('plansummarymain') || '[]'
          );

          this.planssummaryopt = JSON.parse(
            sessionStorage.getItem('plansummaryopt') || '[]'
          );
          let array: any = [];

          this.planSummaryMainResult =
            array.sort((a: any, b: any) => a.id - b.id) || '';

          this.planssummarymain =
            this.planssummarymain.sort(
              (a: any, b: any) => a.packageId - b.packageId
            ) || '';
          this.finalenrollemntsummary = this.planssummarymain;
          this.finalenrollemntsummaryLife = this.planssummarymainLife

          const combinedArray: any = [];
          const groupedByParent: any = {};
          //  this.paymentForm.get('FirstName')

          for (const obj of this.planSummaryMainResult) {
            //this.consoleMessage(obj)

            const name = obj.packageName;

            const products = obj.products;
            if (!groupedByParent[name]) {
              groupedByParent[name] = [];
            }
            groupedByParent[name] = groupedByParent[name].concat(products);
          }
          // Push grouped child arrays into combinedArray

          for (const name in groupedByParent) {
            combinedArray.push({ name, products: groupedByParent[name] });
          }

          this.planSummaryMainResult = combinedArray;

          //this.consoleMessage(this.planSummaryMainResult)

          // let inputData = JSON.parse(sessionStorage.getItem("Data"));
          // let Data = JSON.parse(sessionStorage.getItem("plansummarymain"))

          let plansData = {
            customerName: inputData.firstName + '' + inputData.lastName,
            contactNum: inputData.phone_number,
            dob: inputData.date_of_birth,
            email: inputData.email,
            process: 'planSelection',
            request: { plans: Data },
          };

          //this.consoleMessage(plansData)
          this._SignupformService.savePlan(plansData).subscribe((result: any) => {
          }, (error: any) => {
            console.log('Error occurred:', error);

            // create object for report log
            let currentTimeStamp = new Date().getTime().toString();
            let log = {
              api: environment.app.grp + "api/common/customer/transaction",
              payload: JSON.stringify(plansData),
              message: `Trying to submit transaction api planSelection ${currentTimeStamp}`,
              portal: 'Gig Signup form'
            }
            let obj = {
              customerDetails: JSON.stringify({ username: inputData.email, timeStamp: sessionStorage.getItem('timeStamp') }),
              logs: JSON.stringify(log),
            };
            this._SignupformService.submitReportLog(environment.app.commonurl, obj);
          })


        }
        else {
          this.ShowModelPopup = true
          this.ShowModelPopupMessage = this.lang.Please_select_a_Health_Dental_Plan_along_with_a_Insurance_Plan;
          this.ShowModelPopupTitle = this.lang.Info
        }

      }
      else {

        console.log("here")
        if (this.activeTab < this.tabs.length - 1) {
          this.previousTab = this.activeTab;
          this.activeTab++;
        }
        setTimeout(() => {
          sessionStorage.setItem('pageName', 'Enrollment Summary');
        }, 10);
        this.planssummarymain = JSON.parse(
          sessionStorage.getItem('plansummarymain') || '[]'
        );

        this.planssummaryopt = JSON.parse(
          sessionStorage.getItem('plansummaryopt') || '[]'
        );
        let array: any = [];

        this.planSummaryMainResult =
          array.sort((a: any, b: any) => a.id - b.id) || '';

        this.planssummarymain =
          this.planssummarymain.sort(
            (a: any, b: any) => a.packageId - b.packageId
          ) || '';
        this.finalenrollemntsummary = this.planssummarymain;
        this.finalenrollemntsummaryLife = this.planssummarymainLife

        const combinedArray: any = [];
        const groupedByParent: any = {};
        //  this.paymentForm.get('FirstName')

        for (const obj of this.planSummaryMainResult) {
          //this.consoleMessage(obj)

          const name = obj.packageName;

          const products = obj.products;
          if (!groupedByParent[name]) {
            groupedByParent[name] = [];
          }
          groupedByParent[name] = groupedByParent[name].concat(products);
        }
        // Push grouped child arrays into combinedArray

        for (const name in groupedByParent) {
          combinedArray.push({ name, products: groupedByParent[name] });
        }

        this.planSummaryMainResult = combinedArray;

        //this.consoleMessage(this.planSummaryMainResult)

        // let inputData = JSON.parse(sessionStorage.getItem("Data"));
        // let Data = JSON.parse(sessionStorage.getItem("plansummarymain"))

        let plansData = {
          customerName: inputData.firstName + '' + inputData.lastName,
          contactNum: inputData.phone_number,
          dob: inputData.date_of_birth,
          email: inputData.email,
          process: 'planSelection',
          request: { plans: Data },
        };

        //this.consoleMessage(plansData)
        this._SignupformService.savePlan(plansData).subscribe((result: any) => {
        }, (error: any) => {
          console.log('Error occurred:', error);

          // create object for report log
          let currentTimeStamp = new Date().getTime().toString();
          let log = {
            api: environment.app.grp + "api/common/customer/transaction",
            payload: JSON.stringify(plansData),
            message: `Trying to submit transaction api planSelection ${currentTimeStamp}`,
            portal: 'Gig Signup form'
          }
          let obj = {
            customerDetails: JSON.stringify({ username: inputData.email, timeStamp: sessionStorage.getItem('timeStamp') }),
            logs: JSON.stringify(log),
          };
          this._SignupformService.submitReportLog(environment.app.commonurl, obj);
        })
      }


    }

  }

public resetSelections() {
  this.selectedCount = 1;
  this.memberSelected = true;
  this.isMedcanPopUpSubmitted = false;
  this.spouseSelected = false;
  this.medcanSubmitCount = 1;
  this.doctorSpouseGender = '';
  this.doctorSelfGender='';
  this.clinicSpouseSelection = 'yes';
  this.clinicSelfSelection = 'no';
  this.planOptionsModel = false;

  // Viking builds planScopeDetails purely from the "Add to plan" checkboxes, so it must
  // survive step navigation — only ticking/unticking may change it. Every other form type
  // fills it from the clinic selection, which is genuinely reset when the step is left.
  if (this.currFormType !== 'viking') {
    this.planScopeDetails = []
    sessionStorage.setItem("planScopeDetails", JSON.stringify([]))
  }

  if (this.validationInputData?.childrenDetails?.length > 0) {
    const len = this.validationInputData.childrenDetails.length;
    this.childrenSelected = new Array(len).fill(false);
    // FIX 1: was fill(false), must be 'no' to match radio value strings
    this.clinicSelection = new Array(len).fill('yes');
    // FIX 2: was "" (string), must be an array to support doctorGender[$index]
    this.doctorGender = new Array(len).fill('');
  }
}

// FIX 3: now receives index (number) instead of raw $event (MouseEvent)
public onClinicChildChange(index: number) {

   if(this.clinicSelection[index] == "yes"){
      let existingIndex = this.planScopeDetails.findIndex(
        (person: any) =>
          person.relationShip === 'CHILDREN' &&
          person.childIndex === index
      );
      if (existingIndex === -1) {
      }else{
        let existingChild:any = this.planScopeDetails[existingIndex];
        existingChild.options = []
        this.planScopeDetails[existingIndex] = existingChild
      }
    }
    this.planOptionsModel = this.clinicSelection[index] == 'no' ? true : false;
}

// FIX 4: logic was inverted — was "if exists push" (wrong), now "if !exists push, else update"
public onChildDoctorChange(value: string, index: number, child: any) {
  const existingIndex = this.planScopeDetails.findIndex(
    (person: any) =>
      person.relationShip === 'CHILDREN' &&
      person.childIndex === index
  );

  if (existingIndex === -1) {
    // Child not yet in list — add them
    this.planScopeDetails.push({
      firstName: child.firstName,
      lastName: child.lastName,
      relationShip: 'CHILDREN',
      childIndex: index,
      doctorGender: value
    });
  } else {
    // Already exists — just update their doctorGender
    this.planScopeDetails[existingIndex].doctorGender = value;
  }
}



public openClinicModal(){
  this.currChildType = "SELF"
  const alreadyExists = this.planScopeDetails.some(
    (person: any) => person.relationShip === 'SELF'
  );
  let selfDetails = { firstName: this.validationInputData.firstName, lastName: this.validationInputData.lastName, "relationShip": "SELF",doctorGender: this.doctorSelfGender }
  this.currChild =selfDetails
  if (!alreadyExists) {
    this.planScopeDetails.push(selfDetails);
  }
  this.planOptionsModel = true;
}


public onClinicChange(self:any = false) {
  if(self){
    this.currChildType = "SELF"
    const alreadyExists = this.planScopeDetails.some(
      (person: any) => person.relationShip === 'SELF'
    );
    let selfDetails = { firstName: this.validationInputData.firstName, lastName: this.validationInputData.lastName, "relationShip": "SELF",doctorGender: this.doctorSelfGender }
    this.currChild =selfDetails
    if (!alreadyExists) {
      this.planScopeDetails.push(selfDetails);
    }
  this.planOptionsModel = this.clinicSelfSelection === 'yes';
  }else{
    if(this.clinicSpouseSelection === "yes"){
        let existing:any = this.planScopeDetails.find((item:any) => item.relationShip == "SPOUSE")
        if(existing){
          let extIndex = this.planScopeDetails.findIndex((item:any) => item.relationShip == "SPOUSE");
          existing.options = []
          this.planScopeDetails[extIndex] = existing
        }
      }
      this.planOptionsModel = this.clinicSpouseSelection === 'no';
  }
}

// FIX 5: update doctorGender on spouse entry in planScopeDetails when gender changes
public onSpouseDoctorGenderChange(value: string) {
  const spouse = this.planScopeDetails.find(
    (person: any) => person.relationShip === 'SPOUSE'
  );
  if (spouse) {
    spouse.doctorGender = value;
  }
}

public onSelfDoctorGenderChange(value: string) {
  const spouse = this.planScopeDetails.find(
    (person: any) => person.relationShip === 'SELF'
  );
  if (spouse) {
    spouse.doctorGender = value;
  }
}

onSpouseChange(isChecked: any, spouseDetails: any) {
  if(this.planScopeDetails.length == 0){
    // error throw

    this.clinicSubmitAttempted = true;

    if(this.doctorSelfGenderRef){
      this.doctorSelfGenderRef.control.markAsTouched();
    }


    setTimeout(() => {
      this.spouseSelected = false;
    });

    return;
  }
  if (isChecked) {
    this.currChild = spouseDetails;
    this.currChildType = "SPOUSE";
    const alreadyExists = this.planScopeDetails.some(
      (person: any) => person.relationShip === 'SPOUSE'
    );
    if (!alreadyExists) {
      this.planScopeDetails.push({
        firstName: spouseDetails.firstName,
        lastName: spouseDetails.lastName,
        relationShip: 'SPOUSE',
        // Use current value of doctorSpouseGender at time of selection
        doctorGender: this.doctorSpouseGender ?? ''
      });
    }
  } else {
    this.planScopeDetails = this.planScopeDetails.filter(
      (person: any) => person.relationShip !== 'SPOUSE'
    );
    // Reset spouse-specific fields on uncheck
    this.doctorSpouseGender = '';
    this.clinicSpouseSelection = 'yes';
    this.planOptionsModel = false;
  }
  this.updateCount();
}

onChildChange(isChecked: boolean, index: number, child: any) {

   if(this.planScopeDetails.length == 0){
    // error throw

    this.clinicSubmitAttempted = true;

    if(this.doctorSelfGenderRef){
      this.doctorSelfGenderRef.control.markAsTouched();
    }


    setTimeout(() => {
      this.childrenSelected[index] = false;
    });

    return;
  }

  if (isChecked) {
    this.currChild = child;
    this.currChildType = "CHILDREN";
    this.currChildIndex = index;
    const exists = this.planScopeDetails.some(
      (person: any) =>
        person.relationShip === 'CHILDREN' &&
        person.childIndex === index
    );
    if (!exists) {
      this.planScopeDetails.push({
        firstName: child.firstName,
        lastName: child.lastName,
        relationShip: 'CHILDREN',
        childIndex: index,
        doctorGender: ''
      });
    }
  } else {
    // Remove child and reset their individual fields
    this.planScopeDetails = this.planScopeDetails.filter(
      (person: any) =>
        !(person.relationShip === 'CHILDREN' && person.childIndex === index)
    );
    this.doctorGender[index] = '';
    this.clinicSelection[index] = 'yes';
  }
  this.updateCount();
}

updateCount() {
  let count = 1;
  if (this.spouseSelected) count++;
  count += this.childrenSelected.filter(Boolean).length;
  this.selectedCount = count;
}


 onCloseMedcan() {
    this.showMedcanForm = false;
  }



 onSubmitMedcan(isnotunselect: any = true) {

  console.log("isnotunselect12828: ",isnotunselect)
  this.clinicSubmitAttempted = true;

  if(this.doctorSelfGenderRef){

    this.doctorSelfGenderRef.control.markAsTouched();
    
    if (this.doctorSelfGenderRef.invalid) {
      return;
    }
  }

  // if(this.planScopeDetails.length == 0){
  //   Swal.fire({
  //     title: this.lang.Error,
  //     text: "Please select clinic options for the self member.",
  //     showDenyButton: false,
  //     confirmButtonText: this.lang.ok,
  //   }).then((result) => {
  //     /* Read more about isConfirmed, isDenied below */
  //     if (result.isConfirmed) {
  //       return;
  //     }
  //   });
  // }
    this.multiSelectPlansTotal = this.multiSelectPlansTotal - 1;
    if (this.multiSelectPlansTotal >= 1 && isnotunselect) {
      this.showMedcanForm = true;
    } else {
      this.showMedcanForm = false;
      this.isMedcanPopUpSubmitted = true;
    }
    const submissionData = this.buildSubmissionData();
    this.medcanSubmitCount = submissionData?.count ?? 1


    let sessiondata = JSON.parse(sessionStorage.getItem("plansummarymain") ?? "{}");
    let multiSelectPlans = sessiondata.filter((item: any) => item.multiCountPlan);
    let notMultiSelectPlans = sessiondata.filter((item: any) => !item.multiCountPlan);
    multiSelectPlans.forEach((msp: any) => {
      msp.products.forEach((product: any) => {
        console.log("qwiqplan.planLevel")
        console.log(this.medcanSubmitCount)
        if (product.calculatedTax) {

          if (product.calculatedTax.originalTotal === undefined) {
            product.calculatedTax.originalTotal = product.calculatedTax.total;
          }

          let existingCalculatedTotal =  product.calculatedTax.originalTotal * this.medcanSubmitCount;
          product.calculatedTax.total = existingCalculatedTotal;
        }
        product.total = product.calculatedTax.total
        msp.totalPrice = product.total
        msp.total = product.total
        msp.totalUI = '$' +
          this._decimalPipe.transform(product.total, '1.2-2')
      })
    })


    if (isnotunselect) {

      let newData = [...notMultiSelectPlans, ...multiSelectPlans]

      sessionStorage.setItem("plansummarymain", JSON.stringify(newData));
      let selfDetails = [{ firstName: this.validationInputData.firstName, lastName: this.validationInputData.lastName, "relationShip": "SELF" }]
      // check if self details exists

      let existingSelf = this.planScopeDetails.find((item: any) => item.relationShip == "SELF");
      if (!existingSelf) {
        existingSelf = selfDetails
        this.planScopeDetails = [...selfDetails, ...this.planScopeDetails]
      }

      // check options available for dependents

      let dependents = this.planScopeDetails.filter((item:any) => item.relationShip != "SELF");
      if(dependents && dependents.length > 0){
        dependents.forEach((dep:any) => {
          console.log("deo33838: ",dep)
          if(dep.options && dep.options.length > 0){
            // skip
          }else{
            dep.options = existingSelf?.options ?? []
          }
        })
      }

      console.log(dependents)

      
      
      this.planScopeDetails = [existingSelf, ...dependents]
      // add clinicname to the toplevel

      if(this.planScopeDetails && this.planScopeDetails.length > 0){
        this.planScopeDetails.forEach((item:any) => {
           if(item.options && item.options.length > 0){
            item.options.forEach((opt:any) => {
              opt['planOptionsValueId'] = opt?.id;
            })
            item['clinicName'] = item.options.find((i:any) => i.planOptionsId == 1)?.clinicName ?? "",
            item['yearRoundCare'] = item.options.find((i:any) => i.planOptionsId == 2)?.optinValue ?? ""
          }
        })
      }
      sessionStorage.setItem("planScopeDetails", JSON.stringify(this.planScopeDetails))
      sessionStorage.setItem("multiPlanCount", this.planScopeDetails.length);
    
    }

    this.changeCartAmount()
  }


  buildSubmissionData() {
    const dependents: any = {};

    // Add spouse if selected
    if (this.spouseSelected && this.validationInputData.havingSpouse) {
      dependents.spouse = {
        firstName:                this.validationInputData.spouseDetails.firstName,
        lastName:                 this.validationInputData.spouseDetails.lastName,
        email:                    this.validationInputData.spouseDetails.email,
        dateOfBirth:              this.validationInputData.spouseDetails.dateOfBirth,
        gender:                   this.validationInputData.spouseDetails.gender,
        isSpouseHavingHealthcard: this.validationInputData.spouseDetails.isSpouseHavingHealthcard,
        spouseCarrierName:        this.validationInputData.spouseDetails.spouseCarrierName,
        cobCoverage:              this.validationInputData.spouseDetails.cobCoverage,
        addedToPolicy:              this.validationInputData.spouseDetails.addedToPolicy,
      };
    }

    // Add selected children
    if (this.validationInputData.havingDependentChildren && this.validationInputData.childrenDetails?.length > 0) {
      dependents.children = [];
      this.childrenSelected.forEach((selected, index) => {
        if (selected) {
          dependents.children.push({
            firstName:               this.validationInputData.childrenDetails[index].firstName,
            lastName:                this.validationInputData.childrenDetails[index].lastName,
            gender:                  this.validationInputData.childrenDetails[index].gender,
            dateOfBirth:             this.validationInputData.childrenDetails[index].dateOfBirth,
            isChildHavingHealthcard: this.validationInputData.childrenDetails[index].isChildHavingHealthcard,
            childCarrierName:        this.validationInputData.childrenDetails[index].childCarrierName,
            enrolledInUniversity:    this.validationInputData.childrenDetails[index].enrolledInUniversity,
            isDisabled:              this.validationInputData.childrenDetails[index].isDisabled,
            graduationDay:           this.validationInputData.childrenDetails[index].graduationDay,
            addedToPolicy:             this.validationInputData.childrenDetails[index].addedToPolicy,
          });
        }
      });
    }

    // Build final structure
    const result = {
      count: this.selectedCount,
      member: {
        first_name: this.validationInputData.firstName,
        last_name: this.validationInputData.lastName,
        email: this.validationInputData.email,
        phone_number: this.validationInputData.phone_number,
        date_of_birth: this.validationInputData.dob,
        gender: this.validationInputData.gender,
        street_address_line1: this.validationInputData.street_address_line1,
        street_address_line2: this.validationInputData.street_address_line2,
        city: this.validationInputData.city,
        province: this.validationInputData.province,
        province_id: this.validationInputData.province_id,
        country: this.validationInputData.country,
        country_id: this.validationInputData.country_id,
        postal_code: this.validationInputData.postal_code,
        company_name: this.validationInputData.company_name,
        job_title: this.validationInputData.job_title,
        date_of_hiring: this.validationInputData.date_of_hiring,
        working_20hours: this.validationInputData.working_20hours,
        hours_per_week: this.validationInputData.hours_per_week
      },
      dependents: Object.keys(dependents).length > 0 ? [dependents] : []
    };

    return result;
  }



  // ── NHLAA summary computed getters ─────────────────────────────────────────
  /** Plans paid 100% by company (paidByCompany === 1) */
  get nhlaaCompanyPaidPlans(): any[] {
    return (this.finalenrollemntsummary || []).filter((p: any) => p.paidByCompany === 1);
  }
  /** Plans paid (partly) by employee (upgrade or voluntary) */
  get nhlaaEmployeePlans(): any[] {
    return (this.finalenrollemntsummary || []).filter((p: any) => p.paidByCompany !== 1);
  }
  /** Sum helpers for totals row */
  get nhlaaAllPremiumTotal(): number {
    return (this.finalenrollemntsummary || []).reduce((s: number, p: any) => s + (p.planPrice || 0), 0);
  }
  get nhlaaAllTaxTotal(): number {
    return (this.finalenrollemntsummary || []).reduce((s: number, p: any) => s + (p.tax || 0), 0);
  }
  get nhlaaAllTotal(): number { return this.nhlaaAllPremiumTotal + this.nhlaaAllTaxTotal; }

  get nhlaaCompanyPremiumTotal(): number {
    return this.nhlaaCompanyPaidPlans.reduce((s: number, p: any) => s + (p.planPrice || 0), 0);
  }
  get nhlaaCompanyTaxTotal(): number {
    return this.nhlaaCompanyPaidPlans.reduce((s: number, p: any) => s + (p.tax || 0), 0);
  }
  get nhlaaCompanyTotal(): number { return this.nhlaaCompanyPremiumTotal + this.nhlaaCompanyTaxTotal; }

  /**
   * NHLAA: toggled by the "I confirm signing up for the company-paid benefits plan" checkbox.
   * Mirrors companyPlansConfirmation() in corporate-signup.component.ts.
   */
  companyPlansConfirmation(event: any): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.companyplansCheck = !isChecked;   // false when confirmed, true when unchecked
  }

  /** Mirrors upgradeplansConfirmation() in corporate-signup — upgrade plans checkbox */
  upgradeplansConfirmation(event: any): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.upgradeplansCheck = false;
    } else {
      this.upgradeplansCheck = true;
    }
  }

  /** Mirrors voluntryplansConfirmation() in corporate-signup — voluntary plans checkbox */
  voluntryplansConfirmation(event: any): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.voluntryplansCheck = false;
    } else {
      this.voluntryplansCheck = true;
    }
  }

  // ────────────────────────────────────────────────────────────────────────────

  public paymentpage(tabId: number) {
    // ── NHLAA corp: skip all GIG/IAFG validations, go straight to summary ──
    if (this.currFormType === 'nhlaa') {
      this.gotosumamrypageLogic();
      return;
    }
    console.log("called1299")
    this.bankpayForm.reset();
    this.banknameres = '';
    // this.paymentForm.reset();
    this.paymentForm.get('paymentRadioCheck')?.setValue("CC");

    let benficiryData = JSON.parse(sessionStorage.getItem('addbenificaryData') || '[]');
    let inputData = JSON.parse(sessionStorage.getItem('Data') || '[]');
    let Data = JSON.parse(sessionStorage.getItem('plansummarymain') || '[]');
    let iafgData = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
    let phrPlanSelected = Data.filter((p: any) => p.packageId == 10);
    let healthPlanSelected = Data.filter((p: any) => p.packageId == 1);
    let completeExecutiveplan = Data.filter((p: any) => p.planLevel == 18);
    let medcanPlanSelected = Data.filter((p: any) => p.multiCountPlan);
    let lavieplancheck = Data.filter((p: any) => p.planproductname.includes("La Vie"));
    let iafgDataSelectedPlan = iafgData.filter((p: any) => p.packageId == 13);
    let iafgTermplanCheck = iafgData.filter((p: any) => p.planLevel == 44);
    let benficiaryList = JSON.parse(sessionStorage.getItem('addbenificaryData') || '[]')
    this.paymentemail = inputData.email || this.userForm.get('email')?.value
    this.paymentFirstName = this.capitalize(inputData.firstName) || this.userForm.get('firstName')?.value;
    this.paymentLastName = this.capitalize(inputData.lastName) || this.userForm.get('lastName')?.value
    let iafgTermplanSpouseCheck = iafgData.filter((p: any) => p.coverage == 'MEMBER & SPOUSE');

    // if(iafgTermplanCheck.length>0){

    //   if(this.addbenificaryData.length>0){
    //     this.benficiary =false;
    //   }else{
    //     this.benficiary =true;

    //     return false;

    //   }

    // }


    console.log(medcanPlanSelected)
    if (medcanPlanSelected.length > 0 && !this.isMedcanPopUpSubmitted && this.showMultiCountChanges) {
      this.multiSelectPlansTotal = medcanPlanSelected.length;
      // check how many dependents
      if (!this.validationInputData.havingSpouse && !this.validationInputData.havingDependentChildren) {
        this.showMedcanForm = false
      } else {
        this.resetSelections();
        this.changeCartAmount();
        this.originalMedcanPrice = medcanPlanSelected[0]?.planPrice ?? 0;
        this.medcanPlanName = medcanPlanSelected[0]?.planproductname ?? "Medcan"
        this.showMedcanForm = true;
        return;
      }
    } else {
      if (medcanPlanSelected.length > 0 && this.showMultiCountChanges) {
        this.onSubmitMedcan(false)
      }
      this.showMedcanForm = false;
    }
    console.log(completeExecutiveplan)
    // console.log(completeExecutiveplan[0].options)
    // console.log(completeExecutiveplan[0].options.length)
    if (completeExecutiveplan.length > 0) {
      if (completeExecutiveplan && completeExecutiveplan[0].options && completeExecutiveplan[0].options.length > 0) {

      } else {
        this.planOptionsModel = true
        return false
      }
    }

    if (lavieplancheck && lavieplancheck.length > 0) {
      if (completeExecutiveplan && completeExecutiveplan.length > 0) {

      }
      else {
        this.ShowModelPopup = true
        this.ShowModelPopupMessage = "Select Complete Executive Care Plan along with La Vie";
        this.ShowModelPopupTitle = this.lang.Info
        return false
      }

    }

    if ((iafgTermplanCheck && iafgTermplanCheck.length > 0) || this.showBenificiaryFormCond || this.currFormType == "viking") {

      if (this.addbenificaryData.length > 0) {
        this.benficiary = false;
        const validateBeneficiaries = this.addbenificaryData.reduce((acc: any, obj: any) => {
          const compositeKey = `${obj.customerType}_${obj.type}`;
          if (!acc[compositeKey]) {
            acc[compositeKey] = 0;
          }
          acc[compositeKey] += parseFloat(obj.percentage);
          return acc;
        }, {});

        let beneficiaryError = "";
        for (const key in validateBeneficiaries) {
          if (validateBeneficiaries.hasOwnProperty(key)) {
            const [customerType, type] = key.split("_");
            console.log(`The customerType ${customerType} and type ${type} with perc: ${validateBeneficiaries[key]}`);

            if (validateBeneficiaries[key] != 100) {
              beneficiaryError += `CustomerType ${customerType} and type ${type} has percentage issue. \n`
            }
          }
        }

        if (!this.beneficiaryError) {
          this.benficiary = false

          if (iafgTermplanSpouseCheck.length > 0) {

            if (sessionStorage.getItem("Spousesignature") || "") {
              // this.gotosumamrypageLogic()
            } else {
              this.showSpouseSignature = true
              this.signatureNeeded = this.signaturePad.isEmpty();
              // if(this.signatureNeeded==false){

              //   const base64Data = this.signaturePad.toDataURL();
              //   // console.log(base64Data);
              //   sessionStorage.setItem("Spousesignature", base64Data);

              // }
              // else{
              //   sessionStorage.setItem("signature", "");
              //   this.showpaderrorMessage= true
              // }

            }
          } else {
            // this.gotosumamrypageLogic()
          }



        }
        else {
          this.benficiary = true
          // this.benficiaryCount =true
          // this.benficiaryCountMessage='Please Enter Benefeciary Percentage equal to 100'
        }


      } else {
        this.benficiary = true;
        if (this.addbenificaryData.length > 0) {

        } else {
          this.showBenificiaryForm = true
        }


        return false;

      }

    } else {
      this.addbenificaryData = []
      // this.gotosumamrypageLogic()
    }
    if (inputData.provincial_health_coverage == false) {

      // if (phrPlanSelected.length > 0) {
      //   if (healthPlanSelected.length > 0) {
      //     if (iafgDataSelectedPlan.length > 0) {

      //       if (healthPlanSelected.length > 0) {

      //         if (iafgTermplanCheck.length > 0) {

      //           var total = 0;
      //           for (let i = 0; i < benficiryData.length; i++) {
      //             total += parseFloat(benficiryData[i].percentage);
      //           }

      //           if (!this.beneficiaryError) {
      //             this.benficiary = false
      //             this.showbenificaryTable = false;
      //             this.gotosumamrypageLogic()
      //           } else {
      //             this.benficiary = true
      //             this.showbenificaryTable = true;
      //             this.showaddmorebenficiary = true;

      //           }

      //         }
      //         else {
      //           this.gotosumamrypageLogic()
      //         }



      //       }
      //       else {
      //         this.ShowModelPopup = true
      //         this.ShowModelPopupMessage = this.lang.Please_select_a_Health_Dental_Insurance_Plan_along_with_a_Life_or_Critical_Insurance_Plan;
      //         this.ShowModelPopupTitle = this.lang.Info
      //       }
      //     }
      //     else {
      //       this.gotosumamrypageLogic()
      //     }
      //   }
      //   else {
      //     this.ShowModelPopup = true
      //     this.ShowModelPopupMessage = this.lang.Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan;
      //     this.ShowModelPopupTitle = this.lang.Info
      //   }

      // }


      // else {
      //   if (healthPlanSelected.length > 0) {
      //     this.ShowModelPopup = true
      //     this.ShowModelPopupMessage = this.lang.Please_select_a_Provincial_Health_Replacement_Plan;
      //     this.ShowModelPopupTitle = this.lang.Info
      //   }
      //   else {
      //     this.ShowModelPopup = true
      //     this.ShowModelPopupMessage = this.lang.Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan;
      //     this.ShowModelPopupTitle = this.lang.Info
      //   }


      // }

      if (healthPlanSelected.length > 0) {
        if (phrPlanSelected.length == 0) {
          // this.ShowModelPopup = true
          // this.ShowModelPopupMessage = this.lang.Please_select_a_Provincial_Health_Replacement_Plan;
          // this.ShowModelPopupTitle = this.lang.Info

          this.ShowModelPopup = true
          this.ShowModelPopupMessage = this.lang.Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan;
          this.ShowModelPopupTitle = this.lang.Info
        } else {
          this.gotosumamrypageLogic()
        }
      }
      else {
        this.gotosumamrypageLogic()
      }
    }
    else {

      if (iafgDataSelectedPlan.length > 0) {

        if (healthPlanSelected.length > 0) {

          if (iafgTermplanCheck.length > 0) {

            var total = 0;
            for (let i = 0; i < benficiryData.length; i++) {
              total += parseFloat(benficiryData[i].percentage);
            }

            if (!this.beneficiaryError) {
              this.benficiary = false
              this.showbenificaryTable = false;


              this.gotosumamrypageLogic()
            } else {
              this.benficiary = true
              this.showbenificaryTable = true;
              this.showaddmorebenficiary = true;

            }

          }
          else {

            this.gotosumamrypageLogic()
          }



        }
        else {
          this.ShowModelPopup = true
          this.ShowModelPopupMessage = this.lang.Please_select_a_Health_Dental_Insurance_Plan_along_with_a_Life_or_Critical_Insurance_Plan;
          this.ShowModelPopupTitle = this.lang.Info
        }
      }
      else {
        this.gotosumamrypageLogic()
      }

    }
  }
  public genderCheck(event: any) {

    // console.log(event?.target.value)

    // if(event.target.value !='Male' || event.target.value !='Female'){
    //   if(this.iafgCheck){
    //     this.iafginfo =true
    //   }
    //   else{
    //     this.iafginfo =false
    //   }

    // }
    // else{
    //   this.iafginfo =false

    // }

  }

  public closeConfirmModel() {
    this.ConfirmModel = false
  }
  public gotosumamrypageLogic() {



    let iafgData = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    let iafgTermplanCheck = iafgData.filter((p: any) => p.planLevel == 45);
    let iafgTermLifeplanCheck = iafgData.filter((p: any) => p.planLevel == 44);
    if (iafgData.length > 1) {
      this.ConfirmModel = true
    }



    if (iafgTermplanCheck.length > 0) {
      this.criticalplancheck = true
    }
    else {
      this.criticalplancheck = false
    }

    if (iafgTermLifeplanCheck.length > 0) {
      this.termLifeplancheck = true
    }
    else {
      this.termLifeplancheck = false
    }
    let inputData = JSON.parse(sessionStorage.getItem('Data') || '[]');
    let Data = JSON.parse(sessionStorage.getItem('plansummarymain') || '[]');
    if (this.activeTab < this.tabs.length - 1) {
      this.previousTab = this.activeTab;
      this.activeTab++;
      this.visitedTabs.add(this.previousTab);
    }
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.scrollContainer?.nativeElement.scrollTo(0, 0);
      }
    });
    this.imagedisplay = false;
    setTimeout(() => {
      sessionStorage.setItem('pageName', 'Enrollment Summary');
    }, 10);
    this.planssummarymain = JSON.parse(
      sessionStorage.getItem('plansummarymain') || '[]'
    );

    this.planssummaryopt = JSON.parse(
      sessionStorage.getItem('plansummaryopt') || '[]'
    );
    let array: any = [];

    this.planSummaryMainResult =
      array.sort((a: any, b: any) => a.id - b.id) || '';

    this.planssummarymain =
      this.planssummarymain.sort(
        (a: any, b: any) => a.packageId - b.packageId
      ) || '';
    this.finalenrollemntsummary = this.planssummarymain;
    this.finalenrollemntsummaryLife = this.planssummarymainLife

    console.log(this.finalenrollemntsummaryLife)

    const combinedArray: any = [];
    const groupedByParent: any = {};
    //  this.paymentForm.get('FirstName')

    for (const obj of this.planSummaryMainResult) {
      //this.consoleMessage(obj)

      const name = obj.packageName;

      const products = obj.products;
      if (!groupedByParent[name]) {
        groupedByParent[name] = [];
      }
      groupedByParent[name] = groupedByParent[name].concat(products);
    }
    // Push grouped child arrays into combinedArray

    for (const name in groupedByParent) {
      combinedArray.push({ name, products: groupedByParent[name] });
    }

    this.planSummaryMainResult = combinedArray;

    let plansData = {
      customerName: inputData.firstName + '' + inputData.lastName,
      contactNum: inputData.phone_number,
      dob: inputData.date_of_birth,
      email: inputData.email,
      process: 'planSelection',
      request: { plans: Data },
    };
    this._SignupformService.savePlan(plansData).subscribe((result: any) => {
    }, (error: any) => {
      console.log('Error occurred:', error);

      // create object for report log
      let currentTimeStamp = new Date().getTime().toString();
      let log = {
        api: environment.app.grp + "api/common/customer/transaction",
        payload: JSON.stringify(plansData),
        message: `Trying to submit transaction api planSelection ${currentTimeStamp}`,
        portal: 'Gig Signup form'
      }
      let obj = {
        customerDetails: JSON.stringify({ username: inputData.email, timeStamp: sessionStorage.getItem('timeStamp') }),
        logs: JSON.stringify(log),
      };
      this._SignupformService.submitReportLog(environment.app.commonurl, obj);
    })
  }
  public checkbankdetails(event: any) {
    // this.bankdetailsverify =  true
    if (event.target.value == 'yes') {
    } else {
      this.bankpayForm.reset();
      this.imagedisplay = false;
      sessionStorage.removeItem('fileurl');
      sessionStorage.removeItem('filename');
      // this.bankpayForm.get('bankcode').value
    }

    this.verifybankdetails = false;
  }
  public verifybank() {
    // alert()

    // this.isVisible =0

    this.banknameres = '';

    let personalInfo: any = JSON.parse(sessionStorage.getItem("Data") || '{}');

    let inputData = {
      bankCode: this.bankpayForm.controls['banknumber'].value,
      branchCode: this.bankpayForm.controls['transitnumber'].value,
      firstName: personalInfo?.firstName,
      lastName: personalInfo?.lastName,
      email: personalInfo?.email,
    };

    let activity: any = {};
    activity.action = 'Step 1 of 7 - Verify bank details';
    activity.url = environment.app.grp + '/api/customer/bank/verify';
    activity.requestMethod = 'POST';
    activity.requestBody = inputData;

    this._SignupformService.getbanknames(inputData).subscribe(
      (result: any) => {
        if (result.status == '200') {
          activity.status = 'SUCCESS';
          activity.response = result;
          activity.responseSummary = 'Successfully bank details have verified';
          // this.buildActivityLogObject(activity, true);

          // this.bankdetailsverify =false
          this.verifybutton = false;
          this.bankverifyDetails = result.data;
          this.banknameres =
            result.data.bank.name +
            '\n' +
            result.data.address.split(',').join('\n');
          this.banknameres =
            [result.data.bank.name, ...result.data.address.split(',').map((s: string) => s.trim()).filter((s: string) => s)].join(', ');
          this.bankpayForm.get('bankname')?.setValue(this.banknameres);
          // this.invalidbankdetails = false;
        } else if (result.status == '202') {
          activity.status = 'FAILURE';
          activity.response = result;
          activity.responseSummary = 'Error verifying bank details';
          // this.buildActivityLogObject(activity, true);

          // this.toastrService.warning(result.message, '');
          this.bankerrormsg = result.message;
          // this.invalidbankdetails = true;
          this.verifybankdetails = false;
        } else {
          activity.status = 'FAILURE';
          activity.response = result;
          activity.responseSummary = 'Error verifying bank details';
          // this.buildActivityLogObject(activity, true);

          // this.toastrService.warning(result.message, '');
          this.bankerrormsg = result.message;
          // this.invalidbankdetails = true;
          this.verifybankdetails = false;
        }
      },
      (error) => {
        activity.status = 'FAILURE';
        activity.response = error;
        activity.responseSummary = 'Error verifying bank details';
        // this.buildActivityLogObject(activity, true);

        // alert('Please check the provided bank details');
        this.ShowModelPopup = true
        this.ShowModelPopupTitle = this.lang?.Info ?? 'Info'
        this.ShowModelPopupMessage = 'Please check the provided bank details'
        // this.toastrService.warning(
        //   "Please check the provided bank details",
        //   ""
        // );
      }
    );
  }
  public touchedmsg() {
    // this.invalidbankdetails = false;
    this.bankerrormsg = ''
    if (
      this.bankpayForm.controls['banknumber'].value?.length == 3 &&
      this.bankpayForm.controls['transitnumber'].value?.length == 5 &&
      (this.bankpayForm.controls['accountnumber'].value?.length ?? 0) >= 5
    ) {
      this.verifybankdetails = true;
      this.verifybutton = true;
    } else {
      this.verifybankdetails = false;
      this.verifybutton = false;
    }
  }
  public voidcheckupload(event: any) {
    this.imagedisplay = false
    this.voidCheckFileName = event.target.files[0]?.name || '';
    sessionStorage.removeItem('fileurl');
    sessionStorage.removeItem('filename');
    sessionStorage.removeItem('signature');
    var fileExtension = '.' + event.target.files[0].name.split('.').pop();

    // event.target.files[0].name ="void_cheque_"+Date.now()+fileExtension

    // "void_cheque_"+Date.now()+fileExt
    ////this.consoleMessage(event)
    this.isFileUploaded = true;
    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.bankfile = event.target.files[0];
    this.Shared.setMessage(this.bankfile);
    // this.bankfile.name = (this.bankfile.name,"void_cheque_"+Date.now()+fileExtension)
    // alert(fileExtension.toLowerCase())
    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
      'application/pdf',
    ];

    let error = false;

    let message = '';

    if (allowedMimes.includes(this.bankfile.type)) {
      if (this.bankfile.size <= 1000 * 1024) {
        //300KB

        error = false;
      } else {
        error = true;
        // this.ShowModelPopup =true
        this.ShowModelPopupMessage = this.lang.File_size_is_too_large_maximum_file_size_is_1MB;
        // this.ShowModelPopupTitle =this.lang.Info
      }
    } else {
      error = true;
      // this.ShowModelPopup =true
      this.ShowModelPopupMessage = this.lang.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed;
      // this.ShowModelPopupTitle =this.lang.Info
    }

    if (error) {
      // this.showDeleteModal = true;
      // this.modalMessage = message;

      this.ShowModelPopup = true
      this.ShowModelPopupMessage = this.ShowModelPopupMessage
      this.ShowModelPopupTitle = this.lang.Info
      this.bankpayForm.get('voidcheck')?.reset();
      this.voidCheckFileName = '';
      this.isFileUploaded = true;
    } else {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      //this.consoleMessage(reader)

      if (event.target.files[0].type == 'application/pdf') {
        // alert("1")
        this.pdfview = true;
        this.normalview = false;
      } else {
        this.pdfview = false;
        this.normalview = true;
      }

      reader.onload = (_event) => {
        this.imagedisplay = true
        this.imagedisplay = reader.result;
      };

      //     if(this.imagedisplay ==false){
      //       Swal.fire({
      //         title: this.lang.Info,
      //         html: "Invalid file uploaded, please try again",

      //         showCancelButton: false,
      //         confirmButtonText: "Ok",
      //       }).then((result) => {
      //         if (result.value) {

      // this.bankpayForm.get('voidcheck').reset();
      // this.isFileUploaded =true
      //         } else {
      //         }
      //       });
      //     }
    }

    // sessionStorage.setItem("files", event.target.files[0]);
    // localStorage.setItem("files", JSON.stringify(event.target.files[0]));

    // sessionStorage.setItem("voidCheque",this.bankfile)
  }

  // ── Extra Bank Account methods ─────────────────────────────────────────────

  /** Validates extraBankPayForm, sets extraBankSubmitted flag, and returns invalid field labels for the popup. */
  private validateExtraBank(): string[] {
    if (this.extraBankAccountOption === 'same') return [];
    this.extraBankPayForm.updateValueAndValidity();
    if (!this.extraBankPayForm.invalid) return [];

    this.extraBankSubmitted = true;
    this.extraBankPayForm.markAllAsTouched();

    const invalid: string[] = [];
    const controls: any = this.extraBankPayForm.controls;
    for (const name in controls) {
      if (!controls[name].invalid) continue;
      let label = name;
      if (name === 'bank_number')      label = 'Enter Bank Code for Claims';
      if (name === 'transit_number')   label = 'Enter Transit Number for Claims';
      if (name === 'account_number')   label = 'Enter Account Number for Claims';
      if (label) invalid.push(label);
    }
    return invalid;
  }

  public onExtraBankOptionChange(option: string): void {
    this.extraBankAccountOption = option;
    if (option === 'same') {
      this.saveExtraBankToSession();
    } else {
      this.extraBankPayForm.reset();
      this.extraBankImageDisplay = false;
      this.extraBankNameRes = '';
      this.extraBankVerifyButton = false;
    }
  }

  public onExtraBankVoidCheckUpload(event: any): void {
    this.extraBankImageDisplay = false;
    this.extraBankVoidChequeFile = null;
    const file = event.target.files?.[0];
    if (!file) return;

    const allowedMimes = ['image/jpeg', 'image/pjpeg', 'image/png', 'application/pdf'];
    if (!allowedMimes.includes(file.type)) {
      this.ShowModelPopup = true;
      this.ShowModelPopupMessage = this.lang.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed;
      this.ShowModelPopupTitle = this.lang.Info;
      this.extraBankPayForm.get('upload_void_cheque')?.reset();
      return;
    }
    if (file.size > 1000 * 1024) {
      this.ShowModelPopup = true;
      this.ShowModelPopupMessage = this.lang.File_size_is_too_large_maximum_file_size_is_1MB;
      this.ShowModelPopupTitle = this.lang.Info;
      this.extraBankPayForm.get('upload_void_cheque')?.reset();
      return;
    }

    this.extraBankVoidChequeFile = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.extraBankImageDisplay = reader.result;
      this.saveExtraBankToSession();
    };
  }

  public showExtraBankVoidCheckPreview(): void {
    if (!this.extraBankImageDisplay) return;
    this.imagedisplay = this.extraBankImageDisplay;
    const isPdf = typeof this.extraBankImageDisplay === 'string' &&
                  this.extraBankImageDisplay.startsWith('data:application/pdf');
    this.pdfview = isPdf;
    this.normalview = !isPdf;
    this.imageDisplayShow = true;
  }

  public updateExtraBankVerifyButton(): void {
    const f = this.extraBankPayForm.value;
    this.extraBankVerifyButton =
      (f.bank_number?.length ?? 0) === 3 &&
      (f.transit_number?.length ?? 0) === 5 &&
      (f.account_number?.length ?? 0) >= 5;
  }

  public verifyExtraBank(): void {
    this.extraBankNameRes = '';
    this.extraBankerrormsg = '';
    const f = this.extraBankPayForm.value;
    const personalInfo: any = JSON.parse(sessionStorage.getItem('Data') || '{}');

    const inputData = {
      bankCode:   f.bank_number,
      branchCode: f.transit_number,
      firstName:  personalInfo?.firstName,
      lastName:   personalInfo?.lastName,
      email:      personalInfo?.email,
    };

    this._SignupformService.getbanknames(inputData).subscribe(
      (result: any) => {
        if (result.status == '200') {
          this.extraBankNameRes = result.data.bank.name + '\n' + result.data.address.split(',').join('\n');
          this.extraBankVerifyButton = false;

          // Auto-fill institute name, branch address, city, province from API
          const bankName    = result.data.bank.name ?? '';
          const bankAddress = result.data.address ?? '';
          const branchAddr  = bankAddress.split(',')[0]?.trim() ?? '';

          let city = '';
          let province = '';
          if (bankAddress) {
            const parts = bankAddress.split(',');
            city     = (parts[parts.length - 2] ?? '').trim();
            const lastPart   = (parts[parts.length - 1] ?? '').trim().split(' ');
            province = lastPart.length >= 3 ? lastPart[lastPart.length - 3] : lastPart[0] ?? '';
          }

          this.extraBankPayForm.patchValue({
            financial_institute_name: bankName,
            branch_address:           branchAddr,
            extra_city:               city,
            extra_province:           province,
          }, { emitEvent: false });

          this.saveExtraBankToSession();
        } else {
          this.extraBankerrormsg = result.message;
          this.extraBankVerifyButton = false;
        }
      },
      () => { this.extraBankVerifyButton = false; }
    );
  }

  public resetExtraBank(): void {
    this.extraBankPayForm.reset();
    this.extraBankImageDisplay = false;
    this.extraBankVoidChequeFile = null;
    this.extraBankNameRes = '';
    this.extraBankVerifyButton = false;
    this.extraBankerrormsg = '';
    this.extraBankSubmitted = false;
    sessionStorage.removeItem('extraBankAccountDetails');
  }

  public saveExtraBankToSession(): void {
    let payload: any;
    if (this.extraBankAccountOption === 'same') {
      // Reuse the primary bank verification result so the stored shape matches
      // the 'different' payload (submitClaimsDepositInfo reads these keys).
      const bankAddress = this.bankverifyDetails?.address ?? '';
      const addrParts   = bankAddress ? bankAddress.split(',') : [];
      const lastPart    = (addrParts[addrParts.length - 1] ?? '').trim().split(' ');

      payload = {
        option:        'same',
        instituteName: this.bankverifyDetails?.bank?.name ?? '',
        branchAddress: (addrParts[0] ?? '').trim(),
        city:          (addrParts[addrParts.length - 2] ?? '').trim(),
        province:      lastPart.length >= 3 ? lastPart[lastPart.length - 3] : (lastPart[0] ?? ''),
        transitNumber: this.bankpayForm.get('transitnumber')?.value,
        bankNumber:    this.bankpayForm.get('banknumber')?.value,
        accountNumber: this.bankpayForm.get('accountnumber')?.value,
        bankName:      this.banknameres,
        voidCheque:    this.imagedisplay,
      };
    } else {
      const f = this.extraBankPayForm.value;
      payload = {
        option:              'different',
        instituteName:       f.financial_institute_name,
        branchAddress:       f.branch_address,
        city:                f.extra_city,
        province:            f.extra_province,
        transitNumber:       f.transit_number,
        bankNumber:          f.bank_number,
        accountNumber:       f.account_number,
        bankName:            this.extraBankNameRes,
        voidCheque:          this.extraBankImageDisplay,
      };
    }
    sessionStorage.setItem('extraBankAccountDetails', JSON.stringify(payload));
  }

  private submitClaimsDepositInfo(): void {
    // For 'same', the primary bank may have been verified / void cheque uploaded
    // after the option was picked — rebuild so the session holds the final values.
    if (this.extraBankAccountOption === 'same') {
      this.saveExtraBankToSession();
    }

    const extraBankData = JSON.parse(sessionStorage.getItem('extraBankAccountDetails') || 'null');
    if (!extraBankData || !extraBankData.instituteName) return;

    const personalInfo = JSON.parse(sessionStorage.getItem('Data') || '{}');
    const customerId = parseInt(sessionStorage.getItem('customerId') || '0');

    const sessionPayload = {
      bankCode:      extraBankData.bankNumber ?? '',
      branchCode:    extraBankData.transitNumber ?? '',
      bankName:      extraBankData.instituteName ?? '',
      accountNumber: extraBankData.accountNumber ?? '',
      amount:        null,
      enrollmentDate: sessionStorage.getItem('enrollmentdate'),
      customerId,
      file: {},
    };

    const claimsFormData = new FormData();
    claimsFormData.append('firstName', personalInfo.firstName ?? '');
    claimsFormData.append('lastName',  personalInfo.lastName  ?? '');
    claimsFormData.append('bank', JSON.stringify({
      name:       extraBankData.instituteName   ?? '',
      address:    extraBankData.branchAddress   ?? '',
      city:       extraBankData.city            ?? '',
      province:   extraBankData.province        ?? '',
      postalCode: '',
    }));
    claimsFormData.append('session',   btoa(JSON.stringify(sessionPayload)));
    claimsFormData.append('timestamp', new Date().getTime().toString());

    const voidChequeFile = extraBankData.option === 'same'
      ? this.bankfile
      : this.extraBankVoidChequeFile;

    if (voidChequeFile) {
      claimsFormData.append('files', voidChequeFile, voidChequeFile.name);
    }

    this._SignupformService.claimsDepositInfo(claimsFormData).subscribe({
      next: (result: any) => { console.log('claimsDepositInfo submitted', result); },
      error: (err: any) => { console.error('claimsDepositInfo error', err); },
    });
  }

  // ── end Extra Bank Account methods ────────────────────────────────────────

  public homeaddresscheck(event: any) {
    if (event.target.checked == true) {
      sessionStorage.setItem('homeAddress', 'true');

      // this.aptcheck = this.userForm.get("apt_suite")?.value;
      this.bankpayForm
        .get('bankstreetaddress')
        ?.setValue(this.userForm.controls['street_address_line1'].value);
      this.bankpayForm
        .get('bankstreetaddressline2')
        ?.setValue(this.userForm.controls['street_address_line2'].value);
      this.bankpayForm
        .get('bankcity')
        ?.setValue(this.userForm.controls['city'].value);
      this.bankpayForm
        .get('bankprovince')
        ?.setValue(this.userForm.controls['province'].value);
      this.bankpayForm
        .get('bankpostalcode')
        ?.setValue(this.userForm.controls['postal_code'].value);
    } else {
      sessionStorage.setItem('homeAddress', 'false');
      // this.bankpayForm?.setValue({'bankstreetaddress':'','bankstreetaddressline2':'','bankcity':'','bankprovince':'','bankpostalcode':''})
      this.bankpayForm.get('bankstreetaddress')?.setValue('');
      this.bankpayForm.get('bankstreetaddressline2')?.setValue('');
      this.bankpayForm.get('bankcity')?.setValue('');
      this.bankpayForm.get('bankprovince')?.setValue('');
      this.bankpayForm.get('bankpostalcode')?.setValue('');
    }
  }
  public homeaddresscheckCC(event: any) {
    if (event.target.checked == true) {
      sessionStorage.setItem('homeAddress', 'true');

      // this.aptcheck = this.userForm.get("apt_suite")?.value;
      this.paymentForm
        .get('streetaddress')
        ?.setValue(this.userForm.controls['street_address_line1'].value);
      this.paymentForm
        .get('streetaddressline2')
        ?.setValue(this.userForm.controls['street_address_line2'].value);
      this.paymentForm
        .get('city')
        ?.setValue(this.userForm.controls['city'].value);
      this.paymentForm
        .get('province')
        ?.setValue(this.userForm.controls['province'].value);
      this.paymentForm
        .get('postalcode')
        ?.setValue(this.userForm.controls['postal_code'].value);
    } else {
      sessionStorage.setItem('homeAddress', 'false');
      // this.bankpayForm?.setValue({'bankstreetaddress':'','bankstreetaddressline2':'','bankcity':'','bankprovince':'','bankpostalcode':''})
      this.paymentForm.get('streetaddress')?.setValue('');
      this.paymentForm.get('streetaddressline2')?.setValue('');
      this.paymentForm.get('city')?.setValue('');
      this.paymentForm.get('province')?.setValue('');
      this.paymentForm.get('postalcode')?.setValue('');
    }
  }

  public showmodelsign() {
    // console.log("tets1")
    this.generatePADaggrement = ""

    let inputData = {
      "url": sessionStorage.getItem("fileurl"),
      "filename": sessionStorage.getItem("filename"),
      "signature": sessionStorage.getItem("signature")
    }

    let activity: any = {};
    activity.action = 'Step 3 of 7 - Update pad agreement with signature';
    activity.url = environment.app.grp + '/api/customer/updatePAD';
    activity.requestMethod = 'POST';
    activity.requestBody = inputData;

    this._SignupformService.padsignature(inputData).subscribe((result: any) => {
      if (result.status == "200") {
        activity.status = 'SUCCESS';
        activity.response = result;
        activity.responseSummary = 'Signature updated successfully';
        // this.buildActivityLogObject(activity, true);

        // jQuery("#PADpafaggrement1-modal").modal("show");
        this.padAggrementFinalModel = this.showPADMODAL
        this.generatePADaggrement = result.data.url
        this.signaturestatus = false
        this.agreestatus = true
        sessionStorage.setItem("failed", "")

      } else {
        activity.status = 'FAILURE';
        activity.response = result;
        activity.responseSummary = 'Error updating signature';
        // this.buildActivityLogObject(activity, true);

        this.failedarray.push("updatePAD")
        //this.consoleMessage(this.failedarray)
        sessionStorage.setItem("failed", JSON.stringify(this.failedarray))
        // Swal.fire({
        //   title: "Error",
        //   text: result.message ? result.message : result.error,
        //   icon: "warning",
        //   width: "30%",
        //   showCancelButton: false,
        //   confirmButtonText: "Ok",
        // }).then((result) => {
        //   if (result.value) {
        //   } else {
        //     // this.router.navigate(['pages/signup-form']);
        //   }
        // });
      }

    })



  }
  public showpadaggrement() {
    if (
      sessionStorage.getItem('fileurl') &&
      sessionStorage.getItem('filename') &&
      sessionStorage.getItem('signature')
    ) {
      this.showmodelsign()

      // console.log("sdasds")
    }
    else {
      // console.log("sdasds2")
      let Data = JSON.parse(sessionStorage.getItem('Data') || '{}');
      this.agreestatus = false
      this.signaturestatus = true
      // alert(this.bankdetailsverify)

      if (this.bankpayForm.valid) {
        const extraInvalid = this.validateExtraBank();
        if (extraInvalid.length > 0) {
          this.missingInformation = true;
          this.missingInfo = extraInvalid;
          return;
        }

        let addressobject = {
          address1:
            this.bankpayForm.get('bankstreetaddress')?.value ||
            Data.street_address_line1 ||
            '',
          address2:
            this.bankpayForm.get('bankstreetaddressline2')?.value ||
            Data.street_address_line2 ||
            '',
          apt: this.bankpayForm.get('bankaptcheck')?.value || Data.apt || '',
          city: this.bankpayForm.get('bankcity')?.value || Data.city || '',
          province:
            this.bankpayForm.get('bankprovince')?.value || Data.province || '',
          postalCode:
            this.bankpayForm.get('bankpostalcode')?.value ||
            Data.postal_code ||
            '',
          phone: Data.phone_number,
          email: Data.email,
        };

        let bankAddress = this.bankverifyDetails.address;

        let bankAdressArr = bankAddress.split(',');

        let bankCity = bankAdressArr[bankAdressArr.length - 2].replace(' ', '');

        let provincePostal = bankAdressArr[bankAdressArr.length - 1];

        let provincePostalArr = provincePostal.split(' ');

        let bankProvince = provincePostalArr[provincePostalArr.length - 3];

        let bankPostalCode =
          provincePostalArr[provincePostalArr.length - 2] +
          ' ' +
          provincePostalArr[provincePostalArr.length - 1];

        let bankobject = {
          name: this.bankverifyDetails.bank.name,
          address: this.bankverifyDetails.bank.address.split(',')[0],
          city: bankAdressArr[bankAdressArr.length - 2].replace(' ', ''),
          province: provincePostalArr[provincePostalArr.length - 3],
          postalCode:
            provincePostalArr[provincePostalArr.length - 2] +
            ' ' +
            provincePostalArr[provincePostalArr.length - 1],
        };

        let inputData1 = {
          bankCode: this.bankpayForm.get('banknumber')?.value,
          branchCode: this.bankpayForm.get('transitnumber')?.value,
          accountNumber: this.bankpayForm.get('accountnumber')?.value,
        };

        // ////this.consoleMessage(this.bankfile)
        // this.bankfile[0].name ="test.pdf"
        var fileExtension = '.' + this.bankfile.name.split('.').pop();

        // event.target.files[0].name ="void_cheque_"+Date.now()+fileExtension
        var encBank = btoa(JSON.stringify(inputData1));
        var formData: any = new FormData();
        formData.append('firstName', Data.firstName);
        formData.append('lastName', Data.lastName);
        formData.append('address', JSON.stringify(addressobject));
        formData.append('bank', JSON.stringify(bankobject));
        formData.append(
          'files',
          this.bankfile,
          'void_cheque_' + Date.now() + fileExtension.toLowerCase()
        );
        // formData.append("files", this.bankfile.name,"void.pdf");
        formData.append('session', encBank) || '';
        formData.append('timestamp', new Date().getTime());

        // ////this.consoleMessage(formData)
        // ////this.consoleMessage(this.bankfile)

        let activity: any = {};
        activity.action = 'Step 2 of 7 - Generating pad agreement';
        activity.url = environment.app.grp + '/api/customer/generatePAD';
        activity.requestMethod = 'POST';
        activity.requestBody = formData;

        this._SignupformService
          .padaddgrementdetails(formData)
          .subscribe((result: any) => {
            if (result.status == '200') {
              activity.status = 'SUCCESS';
              activity.response = result;
              activity.responseSummary = 'Successfully pad agreement has been generated';
              // this.buildActivityLogObject(activity, true);

              this.padAggrementModel = true
              this.generatePADaggrement = result.data.url

              // jQuery("#PADpafaggrement-modal").modal("show");

              sessionStorage.setItem('fileurl', result.data.url);
              sessionStorage.setItem('filename', result.data.filename);
              // this.showPADModelDiaslog =true
              // this.header = "PAD Agreement"
              // this.pdfData =result.data.url
            } else {
              activity.status = 'FAILURE';
              activity.response = result;
              activity.responseSummary = 'Error generating pag agreement';
              // this.buildActivityLogObject(activity, true);


              this.ShowModelPopup = true
              this.ShowModelPopupMessage = result.message
                ? result.message
                : result.error
              this.ShowModelPopupTitle = this.lang.Info
            }
          });
      } else {
        this.bankpayForm.markAllAsTouched();
        this.validateExtraBank();
      }
    }

    // this.createCutomerPADagreement(data)
  }

  public agreepadconditions() {
    this.acceptaggrepad = false
    this.padaggrementerror = ""
    this.padAggrementFinalModel = false
    this.signaturestatus = false
    this.agreestatus = false
    this.rejectPADModel = false
    this.closePADModel = true
    this.showagree = false
    // jQuery("#PADpafaggrement1-modal").modal("hide");

    // this.acceptaggrepad = false
    // this.padaggrementerror =""
    // this.showagree =false
    // this.showReject =false
    // this.showClose =true
  }
  public closePADAdggrementModel() {
    this.padAggrementModel = false
    this.padAggrementFinalModel = false
  }

  public rejectPADpafaggrement() {
    this.acceptaggrepad = true
    // this.padaggrementerror = "Please check the PAD aggrement"

    this.padAggrementModel = false
    this.padAggrementFinalModel = false

  }
  public rejectPADpafaggrement1() {
    this.acceptaggrepad = true
    // this.padaggrementerror = "Please check the PAD aggrement"

    this.padAggrementModel = false
    this.padAggrementFinalModel = false

  }
  public signaturestartmodel() {
    // jQuery("#drawsignaturemodel-modal").modal("show");
    this.signModelForBankPay = true
    // this.clearPadSignature();
    this.generatePADaggrement = ""
    // this.acceptaggrepad ==true
  }


  public saveIAFGsignature() {
    // this.padaggrementerror =""
    this.signatureNeeded = this.signaturePad.isEmpty();
    if (this.signatureNeeded == false) {
      const base64Data = this.signaturePad.toDataURL();
      // console.log(base64Data);
      sessionStorage.setItem("Spousesignature", base64Data);
      this.showSpouseSignature = false
    }
    else {
      sessionStorage.setItem("Spousesignature", "");
      this.showIAFGerrorMessage = true
    }


  }
  public savePadsignature() {
    this.acceptaggrepad = false
    // this.padaggrementerror =""
    this.signatureNeeded = this.signaturePad.isEmpty();
    if (this.signatureNeeded == false) {
      const base64Data = this.signaturePad.toDataURL();
      // console.log(base64Data);
      sessionStorage.setItem("signature", base64Data);
    }
    else {
      sessionStorage.setItem("signature", "");
      this.showpaderrorMessage = true
    }
    setTimeout(() => {
      if (sessionStorage.getItem("signature")) {
        // if(sessionStorage.getItem("signature") && sessionStorage.getItem("signature")?.length>0){
        this.signModelForBankPay = false

        setTimeout(() => {
          this.padAggrementModel = false
          this.showmodelsign();

          // console.log("test")
        }, 10);
      }
      else {
        // this.signaturemessagepad = true;
        // this.signaturePad.clear();

        // console.log("tetshere")
      }
    }, 100);

  }
  // <!-- [class.text-green-700]="activeTab === i"
  // [class.animate-pluse]="activeTab === i"
  // [class.bg-green-200]="activeTab === i"

  public creditcardpaysubmit(value: any, value1: any) {

    this.signatureNeeded = this.signaturePad.isEmpty();
    if (this.signatureNeeded == false) {

      const base64Data = this.signaturePad.toDataURL();
      // console.log(base64Data);
      sessionStorage.setItem("signature", base64Data);
      this.signaturemessagecc = false

    }
    else {
      sessionStorage.setItem("signature", "");

      this.signaturemessagecc = true

    }
    let inputData = JSON.parse(sessionStorage.getItem("Data") || '{}');

    if (sessionStorage.getItem("Spousesignature")) {
      inputData.spouseSignature = sessionStorage.getItem("Spousesignature")
    }

    inputData.signature = sessionStorage.getItem("signature") || "";

    let iafgData = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    let iafgTermplanCheck = iafgData.filter((p: any) => p.planLevel == 44);

    if (iafgTermplanCheck.length > 0 || this.showBenificiaryFormCond) {

      if (this.addbenificaryData.length > 0) {
        this.benficiary = false;

        const validateBeneficiaries = this.addbenificaryData.reduce((acc: any, obj: any) => {
          const compositeKey = `${obj.customerType}_${obj.type}`;
          if (!acc[compositeKey]) {
            acc[compositeKey] = 0;
          }
          acc[compositeKey] += parseFloat(obj.percentage);
          return acc;
        }, {});

        let beneficiaryError = "";
        for (const key in validateBeneficiaries) {
          if (validateBeneficiaries.hasOwnProperty(key)) {
            const [customerType, type] = key.split("_");
            console.log(`The customerType ${customerType} and type ${type} with perc: ${validateBeneficiaries[key]}`);

            if (validateBeneficiaries[key] != 100) {
              beneficiaryError += `CustomerType ${customerType} and type ${type} has percentage issue. \n`
            }
          }
        }




        if (beneficiaryError != "") {
          this.benficiaryCount = true
          this.benficiaryCountMessage = this.lang.Distributed_percentages_must_equal_100_and_not_more
          return false;
        }

        else {
          this.benficiary = false

          if (this.addbenificaryData && this.addbenificaryData.length > 0) {
            this.addbenificaryData =
              this.addbenificaryData
                .map((v: any) => ({
                  ...v, contactDetails: {
                    contingentBeneficiary: {

                      firstName: v.contingentFirstName,

                      lastName: v.contingentLastName,

                    }
                  }, trusteeDetails: {
                    firstName: v.trusteeFirstName || "",
                    lastName: v.trusteeLastName || "",
                  }
                }))
            inputData.havingBeneficiaries = true
          }
          else {
            this.benficiary = true;

            return false;
          }
          inputData.beneficiariesDetails = this.addbenificaryData

        }


      }


      else {
        this.benficiary = true;
        if (this.addbenificaryData.length > 0) {

        } else {
          this.showBenificiaryForm = true
        }


        return false;

      }

    } else {
      // this.gotosumamrypageLogic()
    }
    let provincelist = JSON.parse(sessionStorage.getItem("provincelist") || "");

    if (provincelist.includes(inputData.province_id)) {
    } else {
      // if (this.formConfigResult.assign_default_form == true) {
      if (this.formConfigResult.brokershipTransferFeature && this.formConfigResult.assign_default_form == true) {


        inputData.formId = this.formConfigResult.default_form.id;
        inputData.brokershipTransfered = true;
        inputData.originalFormId = this.formConfigResult.form.id;
      } else {
        inputData.brokershipTransfered = false;
      }
    }

    if (sessionStorage.getItem("fusebillCustomerAddressId")) {
      inputData.fusebillCustomerAddressId =
        sessionStorage.getItem("fusebillCustomerAddressId") || null;
    }
    if (
      sessionStorage.getItem("fusebillCustomerId")
    ) {
      inputData.fusebillCustomerId =
        sessionStorage.getItem("fusebillCustomerId") || null;
    }
    if (
      sessionStorage.getItem("fusebillCustomerBillingAddressId")
    ) {
      inputData.fusebillCustomerBillingAddressId =
        sessionStorage.getItem("fusebillCustomerBillingAddressId") || null;
    }
    if (
      sessionStorage.getItem("customerId")
    ) {
      inputData.customerId = sessionStorage.getItem("customerId") || null;
      // inputData.billing_address.customer_id= parseInt(sessionStorage.getItem("customerId")) || null
    }
    inputData.billing_sameas_homeAddress =
      sessionStorage.getItem("homeAddress") == "true" ? true : false;

    if (sessionStorage.getItem("homeAddress") == "true") {
      inputData.billing_address = {
        // "customer_id": parseInt(sessionStorage.getItem("customerId")) || null,
        // "fusebill_customer_id": parseInt(sessionStorage.getItem("fusebillCustomerId")) || null,
        line1: inputData.street_address_line1 || "",
        line2: inputData.street_address_line2 || "",
        city: inputData.city || "",
        state: inputData.province || "",
        state_id: parseInt(this.provineList.id), // this.fusebillid = parseInt(element.fusebillId);
        // ostate_id:this.state_id
        fusebillStateId: parseInt(this.provineList.fusebillId),
        fusebillCountryId: 124,
        country: "Canada",
        country_id: 1,
        // ocountry_id: 1,
        postal_zip: inputData.postal_code || "",
        apt: inputData.apt || "",
      };
    } else {
      inputData.billing_address = {
        // "customer_id": parseInt(sessionStorage.getItem("customerId")) || null,
        // "fusebill_customer_id": parseInt(sessionStorage.getItem("fusebillCustomerId")) || null,
        line1: this.paymentForm.get("streetaddress")?.value || "",
        line2: this.paymentForm.get("streetaddressline2")?.value || "",
        city: this.paymentForm.get("city")?.value || "",
        state: this.paymentForm.get("province")?.value || "",
        state_id: parseInt(this.provineListcreditPayment.id), // this.fusebillid = parseInt(element.fusebillId);
        // ostate_id:this.state_id
        fusebillStateId: parseInt(this.provineListcreditPayment.fusebillId),
        fusebillCountryId: 124,
        country: "Canada",
        country_id: 1,
        // ocountry_id: 1,
        postal_zip: this.paymentForm.get("postalcode")?.value || "",
        apt: this.paymentForm.get("aptcheck")?.value || "",
      };
    }

    if (
      sessionStorage.getItem("customerId") &&
      sessionStorage.getItem("fusebillCustomerId")
    ) {
      inputData.billing_address.customer_id =
        parseInt(sessionStorage.getItem("customerId") || '0') || 0;
      inputData.billing_address.fusebill_customer_id =
        parseInt(sessionStorage.getItem("fusebillCustomerId") || '0') || 0;
    }

    // ////this.consoleMessage(inputData);

    if (this.paymentForm.invalid) {
      const invalid = [];
      this.paymentForm.markAllAsTouched();
      const controls: any = this.paymentForm.controls;
      for (let name in controls) {
        //this.consoleMessage(name)
        if (controls[name].invalid) {

          const paymentMethod = this.paymentForm.get('paymentRadioCheck')?.value;
          if (name == "CardNumber") {
            if (paymentMethod === 'PAD') continue;
            name = this.lang.Enter_Card_Number || 'Enter Card Number';
          }
          if (name == "ExpirationMonth") {
            if (paymentMethod === 'PAD') continue;
            name = this.lang.Select_Expiry_Month || 'Select Expiry Month';
          }
          if (name == "ExporationYear") {
            if (paymentMethod === 'PAD') continue;
            name = this.lang.Select_Expiry_Year || 'Select Expiry Year';
          }
          if (name == "cvv") {
            if (paymentMethod === 'PAD') continue;
            name = this.lang.Enter_CVV || 'Enter CVV';
          }
          if (name == "FirstName") {
            name = this.lang.Enter_First_Name || 'Enter First Name';
          }
          if (name == "LastName") {
            name = this.lang.Enter_Last_Name || 'Enter Last Name';
          }
          if (name == "paymentRadioCheck") {
            name = this.lang.Select_Payment_Method || 'Select Payment Method';
          }
          if (name == "streetaddress") {
            name = this.lang.Enter_Street_Address;
          }
          if (name == "city") {
            name = this.lang.Enter_City;
          }
          if (name == "province") {
            name = this.lang.Select_Province;
          }
          if (name == "postalcode") {
            name = this.lang.Enter_Postal_Code;
          }
          if (name == "recaptchaReactive") {
            name = this.lang.Select_Recaptcha;
          }

          if (!name) continue;
          invalid.push(name);
        }

      }
      this.missingInformation = true
      this.missingInfo = invalid;
      //this.consoleMessage(invalid)
      return invalid;
    }
    if (this.signatureNeeded == true) {
      const invalid = [];
      invalid.push("Draw the Signature");
      this.missingInformation = false

      this.missingInfo = invalid;
      //this.consoleMessage(invalid)
      return invalid;
    }
    if (this.paymentForm.valid && this.signatureNeeded === false) {
      const cardNum = this.paymentForm.controls['CardNumber'].value?.replace(/\s+/g, '');
      const cardData: any = {
        cardNumber: cardNum,
        month: this.paymentForm.controls['ExpirationMonth'].value,
        year: this.paymentForm.controls['ExporationYear'].value,
      };
      const authData = {
        clientKey: environment.app.clientKey,
        apiLoginID: environment.app.apiLoginID
      };
      const secureData = { cardData, authData };
      const dateValue: any = this?.userForm?.controls['planEnrollmentDate'].value;
      // Same YYYY-MM-DD result, without depending on the browser locale and without the
      // UTC/local shift that new Date() applies to a date-only string.
      const formattedDate = toApiDate(dateValue);

      let recordId: any = null;
      let customerProfileId = '-9999';
      let customerPaymentProfileId = '-9999';

      const proceedToLogin = (res2: any = {}) => {
        customerProfileId = res2?.customerProfileId ?? customerProfileId;
        customerPaymentProfileId = res2?.customerPaymentProfileId ?? customerPaymentProfileId;

        inputData.authorizenetCustomerId = customerProfileId;
        inputData.authorizenetPaymentId = customerPaymentProfileId;
        inputData.paymentPlatform = "AuthorizeNet";

        inputData.fusebill_customer_id = inputData.fusebill_customer_id ?? 0;
        inputData.fusebillCustomerId = inputData.fusebillCustomerId ?? 0;

        let loginObservable: any;
        if (environment.app.authorizeNet) {
          sessionStorage.setItem('v5Api', 'true')
          sessionStorage.setItem('authorizenetCustomerId', customerProfileId)
          sessionStorage.setItem('authorizenetPaymentId', customerPaymentProfileId);
          sessionStorage.setItem('paymentPlatform', 'AuthorizeNet')
           sessionStorage.setItem('isVikingSignup', 'true')
           inputData.formType = this.currFormType;
          loginObservable = this._SignupformService.genericLoginV5(inputData)
        } else {
          loginObservable = this._SignupformService.login1(inputData);
        }

        loginObservable.subscribe((result: any) => {
          if (result.status === "200") {
            sessionStorage.removeItem("paymentfail");

            const customerId = result.data.customer.id;

            // if (recordId) {
            //   this._SignupformService.updateAuthorizeNetCustomerId(recordId, customerId).subscribe(
            //     (resp) => console.log("Customer ID updated:", resp),
            //     (err) => console.error("Update customerId failed:", err)
            //   );
            // }

            if (result.data.customer.fusebill) {
              sessionStorage.setItem("fusebillCustomerId", result.data.customer.fusebill.customerId);
              sessionStorage.setItem("publicApiKey", result.data.customer.fusebill.publicApiKey);
              sessionStorage.setItem("fusebillCustomerAddressId", result.data.customer.fusebill.customerAddressId || '');
              sessionStorage.setItem("fusebillCustomerBillingAddressId", result.data.customer.fusebill.customerBillingAddressId || '');
            }

            sessionStorage.setItem("userKey", result.data.userKey);
            sessionStorage.setItem("customerId", result.data.customer.id);
            sessionStorage.setItem("normalcustomerid", result.data.customer.id);
            sessionStorage.setItem("enrollmentdate", inputData.planEnrollmentDate);

            this.submitClaimsDepositInfo();


            fetch(`${environment.app.adminPortal}/api/ap/global/set-adminAdvisors`);
            fetch(`${environment.app.adminPortal}/api/ap/global/set-adminMembers`);

            setTimeout(() => {
              if (environment.app.authorizeNet == true) {
                this.http.post(environment.app.authorizePortal + 'api/authorize-net/update-profile', {
                  customerId: result.data.customer.id,
                  customerProfileId: res2?.customerProfileId,
                  email: this.paymentForm?.value?.email ?? ''
                }).subscribe((response: any) => {
                  if (response.status == 200) {
                    console.log(response)
                  } else {
                    this.ShowModelPopup = true;
                    this.ShowModelPopupTitle = 'Info';
                    this.ShowModelPopupMessage = response.message
                  }
                }, (error: any) => {
                  if ([0, 500, 501, 502, 503].includes(error.status)) {
                    this.ShowModelPopup = true
                    this.ShowModelPopupMessage = this.lang?.Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience ?? 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.';
                    this.ShowModelPopupTitle = this.lang?.Info ?? 'Info'
                  }
                  else {
                    this.ShowModelPopup = true
                    this.ShowModelPopupMessage = error.message ?? 'Unable to Update customer Profile'
                    this.ShowModelPopupTitle = this.lang.Info ?? 'Info'
                  }
                })

                let inputData = {
                  customerId: result.data.customer.id,
                  cc: (cardData.cardNumber)?.toString()?.slice(-4),
                  timestamp: Date.now()?.toString(),
                  expiry: cardData.month?.toString() + '/20' + cardData.year?.toString(),
                };

                var ccSessionDetails = btoa(JSON.stringify(inputData));
                console.log('inputData', inputData);
                console.log('ccSessionDetails', ccSessionDetails);

                // let success = res2.customerPaymentProfileId ? 'True' : 'False';
                // let customerId = res2.customerProfileId ?? 0;
                // window.location.href = environment.app.globalgrp + `#/payment/form?customerId=${customerId}&paymentMethod=CC&success=${success}`;

                this.http.post(environment.app.grp + '/api/authorizenet-payment/details', {
                  customerId: result.data.customer.id,
                  session: ccSessionDetails
                }).subscribe((response: any) => {
                  if (response.status == 200) {
                    console.log(response)
                  } else {
                    let success = res2.customerPaymentProfileId ? 'True' : 'False';
                    let customerId = res2.customerProfileId ?? 0;
                    window.location.href = environment.app.globalgrp + `#/payment/form?customerId=${customerId}&paymentMethod=CC&success=${success}`;
                  }
                }, (error: any) => {
                  if ([0, 500, 501, 502, 503].includes(error.status)) {
                    this.ShowModelPopup = true
                    this.ShowModelPopupMessage = this.lang?.Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience ?? 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.';
                    this.ShowModelPopupTitle = this.lang?.Info ?? 'Info'
                  }
                  else {
                    let success = res2.customerPaymentProfileId ? 'True' : 'False';
                    let customerId = res2.customerProfileId ?? 0;
                    window.location.href = environment.app.globalgrp + `#/payment/form?customerId=${customerId}&paymentMethod=CC&success=${success}`;
                  }
                })
              } else {
                value1.submit();
              }
            }, 100);
          } else {
            this.ShowModelPopup = true;
            this.ShowModelPopupMessage = result.message;
            this.ShowModelPopupTitle = this.lang.Info;
          }
        }, (error: any) => {
          this.ShowModelPopup = true;
          this.ShowModelPopupMessage = error.error?.message || error.error?.error || 'Login failed';
          this.ShowModelPopupTitle = this.lang.Info;
        });
      };

      Accept.dispatchData(secureData, (response: any) => {
        console.log(cardData, authData, response);

        if (response.messages.resultCode !== "Ok") {
          console.error("Accept.js dispatch failed:", response.messages.message);
          // Swal.fire({
          //       title: "Error",
          //       text: response.messages ? response.messages.message : response.error,
          //       icon: "error",
          //       width: "30%",
          //       showCancelButton: false,
          //       confirmButtonText: "Ok",
          //     });

          this.ShowModelPopup = true
          this.ShowModelPopupMessage = response.message ? response.messages.message : response.error;
          this.ShowModelPopupTitle = 'Error';
          proceedToLogin();
          return;
        }

        const opaqueData = response.opaqueData;
        const formData = this.paymentForm.value;

        const profileInfo = { email: formData.email };
        this._SignupformService.authorizeProfileCreation(profileInfo).subscribe({
          next: (res1: any) => {
            customerProfileId = res1.customerProfileId;
            const paymentInfo = {
              opaqueDataDescriptor: opaqueData.dataDescriptor,
              opaqueDataValue: opaqueData.dataValue,
              firstName: formData.FirstName,
              lastName: formData.LastName,
              address: `${formData.streetaddress} ${formData.streetaddressline2}`,
              city: formData.city,
              state: formData.province,
              zip: formData.postalcode,
              country: "Canada",
              customerProfileId: res1.customerProfileId,
              phoneNumber: this.userForm.get("phone_number")?.value?.replace(/^1/, ''),
            };

            this._SignupformService.authorizePaymentProfileCreation(paymentInfo).subscribe({
              next: (res2: any) => {
                sessionStorage.setItem('v5Api', 'true')
                customerPaymentProfileId = res2.customerPaymentProfileId;
                sessionStorage.setItem('authorizenetCustomerId', res2.customerProfileId);
                sessionStorage.setItem('authorizenetPaymentId', res2.customerPaymentProfileId);
                sessionStorage.setItem('payment', "CC");

                value1.authorizenetCustomerId = res2.customerProfileId;
                value1.authorizenetPaymentId = res2.customerPaymentProfileId;

                proceedToLogin(res2);
                // const enrollmentDate = new Date(inputData.planEnrollmentDate);
                // const today = new Date(); today.setHours(0, 0, 0, 0);
                // const authDate = new Date(enrollmentDate);
                // authDate.setDate(enrollmentDate.getDate() - 5);

                // const authorizeReq: any = {
                //   customerProfileId: res2.customerProfileId,
                //   paymentProfileId: res2.customerPaymentProfileId,
                //   amount: this.planAmount.toString(),
                //   authDate: (enrollmentDate < today ? enrollmentDate : authDate).toISOString().split('T')[0],
                //   authTransId: "",
                //   captureDate: enrollmentDate.toISOString().split('T')[0],
                //   captureTransId: "",
                //   status: "Pending"
                // };

                // this._SignupformService.authorizeNetPaymentRecord(authorizeReq).subscribe({
                //   next: (resp3: any) => {
                //     recordId = resp3.id;

                //     // If backdated, charge now
                //     if (enrollmentDate < today) {
                //       let updatePayload: any = {
                //         customerProfileId: res2.customerProfileId,
                //         paymentProfileId: res2.customerPaymentProfileId,
                //         amount: this.planAmount.toString(),
                //       };

                //       this._SignupformService.authorizeChargeNow(updatePayload).subscribe({
                //         next: (res4: any) => {
                //           updatePayload.status = "Captured";
                //           updatePayload.captureTransId = res4.toString();

                //           this._SignupformService.updateAuthorizeNetRecord(recordId, updatePayload).subscribe(
                //             () => {
                //               const emailPayload = {
                //                 from: "admin@aitestpro.com",
                //                 to: "naina.thapar@ideabytes.com",
                //                 subject: "Payment successful",
                //                 body: "Thank you for your payment.",
                //                 cc: [], bcc: [], isHtml: true
                //               };
                //               this._SignupformService.sendEmail(emailPayload).subscribe();
                //             },
                //             (err) => {console.error("Error updating payment record:", err);
                //               Swal.fire({
                //                 title: "Error: Updating Record failed",
                //                 text: err,
                //                 icon: "error",
                //                 width: "30%",
                //                 showCancelButton: false,
                //                 confirmButtonText: "Ok",
                //               });
                //             }
                //           );
                //         },
                //         error: (err) => {
                //           console.error("Charge now failed:", err);
                //           updatePayload.status = "Failed";
                //           Swal.fire({
                //             title: "Error",
                //             text: err,
                //             icon: "error",
                //             width: "30%",
                //             showCancelButton: false,
                //             confirmButtonText: "Ok",
                //           });

                //           this._SignupformService.updateAuthorizeNetRecord(recordId, updatePayload).subscribe();
                //           const emailPayload = {
                //             from: "admin@aitestpro.com",
                //             to: "naina.thapar@ideabytes.com",
                //             subject: "Payment failed",
                //             body: "We’re sorry, but your payment could not be processed. Please login to your portal and try again.",
                //             cc: [], bcc: [], isHtml: true
                //           };
                //           this._SignupformService.sendEmail(emailPayload).subscribe();
                //           alert("Payment failed. Please try again or contact support.");
                //         }
                //       });
                //     }

                //     proceedToLogin();
                //   },
                //   error: (err) => {
                //     console.error("authorizeNetPaymentRecord failed", err);
                //     Swal.fire({
                //       title: "Error: Payment record creation failed",
                //       text: err,
                //       icon: "error",
                //       width: "30%",
                //       showCancelButton: false,
                //       confirmButtonText: "Ok",
                //     });
                //     proceedToLogin();
                //   }
                // });
              },
              error: (err) => {
                console.error("authorizePaymentProfileCreation failed", err);
                // Swal.fire({
                //   title: "Error: Payment Profile Creation failed",
                //   text: err,
                //   icon: "error",
                //   width: "30%",
                //   showCancelButton: false,
                //   confirmButtonText: "Ok",
                // });

                this.ShowModelPopup = true
                this.ShowModelPopupMessage = err;
                this.ShowModelPopupTitle = 'Error';
                proceedToLogin();
              }
            });
          },
          error: (err) => {
            console.error("authorizeProfileCreation failed", err);
            // Swal.fire({
            //   title: "Error: authorizeProfileCreation failed",
            //   text: err,
            //   icon: "error",
            //   width: "30%",
            //   showCancelButton: false,
            //   confirmButtonText: "Ok",
            // });

            this.ShowModelPopup = true
            this.ShowModelPopupMessage = err;
            this.ShowModelPopupTitle = 'Error';
            proceedToLogin();
          }
        });

      });

    }

    else {
      // this.paymentForm.markAsAllTouched();

      if (this.signaturecheckcc == true) {
        this.signaturemessagecc = true;
      }



    }
  }
  public onDateChange(evnt: any) {
    console.log(evnt)
    this.trusteeCheck = false
    let date: any = this.adult(evnt)

    if (this.isInitialLoad) {
      this.isInitialLoad = false; // Prevents it from running on initialization
      this.trusteeCheck = false
      return;
    }
    console.log(date)
    if (this.benficiaryForm.value.relationship == "CHILD" && evnt) {

      if (!date) {
        console.log("test")
        this.trusteeCheck = true
        // this.benficiaryForm.get('isMinor')?.setValidators(Validators.required);
        // this.benficiaryForm.get('isMinor')?.updateValueAndValidity();
        // this.benficiaryForm.get('dob')?.setValidators(Validators.required);
        // this.benficiaryForm.get('dob')?.updateValueAndValidity();

        this.benficiaryForm.get('trusteeFirstName')?.setValidators(Validators.required);
        this.benficiaryForm.get('trusteeFirstName')?.updateValueAndValidity();


        this.benficiaryForm.get('trusteeLastName')?.setValidators(Validators.required);
        this.benficiaryForm.get('trusteeLastName')?.updateValueAndValidity();

        this.benficiaryForm.get('trusteeRelation')?.setValidators(Validators.required);
        this.benficiaryForm.get('trusteeRelation')?.updateValueAndValidity();
      } else {
        this.trusteeCheck = false
        // this.benficiaryForm.get('dob')?.reset();
        this.benficiaryForm.get('trusteeFirstName')?.reset();
        this.benficiaryForm.get('trusteeLastName')?.reset();
        this.benficiaryForm.get('trusteeRelation')?.reset();


        // this.benficiaryForm.get('dob')?.clearValidators();
        // this.benficiaryForm.get('dob')?.updateValueAndValidity();

        this.benficiaryForm.get('trusteeFirstName')?.clearValidators();
        this.benficiaryForm.get('trusteeFirstName')?.updateValueAndValidity();


        this.benficiaryForm.get('trusteeLastName')?.clearValidators();
        this.benficiaryForm.get('trusteeLastName')?.updateValueAndValidity();


        this.benficiaryForm.get('trusteeRelation')?.clearValidators();
        this.benficiaryForm.get('trusteeRelation')?.updateValueAndValidity()


      }
    }

  }
  public bankpayformsubmit(value: any) {
    let inputData = JSON.parse(sessionStorage.getItem("Data") || '{}');

    if (sessionStorage.getItem("Spousesignature")) {
      inputData.spouseSignature = sessionStorage.getItem("Spousesignature")
    }
    inputData.signature = sessionStorage.getItem("signature") || "";

    let provincelist = JSON.parse(sessionStorage.getItem("provincelist") || "");
    // ['trusteeDetails']={'firstName':'','lastName':''}

    let iafgData = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    let iafgTermplanCheck = iafgData.filter((p: any) => p.planLevel == 44);

    if (iafgTermplanCheck.length > 0 || this.showBenificiaryFormCond) {

      if (this.addbenificaryData.length > 0) {
        this.benficiary = false;

        const validateBeneficiaries = this.addbenificaryData.reduce((acc: any, obj: any) => {
          const compositeKey = `${obj.customerType}_${obj.type}`;
          if (!acc[compositeKey]) {
            acc[compositeKey] = 0;
          }
          acc[compositeKey] += parseFloat(obj.percentage);
          return acc;
        }, {});

        let beneficiaryError = "";
        for (const key in validateBeneficiaries) {
          if (validateBeneficiaries.hasOwnProperty(key)) {
            const [customerType, type] = key.split("_");
            console.log(`The customerType ${customerType} and type ${type} with perc: ${validateBeneficiaries[key]}`);

            if (validateBeneficiaries[key] != 100) {
              beneficiaryError += `CustomerType ${customerType} and type ${type} has percentage issue. \n`
            }
          }
        }




        if (beneficiaryError != "") {
          this.benficiaryCount = true
          this.benficiaryCountMessage = this.lang.Distributed_percentages_must_equal_100_and_not_more
          return false;
        }

        else {
          this.benficiary = false

          if (this.addbenificaryData && this.addbenificaryData.length > 0) {
            this.addbenificaryData =
              this.addbenificaryData
                .map((v: any) => ({
                  ...v, contactDetails: {
                    contingentBeneficiary: {

                      firstName: v.contingentFirstName,

                      lastName: v.contingentLastName,

                    }
                  }, trusteeDetails: {
                    firstName: v.trusteeFirstName || "",
                    lastName: v.trusteeLastName || "",
                    relationship: v.trusteeRelation || "",
                  }
                }))
            inputData.havingBeneficiaries = true
          }
          else {
            this.benficiary = true;

            return false;
          }
          inputData.beneficiariesDetails = this.addbenificaryData

        }


      }


      else {
        this.benficiary = true;
        if (this.addbenificaryData.length > 0) {

        } else {
          this.showBenificiaryForm = true
        }


        return false;

      }

    } else {
      // this.gotosumamrypageLogic()
    }

    // console.log(this.addbenificaryData)

    // return false
    if (provincelist.includes(inputData.province_id)) {
    } else {
      // if (this.formConfigResult.assign_default_form == true) {
      if (this.formConfigResult.brokershipTransferFeature && this.formConfigResult.assign_default_form == true) {

        // alert("1");
        inputData.formId = this.formConfigResult.default_form.id;
        inputData.brokershipTransfered = true;
        inputData.originalFormId = this.formConfigResult.form.id;
      } else {
        inputData.brokershipTransfered = false;
      }
    }

    if (
      sessionStorage.getItem("fusebillCustomerAddressId")
    ) {
      inputData.fusebillCustomerAddressId =
        sessionStorage.getItem("fusebillCustomerAddressId") || null;
    }
    if (
      sessionStorage.getItem("fusebillCustomerId")
    ) {
      inputData.fusebillCustomerId =
        sessionStorage.getItem("fusebillCustomerId") || null;
    }
    if (
      sessionStorage.getItem("fusebillCustomerBillingAddressId")
    ) {
      inputData.fusebillCustomerBillingAddressId =
        sessionStorage.getItem("fusebillCustomerBillingAddressId") || null;
    }
    if (
      sessionStorage.getItem("customerId")
    ) {
      inputData.customerId = sessionStorage.getItem("customerId") || null;
    }
    inputData.billing_sameas_homeAddress =
      sessionStorage.getItem("homeAddress") == "true" ? true : false;

    if (sessionStorage.getItem("homeAddress") == "true") {
      inputData.billing_address = {
        // "customer_id": parseInt(sessionStorage.getItem("customerId")) || null,
        // "fusebill_customer_id": parseInt(sessionStorage.getItem("fusebillCustomerId")) || null,
        line1: inputData.street_address_line1,
        line2: inputData.street_address_line2,
        city: inputData.city,
        state: "BC",
        state_id: parseInt(this.provineList.id), // this.fusebillid = parseInt(element.fusebillId);
        fusebillStateId: parseInt(this.provineList.fusebillId),
        fusebillCountryId: 124,
        country: "Canada",
        country_id: 1,
        // ocountry_id: 1,
        postal_zip: inputData.postalcode,
        apt: inputData.apt || "",
      };
    } else {

      //this.consoleMessage(this.paymentForm)
      inputData.billing_address = {
        line1: this.bankpayForm.get("bankstreetaddress")?.value || "",
        line2: this.bankpayForm.get("bankstreetaddressline2")?.value || "",
        city: this.bankpayForm.get("bankcity")?.value || "",
        state: this.bankpayForm.get("bankprovince")?.value || "",
        state_id: parseInt(this.provineListPayment.id),
        fusebillStateId: parseInt(this.provineListPayment.fusebillId),
        fusebillCountryId: 124,
        country: "Canada",
        country_id: 1,
        // ocountry_id: 1,
        postal_zip: this.bankpayForm.get("bankpostalcode")?.value,
        apt: this.bankpayForm.get("bankaptcheck")?.value || "",
      };
    }

    if (
      sessionStorage.getItem("customerId") &&
      sessionStorage.getItem("fusebillCustomerId")
    ) {
      inputData.billing_address.customer_id =
        parseInt(sessionStorage.getItem("customerId") || "0") || 0;
      inputData.billing_address.fusebill_customer_id =
        parseInt(sessionStorage.getItem("fusebillCustomerId") || "0") || 0;


    }
    if (this.acceptaggrepad == true) {
      this.padaggrementerror = this.lang.Please_check_the_PAD_agreement
    }
    else {
      this.padaggrementerror = ""
    }
    if (this.bankpayForm.invalid) {
      // this.bankpayForm.markAsTouched();
      this.bankpayForm.markAllAsTouched();
      const invalid: any = [];
      const controls: any = this.bankpayForm.controls;
      for (let name in controls) {
        //this.consoleMessage(name)
        if (controls[name].invalid) {

          if (name == "banknumber") {
            name = this.lang.Enter_Bank_Number || 'Enter Bank Number';
          }
          if (name == "transitnumber") {
            name = this.lang.Enter_Transit_Number || 'Enter Transit Number';
          }
          if (name == "accountnumber") {
            name = this.lang.Enter_Account_Number || 'Enter Account Number';
          }
          if (name == "bankname") {
            name = this.lang.Verify_the_bank_details || 'Verify the Bank Details';
          }
          if (name == "voidcheck") {
            name = this.lang.Uplaod_VoidCheck || 'Upload Void Cheque';
          }
          if (name == "bankstreetaddress") {
            name = this.lang.Enter_Street_Address || 'Enter Street Address';
          }
          if (name == "bankcity") {
            name = this.lang.Enter_City || 'Enter City';
          }
          if (name == "bankprovince") {
            name = this.lang.Select_Province || 'Select Province';
          }
          if (name == "bankpostalcode") {
            name = this.lang.Enter_Postal_Code || 'Enter Postal Code';
          }
          if (name == "recaptchaReactive") {
            name = this.lang.Select_Recaptcha || 'Select Recaptcha';
          }

          if (!name) continue;
          invalid.push(name);
        }

      }
      // Also include extra bank fields if invalid
      const extraBankInvalid = this.validateExtraBank();
      invalid.push(...extraBankInvalid);
      // jQuery("#missingInfo-modal").modal("show");
      this.missingInformation = true
      this.missingInfo = invalid;
      //this.consoleMessage(invalid)
      return invalid;
    }
    if (this.acceptaggrepad == true) {
      const invalid = [];
      invalid.push("Accept the PAD");
      // jQuery("#missingInfo-modal").modal("show");
      this.missingInformation = true
      this.missingInfo = invalid;
      //this.consoleMessage(invalid)
      return invalid;
    }

    if (this.bankpayForm.valid && this.cartcheckvalue == false) {
      let enrollmentData = {
        "customerName": inputData.firstName + "" + inputData.lastName,
        "contactNum": inputData.phone_number,
        "dob": inputData.date_of_birth,
        "email": inputData.email,
        "process": "enrollmentSummary",
        "request": {
          "paymentMethod": "PAD", "signature": sessionStorage.getItem("signature") || "", "bankCode": this.bankpayForm.get("banknumber")?.value,
          "branchCode": this.bankpayForm.get("transitnumber")?.value, "voidcheque": this.imagedisplay
        }
      }

      console.log('inputData', JSON.stringify(inputData));
      //create authorization net profile
      const profileInfo = {
        email: inputData.email,
        // firstName: inputData.firstName,
        //     lastName: inputData.lastName,
        //     address: this.bankpayForm.get("bankstreetaddress")?.value || "" + ' ' + this.bankpayForm.get("bankstreetaddressline2")?.value || "",
        //     city: this.bankpayForm.get("bankcity"),
        //     state: this.bankpayForm.get("bankprovince"),
        //     zip: this.bankpayForm.get("bankpostalcode"),
        //     country: "Canada",
        //     phoneNumber: inputData?.phone_number ?? inputData?.get("phone_number")?.value?.replace(/^1/, '') ?? '',
      };


      this._SignupformService.savePlan(enrollmentData).subscribe((result: any) => {
        //this.consoleMessage(result)
      }, (error: any) => {
        console.log('Error occurred:', error);

        // create object for report log
        let currentTimeStamp = new Date().getTime().toString();
        let log = {
          api: environment.app.grp + "api/common/customer/transaction",
          payload: JSON.stringify(enrollmentData),
          message: `Trying to submit transaction api enrollmentSummary ${currentTimeStamp}`,
          portal: 'Gig Signup form'
        }
        let obj = {
          customerDetails: JSON.stringify({ username: inputData.email, timeStamp: sessionStorage.getItem('timeStamp') }),
          logs: JSON.stringify(log),
        };
        this._SignupformService.submitReportLog(environment.app.commonurl, obj);
      })
      let loginObservable: Observable<any>;

      if (environment.app.authorizeNet) {
        sessionStorage.setItem('v5Api', 'true')
        loginObservable = this._SignupformService.authorizeProfileCreation(profileInfo).pipe(
          switchMap((res: any) => {
            inputData.authorizenetCustomerId = res?.customerProfileId;
            inputData.authorizenetPaymentId = '';
            inputData.paymentPlatform = 'AuthorizeNet';

            sessionStorage.setItem('authorizenetCustomerId', res?.customerProfileId)
            sessionStorage.setItem('authorizenetPaymentId', '');
            sessionStorage.setItem('paymentPlatform', 'AuthorizeNet')
             sessionStorage.setItem('isVikingSignup', 'true')
            console.log("Authorize Net profile created successfully!!", res);
            inputData.formType = this.currFormType;
            return this._SignupformService.genericLoginV5(inputData);
          })
        );
      } else {
        loginObservable = this._SignupformService.login1(inputData);
      }

      loginObservable.subscribe((result: any) => {
        // this._SignupformService.login1(inputData).subscribe(
        // (result: any) => {

        if (result.status == "200") {
          sessionStorage.removeItem("paymentfail");
          // this.planssummary = JSON.parse(
          //   sessionStorage.getItem("plansummary")
          // );
          // let obj = {};

          // this.planstab = 0;
          // this.cartamount = true;
          // ////this.consoleMessage(result.data.province);
          if (result.data.customer.fusebill) {
            sessionStorage.setItem(
              "fusebillCustomerId",
              result.data.customer.fusebill.customerId
            );
            sessionStorage.setItem(
              "publicApiKey",
              result.data.customer.fusebill.publicApiKey
            );
            if (result.data.customer.fusebill.customerAddressId) {
              sessionStorage.setItem(
                "fusebillCustomerAddressId",
                result.data.customer.fusebill.customerAddressId
              );
            }
            if (result.data.customer.fusebill.customerBillingAddressId) {
              sessionStorage.setItem(
                "fusebillCustomerBillingAddressId",
                result.data.customer.fusebill.customerBillingAddressId
              );
            }
          }
          sessionStorage.setItem("userKey", result.data.userKey);
          sessionStorage.setItem("customerId", result.data.customer.id);
          // sessionStorage.setItem("publicApiKey",result.data.customer.fusebill.publicApiKey)
          sessionStorage.setItem("normalcustomerid", result.data.customer.id);
          sessionStorage.setItem(
            "enrollmentdate",
            inputData.planEnrollmentDate
          );

          this.submitClaimsDepositInfo();

          this.customerid = result.data.customer.fusebill.customerId;
          this.publicapikey = result.data.customer.fusebill.publicApiKey;

          if (environment.app.authorizeNet) {
            this.http.post(environment.app.authorizePortal + 'api/authorize-net/update-profile', {
              customerId: result.data.customer.id,
              customerProfileId: sessionStorage.getItem('authorizenetCustomerId') ?? '',
              email: this.paymentForm?.value?.email ?? ''
            }).subscribe((response: any) => {
              if (response.status == 200) {
                console.log(response)
              } else {
                this.ShowModelPopup = true;
                this.ShowModelPopupTitle = 'Info';
                this.ShowModelPopupMessage = response.message
              }
            }, (error: any) => {
              if ([0, 500, 501, 502, 503].includes(error.status)) {
                this.ShowModelPopup = true
                this.ShowModelPopupMessage = this.lang?.Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience ?? 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.';
                this.ShowModelPopupTitle = this.lang?.Info ?? 'Info'
              }
              else {
                this.ShowModelPopup = true
                this.ShowModelPopupMessage = error.message ?? 'Unable to Update customer Profile'
                this.ShowModelPopupTitle = this.lang.Info ?? 'Info'
              }
            })
          }

          setTimeout(() => {

            // if(this.validateaddresscheck==true){
            //   this.validateaddress(this.paymentForm.value,"1")

            // }
            // else{
            this.bankformsubmitdetails();
            // }
          }, 100);
        }
        else if (result.status == "206") {
          this.ShowModelPopup = true
          this.ShowModelPopupMessage = result.message
          this.ShowModelPopupTitle = this.lang.Info


        }

        else {
          if (result.error || result.errors) {

            this.ShowModelPopup = true
            this.ShowModelPopupMessage = result.error ? result.error[0].value : result.errors[0].value,
              this.ShowModelPopupTitle = this.lang.Info


          }
          else {

            this.ShowModelPopup = true
            this.ShowModelPopupMessage = result.data.message
            this.ShowModelPopupTitle = this.lang.Info

          }



        }

      },
        (error) => {
          if ([0, 500, 501, 502, 503].includes(error.status)) {

            this.ShowModelPopup = true
            this.ShowModelPopupMessage = this.lang?.Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience ?? 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.';
            this.ShowModelPopupTitle = this.lang?.Info ?? 'Info'


          }
          else {

            this.ShowModelPopup = true
            this.ShowModelPopupMessage = error.error.message ? error.error.message : error.error.error,
              this.ShowModelPopupTitle = this.lang.Info


          }
        }
      );
    }
    else {
      this.bankpayForm.markAllAsTouched();
      // this.bankpayForm.get("banknumber").markAsTouched();
      // this.bankpayForm.get("transitnumber").markAsTouched();
      // this.bankpayForm.get("accountnumber").markAsTouched();
      // this.bankpayForm.get("voidcheck").markAsTouched();
      // this.bankpayForm.get("checkbankdetails").markAsTouched();
      // this.bankpayForm.get("bankaptcheck").markAsTouched();
      // this.bankpayForm.get("bankstreetaddress").markAsTouched();
      // this.bankpayForm.get("bankcity").markAsTouched();
      // this.bankpayForm.get("bankprovince").markAsTouched();
      // this.bankpayForm.get("bankpostalcode").markAsTouched();

      if (this.signaturecheck == true) {
        this.signaturemessage = true;
      }
      // this.bankpayForm.get("recaptchaReactive").markAsTouched();
      if (this.cartcheckvalue == true) {
        this.ShowModelPopup = true
        this.ShowModelPopupMessage = this.lang.Please_check_the_Plan_Selection_Page
        this.ShowModelPopupTitle = this.lang.Info



      }
      // this.bankscrollToFirstInvalidControl();
    }
  }

  public bankformsubmitdetails() {
    var formData: any = new FormData();

    let personalInfo = JSON.parse(sessionStorage.getItem("Data") || '{}');

    let bankinputData = {
      bankCode: this.bankpayForm.get("banknumber")?.value,
      branchCode: this.bankpayForm.get("transitnumber")?.value,
      bankName: this.bankpayForm.get("bankname")?.value,
      accountNumber: this.bankpayForm.get("accountnumber")?.value,
    };


    ////this.consoleMessage(sessionStorage.getItem("totalAmount"))
    // ////this.consoleMessage(this._decimalPipe.transform(sessionStorage.getItem("totalAmount"),"1.2-2"))
    // ////this.consoleMessage(this._decimalPipe.transform(parseInt(sessionStorage.getItem("totalAmount")),"1.2-2"))
    // ////this.consoleMessage(this._decimalPipe.transform(parseFloat(sessionStorage.getItem("totalAmount")),"1.2-2"))
    let inputData = {
      customerId: parseInt(sessionStorage.getItem("normalcustomerid") || '0'),
      bankCode: this.bankpayForm.get("banknumber")?.value,
      branchCode: this.bankpayForm.get("transitnumber")?.value,
      accountNumber: this.bankpayForm.get("accountnumber")?.value,

      amount: this._decimalPipe.transform(sessionStorage.getItem("totalAmount"), "1.2-2")?.replace(/,/g, ""),
      totalAmount: this._decimalPipe.transform(sessionStorage.getItem("totalAmount"), "1.2-2")?.replace(/,/g, ""),

      totalAmountUI: sessionStorage.getItem("totalAmountUI"),
      enrollmentDate: sessionStorage.getItem("enrollmentdate"),
      customerName: personalInfo.firstName + " " + personalInfo.lastName,
    };

    ////this.consoleMessage(inputData)

    var encBank = btoa(JSON.stringify(inputData));
    // formData.append("session", encBank);
    // formData.append("timestamp",new Date().getTime());
    // formData.append("files", this.bankfile);

    // ////this.consoleMessage(this.bankfile)

    sessionStorage.setItem("session", encBank);

    this.submitClaimsDepositInfo();

    let link = sessionStorage.getItem("formlink")

    // this.router.navigate([link+"/paymentResponse"]);
    this.router.navigate(["/payment/form"]);

    return false;

  }
  getTabClass(index: any): object {

    //     if(this.visitedTabs.has(index) && this.activeTab !== index){
    //       return 'bg-green-700'
    // }
    //     if(this.visitedTabs.has(index) && this.activeTab !== index){
    //       return 'text-white'
    //     }
    //     if(this.activeTab <index){
    //       return 'bg-gray-700'
    //     }
    //     if(this.activeTab === index){
    //       return 'border-b-2 border-green-700'
    //     }


    return {
      'text-white': this.visitedTabs.has(index) && this.activeTab !== index,
      'border-b-2 border-green-700': this.activeTab === index,

      'bg-green-700': this.visitedTabs.has(index) && this.activeTab !== index,


    };
    // 'bg-gray-200': this.activeTab <index,
    // return {
    //   'bg-green-300 text-green': this.activeTab === index,
    //   'bg-gray-200 text-black': this.activeTab !== index,
    //   'border-b-2 border-green-700': this.activeTab === index,
    //   'hover:bg-green-300': this.activeTab !== index,
    //   'bg-green-700': this.visitedTabs.has(index) && this.activeTab !== index && this.activeTab,  // Custom style for visited tabs

    // };
    // if (index === this.activeTab) {
    //   return 'text-green-700 animate-pulse bg-green-200'; // Active tab
    // } else if (index === this.previousTab) {
    //   return 'bg-green-700 text-white'; // Previous tab
    // } else {
    //   return 'bg-gray-300'; // Other tabs
    // }
  }

  // getTabClass(index: number) {
  //   return this.activeTab === index ? 'bg-blue-500 text-black' : 'bg-green-700 text-white';
  // }
  numbersOnly(event: any) {
    const key = event.key || String.fromCharCode(event.keyCode);
    // Check if the key is an alphabetical character (A-Z or a-z) or a space
    if (/(^[0-9 \-]+$)/.test(key)) {
      return true;
    } else {
      return false;
    }
  }
  decimalNumberOnly(event: any) {
    const key = event.key || String.fromCharCode(event.keyCode);
    // Check if the key is an alphabetical character (A-Z or a-z) or a space
    if (/^[0-9.\- ]+$/.test(key)) {
      return true;
    } else {
      return false;
    }
  }
  public checkDateOfBirthMinor(event: any) {


    // Completed years, parsed in local time (was a bare year subtraction on a UTC parse).
    const age = calculateAgeFrom(event.target.value) ?? -1;





    if (event.type === 'input') {
      if (event.target.value == '') {
        this.benficiaryForm.controls['dob'].reset();
        this.benficiaryForm.controls['dob'].markAsTouched();
      }
    } else {
      if (event.target.value == 'Invalid date') {
        this.benficiaryForm.controls['dob'].reset();
        this.benficiaryForm.controls['dob'].markAsTouched();
      }
      if (event.target.value == '') {
        this.benficiaryForm.controls['dob'].reset();
        this.benficiaryForm.controls['dob'].markAsTouched();
      }
    }
  }
  public checkDateOfBirth(event: any) {


    // Completed years, parsed in local time (was a bare year subtraction on a UTC parse).
    const age = calculateAgeFrom(event.target.value) ?? -1;



    if (age > 17 && age < 70) {
      console.log("true")
      this.memberDateofBirth = true
    } else {
      console.log("false")
      this.memberDateofBirth = false
    }

    if (event.type === 'input') {
      if (event.target.value == '') {
        this.userForm.controls['date_of_birth'].reset();
        this.userForm.controls['date_of_birth'].markAsTouched();
      }
    } else {
      if (event.target.value == 'Invalid date') {
        this.userForm.controls['date_of_birth'].reset();
        this.userForm.controls['date_of_birth'].markAsTouched();
      }
      if (event.target.value == '') {
        this.userForm.controls['date_of_birth'].reset();
        this.userForm.controls['date_of_birth'].markAsTouched();
      }
    }
  }
  public checkDateOfHire(event: any) {

    console.log(event.target.value)
    if (event.type === 'input') {
      if (event.target.value == '') {
        this.userForm.controls['date_of_hiring'].reset();
        this.userForm.controls['date_of_hiring'].markAsTouched();
      }
    }
    else {
      if (event.target.value == 'Invalid date') {
        this.userForm.controls['date_of_hiring'].reset();
        this.userForm.controls['date_of_hiring'].markAsTouched();
      }
      if (event.target.value == '') {
        this.userForm.controls['date_of_hiring'].reset();
        this.userForm.controls['date_of_hiring'].markAsTouched();
      }
    }

  }
  public checkDateOfArrival(event: any) {

    if (event.type === 'input') {
      if (event.target.value == '') {
        this.userForm.controls['dateOfArrival'].reset();
        this.userForm.controls['dateOfArrival'].markAsTouched();
      }
    }
    else {
      if (event.target.value == 'Invalid date') {
        this.userForm.controls['dateOfArrival'].reset();
        this.userForm.controls['dateOfArrival'].markAsTouched();
      }
      if (event.target.value == '') {
        this.userForm.controls['dateOfArrival'].reset();
        this.userForm.controls['dateOfArrival'].markAsTouched();
      }
    }
  }

  public checkSpouseDateofBirth(event: any) {
    if (event.type === 'input') {
      if (event.target.value == '') {
        this.userForm.controls['spousedateofbirth'].reset();
        this.userForm.controls['spousedateofbirth'].markAsTouched();
      }
    } else {
      if (event.target.value == 'Invalid date') {
        this.userForm.controls['spousedateofbirth'].reset();
        this.userForm.controls['spousedateofbirth'].markAsTouched();
      }
      if (event.target.value == '') {
        this.userForm.controls['spousedateofbirth'].reset();
        this.userForm.controls['spousedateofbirth'].markAsTouched();
      }
    }
  }
  public checkDateOfADependentArrival(event: any) {

    if (event.type === 'input') {
      if (event.target.value == '') {
        this.userForm.controls['dependentdateOfArrival'].reset();
        this.userForm.controls['dependentdateOfArrival'].markAsTouched();
      }
    } else {
      if (event.target.value == 'Invalid date') {
        this.userForm.controls['dependentdateOfArrival'].reset();
        this.userForm.controls['dependentdateOfArrival'].markAsTouched();
      }
      if (event.target.value == '') {
        this.userForm.controls['dependentdateOfArrival'].reset();
        this.userForm.controls['dependentdateOfArrival'].markAsTouched();
      }
    }
  }

  // public checkDateOfgraducation(event:any){
  //   if(event.target.value=="Invalid date"){
  //     this.childFormGroup.get('childInfoGraduationday').reset();
  //     this.childFormGroup.get('childInfoGraduationday').markAsTouched();
  //   }
  // }


  public selectplan(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    disallowedPlanLevels: any
  ) {

    console.log(product)

    if (options && options.length > 0) {
      let planOptionValues = options[0]?.planOptionsValues ?? []
      const newResult: any = this.groupClinicsByProvince(planOptionValues, this.validationInputData.province_id)
      options[0].planOptionsValues = newResult;
      sessionStorage.setItem('options', JSON.stringify(options));
      this.openplanoptions(elementcv)
    }

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    // if (options && options.length > 0) {
    //   let coverage = product.planCoverage;

    //   coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
    //     ? coverage
    //     : null;
    //   ////this.consoleMessage(obj)
    //   this.productobj = {
    //     id: product.id,
    //     productId: product.productId,
    //     name: product.name,
    //     planProductId: product.planProductId,
    //     price: this._decimalPipe
    //       .transform(product.price1 || product.price, '1.2-2')
    //       ?.replace(/,/g, ''),
    //     tax: this._decimalPipe
    //       .transform(
    //         product.calculatedTax ? product.calculatedTax.tax : 0,
    //         '1.2-2'
    //       )
    //       ?.replace(/,/g, ''),
    //     total: this._decimalPipe
    //       .transform(
    //         product.calculatedTax ? product.calculatedTax.total : 0,
    //         '1.2-2'
    //       )
    //       ?.replace(/,/g, ''),
    //     tax_details:
    //       product.bundledTaxes && product.bundledTaxes.length > 0
    //         ? product.bundledTaxes
    //         : product.taxesDataJSON,
    //     calculatedTax: product.calculatedTax,
    //     bundledProducts: product.bundledProducts,
    //     planCoverage: product.planCoverage,
    //     planLevel: product.planlevel ? product.planlevel.id : '',
    //     planLevelParent: product.planlevel ? product.planlevel.parentId : '',
    //     description: product.description,
    //     coverage: coverage,
    //   };

    //   let obj1: any = {
    //     packageId: plan.packageId,
    //     packageName: pckage.name,

    //     planproductname: this.productobj.name,

    //     groupid: plan.planLevel,
    //     groupName: group.name,
    //     id: plan.id,
    //     name: plan.name,
    //     planLevel: plan.planLevel ? plan.planLevel : group.id,
    //     planLevelParent: group.parentId,
    //     fusebillPlanID: plan.fusebillId,
    //     planFrequencyID: plan.frqMonthly,
    //     isBundle: plan.isBundle,
    //     coverage: coverage,
    //     planCoverage: product.planCoverage,
    //     bundledProducts: [],
    //     products: [],
    //   };
    //   obj1.products.push(this.productobj);
    //   this.planobjdata = obj1;

    //   this.openplanoptions(elementcv, options, plan, product);
    // }

    // else {


    let obj: any = {
      isBundle: plan.isBundle,
      disallowedPlanLevels: disallowedPlanLevels,
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.userForm.value.planEnrollmentDate
        ? this._CustomDatePipe.transform(
          this.userForm.value.planEnrollmentDate
        ) 
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(product.calculatedTax.price),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(product.calculatedTax.price),
      multiCountPlan: product?.multiCountPlan ?? false,
      amountUI:
        '$' +
        this._decimalPipe.transform(product.calculatedTax.price, '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      version: plan.version,
      description: plan.description,
      insuranceType: plan.insuranceType,
      //  "disallowedPlanLevels":plandetailsobj[11]
    };


    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      // productobj is what ends up as plan.products[0] in plansummary → plansummarymain →
      // allSelectedPlans. For a bundle the row's own `name` just repeats the plan name, so
      // use the coverage product instead. `product` here is the same coverage row the tile
      // renders, so planCoverageUI ("Single"/"Couple"/"Family") is always present even when
      // the API omits the nested product record — without it this fell back to plan.name.
      name: plan.isBundle
        ? (product?.product?.name ?? product?.planCoverageUI ?? plan.name)
        : product.name,
      planProductId: product.planProductId,
      price: this._decimalPipe
        .transform(product.price1 || product.price, '1.2-2')
        ?.replace(/,/g, ''),
      tax: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      total: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel ? product.planlevel.id : '',
      planLevelParent: product.planlevel ? product.planlevel.parentId : '',
      description: product.description,
      coverage: coverage,
    };

    let additionalDetails: any = {}

    if (product.newPlanTaxInfo && product.newPlanTaxInfo.componentsPricesTaxes) {
      let keys_ = this.Object.keys(product.newPlanTaxInfo.componentsPricesTaxes);
      for (const key_ of keys_) {
        if (product.newPlanTaxInfo.componentsPricesTaxes[key_]) {
          additionalDetails = product.newPlanTaxInfo.componentsPricesTaxes[key_]?.additionalDetails;
        }
      }
    }

    if (plan.name.toLowerCase().includes("regenalife")) {
      if (plan.jsonData && plan.jsonData.oneTimePaymentPlan) {
        obj['oneTimePaymentPlan'] = true
      }
      this.productobj['tax_details'].forEach((tax: any) => {
        tax['plan_product_id'] = additionalDetails?.oneTimePaymentPlan?.planProductId ?? additionalDetails?.planProductId;
      })
    }
    // else {
    //   this.productobj['tax_details'].forEach((tax: any) => {
    //     tax['plan_product_id'] = additionalDetails?.planProductId;
    //   })
    //   this.productobj['planProductId'] = additionalDetails?.planProductId;
    // }


  console.log("asdad3y",product)
    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: product?.product?.name ?? plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
    };
    obj1.products.push(this.productobj);
    console.log(obj1)
    console.log("called83883838", this.productobj)
    this.addtoplansummary(obj, obj1);
    setTimeout(() => {


      // this.openplanoptions(elementcv, options, plan, product)
      this.openplanoptions(elementcv)


    }, 1000);

    // }
  }


  public groupClinicsByProvince(clinics: any[], priorityProvinceId: number = 12) {
    // Separate clinics into priority province, other provinces, and null province
    const priorityClinics = clinics.filter(c => c.provinceId === priorityProvinceId);
    const otherClinics = clinics.filter(c => c.provinceId !== priorityProvinceId);
    //   const nullProvinceClinics = clinics.filter(c => c.provinceId === null);

    // // Sort other clinics by provinceId in ascending order
    // otherClinics.sort((a, b) => a.provinceId - b.provinceId);

    // Combine: priority province first, then other provinces by ID ascending, then null
    const result = [
      ...priorityClinics,
      ...otherClinics
    ];

    return result;
  }

  public unselectplan(elementcv: any) {

    // this.planCoverageName = ''
    // this.insuranceplanid =''
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj = {
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.userForm.value.planEnrollmentDate
        ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    this.removeplansummary(obj);
    setTimeout(() => {


      this.openplanoptions(elementcv)


    }, 1000);
  }
  public unselectplanLife(elementcv: any) {

    // this.planCoverageName = ''
    // this.insuranceplanid =''
    console.log(elementcv)

    let plandetails = elementcv.target.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj = {
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.userForm.value.planEnrollmentDate
        ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    this.removeplansummaryLife(obj);
  }
  public addtoplansummary(obj: any, obj1: any) {
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    //  console.log(obj1);
    // console.log(planSummary);
    // console.log('addroplansummaryplans');
    // console.log(planSummary.length);
    // console.log(obj.id);
    // console.log(obj);

    this.addtoslectplans(obj.id, planSummary.length);
    planSummary.push(obj);

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj['gstPrice'] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj['hstPrice'] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj['pstPrice'] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj['qstPrice'] = 0;
    }

    obj['taxUI'] = '';
    if (obj['gstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['gstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
          '&nbsp;(GST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['pstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['pstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
          '&nbsp;(PST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['qstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['qstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
          '&nbsp;(QST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['hstCheck']) {
      obj['taxUI'] += '<span> ';
      if (obj['hstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
          '&nbsp;(HST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (
      !obj['hstCheck'] &&
      !obj['gstCheck'] &&
      !obj['pstCheck'] &&
      !obj['qstCheck']
    ) {
      obj['taxUI'] += '<span>-';

      obj['taxUI'] += '</span>';
    }

    // ////this.consoleMessage(object["taxUI"])

    obj['tax'] = obj1.products
      ? obj1.products.reduce((acc: number, p: any) => {
        return acc + Number(p.tax);
      }, 0)
      : 0;
    obj['tax'] = this.floatPrice(obj['tax']);

    // obj["products"] =obj1
    obj['coverage'] = obj1.coverage;
    obj['planCoverage'] = obj1.planCoverage;
    obj['planLevelParent'] = obj1.planLevelParent;
    obj['planproductname'] = obj1.planproductname;

    obj['products'] = obj1.products;

    //this.consoleMessage(obj.planPrice)
    //this.consoleMessage(gstprice)
    //this.consoleMessage(hstprice)
    //this.consoleMessage(pstprice)

    //this.consoleMessage(qstprice)
    let pricecal = obj1.products.reduce((acc: any, calculatedTax: any) => {
      return acc + calculatedTax.total;
    }, 0);
    obj['totalPrice'] = parseFloat(pricecal);

    obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

    obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');

    //this.consoleMessage(obj1)

    obj['skuTotalPrice'] = parseFloat(obj1.products.reduce(
      (acc: any, calculatedTax: any) => {
        return acc + calculatedTax.total;
      },
      0
    ))

    let updatedSum = this.addtosum(obj.totalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
    sessionStorage.setItem(
      'plansummarymain',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'plansummaryopt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
    let planSummaryData = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    if (planSummary.length > 0 || planSummaryData.length > 0) {
      this.plansnexttab = false;

    } else {
      this.plansnexttab = true;
    }
    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {
      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      console.log(this.planssummarymain)
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        if (obj.planproductname.includes("La Vie")) {

          if (this.planssummarymain[i].planLevel == 18) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
              setTimeout(() => {
                plan.click()
                this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
              }, 1000);
            }
            break;
          }
          else {

            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelector(`#plancheck792`)
            const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

            console.log(plan)
            setTimeout(() => {
              plan.click()
              this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
            }, 1000);
          }
        }
      }

      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);

      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }, 100);
  }

   public isBundlePlan(plan: any) {
    return plan?.isBundle === true || plan?.isBundle === 'true';
  }


  public changeCartAmount() {
    var total = 0;
    for (let i = 0; i < this.planssummarymainLife.length; i++) {
      total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
    }

    for (let i = 0; i < this.planssummarymain.length; i++) {
      if (this.planssummarymain[i].multiCountPlan) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice) * this.medcanSubmitCount;
      } else {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
    }


    this.planAmount = this._decimalPipe
      .transform(total, '1.2-2')
      ?.replace(/,/g, '');
    sessionStorage.setItem('totalAmount', this.planAmount);

    if (this.planAmount > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }



  }
  public addtoplansummaryLife(obj: any, obj1: any) {
    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    // console.log(obj1);
    // console.log(planSummary);
    // console.log('addroplansummaryplans');
    // console.log(planSummary.length);
    // console.log(obj.id);
    // console.log(obj);

    this.addtoslectplansLife(obj.id, plansummaryLife.length);
    plansummaryLife.push(obj);

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj['gstPrice'] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj['hstPrice'] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj['pstPrice'] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj['qstPrice'] = 0;
    }

    obj['taxUI'] = '';
    if (obj['gstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['gstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
          '&nbsp;(GST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['pstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['pstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
          '&nbsp;(PST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['qstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['qstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
          '&nbsp;(QST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['hstCheck']) {
      obj['taxUI'] += '<span> ';
      if (obj['hstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
          '&nbsp;(HST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (
      !obj['hstCheck'] &&
      !obj['gstCheck'] &&
      !obj['pstCheck'] &&
      !obj['qstCheck']
    ) {
      obj['taxUI'] += '<span>-';

      obj['taxUI'] += '</span>';
    }

    // ////this.consoleMessage(object["taxUI"])

    obj['tax'] = obj1.products
      ? this._decimalPipe.transform(
        obj1.products?.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.tax;
        }, 0),
        '1.2-2'
      )
      : 0;
    obj['tax'] = this.floatPrice(obj['tax']);

    // obj["products"] =obj1
    obj['coverage'] = obj1.coverage;
    obj['planCoverage'] = obj1.planCoverage;
    obj['planLevelParent'] = obj1.planLevelParent;
    obj['planproductname'] = obj1.planproductname;

    obj['products'] = obj1.products;

    //this.consoleMessage(obj.planPrice)
    //this.consoleMessage(gstprice)
    //this.consoleMessage(hstprice)
    //this.consoleMessage(pstprice)

    //this.consoleMessage(qstprice)
    let pricecal = obj1.products.reduce((acc: any, calculatedTax: any) => {
      return acc + calculatedTax.total;
    }, 0);
    obj['totalPrice'] = parseFloat(pricecal);

    obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

    obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');

    //this.consoleMessage(obj1)

    obj['skuTotalPrice'] = parseFloat(obj1.products.reduce(
      (acc: any, calculatedTax: any) => {
        return acc + calculatedTax.total;
      },
      0
    ))

    let updatedSum = this.addtosum(obj.totalPrice);
    this.planssummarymainLife = [];
    this.planssummaryopt = [];

    plansummaryLife.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymainLife.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
    sessionStorage.setItem(
      'planssummarymainLife',
      JSON.stringify(this.planssummarymainLife)
    );
    sessionStorage.setItem(
      'plansummaryopt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));
    let planSummaryData = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    if (plansummaryLife.length > 0 || planSummaryData.length > 0) {
      this.plansnexttab = false;
    } else {
      this.plansnexttab = true;
    }
    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {
      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);

      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }, 100);
  }
  public removeplansummary(obj: any) {
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    console.log(obj);

    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }

    console.log(planSummary)


    if (planSummary) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplans(obj.id);
      ////this.consoleMessage(index)

      if (index > -1) {
        // console.log(index);
        planSummary.splice(index, 1);

      } else {
        return;
      }

      // ////this.consoleMessage(planSummary)
      // ////this.consoleMessage(planSummary.length)
      ////this.consoleMessage("beforeremoveplans")
      let selectedPlans = JSON.parse(
        sessionStorage.getItem('selectedPlans') || '[]'
      );
      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      ////this.consoleMessage("newselectedPlans")
      ////this.consoleMessage(newselectedplans)
      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));
      // this.removeslectplans(obj.id,planSummary.length)

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj['gstPrice'] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);
      } else {
        obj['hstPrice'] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);
      } else {
        obj['pstPrice'] = 0;
      }

      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj['qstPrice'] = 0;
      }
      obj['taxUI'] = '';
      if (obj['gstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['gstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
            '&nbsp;(GST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['pstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['pstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
            '&nbsp;(PST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['qstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['qstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
            '&nbsp;(QST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['hstCheck']) {
        obj['taxUI'] += '<span> ';
        if (obj['hstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
            '&nbsp;(HST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (
        !obj['hstCheck'] &&
        !obj['gstCheck'] &&
        !obj['pstCheck'] &&
        !obj['qstCheck']
      ) {
        obj['taxUI'] += '<span>-';

        obj['taxUI'] += '</span>';
      }

      // ////this.consoleMessage(object["taxUI"])

      obj['tax'] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      (obj['totalPrice'] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj['totalUI'] =
          '$' +
          this._decimalPipe.transform(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice,
            '1.2-2'
          ));

      obj['total'] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      sessionStorage.setItem(
        'plansummarymain',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'plansummaryopt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
      let planSummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

      if (planSummary.length > 0 || planSummaryLife.length > 0) {
        this.plansnexttab = false;
      } else {
        this.plansnexttab = true;
      }
      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }

    setTimeout(() => {
      // this.planssummarymain = JSON.parse(
      //   sessionStorage.getItem('plansummarymain') || '[]'
      // );

      // var total = 0;
      // for (let i = 0; i < this.planssummarymain.length; i++) {
      //   total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      // }

      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);
    }, 100);


    for (let i = 0; i < this.planssummarymain.length; i++) {
      if (this.planssummarymain[i].disallowedPlanLevels != null) {
        let disallowed_plans = this.planssummarymain[i].disallowedPlanLevels.split(',');
        const dom1: HTMLElement = this.elementRef.nativeElement;
        for (let i = 0; i < disallowed_plans.length; i++) {
          // console.log(disallowed_plans[i]);
          // console.log(disallowed_plans[i]);
          setTimeout(() => {
            let elem: any = dom1.querySelector(`#plancheck${disallowed_plans[i]}`)

            if (elem != null) {
              if (!elem.disabled) {

                elem.disabled = true
              }
            }
          }, 100);

        }
      }
    }

    this.changeCartAmount()
  }
  public removeplansummaryLife(obj: any) {

    console.log(obj)
    let planSummary = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    // console.log(planSummary);

    if (planSummary) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplansLife(obj.id);
      ////this.consoleMessage(index)

      if (index > -1) {

        planSummary.splice(index, 1);
        ////this.consoleMessage("afterremove")
        ////this.consoleMessage(planSummary)
      } else {
        return;
      }

      // ////this.consoleMessage(planSummary)
      // ////this.consoleMessage(planSummary.length)
      ////this.consoleMessage("beforeremoveplans")
      let selectedPlans = JSON.parse(
        sessionStorage.getItem('selectedPlans') || '[]'
      );
      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      ////this.consoleMessage("newselectedPlans")
      ////this.consoleMessage(newselectedplans)

      sessionStorage.setItem('selectedPlansLife', JSON.stringify(newselectedplans));
      // this.removeslectplans(obj.id,planSummary.length)

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj['gstPrice'] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);
      } else {
        obj['hstPrice'] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);
      } else {
        obj['pstPrice'] = 0;
      }

      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj['qstPrice'] = 0;
      }
      obj['taxUI'] = '';
      if (obj['gstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['gstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
            '&nbsp;(GST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['pstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['pstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
            '&nbsp;(PST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['qstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['qstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
            '&nbsp;(QST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['hstCheck']) {
        obj['taxUI'] += '<span> ';
        if (obj['hstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
            '&nbsp;(HST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (
        !obj['hstCheck'] &&
        !obj['gstCheck'] &&
        !obj['pstCheck'] &&
        !obj['qstCheck']
      ) {
        obj['taxUI'] += '<span>-';

        obj['taxUI'] += '</span>';
      }

      // ////this.consoleMessage(object["taxUI"])

      obj['tax'] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      (obj['totalPrice'] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj['totalUI'] =
          '$' +
          this._decimalPipe.transform(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice,
            '1.2-2'
          ));

      obj['total'] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymainLife = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymainLife.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      sessionStorage.setItem(
        'planssummarymainLife',
        JSON.stringify(this.planssummarymainLife)
      );
      sessionStorage.setItem(
        'plansummaryopt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('plansummaryLife', JSON.stringify(planSummary));
      let planSummaryData = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

      if (planSummary.length > 0 || planSummaryData.length > 0) {
        this.plansnexttab = false;
      } else {
        this.plansnexttab = true;
      }
      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }

    setTimeout(() => {
      // this.planssummarymain = JSON.parse(
      //   sessionStorage.getItem('plansummarymain') || '[]'
      // );

      // var total = 0;
      // for (let i = 0; i < this.planssummarymain.length; i++) {
      //   total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      // }

      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);
    }, 100);
  }
  public addtoslectplans(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeaddtoplans")
    ////this.consoleMessage(planid)
    ////this.consoleMessage(plansumamryindex)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.consoleMessage("afteraddtoplans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }
  public addtoslectplansLife(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeaddtoplans")
    ////this.consoleMessage(planid)
    ////this.consoleMessage(plansumamryindex)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlansLife') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.consoleMessage("afteraddtoplans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem('selectedPlansLife', JSON.stringify(selectedPlans));
  }
  public removeslectplans(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeremoveplans")
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );

    ////this.consoleMessage(selectedPlans)
    delete selectedPlans[planid];

    for (const planid in selectedPlans) {
      ////this.consoleMessage(planid)
      ////this.consoleMessage(selectedPlans[planid])

      if (selectedPlans[planid] != 0) {
        selectedPlans[planid] = selectedPlans[planid] - 1;
        if (selectedPlans[planid]) {
        }
      }
    }
    ////this.consoleMessage("adjustedselectedPlans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  public getslectedplans(planid: number) {
    ////this.consoleMessage(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    return selectedPlans[planid];
  }
  public getslectedplansLife(planid: number) {
    ////this.consoleMessage(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlansLife') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    return selectedPlans[planid];
  }
  public addtosum(amount: any) {
    //this.consoleMessage("addtosum"+amount)

    // amount = Math.round((amount + Number.EPSILON) * 100) / 100;

    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount') || '0.00'
    );

    selectedPlansAmount = selectedPlansAmount + parseFloat(amount);

    //this.consoleMessage("selectedPlansAmount"+selectedPlansAmount)
    sessionStorage.setItem(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '') ?? '0'
    );

    sessionStorage.setItem(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '')
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, '1.2-2')
      ?.replace(/,/g, '');

    return selectedPlansAmount;
  }

  public removetosum(amount: number) {
    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount')?.replace(/,/g, '') ?? '0'
    );

    selectedPlansAmount = selectedPlansAmount - amount;
    sessionStorage.setItem(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '') ?? '0'
    );
    sessionStorage.setItem(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '')
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, '1.2-2')
      ?.replace(/,/g, '');
    return selectedPlansAmount;
  }



  public openplanoptions(
    elementcv: any,

  ) {
    let plandetails = elementcv.attributes.data.value;
    console.log("plandetails12", plandetails)

    let plandetailsobj = plandetails.split('##');

    let modifiedOptions: any = [];



    let optionsValue = JSON.parse(sessionStorage.getItem('options') || '[]');


    console.log(optionsValue)
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    for (let i = 0; i < planSummary.length; i++) {

      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });

        optionsValue = filteredData


      }
      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });

        optionsValue = filteredData


      }

      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie") && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") || option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });

        optionsValue = filteredData


      }

    }

    // this.plandetailsobjvalue = plandetailsobj;
    //this.consoleMessage(plandetails)
    //this.consoleMessage(product.id)

    this.plandetailsobjvalue = plandetails.split("##");

    optionsValue.forEach((element: any) => {
      element.planOptionsValues.forEach((options: any) => {
        options.planOptionName = element.name;
        options.json = JSON.stringify(options);
      });

      modifiedOptions.push(element);
    });

    this.optionstitle = modifiedOptions;
    // alert("startrhetre")
    // jQuery("#showplanoptions-modal").modal("show");

    // this.planOptionsModel =true
  }

  public closeplanoptions() { }
  public capitalize(str: String) {
    if (str) {
      // return str.charAt(0).toUpperCase() + str.slice(1);
      const words = str.split(' ');

      let finalres: any = words.filter((v) => v != '');
      return finalres
        .map((word: any) => {
          return word[0].toUpperCase() + word.substring(1);
        })
        .join(' ');
    }
  }
  public capitalizeFirstLetter(str: String) {
    if (str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

    }
  }
  public closemissingInfoModel() {
    this.missingInformation = false
    this.missingInfo = []
  }


  getGroupedByProvince(clinics: any[]): any[] {
    if (!clinics || clinics.length === 0) {
      return [];
    }

    // Create a map to group clinics by province
    const provinceMap = new Map<number | null, any>();

    console.log(clinics)

    clinics.forEach(clinic => {
      const provinceId = clinic.provinceId;
      const provinceName = clinic.provinceName || 'Other';

      if (!provinceMap.has(provinceId)) {
        provinceMap.set(provinceId, {
          provinceId: provinceId,
          provinceName: provinceName,
          clinics: []
        });
      }

      provinceMap.get(provinceId)!.clinics.push(clinic);
    });

    // Convert map to array and sort by province name
    const groupedProvinces = Array.from(provinceMap.values());

    // // Sort provinces: null/Other at the end, rest alphabetically
    // groupedProvinces.sort((a, b) => {
    //   if (a.provinceId === null) return 1;
    //   if (b.provinceId === null) return -1;
    //   return a.provinceName.localeCompare(b.provinceName);
    // });

    // Sort clinics within each province by ordering field
    // groupedProvinces.forEach(province => {
    //   province.clinics.sort((a: any, b: any) => (a.ordering || 0) - (b.ordering || 0));
    // });


    let selectedProvince = this.validationInputData.province_id;

    // Sort the data array to put selected province first
    const sortedData = [...groupedProvinces].sort((a, b) => {
      // Handle "Other" province (null) - always put it last
      if (a.provinceId === null) return 1;
      if (b.provinceId === null) return -1;

      // Put selected province first
      if (a.provinceId === selectedProvince) return -1;
      if (b.provinceId === selectedProvince) return 1;

      // Keep original ordering for the rest
      return 0;
    });


    console.log(sortedData)

    return sortedData;
  }


  public closeoptionsselection() {
    // console.log(this.optionstitle)
    // Viking never opens the clinic options modal and owns planScopeDetails via the
    // "Add to plan" checkboxes, so this cleanup must not empty it.
    if(this.planScopeDetails && this.planScopeDetails.length >0 && this.currFormType !== 'viking'){
      for(const psd of this.planScopeDetails){
        if(!psd.options){
          if(this.currChildType == "SELF"){
            this.planScopeDetails = [];
          }else if(this.currChildType == "CHILDREN"){
            this.clinicSelection[this.currChildIndex] = 'yes';
          }else if(this.currChildType == "SPOUSE"){
            this.clinicSpouseSelection = 'yes'
          }else{
            this.planScopeDetails = [];
          }
        }
      }
    }
    this.planOptionsModel = false
    // let plandetailsobj = this.optionPlanDetailsObj.nativeElement.value.split("##");


    // const planCheck = this.renderer.selectRootElement("#plancheck" + plandetailsobj[7]);
    // // this.renderer.setProperty(planCheck, 'checked', false);
    // planCheck.click()


    // let optionumber = this.optionNumberInput.nativeElement.value;

    // this.planOptionsModel = false
    // for (let i = 1; i <= optionumber; i++) {
    //   // $(".optionselectionmethod-" + i + ":checked").prop("checked", false);
    //   const radioButton = this.renderer.selectRootElement(".optionselectionmethod-" + i + ":checked", true);
    //   this.renderer.setProperty(radioButton, 'checked', false);

    // }
  }
  public planoptionselection(event: any, optionvalue: any, optionid: any, optionvalueid: any, index: any, className: any) {

    let obj = {
      id: optionid,
    }

    this.planoptionsValues.push(obj)

    const radioButton = this.renderer.selectRootElement(".optionselectionmethod-" + optionid);
    this.renderer.setProperty(radioButton, 'checked', false);

    // $(".optionselectionmethod-" + optionid)
    //   .not(this)
    //   .prop("checked", false);

    const elements = document.querySelectorAll(`.${className}` + optionid);
    elements.forEach((element: Element) => {
      this.renderer.setProperty(element, 'checked', false);
    });
    // this.checkboxes.forEach((radioButton) => {
    //   const [currentGroupIndex] = radioButton.nativeElement.id
    //     .split('-')
    //     .slice(2)
    //     .map(Number);

    //     console.log("curreny"+currentGroupIndex)
    //     console.log("indexValle"+index)
    //     console.log("curremtoption"+currentOptionId)
    //     console.log("optionid"+optionid)

    //   if (currentGroupIndex === index+1 && currentOptionId === optionid) {
    //     radioButton.nativeElement.checked = false;
    //   }
    // });

    //   const radioButton:any = this.renderer.selectRootElement(".optionselectionmethod-" + optionid, true);
    //   console.log(radioButton)
    //   radioButton.forEach((element: HTMLElement) => {
    //    this.renderer.setProperty(element, 'checked', false);
    //  });

    // this.checkboxes.forEach((checkbox) => {
    //   const [currentGroupIndex, currentOptionId] = checkbox.nativeElement.id
    //   .split('-')
    //   .slice(2)
    //   .map(Number);

    // if (currentGroupIndex === groupIndex && currentOptionId == optionid) {
    //   checkbox.nativeElement.checked = false;
    // }
    // });
    //       console.log(this.checkboxes)
    //       this.checkboxes.forEach((radioButton) => {
    //         console.log(optionid)
    //         if (radioButton.nativeElement.id.split('-')
    //           .slice(2)
    //           .map(Number) === optionid) {

    //  }
    //       });


    const radioButtonID = this.renderer.selectRootElement("#planselectionvalue-" + optionvalueid + "-" + optionid, true);
    this.renderer.setProperty(radioButtonID, 'checked', true);




    // $("#planselectionvalue-" + optionvalueid + "-" + optionid).prop(
    //   "checked",
    //   true
    // );
    // console.log(this.planoptionsValues)
    this.optionmessage = "";
  }
  public confirmoptionsselection() {
    // let optionumber = $("#optionumber").val();
    // console.log(this.planoptionsValues)
    // if (this.planoptionsValues) {
    //   this.optionmessage = "Please select all plan options";
    //   return;
    // } else {
    //   this.optionmessage = "";
    // }

    let optionumber: any = this.optionNumberInput.nativeElement.value;
    //this.consoleMessage($("#plandetailsobj").val())

    // console.log(optionumber)

    let plandetailsobj = this.optionPlanDetailsObj.nativeElement.value.split("##");

    // console.log(optionumber)
    // console.log(plandetailsobj)

    let array = [];

    let optionarray = [];


    let checkvalue = true;

    //  let finalArray=   this.planoptionsValues.filter((p: any) => p.id == 1 && p.id==2);

    for (let i = 1; i <= optionumber; i++) {
      // console.log(this.renderer.selectRootElement(".optionselectionmethod-" + i +":checked").value)
      // checkvalue = checkvalue &&   this.renderer.selectRootElement(".optionselectionmethod-" + i +":checked").value;
      const dom: HTMLElement = this.elementRef.nativeElement;
      const selector = `.optionselectionmethod-${i}:checked`;
      const element = dom.querySelector(selector);

      if (!element) {
        checkvalue = false; // Set to false if any element is not checked
        break; // Exit the loop early since we found an unchecked element
      }
    }

    // for (let i = 1; i <= optionumber; i++) {
    //   // console.log(this.renderer.selectRootElement(".optionselectionmethod-" + i +":checked").value)
    //   // checkvalue = checkvalue &&   this.renderer.selectRootElement(".optionselectionmethod-" + i +":checked").value;
    //   const dom: HTMLElement = this.elementRef.nativeElement;
    //   const selector = `.optionselectionmethod-${i}:checked`;
    //   const element = dom.querySelector(selector);
    //   if (element) {
    //     checkvalue= true; // Return true immediately if an element is found and checked
    //   }
    //   else{
    //     checkvalue =false
    //   }
    // }



    if (!checkvalue) {
      this.optionmessage = this.lang.Please_select_all_plan_options;
      return;
    } else {
      this.optionmessage = "";
    }

    // jQuery("#showplanoptions-modal").modal("hide");

    this.planOptionsModel = false


    for (let i = 1; i <= optionumber; i++) {
      let optionobj: any = {};
      // console.log(this.planoptionsValues)
      let selectedOptionValues = JSON.parse(
        this.renderer.selectRootElement(".optionselectionmethod-" + i + ":checked").value
      );
      console.log("selectedOptionValues123: ",selectedOptionValues)

      // ////this.consoleMessage(selectedOptionValues)
      optionobj = selectedOptionValues;

      optionobj.name = selectedOptionValues.planOptionName;
      optionobj.value = selectedOptionValues.value;
      optionobj.planOptionsValueId = selectedOptionValues?.planOptionsValueId ?? selectedOptionValues?.id;

      optionarray.push(optionobj);
    }

    // let plandetailsobj = $("#plandetailsobj").val().split(",");

    let obj = {
      isBundle: "true",
      disallowedPlanLevels: plandetailsobj[22],

      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.userForm.value.planEnrollmentDate
        ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: optionarray || [],

      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
        // elementcv.checked =false
      }
    }

    let obj1 = {}
    //this.consoleMessage(obj)

    console.log(obj)
    console.log(this.planobjdata)

    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    for (let i = 0; i < planSummary.length; i++) {
      if (planSummary[i].planLevel == 18) {
        planSummary[i].options = obj.options
      }
    }

    console.log(planSummary)
    sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
    sessionStorage.setItem('plansummarymain', JSON.stringify(planSummary));
    // this.addtoplansummary(obj,this.planobjdata)




  }

  public confirmoptionsselectionV2(elem: any) {
    console.log("called3939")
    console.log(elem)
    this.planOptionsModel = false
    // let optionumber = $("#optionumber").val();
    // console.log(this.planoptionsValues)
    // if (this.planoptionsValues) {
    //   this.optionmessage = "Please select all plan options";
    //   return;
    // } else {
    //   this.optionmessage = "";
    // }

    // let optionumber: any = elem;
    // //this.consoleMessage($("#plandetailsobj").val())

    // // console.log(optionumber)

    // let plandetailsobj = this.optionPlanDetailsObj.nativeElement.value.split("##");

    // // console.log(optionumber)
    // // console.log(plandetailsobj)

    // let array = [];

    // let optionarray = [];


    // let checkvalue = true;

    // //  let finalArray=   this.planoptionsValues.filter((p: any) => p.id == 1 && p.id==2);

    // for (let i = 1; i <= optionumber; i++) {
    //   // console.log(this.renderer.selectRootElement(".optionselectionmethod-" + i +":checked").value)
    //   // checkvalue = checkvalue &&   this.renderer.selectRootElement(".optionselectionmethod-" + i +":checked").value;
    //   const dom: HTMLElement = this.elementRef.nativeElement;
    //   const selector = `.optionselectionmethod-${i}:checked`;
    //   const element = dom.querySelector(selector);

    //   if (!element) {
    //     checkvalue = false; // Set to false if any element is not checked
    //     break; // Exit the loop early since we found an unchecked element
    //   }
    // }

    // // for (let i = 1; i <= optionumber; i++) {
    // //   // console.log(this.renderer.selectRootElement(".optionselectionmethod-" + i +":checked").value)
    // //   // checkvalue = checkvalue &&   this.renderer.selectRootElement(".optionselectionmethod-" + i +":checked").value;
    // //   const dom: HTMLElement = this.elementRef.nativeElement;
    // //   const selector = `.optionselectionmethod-${i}:checked`;
    // //   const element = dom.querySelector(selector);
    // //   if (element) {
    // //     checkvalue= true; // Return true immediately if an element is found and checked
    // //   }
    // //   else{
    // //     checkvalue =false
    // //   }
    // // }



    // if (!checkvalue) {
    //   this.optionmessage = this.lang.Please_select_all_plan_options;
    //   return;
    // } else {
    //   this.optionmessage = "";
    // }

    // // jQuery("#showplanoptions-modal").modal("hide");



    // for (let i = 1; i <= optionumber; i++) {
    //   let optionobj: any = {};
    //   // console.log(this.planoptionsValues)
    //   let selectedOptionValues = JSON.parse(
    //     this.renderer.selectRootElement(".optionselectionmethod-" + i + ":checked").value
    //   );
    //   // console.log(selectedOptionValues)

    //   // ////this.consoleMessage(selectedOptionValues)
    //   optionobj = selectedOptionValues;

    //   optionobj.name = selectedOptionValues.planOptionName;
    //   optionobj.value = selectedOptionValues.value;
    //   optionobj.planOptionsValueId = selectedOptionValues.planOptionsValueId;

    //   optionarray.push(optionobj);
    // }

    // // let plandetailsobj = $("#plandetailsobj").val().split(",");

    // let obj = {
    //   isBundle: "true",
    //   disallowedPlanLevels: plandetailsobj[22],

    //   // enrollmentDate: moment(
    //   //   this.userForm.get("planenrollmentdate").value,
    //   //   "MM-DD-YYYY"
    //   // ).format("YYYY-MM-DD"),
    //   enrollmentDate: this.userForm.value.planEnrollmentDate
    //     ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
    //     : undefined,
    //   // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
    //   name: plandetailsobj[14],
    //   details: plandetailsobj[0],
    //   packagename: plandetailsobj[0],
    //   groupName: plandetailsobj[1],
    //   amount: parseFloat(plandetailsobj[3]),
    //   planCoverage: plandetailsobj[2],
    //   planPrice: parseFloat(plandetailsobj[3]),
    //   amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
    //   gst:
    //     plandetailsobj[4] == null ||
    //       plandetailsobj[4] == "" ||
    //       plandetailsobj[4] == undefined ||
    //       plandetailsobj[4] == "null"
    //       ? 0
    //       : parseFloat(plandetailsobj[4]),
    //   hst:
    //     plandetailsobj[5] == null ||
    //       plandetailsobj[5] == "" ||
    //       plandetailsobj[5] == undefined ||
    //       plandetailsobj[5] == "null"
    //       ? 0
    //       : parseFloat(plandetailsobj[5]),
    //   pst:
    //     plandetailsobj[6] == null ||
    //       plandetailsobj[6] == "" ||
    //       plandetailsobj[6] == undefined ||
    //       plandetailsobj[6] == "null"
    //       ? 0
    //       : parseFloat(plandetailsobj[6]),
    //   qst:
    //     plandetailsobj[17] == null ||
    //       plandetailsobj[17] == "" ||
    //       plandetailsobj[17] == undefined ||
    //       plandetailsobj[17] == "null"
    //       ? 0
    //       : parseFloat(plandetailsobj[17]),
    //   gstCheck:
    //     plandetailsobj[4] == null ||
    //       plandetailsobj[4] == "" ||
    //       plandetailsobj[4] == undefined ||
    //       plandetailsobj[4] == "null"
    //       ? false
    //       : true,
    //   hstCheck:
    //     plandetailsobj[5] == null ||
    //       plandetailsobj[5] == "" ||
    //       plandetailsobj[5] == undefined ||
    //       plandetailsobj[5] == "null"
    //       ? false
    //       : true,
    //   pstCheck:
    //     plandetailsobj[6] == null ||
    //       plandetailsobj[6] == "" ||
    //       plandetailsobj[6] == undefined ||
    //       plandetailsobj[6] == "null"
    //       ? false
    //       : true,
    //   qstCheck:
    //     plandetailsobj[17] == null ||
    //       plandetailsobj[17] == "" ||
    //       plandetailsobj[17] == undefined ||
    //       plandetailsobj[17] == "null"
    //       ? false
    //       : true,
    //   id: parseFloat(plandetailsobj[7]),
    //   fusebillPlanID:
    //     plandetailsobj[8] == null ||
    //       plandetailsobj[8] == "" ||
    //       plandetailsobj[8] == undefined ||
    //       plandetailsobj[8] == "null"
    //       ? 0
    //       : parseFloat(plandetailsobj[8]),
    //   planFrequencyID:
    //     plandetailsobj[9] == null ||
    //       plandetailsobj[9] == "" ||
    //       plandetailsobj[9] == undefined ||
    //       plandetailsobj[9] == "null"
    //       ? 0
    //       : parseFloat(plandetailsobj[9]),
    //   optIn: plandetailsobj[10] == "true" ? true : false,
    //   planname: plandetailsobj[14],
    //   planLevel: parseInt(plandetailsobj[15]),
    //   packageId: parseInt(plandetailsobj[16]),
    //   options: optionarray || [],

    //   //  "disallowedPlanLevels":plandetailsobj[11]
    // };
    // if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
    //   if (plandetailsobj[11].includes(plandetailsobj[12])) {
    //     // elementcv.checked =false
    //   }
    // }

    // let obj1 = {}
    // //this.consoleMessage(obj)

    // console.log(obj)
    // console.log(this.planobjdata)

    // let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    // for (let i = 0; i < planSummary.length; i++) {
    //   if (planSummary[i].planLevel == 18) {
    //     planSummary[i].options = obj.options
    //   }
    // }

    // console.log(planSummary)
    // sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
    // sessionStorage.setItem('plansummarymain', JSON.stringify(planSummary));
    // this.addtoplansummary(obj,this.planobjdata)




  }

  public showvoidcheckpreview() {
    this.imageDisplayShow = true

  }
  public closeImagePreview() {
    this.imageDisplayShow = false
  }

  public async creditcardpaysubmit2(value: any, value1: any) {
    this.signatureNeeded = this.signaturePad.isEmpty();
    if (this.signatureNeeded == false) {
      const base64Data = this.signaturePad.toDataURL();
      // console.log(base64Data);
      sessionStorage.setItem("signature", base64Data);
      this.signaturemessagecc = false
    }
    else {
      sessionStorage.setItem("signature", "");
      this.signaturemessagecc = true
    }
    let inputData = JSON.parse(sessionStorage.getItem("Data") || '{}');

    if (sessionStorage.getItem("Spousesignature")) {
      inputData.spouseSignature = sessionStorage.getItem("Spousesignature")
    }

    inputData.signature = sessionStorage.getItem("signature") || "";

    let iafgData = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
    let iafgTermplanCheck = iafgData.filter((p: any) => p.planLevel == 44);

    if (iafgTermplanCheck.length > 0 || this.showBenificiaryFormCond) {
      if (this.addbenificaryData.length > 0) {
        this.benficiary = false;

        const validateBeneficiaries = this.addbenificaryData.reduce((acc: any, obj: any) => {
          const compositeKey = `${obj.customerType}_${obj.type}`;
          if (!acc[compositeKey]) {
            acc[compositeKey] = 0;
          }
          acc[compositeKey] += parseFloat(obj.percentage);
          return acc;
        }, {});

        let beneficiaryError = "";
        for (const key in validateBeneficiaries) {
          if (validateBeneficiaries.hasOwnProperty(key)) {
            const [customerType, type] = key.split("_");
            console.log(`The customerType ${customerType} and type ${type} with perc: ${validateBeneficiaries[key]}`);

            if (validateBeneficiaries[key] != 100) {
              beneficiaryError += `CustomerType ${customerType} and type ${type} has percentage issue. \n`
            }
          }
        }

        if (beneficiaryError != "") {
          this.benficiaryCount = true
          this.benficiaryCountMessage = this.lang.Distributed_percentages_must_equal_100_and_not_more
          return false;
        }

        else {
          this.benficiary = false

          if (this.addbenificaryData && this.addbenificaryData.length > 0) {
            this.addbenificaryData = this.addbenificaryData.map((v: any) => ({
              ...v,
              contactDetails: {
                contingentBeneficiary: {
                  firstName: v.contingentFirstName,
                  lastName: v.contingentLastName,
                }
              },
              // additionalDetails
              additionalDetails: {
                email: v.email,
                phoneNumber: v.phone_number
              },
              trusteeDetails: {
                firstName: v.trusteeFirstName || "",
                lastName: v.trusteeLastName || "",
              }
            })
            )
            inputData.havingBeneficiaries = true
          }
          else {
            this.benficiary = true;
            return false;
          }
          inputData.beneficiariesDetails = this.addbenificaryData
        }
      } else {
        this.benficiary = true;
        if (this.addbenificaryData.length > 0) {

        } else {
          this.showBenificiaryForm = true
        }
        return false;
      }

      if (this.smokerDetails) {
        // means there is data
        inputData.smoker = this.smokerDetails.smoker == "true" ? true : false
        inputData.earningsFrequency = this.smokerDetails.earningsFrequency
        inputData.earningsAmount = JSON.stringify(this.smokerDetails.earningsAmount)
      }
    } else {
      // this.gotosumamrypageLogic()
    }
    let provincelist = JSON.parse(sessionStorage.getItem("provincelist") || "");

    if (provincelist.includes(inputData.province_id)) { } else {
      // if (this.formConfigResult.assign_default_form == true) {
      if (this.formConfigResult.brokershipTransferFeature && this.formConfigResult.assign_default_form == true) {
        inputData.formId = this.formConfigResult.default_form.id;
        inputData.brokershipTransfered = true;
        inputData.originalFormId = this.formConfigResult.form.id;
      } else {
        inputData.brokershipTransfered = false;
      }
    }

    if (sessionStorage.getItem("fusebillCustomerAddressId")) {
      inputData.fusebillCustomerAddressId = sessionStorage.getItem("fusebillCustomerAddressId") || null;
    }
    if (
      sessionStorage.getItem("fusebillCustomerId")
    ) {
      inputData.fusebillCustomerId = sessionStorage.getItem("fusebillCustomerId") || null;
    }
    if (
      sessionStorage.getItem("fusebillCustomerBillingAddressId")
    ) {
      inputData.fusebillCustomerBillingAddressId = sessionStorage.getItem("fusebillCustomerBillingAddressId") || null;
    }
    if (
      sessionStorage.getItem("customerId")
    ) {
      inputData.customerId = sessionStorage.getItem("customerId") || null;
    }
    inputData.billing_sameas_homeAddress =
      sessionStorage.getItem("homeAddress") == "true" ? true : false;

    if (sessionStorage.getItem("homeAddress") == "true") {
      inputData.billing_address = {
        line1: inputData.street_address_line1 || "",
        line2: inputData.street_address_line2 || "",
        city: inputData.city || "",
        state: inputData.province || "",
        state_id: parseInt(this.provineList.id), // this.fusebillid = parseInt(element.fusebillId);
        fusebillStateId: parseInt(this.provineList.fusebillId),
        fusebillCountryId: 124,
        country: "Canada",
        country_id: 1,
        postal_zip: inputData.postal_code || "",
        apt: inputData.apt || "",
      };
    } else {
      inputData.billing_address = {
        line1: this.paymentForm.get("streetaddress")?.value || "",
        line2: this.paymentForm.get("streetaddressline2")?.value || "",
        city: this.paymentForm.get("city")?.value || "",
        state: this.paymentForm.get("province")?.value || "",
        state_id: parseInt(this.provineListcreditPayment.id), // this.fusebillid = parseInt(element.fusebillId);
        fusebillStateId: parseInt(this.provineListcreditPayment.fusebillId),
        fusebillCountryId: 124,
        country: "Canada",
        country_id: 1,
        postal_zip: this.paymentForm.get("postalcode")?.value || "",
        apt: this.paymentForm.get("aptcheck")?.value || "",
      };
    }

    if (sessionStorage.getItem("customerId") && sessionStorage.getItem("fusebillCustomerId")) {
      inputData.billing_address.customer_id = parseInt(sessionStorage.getItem("customerId") || '0') || 0;
      inputData.billing_address.fusebill_customer_id = parseInt(sessionStorage.getItem("fusebillCustomerId") || '0') || 0;
    }


    console.log("this.extraBankPayForm1234: ",this.extraBankPayForm)
    if (this.paymentForm.invalid) {
      const invalid = [];
      this.paymentForm.markAllAsTouched();
      console.log("this.paymentForm2312: ",this.paymentForm)
      const controls: any = this.paymentForm.controls;
      for (let name in controls) {
        if (controls[name].invalid) {

          if (name == "CardNumber") {
            name = this.lang.Please_enter_Card_number;
          }
          if (name == "ExpirationMonth") {
            name = this.lang.Please_select_expiry_month;
          }
          if (name == "ExporationYear") {
            name = this.lang.Please_select_expiry_year;
          }
          if (name == "cvv") {
            name = this.lang.Please_enter_cvv
          }
          if (name == "streetaddress") {
            name = this.lang.Enter_Street_Address;
          }
          if (name == "city") {
            name = this.lang.Enter_City;
          }
          if (name == "province") {
            name = this.lang.Select_Province;
          }
          if (name == "postalcode") {
            name = this.lang.Enter_Postal_Code;

          }
          if (name == "recaptchaReactive") {
            name = this.lang.Select_Recaptcha;
          }

          invalid.push(name);
        }

      }
      this.missingInformation = true
      this.missingInfo = invalid;

       const extraBankInvalid = this.validateExtraBank();
    if (extraBankInvalid && extraBankInvalid.length > 0) {
      // jQuery("#missingInfo-modal").modal("show");
      this.missingInformation = true
      this.missingInfo.push(...extraBankInvalid);
      //this.consoleMessage(invalid)
      return extraBankInvalid;
    }
      return invalid;
    }

    const extraBankInvalid = this.validateExtraBank();
    if (extraBankInvalid && extraBankInvalid.length > 0) {
      // jQuery("#missingInfo-modal").modal("show");
      this.missingInformation = true
      this.missingInfo.push(...extraBankInvalid);
      //this.consoleMessage(invalid)
      return extraBankInvalid;
    }

    // check if 
    if (this.signatureNeeded == true) {
      const invalid = [];
      invalid.push("Draw the Signature");
      this.missingInformation = false

      this.missingInfo = invalid;
      return invalid;
    }
    if (this.paymentForm.valid && this.signatureNeeded === false) {
      // call registration api with payment platform as authorize net
      inputData.authorizenetCustomerId = '';
      inputData.authorizenetPaymentId = '';
      inputData.paymentPlatform = "AuthorizeNet";

      inputData.fusebill_customer_id = inputData.fusebill_customer_id ?? 0;
      inputData.fusebillCustomerId = inputData.fusebillCustomerId ?? 0;

      if (this.smokerInformation != '') {
        inputData.smoker = this.smokerInformation;
      }
      if (sessionStorage.getItem('registrationcalled') == '1') {
        if (environment.app.authorizeNet) {
          let authorizenetCustomerId = sessionStorage.getItem("authorizenetCustomerId")
          if (!!authorizenetCustomerId && authorizenetCustomerId != '0' && authorizenetCustomerId != 'null' && authorizenetCustomerId != 'undefined') {
            this.navigateToPayment(authorizenetCustomerId, true);
          } else {
            this.ShowModelPopup = true
            this.ShowModelPopupMessage = this.lang.You_are_already_done_with_the_subscription_Please_check_your_mail_or_contact_admin_groupbenefitz_ca ?? 'You are already done with the registration.Please check your mail or contact admin@groupbenefitz.ca',
              this.ShowModelPopupTitle = this.lang.Info ?? 'Info'

            // create object for report log
            let currentTimeStamp = new Date().getTime().toString();
            let log = {
              api: environment.app.grp + "api/customer/generic/v5/registration",
              payload: JSON.stringify(inputData),
              message: `Trying to submit registraion form again ${currentTimeStamp}`,
              portal: 'Corporate Signup form'
            }
            let obj = {
              customerDetails: JSON.stringify({ username: inputData.email, timeStamp: sessionStorage.getItem('timeStamp') }),
              logs: JSON.stringify(log),
            };
            this._SignupformService.submitReportLog(environment.app.commonurl, obj);
          }
        } else {
          let fusebillCustomerId = sessionStorage.getItem("fusebillCustomerId")
          if (!!fusebillCustomerId && fusebillCustomerId != '0' && fusebillCustomerId != 'null' && fusebillCustomerId != 'undefined') {
            this.navigateToPayment(fusebillCustomerId, true);
          } else {
            this.ShowModelPopup = true
            this.ShowModelPopupMessage = this.lang.You_are_already_done_with_the_subscription_Please_check_your_mail_or_contact_admin_groupbenefitz_ca ?? 'You are already done with the registration.Please check your mail or contact admin@groupbenefitz.ca',
              this.ShowModelPopupTitle = this.lang.Info ?? 'Info'

            // create object for report log
            let currentTimeStamp = new Date().getTime().toString();
            let log = {
              api: environment.app.grp + "api/customer/generic/v5/registration",
              payload: JSON.stringify(inputData),
              message: `Trying to submit registraion form again ${currentTimeStamp}`,
              portal: 'Gig Signup form'
            }
            let obj = {
              customerDetails: JSON.stringify({ username: inputData.email, timeStamp: sessionStorage.getItem('timeStamp') }),
              logs: JSON.stringify(log),
            };
            this._SignupformService.submitReportLog(environment.app.commonurl, obj);
          }
        }
        return;
      }

      inputData.maritalStatus = this.maritalStatus();

      let loginObservable: any;
      if (environment.app.authorizeNet) {
        sessionStorage.setItem('v5Api', 'true')
        sessionStorage.setItem('paymentPlatform', 'AuthorizeNet')
        sessionStorage.setItem('isVikingSignup', 'true')
        inputData.formType = this.currFormType;
        loginObservable = this._SignupformService.loginV5(inputData)
        if(this.currFormType =='viking'){
          loginObservable = this._SignupformService.genericLoginV5(inputData)
        }
      } else {
        loginObservable = this._SignupformService.login1(inputData);
      }

      // step 1: triggered payment method update to <paymentMethod (CC/PAD)>
      let activity: any = {};
      activity.action = 'Step 1 of 7 - Payment method update triggered to Credit Card';
      activity.requestBody = this.paymentForm;

      activity.requestBody = {};
      activity.status = 'SUCCESS';
      activity.responseSummary = 'Payment method update triggered successfully';
      // this.buildActivityLogObject(activity, true);

      // waiting for a while to let previous add-activity api to hit
      await new Promise(resolve => setTimeout(resolve, 0))
        .then(() => { })
      activity = {};
      activity.action = 'Step 2 of 7 - Customer Registration';
      activity.url = environment.app.grp + 'api/customer/' + (environment.app.authorizeNet ? 'v5' : 'v3') + '/registration';
      activity.requestMethod = 'POST';
      activity.requestBody = inputData;
      loginObservable.subscribe((result: any) => {
        if (result.status === "200") {
          activity.status = 'SUCCESS';
          activity.response = result;
          activity.responseSummary = 'Registration done successfully';
          activity.effectedUserId = result.data?.customer?.id;
          // this.buildActivityLogObject(activity, true);

          sessionStorage.setItem('registrationcalled', '1')
          sessionStorage.removeItem("paymentfail");

          if (result.data.customer.fusebill) {
            sessionStorage.setItem("fusebillCustomerId", result.data.customer.fusebill.customerId);
            sessionStorage.setItem("publicApiKey", result.data.customer.fusebill.publicApiKey);
            sessionStorage.setItem("fusebillCustomerAddressId", result.data.customer.fusebill.customerAddressId || '');
            sessionStorage.setItem("fusebillCustomerBillingAddressId", result.data.customer.fusebill.customerBillingAddressId || '');
          }

          sessionStorage.setItem("userKey", result.data.userKey);
          sessionStorage.setItem("customerId", result.data.customer.id);
          sessionStorage.setItem("normalcustomerid", result.data.customer.id);
          sessionStorage.setItem("enrollmentdate", inputData.planEnrollmentDate);

          let authorizeNetCustomerId = result.data.customer?.authorizenet?.customerId ?? 0;
          let validAuthorizeId: boolean = false;
          if (!!authorizeNetCustomerId && authorizeNetCustomerId != '-9999' && authorizeNetCustomerId != 0) {
            validAuthorizeId = true;
          }
          if (environment.app.authorizeNet && validAuthorizeId) {
            sessionStorage.setItem('v5Api', 'true')
            sessionStorage.setItem('authorizenetCustomerId', authorizeNetCustomerId);
            sessionStorage.setItem('payment', "CC");

            activity = {};
            activity.action = 'Step 3 of 7 - Authorize profile creation';

            activity.status = 'SUCCESS';
            activity.response = {};
            activity.responseSummary = 'Found Authorize profile, using the same id ' + authorizeNetCustomerId;
            activity.effectedUserId = result.data?.customer?.id;
            // this.buildActivityLogObject(activity, true);

            // call add payment profile
            this.addPaymentProfile(result.data.customer.id, authorizeNetCustomerId);
          } else {
            // create profile
            this.createAuthorizeProfile(result.data.customer.id, this.userForm.get("email")?.value, 'cc')
          }

        this.submitClaimsDepositInfo();

        } else {
          this.ShowModelPopup = true;
          this.ShowModelPopupMessage = result.message;
          this.ShowModelPopupTitle = this.lang.Info;
        }
      }, (error: any) => {
        this.ShowModelPopup = true;
        this.ShowModelPopupMessage = error.error?.message || error.error?.error || 'Login failed';
        this.ShowModelPopupTitle = this.lang.Info;
      });
    }
    else {
      if (this.signaturecheckcc == true) {
        this.signaturemessagecc = true;
      }
    }
  }

  addPaymentProfile(customerId: any, authorizeNetCustomerId: any = '') {
    sessionStorage.setItem('authorizenetCustomerId', authorizeNetCustomerId);
    const cardNum = this.paymentForm.controls['CardNumber'].value?.replace(/\s+/g, '');
    const cardData: any = {
      cardNumber: cardNum,
      month: this.paymentForm.controls['ExpirationMonth'].value,
      year: this.paymentForm.controls['ExporationYear'].value,
    };
    const authData = {
      clientKey: environment.app.clientKey,
      apiLoginID: environment.app.apiLoginID
    };
    const secureData = { cardData, authData };

    let activity: any = {};
    activity.action = 'Step 4 of 7 - Connecting to Authorize';
    activity.requestMethod = 'POST';
    activity.requestBody = secureData;

    Accept.dispatchData(secureData, (response: any) => {
      console.log(cardData, authData, response);

      if (response.messages.resultCode !== "Ok") {
        activity.status = 'FAILURE';
        activity.response = response;
        activity.responseSummary = 'Error connecting authorize';
        // this.buildActivityLogObject(activity, true);

        console.error("Accept.js dispatch failed:", response.messages.message);
        this.ShowModelPopup = true;
        this.ShowModelPopupTitle = 'Error';
        this.ShowModelPopupMessage = 'Unable to connect to payment platform to add payment details';
        return;
      }

      activity.status = 'SUCCESS';
      activity.response = response;
      activity.responseSummary = 'Successfully connected to authorize';
      // this.buildActivityLogObject(activity, true);

      const opaqueData = response.opaqueData;
      const formData = this.paymentForm.value;

      const paymentInfo = {
        opaqueDataDescriptor: opaqueData.dataDescriptor,
        opaqueDataValue: opaqueData.dataValue,
        firstName: formData.FirstName,
        lastName: formData.LastName,
        address: `${formData.streetaddress} ${formData.streetaddressline2}`,
        city: formData.city,
        state: formData.province,
        zip: formData.postalcode,
        country: "Canada",
        customerProfileId: authorizeNetCustomerId,
        phoneNumber: this.userForm.get("phone_number")?.value?.replace(/^1/, ''),
      };

      activity = {};
      // activity.action = 'Step 5 of 7 - Creating payment profile in authorize';
      activity.action = 'Member enrollment - AuthorizeNet Payment Initiation';
      activity.url = environment.app.authorizePortal + 'api/authorize-net/add-payment-profile';
      activity.requestMethod = 'POST';
      activity.requestBody = paymentInfo;

      this._SignupformService.authorizePaymentProfileCreation(paymentInfo).subscribe({
        next: (res2: any) => {
          sessionStorage.setItem('authorizenetPaymentId', res2.customerPaymentProfileId);

          activity.status = 'SUCCESS';
          activity.response = res2;
          activity.responseSummary = 'Successfully payment profile has been created';
          this.buildActivityLogObject(activity, true);

          // add payment details to our DB
          this.addPaymentDetails(customerId, authorizeNetCustomerId, res2.customerPaymentProfileId, cardData);
        },
        error: (err) => {
          activity.status = 'FAILURE';
          activity.response = err;
          activity.responseSummary = 'Error creating payment profile';
          this.buildActivityLogObject(activity, true);

          console.error("authorizePaymentProfileCreation failed", err);
          this.ShowModelPopup = true;
          this.ShowModelPopupTitle = 'Error';
          this.ShowModelPopupMessage = 'Unable to create profile for payment method';

          // navigate to payment
          this.navigateToPayment('-9999', false);
        }
      });
    });
  }

  addPaymentDetails(customerId: any, authorizeNetCustomerId: any, authorizeNetPaymentId: any, cardData: any) {
    let inputData = {
      customerId: customerId,
      cc: (cardData.cardNumber)?.toString()?.slice(-4),
      timestamp: Date.now()?.toString(),
      expiry: cardData.month?.toString() + '/20' + cardData.year?.toString(),
    };

    let ccSessionDetails: any = btoa(JSON.stringify(inputData));
    console.log('inputData', inputData);
    console.log('ccSessionDetails', ccSessionDetails);

    let activity: any = {};
    activity.url = environment.app.grp + '/api/authorizenet-payment/details';
    activity.action = 'Step 6 of 7 - Updating payment method';
    activity.requestMethod = 'POST';
    activity.requestBody = { customerId: customerId, session: ccSessionDetails };

    let personalInfo: any = JSON.parse(sessionStorage.getItem("Data") || '{}');

    this.http.post(environment.app.grp + '/api/authorizenet-payment/details', {
      customerId: customerId,
      session: ccSessionDetails,
      firstName: personalInfo?.firstName,
      lastName: personalInfo?.lastName,
      email: personalInfo?.email,
    }).subscribe((response: any) => {
      if (response.status == 200) {
        activity.status = 'SUCCESS';
        activity.response = response;
        activity.responseSummary = 'Successfully payment method has been updated to CC';
        // this.submitActivitytLog(activity);
        // this.buildActivityLogObject(activity, true);
        console.log(response)
      } else {
        activity.status = 'FAILURE';
        activity.response = response;
        activity.responseSummary = 'Error updating payment details';
        // this.buildActivityLogObject(activity, true);
        // this.navigateToPayment(authorizeNetCustomerId,authorizeNetPaymentId);
      }
      this.navigateToPayment(authorizeNetCustomerId, authorizeNetPaymentId);
    }, (error: any) => {
      // if ([0, 500, 501, 502, 503].includes(error.status)) {
      //   this.ShowModelPopup = true
      //   this.ShowModelPopupMessage = this.lang.Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience;
      //   this.ShowModelPopupTitle = this.lang.Info
      // }
      // else {
      //   this.navigateToPayment(authorizeNetCustomerId,authorizeNetPaymentId);
      // }
      activity.status = 'FAILURE';
      activity.response = error;
      activity.responseSummary = 'Error updating payment details';
      // this.buildActivityLogObject(activity, true);

      console.log(error)
      this.navigateToPayment(authorizeNetCustomerId, authorizeNetPaymentId);
    })
  }

  navigateToPayment(authorizeNetCustomerId: any, authorizeNetPaymentId: any) {
    let success: any = 'False';
    if (!!authorizeNetPaymentId) {
      success = 'True';
    }

    if(this.currForm == "GIG"){
      window.location.href = environment.app.globalgrp + `#/payment/form?customerId=${authorizeNetCustomerId}&paymentMethod=CC&success=${success}`;
    }else{
      window.location.href =  `/#/payment/corporate?customerId=${authorizeNetCustomerId}&paymentMethod=CC&success=${success}`;
    }
    // window.location.href = environment.app.localgrp + `#/payment/form?customerId=${authorizeNetCustomerId}&paymentMethod=CC&success=${success}`;
  }

  
  createCorpAuthorizeProfile(customerId: any, email: any, payment: any, navigateToPayment: any = false) {
    const profileInfo = { customerId, email };
    let activity: any = {};
    // activity.action = 'Step 3 of 7 - Authorize profile creation';
    activity.action = 'Member enrollment - Authorizenet Customer Profile';
    activity.requestBody = profileInfo;

    this._CorporateService.authorizeProfileCreation(profileInfo).subscribe({
      next: (res1: any) => {
        if (payment == 'cc') {
          if (navigateToPayment) {
            let activity: any = {};
            activity.action = 'Step 4 of 7 - Connecting to Authorize';
            activity.requestMethod = 'POST';
            activity.status = 'FAILURE';
            activity.responseSummary = 'Skipping this step, no voluntry plans choosen';
            // this.buildActivityLogObject(activity, true);

            activity.action = 'Step 5 of 7 - Creating payment profile in authorize';
            // this.buildActivityLogObject(activity, true);

            activity.action = 'Step 6 of 7 - Updating payment method';
            // this.buildActivityLogObject(activity, true);

            this.navigateToPayment(res1.customerProfileId, true);
          } else {
            // activity.action = 'Step 6 of 7 - Authorize profile creation';
            activity.status = 'SUCCESS';
            activity.response = res1;
            activity.responseSummary = 'Authorize profile created successfully - ' + res1.customerProfileId;
            this.buildActivityLogObject(activity, true);

            this.addPaymentProfile(customerId, res1.customerProfileId);
          }
        } else {
          // activity.action = 'Step 6 of 7 - Authorize profile creation';
          activity.action = 'Member enrollment - Authorizenet Customer Profile';
          activity.status = 'SUCCESS';
          activity.response = res1;
          activity.responseSummary = 'Authorize profile created successfully - ' + res1.customerProfileId;
          this.buildActivityLogObject(activity, true);

          setTimeout(() => {
            this.bankformsubmitdetails();
          }, 100);
        }
      },
      error: (err) => {
        activity.status = 'FAILURE';
        activity.response = err;
        activity.responseSummary = 'Failed to create authorize profile';
        this.buildActivityLogObject(activity, true);

        console.error("authorizeProfileCreation failed", err);
        if (payment == 'cc') {
          this.navigateToPayment(customerId, false);
        } else {
          setTimeout(() => {
            this.bankformsubmitdetails();
          }, 100);
        }
      }
    });
  }

  createAuthorizeProfile(customerId: any, email: any, payment: any) {
    const profileInfo = { customerId, email };
    let activity: any = {};
    activity.action = 'Member enrollment - Authorizenet Customer Profile';
    activity.requestBody = profileInfo;

    this._SignupformService.authorizeProfileCreation(profileInfo).subscribe({
      next: (res1: any) => {
        if (payment == 'cc') {
          activity.status = 'SUCCESS';
          activity.response = res1;
          activity.responseSummary = 'Authorize profile created successfully - ' + res1.customerProfileId;
          this.buildActivityLogObject(activity, true);

          this.addPaymentProfile(customerId, res1.customerProfileId);
        } else {
          activity.action = 'Step 6 of 7 - Authorize profile creation';
          activity.status = 'SUCCESS';
          activity.response = res1;
          activity.responseSummary = 'Authorize profile created successfully - ' + res1.customerProfileId;
          this.buildActivityLogObject(activity, true);

          setTimeout(() => {
            this.bankformsubmitdetails();
          }, 100);
        }
      },
      error: (err) => {
        activity.status = 'FAILURE';
        activity.response = err;
        activity.responseSummary = 'Failed to create authorize profile';
        this.buildActivityLogObject(activity, true);

        console.error("authorizeProfileCreation failed", err);
        if (payment == 'cc') {
          this.navigateToPayment(customerId, false);
        } else {
          setTimeout(() => {
            this.bankformsubmitdetails();
          }, 100);
        }
      }
    });
  }

  checkSpouse() {
    if (this.spouseSynonyms.includes(this.benficiaryForm.value.relationshipSpecific?.toLowerCase() ?? '')) {

      if (this.userForm.get('having_spouse')?.value != 'true' && this.benficiaryForm.value.relationship?.toLowerCase() == 'spouse' && this.currFormType != "viking") {
        this.ShowModelPopup = true;
        this.ShowModelPopupMessage = 'Please select yes for Spouse.';
        this.ShowModelPopupTitle = this.lang.Info;

        this.addeditbenficiary = false;
        this.benficiary = false;
        this.gotoPersonalInfoPage();
        return;
      }
      if (this.userForm.get('having_dependent_children')?.value != 'true' && this.benficiaryForm.value.relationship?.toLowerCase() == 'child' && this.currFormType != "viking") {
        this.ShowModelPopup = true;
        this.ShowModelPopupMessage = 'Please select yes for Dependent.';
        this.ShowModelPopupTitle = this.lang.Info;

        this.addeditbenficiary = false;
        this.benficiary = false;
        this.gotoPersonalInfoPage();
        return;
      }

      this.benficiaryForm.get('firstName')?.setValue(this.SpouseDetails.firstName);
      this.benficiaryForm.get('lastName')?.setValue(this.SpouseDetails.lastName);

      // The control holds the MM-DD-YYYY text the datepicker parses, which is what the
      // old YYYY-MM-DD string surgery produced. toTypingDate builds it from local date
      // parts and accepts a Date or any of our date strings, so it no longer breaks (or
      // silently reorders the parts) when the spouse details arrive in another shape.
      const formattedDob = toTypingDate(this.SpouseDetails.dob);
      this.benficiaryForm.get('dob')?.setValue(formattedDob);
      this.benficiaryForm.get('gender')?.setValue(this.SpouseDetails.gender);
    }
  }


    public  generateAndSubmitPAD(showModal:any = false) {
      this.showPADMODAL = showModal;
      this.rejectPADModel = false
      this.closePADModel = true
      this.showagree = false
      this.acceptaggrepad = false
      this.signatureNeeded = this.signaturePad.isEmpty();
      if (this.signatureNeeded == false) {

        const base64Data = this.signaturePad.toDataURL();
        // console.log(base64Data);
        sessionStorage.setItem("signature", base64Data);
        this.signaturemessagecc = false

      }
      else {
        sessionStorage.setItem("signature", "");

        this.signaturemessagecc = true

      }
  
      if (this.signaturemessagepad) {
        return false;
      }
  
      let Data = JSON.parse(sessionStorage.getItem('Data') || '{}');
      this.agreestatus = false
      this.signaturestatus = true
  
      console.log(this.bankpayForm)
      console.log(this.bankpayForm.valid)
  
      if (!this.bankpayForm.valid) {
        this.bankpayForm.markAllAsTouched();
        return false;
      }
  
      let addressobject = {
        address1:
          this.bankpayForm.get('bankstreetaddress')?.value ||
          Data.street_address_line1 ||
          '',
        address2:
          this.bankpayForm.get('bankstreetaddressline2')?.value ||
          Data.street_address_line2 ||
          '',
        apt: this.bankpayForm.get('bankaptcheck')?.value || Data.apt || '',
        city: this.bankpayForm.get('bankcity')?.value || Data.city || '',
        province:
          this.bankpayForm.get('bankprovince')?.value || Data.province || '',
        postalCode:
          this.bankpayForm.get('bankpostalcode')?.value ||
          Data.postal_code ||
          '',
        phone: Data.phone_number,
        email: Data.email,
      };
  
      let bankAddress = this.bankverifyDetails.address;
      let bankAdressArr = bankAddress.split(',');
      let bankCity = bankAdressArr[bankAdressArr.length - 2].replace(' ', '');
      let provincePostal = bankAdressArr[bankAdressArr.length - 1];
      let provincePostalArr = provincePostal.split(' ');
      let bankProvince = provincePostalArr[provincePostalArr.length - 3];
      let bankPostalCode =
        provincePostalArr[provincePostalArr.length - 2] +
        ' ' +
        provincePostalArr[provincePostalArr.length - 1];
  
      let bankobject = {
        name: this.bankverifyDetails.bank.name,
        address: this.bankverifyDetails.bank.address.split(',')[0],
        city: bankAdressArr[bankAdressArr.length - 2].replace(' ', ''),
        province: provincePostalArr[provincePostalArr.length - 3],
        postalCode:
          provincePostalArr[provincePostalArr.length - 2] +
          ' ' +
          provincePostalArr[provincePostalArr.length - 1],
      };
  
      let inputData1 = {
        bankCode: this.bankpayForm.get('banknumber')?.value,
        branchCode: this.bankpayForm.get('transitnumber')?.value,
        accountNumber: this.bankpayForm.get('accountnumber')?.value,
      };
  
      var fileExtension = '.' + this.bankfile.name.split('.').pop();
      var encBank = btoa(JSON.stringify(inputData1));
      var formData: any = new FormData();
      formData.append('firstName', Data.firstName);
      formData.append('lastName', Data.lastName);
      formData.append('address', JSON.stringify(addressobject));
      formData.append('bank', JSON.stringify(bankobject));
      formData.append(
        'files',
        this.bankfile,
        'void_cheque_' + Date.now() + fileExtension.toLowerCase()
      );
      formData.append('session', encBank) || '';
      formData.append('timestamp', new Date().getTime());
  
      let activity: any = {};
      activity.action = 'Step 2 of 7 - Generating pad agreement';
      activity.url = environment.app.grp + '/api/corporate/customer/generatePAD';
      activity.requestMethod = 'POST';
      activity.requestBody = formData;
  
      try {
        this._SignupformService.padaddgrementdetails(formData)
        .subscribe((result: any) => {
        if (result.status == '200') {
          activity.status = 'SUCCESS';
          activity.response = result;
          activity.responseSummary = 'Successfully pad agreement has been generated';
  
          sessionStorage.setItem('fileurl', result.data.url);
          sessionStorage.setItem('filename', result.data.filename);
  
          if (
            sessionStorage.getItem('fileurl') &&
            sessionStorage.getItem('filename') &&
            sessionStorage.getItem('signature')
          ) {
            this.showmodelsign()
          }
          return true;
        } else {
          activity.status = 'FAILURE';
          activity.response = result;
          activity.responseSummary = 'Error generating pad agreement';
  
          this.ShowModelPopup = true
          this.ShowModelPopupMessage = result.message ? result.message : result.error
          this.ShowModelPopupTitle = this.lang.Info
          return false;
        }
      })
      } catch (err) {
        this.ShowModelPopup = true
        this.ShowModelPopupMessage = 'An error occurred generating the PAD agreement. Please try again.'
        this.ShowModelPopupTitle = this.lang.Info
        return false;
      }
    }

  public async bankpayformsubmit2(value: any) {

    this.generateAndSubmitPAD()
    // if (!padSuccess) return;
    let inputData = JSON.parse(sessionStorage.getItem("Data") || '{}');

    if (sessionStorage.getItem("Spousesignature")) {
      inputData.spouseSignature = sessionStorage.getItem("Spousesignature")
    }
    inputData.signature = sessionStorage.getItem("signature") || "";

    let provincelist = JSON.parse(sessionStorage.getItem("provincelist") || "");
    // ['trusteeDetails']={'firstName':'','lastName':''}

    let iafgData = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    let iafgTermplanCheck = iafgData.filter((p: any) => p.planLevel == 44);

    if (iafgTermplanCheck.length > 0 || this.showBenificiaryFormCond) {

      if (this.addbenificaryData.length > 0) {
        this.benficiary = false;

        const validateBeneficiaries = this.addbenificaryData.reduce((acc: any, obj: any) => {
          const compositeKey = `${obj.customerType}_${obj.type}`;
          if (!acc[compositeKey]) {
            acc[compositeKey] = 0;
          }
          acc[compositeKey] += parseFloat(obj.percentage);
          return acc;
        }, {});

        let beneficiaryError = "";
        for (const key in validateBeneficiaries) {
          if (validateBeneficiaries.hasOwnProperty(key)) {
            const [customerType, type] = key.split("_");
            console.log(`The customerType ${customerType} and type ${type} with perc: ${validateBeneficiaries[key]}`);

            if (validateBeneficiaries[key] != 100) {
              beneficiaryError += `CustomerType ${customerType} and type ${type} has percentage issue. \n`
            }
          }
        }




        if (beneficiaryError != "") {
          this.benficiaryCount = true
          this.benficiaryCountMessage = this.lang.Distributed_percentages_must_equal_100_and_not_more
          return false;
        }

        else {
          this.benficiary = false

          if (this.addbenificaryData && this.addbenificaryData.length > 0) {
            this.addbenificaryData =
              this.addbenificaryData
                .map((v: any) => ({
                  ...v, contactDetails: {
                    contingentBeneficiary: {

                      firstName: v.contingentFirstName,

                      lastName: v.contingentLastName,

                    }
                  }, 
                  additionalDetails: {
                    email: v.email,
                    phoneNumber: v.phone_number
                  },
                  trusteeDetails: {
                    firstName: v.trusteeFirstName || "",
                    lastName: v.trusteeLastName || "",
                    relationship: v.trusteeRelation || "",
                  }
                }))
            inputData.havingBeneficiaries = true
          }
          else {
            this.benficiary = true;

            return false;
          }
          inputData.beneficiariesDetails = this.addbenificaryData

        }



         if (this.smokerDetails) {
        // means there is data
        inputData.smoker = this.smokerDetails.smoker == "true" ? true : false
        inputData.earningsFrequency = this.smokerDetails.earningsFrequency
        inputData.earningsAmount = JSON.stringify(this.smokerDetails.earningsAmount)
      }
      }


      else {
        this.benficiary = true;
        if (this.addbenificaryData.length > 0) {

        } else {
          this.showBenificiaryForm = true
        }


        return false;

      }

    } else {
      // this.gotosumamrypageLogic()
    }

    // console.log(this.addbenificaryData)

    // return false
    if (provincelist.includes(inputData.province_id)) {
    } else {
      // if (this.formConfigResult.assign_default_form == true) {
      if (this.formConfigResult.brokershipTransferFeature && this.formConfigResult.assign_default_form == true) {

        // alert("1");
        inputData.formId = this.formConfigResult.default_form.id;
        inputData.brokershipTransfered = true;
        inputData.originalFormId = this.formConfigResult.form.id;
      } else {
        inputData.brokershipTransfered = false;
      }
    }

    if (
      sessionStorage.getItem("fusebillCustomerAddressId")
    ) {
      inputData.fusebillCustomerAddressId =
        sessionStorage.getItem("fusebillCustomerAddressId") || null;
    }
    if (
      sessionStorage.getItem("fusebillCustomerId")
    ) {
      inputData.fusebillCustomerId =
        sessionStorage.getItem("fusebillCustomerId") || null;
    }
    if (
      sessionStorage.getItem("fusebillCustomerBillingAddressId")
    ) {
      inputData.fusebillCustomerBillingAddressId =
        sessionStorage.getItem("fusebillCustomerBillingAddressId") || null;
    }
    if (
      sessionStorage.getItem("customerId")
    ) {
      inputData.customerId = sessionStorage.getItem("customerId") || null;
    }
    inputData.billing_sameas_homeAddress =
      sessionStorage.getItem("homeAddress") == "true" ? true : false;

    if (sessionStorage.getItem("homeAddress") == "true") {
      inputData.billing_address = {
        // "customer_id": parseInt(sessionStorage.getItem("customerId")) || null,
        // "fusebill_customer_id": parseInt(sessionStorage.getItem("fusebillCustomerId")) || null,
        line1: inputData.street_address_line1,
        line2: inputData.street_address_line2,
        city: inputData.city,
        state: "BC",
        state_id: parseInt(this.provineList.id), // this.fusebillid = parseInt(element.fusebillId);
        fusebillStateId: parseInt(this.provineList.fusebillId),
        fusebillCountryId: 124,
        country: "Canada",
        country_id: 1,
        // ocountry_id: 1,
        postal_zip: inputData.postalcode,
        apt: inputData.apt || "",
      };
    } else {

      //this.consoleMessage(this.paymentForm)
      inputData.billing_address = {
        line1: this.bankpayForm.get("bankstreetaddress")?.value || "",
        line2: this.bankpayForm.get("bankstreetaddressline2")?.value || "",
        city: this.bankpayForm.get("bankcity")?.value || "",
        state: this.bankpayForm.get("bankprovince")?.value || "",
        state_id: parseInt(this.provineListPayment.id),
        fusebillStateId: parseInt(this.provineListPayment.fusebillId),
        fusebillCountryId: 124,
        country: "Canada",
        country_id: 1,
        // ocountry_id: 1,
        postal_zip: this.bankpayForm.get("bankpostalcode")?.value,
        apt: this.bankpayForm.get("bankaptcheck")?.value || "",
      };
    }

    if (
      sessionStorage.getItem("customerId") &&
      sessionStorage.getItem("fusebillCustomerId")
    ) {
      inputData.billing_address.customer_id =
        parseInt(sessionStorage.getItem("customerId") || "0") || 0;
      inputData.billing_address.fusebill_customer_id =
        parseInt(sessionStorage.getItem("fusebillCustomerId") || "0") || 0;


    }
    if (this.acceptaggrepad == true) {
      this.padaggrementerror = this.lang.Please_check_the_PAD_agreement
    }
    else {
      this.padaggrementerror = ""
    }
    console.log("extraBankInvalid123: ")
    console.log(this.bankpayForm)
    console.log(this.bankpayForm.invalid)
    const extraBankInvalid = this.validateExtraBank();

    if (extraBankInvalid && extraBankInvalid.length >0) {
      // this.bankpayForm.markAsTouched();
      // jQuery("#missingInfo-modal").modal("show");
      this.missingInformation = true
      this.missingInfo.push(...extraBankInvalid);
      //this.consoleMessage(invalid)
      return extraBankInvalid;
    }
    if (this.acceptaggrepad == true) {
      const invalid = [];
      invalid.push("Accept the PAD");
      // jQuery("#missingInfo-modal").modal("show");
      this.missingInformation = true
      this.missingInfo = invalid;
      //this.consoleMessage(invalid)
      return invalid;
    }

    if (this.bankpayForm.valid && this.cartcheckvalue == false) {
      let enrollmentData = {
        "customerName": inputData.firstName + "" + inputData.lastName,
        "contactNum": inputData.phone_number,
        "dob": inputData.date_of_birth,
        "email": inputData.email,
        "process": "enrollmentSummary",
        "request": {
          "paymentMethod": "PAD", "signature": sessionStorage.getItem("signature") || "", "bankCode": this.bankpayForm.get("banknumber")?.value,
          "branchCode": this.bankpayForm.get("transitnumber")?.value, "voidcheque": this.imagedisplay
        }
      }

      console.log('inputData', JSON.stringify(inputData));
      //create authorization net profile
      const profileInfo = {
        email: inputData.email,
        // firstName: inputData.firstName,
        //     lastName: inputData.lastName,
        //     address: this.bankpayForm.get("bankstreetaddress")?.value || "" + ' ' + this.bankpayForm.get("bankstreetaddressline2")?.value || "",
        //     city: this.bankpayForm.get("bankcity"),
        //     state: this.bankpayForm.get("bankprovince"),
        //     zip: this.bankpayForm.get("bankpostalcode"),
        //     country: "Canada",
        //     phoneNumber: inputData?.phone_number ?? inputData?.get("phone_number")?.value?.replace(/^1/, '') ?? '',
      };


      this._SignupformService.savePlan(enrollmentData).subscribe((result: any) => {
        //this.consoleMessage(result)
      }, (error: any) => {
        console.log('Error occurred:', error);

        // create object for report log
        let currentTimeStamp = new Date().getTime().toString();
        let log = {
          api: environment.app.grp + "api/common/customer/transaction",
          payload: JSON.stringify(enrollmentData),
          message: `Trying to submit transaction api enrollmentSummary ${currentTimeStamp}`,
          portal: 'Gig Signup form'
        }
        let obj = {
          customerDetails: JSON.stringify({ username: inputData.email, timeStamp: sessionStorage.getItem('timeStamp') }),
          logs: JSON.stringify(log),
        };
        this._SignupformService.submitReportLog(environment.app.commonurl, obj);
      })
      let loginObservable: Observable<any>;
      if (sessionStorage.getItem('registrationcalled') == '1') {
        if (environment.app.authorizeNet) {
          let authorizenetCustomerId = sessionStorage.getItem("authorizenetCustomerId")
          if (!!authorizenetCustomerId && authorizenetCustomerId != '0' && authorizenetCustomerId != 'null' && authorizenetCustomerId != 'undefined') {
            this.navigateToPayment(authorizenetCustomerId, true);
          } else {
            this.ShowModelPopup = true
            this.ShowModelPopupMessage = 'You are already done with the registration.Please check your mail or contact admin@groupbenefitz.ca',
              this.ShowModelPopupTitle = this.lang.Info ?? 'Info'

            // create object for report log
            let currentTimeStamp = new Date().getTime().toString();
            let log = {
              api: environment.app.grp + "api/customer/generic/v5/registration",
              payload: JSON.stringify(inputData),
              message: `Trying to submit registraion form again ${currentTimeStamp}`,
              portal: 'Gig Signup form'
            }
            let obj = {
              customerDetails: JSON.stringify({ username: inputData.email, timeStamp: sessionStorage.getItem('timeStamp') }),
              logs: JSON.stringify(log),
            };
            this._SignupformService.submitReportLog(environment.app.commonurl, obj);
          }
        } else {
          let fusebillCustomerId = sessionStorage.getItem("fusebillCustomerId")
          if (!!fusebillCustomerId && fusebillCustomerId != '0' && fusebillCustomerId != 'null' && fusebillCustomerId != 'undefined') {
            this.navigateToPayment(fusebillCustomerId, true);
          } else {
            this.ShowModelPopup = true
            this.ShowModelPopupMessage = 'You are already done with the registration.Please check your mail or contact admin@groupbenefitz.ca',
              this.ShowModelPopupTitle = this.lang.Info ?? 'Info'

            // create object for report log
            let currentTimeStamp = new Date().getTime().toString();
            let log = {
              api: environment.app.grp + "api/customer/v3/registration",
              payload: JSON.stringify(inputData),
              message: `Trying to submit registraion form again ${currentTimeStamp}`,
              portal: 'Gig Signup form'
            }
            let obj = {
              customerDetails: JSON.stringify({ username: inputData.email, timeStamp: sessionStorage.getItem('timeStamp') }),
              logs: JSON.stringify(log),
            };
            this._SignupformService.submitReportLog(environment.app.commonurl, obj);
          }
        }
        return;
      }

      inputData.maritalStatus = this.maritalStatus();

      if (environment.app.authorizeNet) {
        sessionStorage.setItem('v5Api', 'true')
        inputData.authorizenetCustomerId = '';
        inputData.authorizenetPaymentId = '';
        inputData.paymentPlatform = 'AuthorizeNet';
         sessionStorage.setItem('isVikingSignup', 'true')
        inputData.formType = this.currFormType;
        if(this.currForm == "GIG"){
          loginObservable = this._SignupformService.loginV5(inputData)
          if(this.currFormType == "viking"){
            loginObservable = this._SignupformService.genericLoginV5(inputData)
          }
        }else{
          loginObservable = this._CorporateService.genericLoginV5(inputData)
        }
      } else {
        loginObservable = this._SignupformService.login1(inputData);
      }

      let activity: any = {};
      activity.action = 'Step 4 of 7 - Payment method update triggered to PAD';
      activity.requestBody = {};
      activity.status = 'SUCCESS';
      activity.responseSummary = 'Payment method update triggered successfully';
      // this.buildActivityLogObject(activity, true);

      // waiting for a while to let previous add-activity api to hit
      await new Promise(resolve => setTimeout(resolve, 0))
        .then(() => {
          loginObservable.subscribe((result: any) => {
            // this._SignupformService.login1(inputData).subscribe(
            // (result: any) => {

            let activity: any = {};
            activity.action = 'Step 5 of 7 - Customer registration';
            activity.url = environment.app.grp + 'api/customer/' + (environment.app.authorizeNet ? 'v5' : 'v3') + '/registration';
            activity.requestMethod = 'POST';
            activity.requestBody = inputData;

            if (result.status == "200") {
              activity.status = 'SUCCESS';
              activity.response = result;
              activity.responseSummary = 'Registration done successfully';
              activity.effectedUserId = result.data?.customer?.id;
              // this.buildActivityLogObject(activity, true);

              sessionStorage.setItem('registrationcalled', '1')
              sessionStorage.removeItem("paymentfail");
              // this.planssummary = JSON.parse(
              //   sessionStorage.getItem("plansummary")
              // );
              // let obj = {};

              // this.planstab = 0;
              // this.cartamount = true;
              // ////this.consoleMessage(result.data.province);
              if (result.data.customer.fusebill) {
                sessionStorage.setItem(
                  "fusebillCustomerId",
                  result.data.customer.fusebill.customerId
                );
                sessionStorage.setItem(
                  "publicApiKey",
                  result.data.customer.fusebill.publicApiKey
                );
                if (result.data.customer.fusebill.customerAddressId) {
                  sessionStorage.setItem(
                    "fusebillCustomerAddressId",
                    result.data.customer.fusebill.customerAddressId
                  );
                }
                if (result.data.customer.fusebill.customerBillingAddressId) {
                  sessionStorage.setItem(
                    "fusebillCustomerBillingAddressId",
                    result.data.customer.fusebill.customerBillingAddressId
                  );
                }
              }
              sessionStorage.setItem("userKey", result.data.userKey);
              sessionStorage.setItem("customerId", result.data.customer.id);
              // sessionStorage.setItem("publicApiKey",result.data.customer.fusebill.publicApiKey)
              sessionStorage.setItem("normalcustomerid", result.data.customer.id);
              sessionStorage.setItem(
                "enrollmentdate",
                inputData.planEnrollmentDate
              );
              this.customerid = result.data.customer.fusebill.customerId;
              this.publicapikey = result.data.customer.fusebill.publicApiKey;

              let authorizeNetCustomerId = result.data.customer?.authorizenet?.customerId ?? 0;
              let validAuthorizeId: boolean = false;
              if (!!authorizeNetCustomerId && authorizeNetCustomerId != '-9999' && authorizeNetCustomerId != 0) {
                validAuthorizeId = true;
              }
              if (environment.app.authorizeNet && validAuthorizeId) {
                sessionStorage.setItem('v5Api', 'true')
                sessionStorage.setItem('authorizenetCustomerId', authorizeNetCustomerId);
                sessionStorage.setItem('payment', "CC");

                let activity: any = {};
                activity.action = 'Step 6 of 7 - Authorize profile creation';
                activity.status = 'SUCCESS';
                activity.responseSummary = 'Found Authorize profile, using the same id ' + authorizeNetCustomerId;
                activity.effectedUserId = result.data?.customer?.id;
                // this.buildActivityLogObject(activity, true);

                // call subscription api
                setTimeout(() => {
                  // if(this.validateaddresscheck==true){
                  //   this.validateaddress(this.paymentForm.value,"1")
                  // }
                  // else{
                  this.bankformsubmitdetails();
                  // }
                }, 100);
              } else {
                // create profile and call subcription api
                this.createAuthorizeProfile(result.data.customer.id, this.userForm.get("email")?.value, 'pad')
              }

              this.submitClaimsDepositInfo();


            }
            else if (result.status == "206") {
              activity.status = 'FAILURE';
              activity.response = result;
              activity.responseSummary = result.message;
              activity.effectedUserId = result.data?.customer?.id;
              // this.buildActivityLogObject(activity, true);

              this.ShowModelPopup = true
              this.ShowModelPopupMessage = result.message
              this.ShowModelPopupTitle = this.lang.Info


            }

            else {
              if (result.error || result.errors) {
                activity.status = 'FAILURE';
                activity.response = result;
                activity.responseSummary = (result.error ? result.error[0].value : result.errors[0].value) ?? result.data?.message ?? result?.message;
                activity.effectedUserId = result.data?.customer?.id;
                // this.buildActivityLogObject(activity, true);

                this.ShowModelPopup = true
                this.ShowModelPopupMessage = result.error ? result.error[0].value : result.errors[0].value,
                  this.ShowModelPopupTitle = this.lang.Info


              }
              else {
                activity.status = 'FAILURE';
                activity.response = result;
                activity.responseSummary = result?.data?.message ?? result.message;
                activity.effectedUserId = result.data?.customer?.id;
                // this.buildActivityLogObject(activity, true);

                this.ShowModelPopup = true
                this.ShowModelPopupMessage = result.data.message
                this.ShowModelPopupTitle = this.lang.Info

              }



            }

          },
            (error) => {
              if ([0, 500, 501, 502, 503].includes(error.status)) {
                activity.status = 'FAILURE';
                activity.response = error;
                activity.responseSummary = 'Customer registration failed';
                // this.buildActivityLogObject(activity, true);

                this.ShowModelPopup = true
                this.ShowModelPopupMessage = this.lang?.Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience ?? 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.';
                this.ShowModelPopupTitle = this.lang?.Info ?? 'Info'


              }
              else {
                activity.status = 'FAILURE';
                activity.response = error;
                activity.responseSummary = 'Customer registration failed';
                // this.buildActivityLogObject(activity, true);

                this.ShowModelPopup = true
                this.ShowModelPopupMessage = error.error.message ? error.error.message : error.error.error,
                  this.ShowModelPopupTitle = this.lang.Info


              }
            }
          );
        })
    }
    else {
      this.bankpayForm.markAllAsTouched();

      if (this.signaturecheck == true) {
        this.signaturemessage = true;
      }
      if (this.cartcheckvalue == true) {
        this.ShowModelPopup = true
        this.ShowModelPopupMessage = this.lang.Please_check_the_Plan_Selection_Page
        this.ShowModelPopupTitle = this.lang.Info
      } else if (this.bankpayForm.invalid) {
        const fieldLabels: Record<string, string> = {
          banknumber: 'Bank Number',
          transitnumber: 'Transit Number',
          accountnumber: 'Account Number',
          bankname: 'Bank Details (please verify bank)',
          voidcheck: 'Void Cheque',
          bankstreetaddress: 'Street Address',
          bankcity: 'City',
          bankprovince: 'Province',
          bankpostalcode: 'Postal Code',
        };
        const invalid: string[] = [];
        Object.keys(fieldLabels).forEach(ctrl => {
          if (this.bankpayForm.get(ctrl)?.invalid) {
            invalid.push(fieldLabels[ctrl]);
          }
        });
        if (invalid.length > 0) {
          this.missingInformation = true;
          this.missingInfo = invalid;
        }
      }
    }
  }


//   buildBeneficiaryForm(): void {
//   const controls: Record<string, AbstractControl> = {};

//   // permanent controls that are UI-only (not in config)
//   const permanentControls: Record<string, any> = {
//     customerType:        [''],
//     isMinor:             [''],
//     trusteeFirstName:    [''],
//     trusteeLastName:     [''],
//     trusteeRelation:     [''],
//     relationshipSpecific: [''],
//   };

//   // add permanent controls first
//   Object.keys(permanentControls).forEach(key => {
//     controls[key] = this.formBuilder.control(
//       permanentControls[key][0],
//       permanentControls[key][1] || []
//     );
//   });

//   // add dynamic controls from config
//   const allSections = Object.keys(beneficiaryData);
//   for (const sectionKey of allSections) {
//     const section = beneficiaryData[sectionKey];
//     for (const fieldKey of Object.keys(section)) {
//       const field = section[fieldKey];

//       // skip if not applicable to current form type
//       if (!field[this.currFormType]) continue;
//       // skip empty control names
//       if (!field.control_name) continue;

//       const validators = this.buildBeneficiaryValidators(field);
//       controls[field.control_name] = this.formBuilder.control(
//         field.defaultvalue ?? '',
//         validators
//       );
//     }
//   }

//   this.benficiaryForm = this.formBuilder.group(controls);
// }

// private buildBeneficiaryValidators(field: any): any[] {
//   const v: any[] = [];

//   if (field.required?.includes(this.currFormType)) {
//     v.push(Validators.required);
//   }

//   if (field.type === 'text') {
//     v.push(Validators.minLength(1));
//   }

//   if (field.type === 'number' && field.field === 'earningsAmount') {
//     v.push(Validators.min(1));
//   }

//   return v;
// }


  buildActivityLogObject(obj: any, submit: boolean = false) {
    let activity: any = {};
    activity.portal = 'SIGNUP';

    activity.effectedUserType = 'CUSTOMER';
    activity.effectedUserId = obj?.effectedUserId ?? sessionStorage.getItem('customerId') ?? this.customerid;

    activity.changedById = obj?.effectedUserId ?? sessionStorage.getItem('customerId') ?? this.customerid;
    activity.changedByUserName = JSON.parse(sessionStorage.getItem('data') ?? '{}')?.email;

    activity.url = obj?.url ?? undefined;
    activity.action = obj?.action ?? undefined;
    activity.requestMethod = obj?.requestMethod;
    activity.requestBody = JSON.stringify(obj?.requestBody ?? {});
    activity.status = obj?.status ?? undefined;
    activity.response = JSON.stringify(obj?.response ?? {});
    activity.responseSummary = obj?.responseSummary ?? undefined;

    if (submit) {
      this.commonSerivce.submitActivityLog(environment?.app?.commonurl, activity, environment?.app?.grp);
    }
  }

  maritalStatus() {
    let data: any = sessionStorage.getItem('Data')
    if (typeof data == 'string') {
      data = JSON.parse(data ?? '{}')
    } else if (typeof data == 'object') {
      data = data
    }

    let children = data?.children_details ?? [];
    let spouse = data?.spouse_details ?? {};

    if (children.length == 0 && Object.keys(spouse).length == 0) {
      return 'Single'
    } else if ((children.length == 1 && Object.keys(spouse).length == 0) || (children.length == 0 && Object.keys(spouse).length > 0)) {
      return 'Couple'
    } else if ((children.length > 0 && Object.keys(spouse).length > 0) || (children.length > 1)) {
      return 'Family'
    }
  }


  maritalStatusNew(data:any) {
    // let data: any = sessionStorage.getItem('Data')
    // if (typeof data == 'string') {
    //   data = JSON.parse(data ?? '{}')
    // } else if (typeof data == 'object') {
    //   data = data
    // }

    let children = data?.childrenDetails ?? [];
    let spouse = data?.spouseDetails ?? {};

    if (children.length == 0 && Object.keys(spouse).length == 0) {
      return 'Single'
    } else if ((children.length == 1 && Object.keys(spouse).length == 0) || (children.length == 0 && Object.keys(spouse).length > 0)) {
      return 'Couple'
    } else if ((children.length > 0 && Object.keys(spouse).length > 0) || (children.length > 1)) {
      return 'Family'
    }
  }

  floatPrice(price: any) {
    return parseFloat(price?.toString()?.replace(/,/g, ''));
  }
}

export function childrenminimumAgeValidator(minimumAge: number) {
  return (control: { value: string | number | Date }) => {
    // Completed years, parsed in local time (was a bare year subtraction on a UTC parse).
    const age = calculateAgeFrom(control.value) ?? -1;

    // //this.consoleMessage(age)
    // //this.consoleMessage(minimumAge)

    if (age == 55) {
      return { childrenminimumAge: false };
    }
    if (age > 21 || age < 0) {
      return { childrenminimumAge: true };
    }

    return null;
  };
}
export function validatehoursperweek(isdandjform: any = false): any {
  return (control: AbstractControl): any => {
    if (control.value && control.value < 20 && !isdandjform) {
      return { mininvalidhours: true };
    } else if (control.value && control.value < 30 && isdandjform) {
      return { mininvalidhours: true };
    } else if (control.value && control.value >= 81) {
      return { maxinvalidhours: true };
    }
  }
}
export function hourselectioncondition(control: AbstractControl): any {
  if (control.value && control.value === 'false') {
    return { invalidhoursselection: true };
  }
}
export function creditcardvalidation(control: AbstractControl): any {
  if (control.value.slice(0, 2) == 34 || control.value.slice(0, 2) == 37) {
    var creditcardRegexp = /^[0-9_ ]{17,17}$/;
    if (control.value && !creditcardRegexp.test(control.value)) {
      return { invalidcreditcarddetails: true };
    }
  } else {
    var creditcardRegexp = /^[0-9_ ]{19,19}$/;
    if (control.value && !creditcardRegexp.test(control.value)) {
      return { invalidcreditcarddetails: true };
    }
  }
}
export function creditcardvalidationAmerica(control: AbstractControl): any { }
export function checkbanknumber(control: AbstractControl): any {
  if (control.value && control.value.length != 3) {
    return { checkbanknumbervalidator: true };
  }
}
export function checktransitnumber(control: AbstractControl): any {
  if (control.value && control.value.length != 5) {
    return { checktransitnumbervalidator: true };
  }
}

export function checkaccountnumber(control: AbstractControl): any {
  if (
    control.value &&
    (control.value.length < 5 || control.value.length > 12)
  ) {
    return { checkaccountnumbervalidator: true };
  }
}
export function emailValidator(control: AbstractControl): any {


  var emailRegexp =
    /^(?!\\s)*[\sA-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-z]{2,3}(?!\\s)*$/i;

  // var emailRegexp =
  //   /^(?!\\s)[_A-Za-z0-9._%+-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$/i;

  if (control.value && !emailRegexp.test(control.value)) {
    return { invalidEmail: true };
  }
}



